const locationData = {
  rows: [
    {
      columns: ["An Giang", "An Biên", "Thị trấn Thứ Ba, Xã Đông Yên, Xã Hưng Yên"],
    },
    {
      columns: ["An Giang", "An Châu", "Thị trấn An Châu, Xã Hòa Bình Thạnh, Xã Vĩnh Thành"],
    },
    {
      columns: ["An Giang", "An Cư", "Xã Văn Giáo, Xã Vĩnh Trung, Xã An Cư"],
    },
    {
      columns: ["An Giang", "An Minh", "Thị trấn Thứ Mười Một, Xã Đông Hưng, Xã Đông Hưng B"],
    },
    {
      columns: [
        "An Giang",
        "An Phú",
        "Thị trấn An Phú, Xã Vĩnh Hội Đông, Xã Phú Hội, Xã Phước Hưng",
      ],
    },
    {
      columns: ["An Giang", "Ba Chúc", "Thị trấn Ba Chúc, Xã Lạc Quới, Xã Lê Trì"],
    },
    {
      columns: [
        "An Giang",
        "Bình An",
        "Xã Bình An (huyện Châu Thành), Xã Vĩnh Hòa Hiệp, Xã Vĩnh Hòa Phú",
      ],
    },
    {
      columns: ["An Giang", "Bình Đức", "Phường Bình Khánh, Phường Bình Đức, Xã Mỹ Khánh"],
    },
    {
      columns: ["An Giang", "Bình Giang", "Không sáp nhập"],
    },
    {
      columns: ["An Giang", "Bình Hòa", "Xã Bình Thạnh, Xã An Hòa, Xã Bình Hòa"],
    },
    {
      columns: ["An Giang", "Bình Mỹ", "Xã Bình Thủy, Xã Bình Chánh, Xã Bình Mỹ"],
    },
    {
      columns: ["An Giang", "Bình Sơn", "Không sáp nhập"],
    },
    {
      columns: ["An Giang", "Bình Thạnh Đông", "Xã Hiệp Xương, Xã Phú Bình, Xã Bình Thạnh Đông"],
    },
    {
      columns: ["An Giang", "Cần Đăng", "Xã Vĩnh Lợi, Xã Cần Đăng"],
    },
    {
      columns: [
        "An Giang",
        "Châu Đốc",
        "Phường Vĩnh Nguơn, Phường Châu Phú A, Phường Châu Phú B, Phường Vĩnh Mỹ, Xã Vĩnh Châu",
      ],
    },
    {
      columns: ["An Giang", "Châu Phong", "Xã Phú Vĩnh, Xã Lê Chánh, Xã Châu Phong"],
    },
    {
      columns: ["An Giang", "Châu Phú", "Thị trấn Cái Dầu, Xã Bình Long, Xã Bình Phú"],
    },
    {
      columns: ["An Giang", "Châu Thành", "Thị trấn Minh Lương, Xã Minh Hòa, Xã Giục Tượng"],
    },
    {
      columns: ["An Giang", "Chi Lăng", "Phường Núi Voi, Phường Chi Lăng, Xã Tân Lợi"],
    },
    {
      columns: ["An Giang", "Chợ Mới", "Thị trấn Chợ Mới, Xã Kiến An, Xã Kiến Thành"],
    },
    {
      columns: ["An Giang", "Chợ Vàm", "Thị trấn Chợ Vàm, Xã Phú Thạnh, Xã Phú Thành"],
    },
    {
      columns: ["An Giang", "Cô Tô", "Thị trấn Cô Tô, Xã Tà Đảnh, Xã Tân Tuyến"],
    },
    {
      columns: ["An Giang", "Cù Lao Giêng", "Xã Tấn Mỹ, Xã Mỹ Hiệp, Xã Bình Phước Xuân"],
    },
    {
      columns: ["An Giang", "Định Hòa", "Xã Thới Quản, Xã Thủy Liễu, Xã Định Hòa"],
    },
    {
      columns: ["An Giang", "Định Mỹ", "Xã Vĩnh Phú (huyện Thoại Sơn), Xã Định Thành, Xã Định Mỹ"],
    },
    {
      columns: ["An Giang", "Đông Hòa", "Xã Đông Thạnh, Xã Đông Hòa"],
    },
    {
      columns: ["An Giang", "Đông Hưng", "Xã Vân Khánh Đông, Xã Đông Hưng A"],
    },
    {
      columns: ["An Giang", "Đông Thái", "Xã Nam Thái, Xã Nam Thái A, Xã Đông Thái"],
    },
    {
      columns: ["An Giang", "Giang Thành", "Xã Tân Khánh Hòa, Xã Phú Lợi, Xã Phú Mỹ"],
    },
    {
      columns: [
        "An Giang",
        "Giồng Riềng",
        "Thị trấn Giồng Riềng, Xã Bàn Tân Định, Xã Thạnh Hòa, Xã Bàn Thạch, Xã Thạnh Bình",
      ],
    },
    {
      columns: ["An Giang", "Gò Quao", "Thị trấn Gò Quao, Xã Vĩnh Phước B, Xã Định An"],
    },
    {
      columns: [
        "An Giang",
        "Hà Tiên",
        "Phường Pháo Đài, Phường Bình San, Phường Mỹ Đức, Phường Đông Hồ",
      ],
    },
    {
      columns: ["An Giang", "Hòa Điền", "Xã Kiên Bình, Xã Hòa Điền"],
    },
    {
      columns: ["An Giang", "Hòa Hưng", "Xã Hòa An (huyện Giồng Riềng), Xã Hòa Lợi, Xã Hòa Hưng"],
    },
    {
      columns: ["An Giang", "Hòa Lạc", "Xã Phú Hiệp, Xã Hòa Lạc"],
    },
    {
      columns: ["An Giang", "Hòa Thuận", "Xã Ngọc Hòa, Xã Hòa Thuận"],
    },
    {
      columns: [
        "An Giang",
        "Hòn Đất",
        "Thị trấn Hòn Đất, Xã Lình Huỳnh, Xã Thổ Sơn, Xã Nam Thái Sơn",
      ],
    },
    {
      columns: ["An Giang", "Hòn Nghệ", "Không sáp nhập"],
    },
    {
      columns: ["An Giang", "Hội An", "Thị trấn Hội An, Xã Hòa An (huyện Chợ Mới), Xã Hòa Bình"],
    },
    {
      columns: ["An Giang", "Khánh Bình", "Thị trấn Long Bình, Xã Khánh An, Xã Khánh Bình"],
    },
    {
      columns: ["An Giang", "Kiên Hải", "Huyện Kiên Hải"],
    },
    {
      columns: [
        "An Giang",
        "Kiên Lương",
        "Thị trấn Kiên Lương, Xã Bình An (huyện Kiên Lương), Xã Bình Trị",
      ],
    },
    {
      columns: ["An Giang", "Long Điền", "Thị trấn Mỹ Luông, Xã Long Điền A, Xã Long Điền B"],
    },
    {
      columns: ["An Giang", "Long Kiến", "Xã An Thạnh Trung, Xã Mỹ An, Xã Long Kiến"],
    },
    {
      columns: ["An Giang", "Long Phú", "Phường Long Hưng, Phường Long Châu, Phường Long Phú"],
    },
    {
      columns: [
        "An Giang",
        "Long Thạnh",
        "Xã Vĩnh Phú (huyện Giồng Riềng), Xã Vĩnh Thạnh, Xã Long Thạnh",
      ],
    },
    {
      columns: [
        "An Giang",
        "Long Xuyên",
        "Phường Mỹ Bình, Phường Mỹ Long, Phường Mỹ Xuyên, Phường Mỹ Phước, Phường Mỹ Quý, Phường Mỹ Hòa",
      ],
    },
    {
      columns: ["An Giang", "Mỹ Đức", "Xã Khánh Hòa, Xã Mỹ Đức"],
    },
    {
      columns: ["An Giang", "Mỹ Hòa Hưng", "Không sáp nhập"],
    },
    {
      columns: ["An Giang", "Mỹ Thới", "Phường Mỹ Thạnh, Phường Mỹ Thới"],
    },
    {
      columns: [
        "An Giang",
        "Mỹ Thuận",
        "Thị trấn Sóc Sơn, Xã Mỹ Hiệp Sơn, Xã Mỹ Phước, Xã Mỹ Thuận",
      ],
    },
    {
      columns: ["An Giang", "Ngọc Chúc", "Xã Ngọc Thuận, Xã Ngọc Thành, Xã Ngọc Chúc"],
    },
    {
      columns: [
        "An Giang",
        "Nhơn Hội",
        "Xã Quốc Thái, Xã Nhơn Hội, Xã Phước Hưng, Xã Phú Hội (phần còn lại sau khi sáp nhập vào xã An Phú)",
      ],
    },
    {
      columns: ["An Giang", "Nhơn Mỹ", "Xã Mỹ Hội Đông, Xã Long Giang, Xã Nhơn Mỹ"],
    },
    {
      columns: ["An Giang", "Núi Cấm", "Xã Tân Lập, Xã An Hảo"],
    },
    {
      columns: ["An Giang", "Óc Eo", "Thị trấn Óc Eo, Xã Vọng Thê, Xã Vọng Đông"],
    },
    {
      columns: ["An Giang", "Ô Lâm", "Xã An Tức, Xã Lương Phi, Xã Ô Lâm"],
    },
    {
      columns: ["An Giang", "Phú An", "Xã Phú Thọ, Xã Phú Xuân, Xã Phú An"],
    },
    {
      columns: ["An Giang", "Phú Hòa", "Thị trấn Phú Hòa, Xã Phú Thuận, Xã Vĩnh Chánh"],
    },
    {
      columns: [
        "An Giang",
        "Phú Hữu",
        "Xã Phú Hữu, Xã Vĩnh Lộc, Xã Phước Hưng (phần còn lại sau khi sáp nhập vào xã An Phú và Nhơn Hội)",
      ],
    },
    {
      columns: ["An Giang", "Phú Lâm", "Xã Long Hòa, Xã Phú Long, Xã Phú Lâm"],
    },
    {
      columns: [
        "An Giang",
        "Phú Quốc",
        "Phường Dương Đông, Phường An Thới, Xã Dương Tơ, Xã Hàm Ninh, Xã Cửa Dương, Xã Bãi Thơm, Xã Gành Dầu, Xã Cửa Cạn",
      ],
    },
    {
      columns: [
        "An Giang",
        "Phú Tân",
        "Thị trấn Phú Mỹ, Xã Tân Hòa (huyện Phú Tân), Xã Tân Trung, Xã Phú Hưng",
      ],
    },
    {
      columns: [
        "An Giang",
        "Rạch Giá",
        "Phường Vĩnh Quang, Phường Vĩnh Thanh, Phường Vĩnh Thanh Vân, Phường Vĩnh Lạc, Phường An Hòa, Phường Vĩnh Hiệp, Phường An Bình, Phường Rạch Sỏi, Phường Vĩnh Lợi",
      ],
    },
    {
      columns: ["An Giang", "Sơn Hải", "Không sáp nhập"],
    },
    {
      columns: ["An Giang", "Sơn Kiên", "Xã Sơn Bình, Xã Mỹ Thái, Xã Sơn Kiên"],
    },
    {
      columns: ["An Giang", "Tân An", "Xã Tân An, Xã Tân Thạnh (thị xã Tân Châu), Xã Long An"],
    },
    {
      columns: ["An Giang", "Tân Châu", "Phường Long Thạnh, Phường Long Sơn"],
    },
    {
      columns: [
        "An Giang",
        "Tân Hiệp",
        "Thị trấn Tân Hiệp, Xã Tân Hiệp B, Xã Thạnh Đông B, Xã Thạnh Đông",
      ],
    },
    {
      columns: [
        "An Giang",
        "Tân Hội",
        "Xã Tân Hòa, Xã Tân An (huyện Tân Hiệp), Xã Tân Thành, Xã Tân Hội",
      ],
    },
    {
      columns: ["An Giang", "Tân Thạnh", "Xã Tân Thạnh (huyện An Minh), Xã Thuận Hòa"],
    },
    {
      columns: ["An Giang", "Tây Phú", "Xã An Bình, Xã Mỹ Phú Đông, Xã Tây Phú"],
    },
    {
      columns: ["An Giang", "Tây Yên", "Xã Tây Yên A, Xã Nam Yên, Xã Tây Yên"],
    },
    {
      columns: ["An Giang", "Thạnh Đông", "Xã Tân Hiệp A, Xã Thạnh Trị, Xã Thạnh Đông A"],
    },
    {
      columns: [
        "An Giang",
        "Thạnh Hưng",
        "Xã Thạnh Lộc (huyện Giồng Riềng), Xã Thạnh Phước, Xã Thạnh Hưng",
      ],
    },
    {
      columns: [
        "An Giang",
        "Thạnh Lộc",
        "Xã Thạnh Lộc (huyện Châu Thành), Xã Mong Thọ, Xã Mong Thọ A, Xã Mong Thọ B",
      ],
    },
    {
      columns: ["An Giang", "Thạnh Mỹ Tây", "Xã Đào Hữu Cảnh, Xã Ô Long Vĩ, Xã Thạnh Mỹ Tây"],
    },
    {
      columns: ["An Giang", "Thoại Sơn", "Thị trấn Núi Sập, Xã Thoại Giang, Xã Bình Thành"],
    },
    {
      columns: ["An Giang", "Thổ Châu", "Xã Thổ Châu"],
    },
    {
      columns: ["An Giang", "Thới Sơn", "Phường Nhơn Hưng, Phường Nhà Bàng, Phường Thới Sơn"],
    },
    {
      columns: ["An Giang", "Tiên Hải", "Không sáp nhập"],
    },
    {
      columns: ["An Giang", "Tịnh Biên", "Phường An Phú, Phường Tịnh Biên, Xã An Nông"],
    },
    {
      columns: ["An Giang", "Tô Châu", "Phường Tô Châu, Xã Thuận Yên, Xã Dương Hòa"],
    },
    {
      columns: ["An Giang", "Tri Tôn", "Thị trấn Tri Tôn, Xã Núi Tô, Xã Châu Lăng"],
    },
    {
      columns: ["An Giang", "U Minh Thượng", "Xã An Minh Bắc, Xã Minh Thuận"],
    },
    {
      columns: ["An Giang", "Vân Khánh", "Xã Vân Khánh Tây, Xã Vân Khánh"],
    },
    {
      columns: ["An Giang", "Vĩnh An", "Thị trấn Vĩnh Bình, Xã Tân Phú, Xã Vĩnh An"],
    },
    {
      columns: ["An Giang", "Vĩnh Bình", "Xã Vĩnh Bình Bắc, Xã Vĩnh Bình Nam, Xã Bình Minh"],
    },
    {
      columns: ["An Giang", "Vĩnh Điều", "Xã Vĩnh Phú (huyện Giang Thành), Xã Vĩnh Điều"],
    },
    {
      columns: ["An Giang", "Vĩnh Gia", "Xã Vĩnh Phước, Xã Lương An Trà, Xã Vĩnh Gia"],
    },
    {
      columns: ["An Giang", "Vĩnh Hanh", "Xã Vĩnh Nhuận, Xã Vĩnh Hanh"],
    },
    {
      columns: ["An Giang", "Vĩnh Hậu", "Thị trấn Đa Phước, Xã Vĩnh Trường, Xã Vĩnh Hậu"],
    },
    {
      columns: [
        "An Giang",
        "Vĩnh Hòa",
        "Xã Vĩnh Hòa (huyện U Minh Thượng), Xã Thạnh Yên A, Xã Hòa Chánh, Xã Thạnh Yên",
      ],
    },
    {
      columns: ["An Giang", "Vĩnh Hòa Hưng", "Xã Vĩnh Hòa Hưng Bắc, Xã Vĩnh Hòa Hưng Nam"],
    },
    {
      columns: ["An Giang", "Vĩnh Phong", "Thị trấn Vĩnh Thuận, Xã Phong Đông, Xã Vĩnh Phong"],
    },
    {
      columns: [
        "An Giang",
        "Vĩnh Tế",
        "Phường Núi Sam, Xã Vĩnh Tế, Xã Vĩnh Châu (phần còn lại sau khi sáp nhập vào phường Châu Đốc)",
      ],
    },
    {
      columns: ["An Giang", "Vĩnh Thạnh Trung", "Thị trấn Vĩnh Thạnh Trung, Xã Mỹ Phú"],
    },
    {
      columns: ["An Giang", "Vĩnh Thông", "Phường Vĩnh Thông, Xã Phi Thông, Xã Mỹ Lâm"],
    },
    {
      columns: ["An Giang", "Vĩnh Thuận", "Xã Tân Thuận, Xã Vĩnh Thuận"],
    },
    {
      columns: ["An Giang", "Vĩnh Trạch", "Xã Vĩnh Khánh, Xã Vĩnh Trạch"],
    },
    {
      columns: ["An Giang", "Vĩnh Tuy", "Xã Vĩnh Thắng, Xã Vĩnh Phước A, Xã Vĩnh Tuy"],
    },
    {
      columns: [
        "An Giang",
        "Vĩnh Xương",
        "Xã Vĩnh Hòa (thị xã Tân Châu), Xã Phú Lộc, Xã Vĩnh Xương",
      ],
    },
    {
      columns: ["Bắc Ninh", "An Lạc", "Xã Lệ Viễn, Xã An Lạc"],
    },
    {
      columns: ["Bắc Ninh", "Bảo Đài", "Xã Bảo Sơn, Xã Thanh Lâm, Xã Tam Dị, Xã Bảo Đài"],
    },
    {
      columns: [
        "Bắc Ninh",
        "Bắc Giang",
        "Phường Thọ Xương, Phường Ngô Quyền, Phường Xương Giang, Phường Hoàng Văn Thụ, Phường Trần Phú, Phường Dĩnh Kế, Phường Dĩnh Trì",
      ],
    },
    {
      columns: ["Bắc Ninh", "Bắc Lũng", "Xã Yên Sơn, Xã Lan Mẫu, Xã Khám Lạng, Xã Bắc Lũng"],
    },
    {
      columns: ["Bắc Ninh", "Biển Động", "Thị trấn Biển Động, Xã Kim Sơn, Xã Phú Nhuận"],
    },
    {
      columns: ["Bắc Ninh", "Biên Sơn", "Xã Phong Vân, Xã Biên Sơn, Trường bắn TB1"],
    },
    {
      columns: ["Bắc Ninh", "Bố Hạ", "Thị trấn Bố Hạ, Xã Đông Sơn, Xã Hương Vĩ"],
    },
    {
      columns: ["Bắc Ninh", "Bồng Lai", "Phường Cách Bi, Phường Bồng Lai, Xã Mộ Đạo"],
    },
    {
      columns: ["Bắc Ninh", "Cảnh Thụy", "Phường Cảnh Thụy, Xã Tiến Dũng, Xã Tư Mại"],
    },
    {
      columns: ["Bắc Ninh", "Cao Đức", "Xã Vạn Ninh, Xã Cao Đức"],
    },
    {
      columns: ["Bắc Ninh", "Cẩm Lý", "Xã Đan Hội, Xã Cẩm Lý"],
    },
    {
      columns: ["Bắc Ninh", "Chi Lăng", "Xã Yên Giả, Xã Chi Lăng"],
    },
    {
      columns: [
        "Bắc Ninh",
        "Chũ",
        "Phường Thanh Hải, Phường Hồng Giang, Phường Trù Hựu, Phường Chũ",
      ],
    },
    {
      columns: ["Bắc Ninh", "Dương Hưu", "Xã Long Sơn, Xã Dương Hưu"],
    },
    {
      columns: [
        "Bắc Ninh",
        "Đa Mai",
        "Phường Tân Mỹ, Phường Mỹ Độ, Phường Song Mai, Phường Đa Mai, Xã Quế Nham",
      ],
    },
    {
      columns: ["Bắc Ninh", "Đại Đồng", "Xã Tri Phương, Xã Hoàn Sơn, Xã Đại Đồng"],
    },
    {
      columns: ["Bắc Ninh", "Đại Lai", "Xã Song Giang, Xã Đại Lai"],
    },
    {
      columns: ["Bắc Ninh", "Đại Sơn", "Xã Giáo Liêm, Xã Phúc Sơn, Xã Đại Sơn"],
    },
    {
      columns: ["Bắc Ninh", "Đào Viên", "Phường Phù Lương, Xã Ngọc Xá, Xã Đào Viên"],
    },
    {
      columns: ["Bắc Ninh", "Đèo Gia", "Xã Tân Lập, Xã Đèo Gia"],
    },
    {
      columns: ["Bắc Ninh", "Đông Cứu", "Xã Giang Sơn, Xã Lãng Ngâm, Xã Đông Cứu"],
    },
    {
      columns: ["Bắc Ninh", "Đồng Kỳ", "Xã Đồng Hưu, Xã Đồng Vương, Xã Đồng Kỳ"],
    },
    {
      columns: ["Bắc Ninh", "Đồng Nguyên", "Phường Trang Hạ, Phường Đồng Kỵ, Phường Đồng Nguyên"],
    },
    {
      columns: ["Bắc Ninh", "Đông Phú", "Xã Đông Hưng, Xã Đông Phú"],
    },
    {
      columns: ["Bắc Ninh", "Đồng Việt", "Xã Đức Giang, Xã Đồng Phúc, Xã Đồng Việt"],
    },
    {
      columns: ["Bắc Ninh", "Gia Bình", "Thị trấn Gia Bình, Xã Xuân Lai, Xã Quỳnh Phú, Xã Đại Bái"],
    },
    {
      columns: ["Bắc Ninh", "Hạp Lĩnh", "Phường Khắc Niệm, Phường Hạp Lĩnh"],
    },
    {
      columns: [
        "Bắc Ninh",
        "Hiệp Hòa",
        "Thị trấn Thắng, Xã Đông Lỗ, Xã Đoan Bái, Xã Danh Thắng, Xã Lương Phong",
      ],
    },
    {
      columns: [
        "Bắc Ninh",
        "Hoàng Vân",
        "Xã Đồng Tiến (huyện Hiệp Hòa), Xã Toàn Thắng, Xã Ngọc Sơn, Xã Hoàng Vân",
      ],
    },
    {
      columns: [
        "Bắc Ninh",
        "Hợp Thịnh",
        "Xã Thường Thắng, Xã Mai Trung, Xã Hùng Thái, Xã Sơn Thịnh, Xã Hợp Thịnh",
      ],
    },
    {
      columns: ["Bắc Ninh", "Kép", "Thị trấn Kép, Xã Quang Thịnh, Xã Hương Sơn"],
    },
    {
      columns: ["Bắc Ninh", "Kiên Lao", "Xã Kiên Thành, Xã Kiên Lao"],
    },
    {
      columns: [
        "Bắc Ninh",
        "Kinh Bắc",
        "Phường Suối Hoa, Phường Tiền Ninh Vệ, Phường Vạn An, Phường Hòa Long, Phường Khúc Xuyên, Phường Kinh Bắc",
      ],
    },
    {
      columns: ["Bắc Ninh", "Lạng Giang", "Thị trấn Vôi, Xã Xương Lâm, Xã Hương Lạc, Xã Tân Hưng"],
    },
    {
      columns: ["Bắc Ninh", "Lâm Thao", "Xã Bình Định, Xã Quảng Phú, Xã Lâm Thao"],
    },
    {
      columns: ["Bắc Ninh", "Liên Bão", "Xã Hiên Vân, Xã Việt Đoàn, Xã Liên Bão"],
    },
    {
      columns: [
        "Bắc Ninh",
        "Lục Nam",
        "Thị trấn Phương Sơn, Thị trấn Đồi Ngô, Xã Cương Sơn, Xã Tiên Nha, Xã Chu Điện",
      ],
    },
    {
      columns: [
        "Bắc Ninh",
        "Lục Ngạn",
        "Thị trấn Phì Điền, Xã Giáp Sơn, Xã Đồng Cốc, Xã Tân Hoa, Xã Tân Quang",
      ],
    },
    {
      columns: ["Bắc Ninh", "Lục Sơn", "Xã Bình Sơn, Xã Lục Sơn"],
    },
    {
      columns: ["Bắc Ninh", "Lương Tài", "Thị trấn Thứa, Xã Phú Hòa, Xã Tân Lãng"],
    },
    {
      columns: ["Bắc Ninh", "Mão Điền", "Phường An Bình, Xã Hoài Thượng, Xã Mão Điền"],
    },
    {
      columns: ["Bắc Ninh", "Mỹ Thái", "Xã Xuân Hương, Xã Dương Đức, Xã Tân Thanh, Xã Mỹ Thái"],
    },
    {
      columns: ["Bắc Ninh", "Nam Dương", "Xã Tân Mộc, Xã Nam Dương"],
    },
    {
      columns: ["Bắc Ninh", "Nam Sơn", "Phường Vân Dương, Phường Nam Sơn"],
    },
    {
      columns: [
        "Bắc Ninh",
        "Nếnh",
        "Phường Quang Châu, Phường Vân Trung, Phường Tăng Tiến, Phường Nếnh",
      ],
    },
    {
      columns: ["Bắc Ninh", "Nghĩa Phương", "Xã Trường Giang, Xã Huyền Sơn, Xã Nghĩa Phương"],
    },
    {
      columns: [
        "Bắc Ninh",
        "Ngọc Thiện",
        "Xã Song Vân, Xã Ngọc Châu, Xã Ngọc Vân, Xã Việt Ngọc, Xã Ngọc Thiện",
      ],
    },
    {
      columns: ["Bắc Ninh", "Nhã Nam", "Thị trấn Nhã Nam, Xã Tân Trung, Xã Liên Sơn, Xã An Dương"],
    },
    {
      columns: ["Bắc Ninh", "Nhân Hòa", "Phường Đại Xuân, Phường Nhân Hòa, Xã Việt Thống"],
    },
    {
      columns: ["Bắc Ninh", "Nhân Thắng", "Thị trấn Nhân Thắng, Xã Thái Bảo, Xã Bình Dương"],
    },
    {
      columns: ["Bắc Ninh", "Ninh Xá", "Phường Ninh Xá, Xã Nguyệt Đức"],
    },
    {
      columns: ["Bắc Ninh", "Phật Tích", "Xã Minh Đạo, Xã Cảnh Hưng, Xã Phật Tích"],
    },
    {
      columns: ["Bắc Ninh", "Phù Khê", "Phường Châu Khê, Phường Hương Mạc, Phường Phù Khê"],
    },
    {
      columns: ["Bắc Ninh", "Phù Lãng", "Xã Châu Phong, Xã Đức Long, Xã Phù Lãng"],
    },
    {
      columns: ["Bắc Ninh", "Phúc Hoà", "Xã Hợp Đức, Xã Liên Chung, Xã Phúc Hòa"],
    },
    {
      columns: ["Bắc Ninh", "Phương Liễu", "Phường Phượng Mao, Phường Phương Liễu"],
    },
    {
      columns: ["Bắc Ninh", "Phượng Sơn", "Phường Phượng Sơn, Xã Quý Sơn, Xã Mỹ An"],
    },
    {
      columns: ["Bắc Ninh", "Quang Trung", "Xã Lam Sơn, Xã Quang Trung"],
    },
    {
      columns: [
        "Bắc Ninh",
        "Quế Võ",
        "Phường Phố Mới, Phường Bằng An, Phường Việt Hùng, Phường Quế Tân",
      ],
    },
    {
      columns: ["Bắc Ninh", "Sa Lý", "Xã Phong Minh, Xã Sa Lý"],
    },
    {
      columns: [
        "Bắc Ninh",
        "Song Liễu",
        "Phường Xuân Lâm, Phường Hà Mãn, Xã Ngũ Thái, Xã Song Liễu",
      ],
    },
    {
      columns: ["Bắc Ninh", "Sơn Động", "Thị trấn An Châu, Xã An Bá, Xã Vĩnh An"],
    },
    {
      columns: ["Bắc Ninh", "Sơn Hải", "Xã Hộ Đáp, Xã Sơn Hải"],
    },
    {
      columns: ["Bắc Ninh", "Tam Đa", "Xã Thụy Hòa, Xã Đông Phong, Xã Tam Đa"],
    },
    {
      columns: ["Bắc Ninh", "Tam Giang", "Xã Hòa Tiến, Xã Tam Giang"],
    },
    {
      columns: ["Bắc Ninh", "Tam Sơn", "Phường Tương Giang, Phường Tam Sơn"],
    },
    {
      columns: ["Bắc Ninh", "Tam Tiến", "Xã Tiến Thắng, Xã An Thượng, Xã Tam Tiến"],
    },
    {
      columns: ["Bắc Ninh", "Tân An", "Phường Tân An, Xã Quỳnh Sơn, Xã Trí Yên, Xã Lãng Sơn"],
    },
    {
      columns: ["Bắc Ninh", "Tân Chi", "Xã Lạc Vệ, Xã Tân Chi"],
    },
    {
      columns: ["Bắc Ninh", "Tân Dĩnh", "Xã Tân Dĩnh, Xã Thái Đào, Xã Đại Lâm"],
    },
    {
      columns: ["Bắc Ninh", "Tân Sơn", "Xã Cấm Sơn, Xã Tân Sơn"],
    },
    {
      columns: ["Bắc Ninh", "Tân Tiến", "Phường Hương Gián, Phường Tân Tiến, Xã Xuân Phú"],
    },
    {
      columns: ["Bắc Ninh", "Tân Yên", "Thị trấn Cao Thượng, Xã Cao Xá, Xã Việt Lập, Xã Ngọc Lý"],
    },
    {
      columns: ["Bắc Ninh", "Tây Yên Tử", "Thị trấn Tây Yên Tử, Xã Thanh Luận"],
    },
    {
      columns: [
        "Bắc Ninh",
        "Thuận Thành",
        "Phường Hồ, Phường Song Hồ, Phường Gia Đông, Xã Đại Đồng Thành",
      ],
    },
    {
      columns: ["Bắc Ninh", "Tiên Du", "Thị trấn Lim, Xã Nội Duệ, Xã Phú Lâm"],
    },
    {
      columns: [
        "Bắc Ninh",
        "Tiên Lục",
        "Xã Đào Mỹ, Xã Nghĩa Hòa, Xã An Hà, Xã Nghĩa Hưng, Xã Tiên Lục",
      ],
    },
    {
      columns: [
        "Bắc Ninh",
        "Tiền Phong",
        "Phường Nội Hoàng, Phường Song Khê, Phường Đồng Sơn, Phường Tiền Phong",
      ],
    },
    {
      columns: ["Bắc Ninh", "Trạm Lộ", "Phường Trạm Lộ, Xã Nghĩa Đạo"],
    },
    {
      columns: ["Bắc Ninh", "Trí Quả", "Phường Thanh Khương, Phường Trí Quả, Xã Đình Tổ"],
    },
    {
      columns: ["Bắc Ninh", "Trung Chính", "Xã Phú Lương, Xã Quang Minh, Xã Trung Chính"],
    },
    {
      columns: ["Bắc Ninh", "Trung Kênh", "Xã An Thịnh, Xã An Tập, Xã Trung Kênh"],
    },
    {
      columns: ["Bắc Ninh", "Trường Sơn", "Xã Vô Tranh, Xã Trường Sơn"],
    },
    {
      columns: ["Bắc Ninh", "Tuấn Đạo", "Không sáp nhập"],
    },
    {
      columns: ["Bắc Ninh", "Tự Lạn", "Phường Tự Lạn, Xã Việt Tiến, Xã Thượng Lan, Xã Hương Mai"],
    },
    {
      columns: [
        "Bắc Ninh",
        "Từ Sơn",
        "Phường Đông Ngàn, Phường Tân Hồng, Phường Phù Chẩn, Phường Đình Bảng",
      ],
    },
    {
      columns: ["Bắc Ninh", "Văn Môn", "Xã Yên Phụ, Xã Đông Thọ, Xã Văn Môn"],
    },
    {
      columns: [
        "Bắc Ninh",
        "Vân Hà",
        "Phường Ninh Sơn, Phường Quảng Minh, Xã Tiên Sơn, Xã Trung Sơn, Xã Vân Hà",
      ],
    },
    {
      columns: ["Bắc Ninh", "Vân Sơn", "Xã Hữu Sản, Xã Vân Sơn"],
    },
    {
      columns: [
        "Bắc Ninh",
        "Việt Yên",
        "Phường Bích Động, Phường Hồng Thái, Xã Minh Đức, Xã Nghĩa Trung",
      ],
    },
    {
      columns: ["Bắc Ninh", "Võ Cường", "Phường Đại Phúc, Phường Phong Khê, Phường Võ Cường"],
    },
    {
      columns: [
        "Bắc Ninh",
        "Vũ Ninh",
        "Phường Kim Chân, Phường Đáp Cầu, Phường Thị Cầu, Phường Vũ Ninh",
      ],
    },
    {
      columns: [
        "Bắc Ninh",
        "Xuân Cẩm",
        "Thị trấn Bắc Lý, Xã Hương Lâm, Xã Mai Đình, Xã Châu Minh, Xã Xuân Cẩm",
      ],
    },
    {
      columns: [
        "Bắc Ninh",
        "Xuân Lương",
        "Xã Đồng Tiến (huyện Yên Thế), Xã Canh Nậu, Xã Xuân Lương",
      ],
    },
    {
      columns: ["Bắc Ninh", "Yên Dũng", "Phường Tân Liễu, Phường Nham Biền, Xã Yên Lư"],
    },
    {
      columns: ["Bắc Ninh", "Yên Định", "Xã Cẩm Đàn, Xã Yên Định"],
    },
    {
      columns: [
        "Bắc Ninh",
        "Yên Phong",
        "Thị trấn Chờ, Xã Trung Nghĩa, Xã Long Châu, Xã Đông Tiến",
      ],
    },
    {
      columns: [
        "Bắc Ninh",
        "Yên Thế",
        "Thị trấn Phồn Xương, Xã Đồng Lạc, Xã Đồng Tâm, Xã Tân Hiệp, Xã Tân Sỏi",
      ],
    },
    {
      columns: ["Bắc Ninh", "Yên Trung", "Xã Dũng Liệt, Xã Yên Trung"],
    },
    {
      columns: ["Cà Mau", "An Trạch", "Xã An Trạch A, Xã An Trạch"],
    },
    {
      columns: [
        "Cà Mau",
        "An Xuyên",
        "Phường 1 (thành phố Cà Mau), Phường 2 (thành phố Cà Mau), Phường 9, Phường Tân Xuyên, Xã An Xuyên",
      ],
    },
    {
      columns: [
        "Cà Mau",
        "Bạc Liêu",
        "Phường 1 (thành phố Bạc Liêu), Phường 2 (thành phố Bạc Liêu), Phường 7 (thành phố Bạc Liêu), Phường 8 (thành phố Bạc Liêu), Phường 3",
      ],
    },
    {
      columns: ["Cà Mau", "Biển Bạch", "Xã Tân Bằng, Xã Biển Bạch Đông, Xã Biển Bạch"],
    },
    {
      columns: ["Cà Mau", "Cái Đôi Vàm", "Thị trấn Cái Đôi Vàm, Xã Nguyễn Việt Khái"],
    },
    {
      columns: [
        "Cà Mau",
        "Cái Nước",
        "Thị trấn Cái Nước, Xã Trần Thới, Xã Đông Hưng (phần còn lại), Xã Đông Thới (phần còn lại), Xã Tân Hưng Đông (phần còn lại)",
      ],
    },
    {
      columns: ["Cà Mau", "Châu Thới", "Xã Vĩnh Hưng, Xã Vĩnh Hưng A, Xã Châu Thới"],
    },
    {
      columns: [
        "Cà Mau",
        "Đá Bạc",
        "Xã Khánh Bình Tây (bao gồm Hòn Đá Bạc), Xã Khánh Bình Tây Bắc, Xã Trần Hợi (một phần)",
      ],
    },
    {
      columns: [
        "Cà Mau",
        "Đầm Dơi",
        "Thị trấn Đầm Dơi, Xã Tân Duyệt, Xã Tân Dân, Xã Tạ An Khương (phần còn lại sau khi sáp nhập vào xã Tạ An Khương mới)",
      ],
    },
    {
      columns: [
        "Cà Mau",
        "Đất Mới",
        "Xã Lâm Hải, Xã Đất Mới, Thị trấn Năm Căn, Xã Hàm Rồng, Xã Viên An (phần còn lại sau khi sáp nhập vào xã Đất Mũi)",
      ],
    },
    {
      columns: [
        "Cà Mau",
        "Đất Mũi",
        "Xã Đất Mũi, Xã Viên An, Xã Tân Ân (phần còn lại sau khi sáp nhập vào xã Phan Ngọc Hiển)",
      ],
    },
    {
      columns: ["Cà Mau", "Định Thành", "Xã An Phúc, Xã Định Thành A, Xã Định Thành"],
    },
    {
      columns: ["Cà Mau", "Đông Hải", "Xã Long Điền Đông, Xã Long Điền Đông A"],
    },
    {
      columns: ["Cà Mau", "Gành Hào", "Thị trấn Gành Hào, Xã Long Điền Tây"],
    },
    {
      columns: [
        "Cà Mau",
        "Giá Rai",
        "Phường 1 (thị xã Giá Rai), Phường Hộ Phòng, Xã Phong Thạnh, Xã Phong Thạnh A",
      ],
    },
    {
      columns: ["Cà Mau", "Hiệp Thành", "Phường Nhà Mát, Xã Vĩnh Trạch Đông, Xã Hiệp Thành"],
    },
    {
      columns: ["Cà Mau", "Hoà Bình", "Thị trấn Hòa Bình, Xã Vĩnh Mỹ A, Xã Long Thạnh"],
    },
    {
      columns: [
        "Cà Mau",
        "Hoà Thành",
        "Xã Hòa Tân, Xã Hòa Thành, Phường 7 (thành phố Cà Mau) (phần còn lại sau khi sáp nhập vào phường Tân Thành), Phường 6 (phần còn lại sau khi sáp nhập vào phường Tân Thành), Xã Định Bình (phần còn lại sau khi sáp nhập vào phường Tân Thành), Xã Tắc Vân (phần còn lại sau khi sáp nhập vào phường Tân Thành)",
      ],
    },
    {
      columns: ["Cà Mau", "Hồ Thị Kỷ", "Không sáp nhập"],
    },
    {
      columns: ["Cà Mau", "Hồng Dân", "Thị trấn Ngan Dừa, Xã Lộc Ninh, Xã Ninh Hòa"],
    },
    {
      columns: ["Cà Mau", "Hưng Hội", "Xã Hưng Thành, Xã Hưng Hội"],
    },
    {
      columns: [
        "Cà Mau",
        "Hưng Mỹ",
        "Xã Hưng Mỹ, Xã Tân Hưng Đông, Xã Hòa Mỹ (phần còn lại sau khi sáp nhập vào xã Phú Mỹ, xã Tân Hưng)",
      ],
    },
    {
      columns: [
        "Cà Mau",
        "Khánh An",
        "Xã Khánh An, Xã Nguyễn Phích (phần còn lại sau khi sáp nhập vào xã Nguyễn Phích, xã Khánh Lâm)",
      ],
    },
    {
      columns: ["Cà Mau", "Khánh Bình", "Xã Khánh Bình Đông, Xã Khánh Bình"],
    },
    {
      columns: ["Cà Mau", "Khánh Hưng", "Xã Khánh Hải, Xã Khánh Hưng"],
    },
    {
      columns: [
        "Cà Mau",
        "Khánh Lâm",
        "Xã Khánh Hội, Xã Nguyễn Phích, Xã Khánh Lâm (phần còn lại sau khi sáp nhập vào xã U Minh)",
      ],
    },
    {
      columns: ["Cà Mau", "Láng Tròn", "Phường Láng Tròn, Xã Phong Tân, Xã Phong Thạnh Đông"],
    },
    {
      columns: ["Cà Mau", "Long Điền", "Xã Điền Hải, Xã Long Điền"],
    },
    {
      columns: [
        "Cà Mau",
        "Lương Thế Trân",
        "Xã Thạnh Phú, Xã Phú Hưng, Xã Lương Thế Trân, Xã Lợi An",
      ],
    },
    {
      columns: [
        "Cà Mau",
        "Lý Văn Lâm",
        "Phường 8 (thành phố Cà Mau), Xã Lý Văn Lâm, Xã Lợi An (phần còn lại sau khi sáp nhập vào xã Trần Văn Thời, xã Lương Thế Trân)",
      ],
    },
    {
      columns: [
        "Cà Mau",
        "Năm Căn",
        "Xã Hàng Vịnh, Thị trấn Năm Căn (phần còn lại), Xã Hàm Rồng (phần còn lại)",
      ],
    },
    {
      columns: [
        "Cà Mau",
        "Nguyễn Phích",
        "Thị trấn U Minh, Xã Nguyễn Phích, Xã Khánh Thuận (phần còn lại sau khi sáp nhập vào xã U Minh)",
      ],
    },
    {
      columns: ["Cà Mau", "Nguyễn Việt Khái", "Xã Tân Hưng Tây, Xã Rạch Chèo, Xã Việt Thắng"],
    },
    {
      columns: ["Cà Mau", "Ninh Quới", "Xã Ninh Quới A, Xã Ninh Quới"],
    },
    {
      columns: ["Cà Mau", "Ninh Thạnh Lợi", "Xã Ninh Thạnh Lợi A, Xã Ninh Thạnh Lợi"],
    },
    {
      columns: ["Cà Mau", "Phan Ngọc Hiển", "Thị trấn Rạch Gốc, Xã Viên An Đông, Xã Tân Ân"],
    },
    {
      columns: ["Cà Mau", "Phong Hiệp", "Xã Phong Thạnh Tây A, Xã Phong Thạnh Tây B"],
    },
    {
      columns: ["Cà Mau", "Phong Thạnh", "Xã Tân Thạnh, Xã Phong Thạnh Tây, Xã Tân Phong"],
    },
    {
      columns: ["Cà Mau", "Phú Mỹ", "Xã Phú Thuận, Xã Phú Mỹ, Xã Hòa Mỹ"],
    },
    {
      columns: ["Cà Mau", "Phú Tân", "Xã Tân Hải, Xã Phú Tân"],
    },
    {
      columns: ["Cà Mau", "Phước Long", "Thị trấn Phước Long, Xã Vĩnh Phú Đông"],
    },
    {
      columns: ["Cà Mau", "Quách Phẩm", "Xã Quách Phẩm Bắc, Xã Quách Phẩm"],
    },
    {
      columns: [
        "Cà Mau",
        "Sông Đốc",
        "Thị trấn Sông Đốc (bao gồm cụm đảo Hòn Chuối), Xã Phong Điền",
      ],
    },
    {
      columns: [
        "Cà Mau",
        "Tạ An Khương",
        "Xã Tạ An Khương Đông, Xã Tạ An Khương Nam, Xã Tạ An Khương",
      ],
    },
    {
      columns: ["Cà Mau", "Tam Giang", "Xã Hiệp Tùng, Xã Tam Giang Đông, Xã Tam Giang"],
    },
    {
      columns: ["Cà Mau", "Tân Ân", "Xã Tam Giang Tây, Xã Tân Ân Tây"],
    },
    {
      columns: ["Cà Mau", "Tân Hưng", "Xã Tân Hưng, Xã Đông Hưng, Xã Đông Thới, Xã Hòa Mỹ"],
    },
    {
      columns: ["Cà Mau", "Tân Lộc", "Xã Tân Lộc Bắc, Xã Tân Lộc Đông, Xã Tân Lộc"],
    },
    {
      columns: [
        "Cà Mau",
        "Tân Thành",
        "Phường 5 (thành phố Cà Mau), Phường Tân Thành, Xã Tân Thành, Phường 7 (thành phố Cà Mau), Phường 6, Xã Định Bình, Xã Tắc Vân",
      ],
    },
    {
      columns: ["Cà Mau", "Tân Thuận", "Xã Tân Đức, Xã Tân Thuận"],
    },
    {
      columns: ["Cà Mau", "Tân Tiến", "Xã Nguyễn Huân, Xã Tân Tiến"],
    },
    {
      columns: ["Cà Mau", "Thanh Tùng", "Xã Ngọc Chánh, Xã Thanh Tùng"],
    },
    {
      columns: ["Cà Mau", "Thới Bình", "Thị trấn Thới Bình, Xã Thới Bình"],
    },
    {
      columns: ["Cà Mau", "Trần Phán", "Xã Tân Trung, Xã Trần Phán"],
    },
    {
      columns: [
        "Cà Mau",
        "Trần Văn Thời",
        "Thị trấn Trần Văn Thời, Xã Khánh Lộc, Xã Phong Lạc, Xã Lợi An, Xã Trần Hợi (phần còn lại sau khi sáp nhập vào xã Đá Bạc), Xã Phong Điền (phần còn lại sau khi sáp nhập vào xã Sông Đốc)",
      ],
    },
    {
      columns: ["Cà Mau", "Trí Phải", "Xã Trí Lực, Xã Tân Phú, Xã Trí Phải"],
    },
    {
      columns: ["Cà Mau", "U Minh", "Xã Khánh Tiến, Xã Khánh Hòa, Xã Khánh Thuận, Xã Khánh Lâm"],
    },
    {
      columns: ["Cà Mau", "Vĩnh Hậu", "Xã Vĩnh Thịnh, Xã Vĩnh Hậu A, Xã Vĩnh Hậu"],
    },
    {
      columns: ["Cà Mau", "Vĩnh Lộc", "Xã Vĩnh Lộc A, Xã Vĩnh Lộc"],
    },
    {
      columns: ["Cà Mau", "Vĩnh Lợi", "Thị trấn Châu Hưng, Xã Châu Hưng A"],
    },
    {
      columns: ["Cà Mau", "Vĩnh Mỹ", "Xã Minh Diệu, Xã Vĩnh Bình, Xã Vĩnh Mỹ B"],
    },
    {
      columns: ["Cà Mau", "Vĩnh Phước", "Xã Phước Long, Xã Vĩnh Phú Tây"],
    },
    {
      columns: ["Cà Mau", "Vĩnh Thanh", "Xã Hưng Phú, Xã Vĩnh Thanh"],
    },
    {
      columns: ["Cà Mau", "Vĩnh Trạch", "Phường 5 (thành phố Bạc Liêu), Xã Vĩnh Trạch"],
    },
    {
      columns: ["Cao Bằng", "Bạch Đằng", "Xã Thịnh Vượng, Xã Bình Dương, Xã Bạch Đằng"],
    },
    {
      columns: ["Cao Bằng", "Bảo Lạc", "Thị trấn Bảo Lạc, Xã Bảo Toàn, Xã Hồng Trị"],
    },
    {
      columns: ["Cao Bằng", "Bảo Lâm", "Thị trấn Pác Miầu, Xã Mông Ân, Xã Vĩnh Phong"],
    },
    {
      columns: ["Cao Bằng", "Bế Văn Đàn", "Xã Hồng Quang, Xã Cách Linh, Xã Bế Văn Đàn"],
    },
    {
      columns: ["Cao Bằng", "Ca Thành", "Xã Yên Lạc, Xã Ca Thành"],
    },
    {
      columns: ["Cao Bằng", "Canh Tân", "Xã Đức Thông, Xã Canh Tân"],
    },
    {
      columns: ["Cao Bằng", "Cần Yên", "Xã Cần Nông, Xã Lương Thông, Xã Cần Yên"],
    },
    {
      columns: ["Cao Bằng", "Cô Ba", "Xã Thượng Hà, Xã Cô Ba"],
    },
    {
      columns: ["Cao Bằng", "Cốc Pàng", "Xã Đức Hạnh, Xã Cốc Pàng"],
    },
    {
      columns: ["Cao Bằng", "Đàm Thủy", "Xã Chí Viễn, Xã Phong Châu, Xã Đàm Thủy"],
    },
    {
      columns: ["Cao Bằng", "Đình Phong", "Xã Ngọc Côn, Xã Ngọc Khê, Xã Phong Nặm, Xã Đình Phong"],
    },
    {
      columns: ["Cao Bằng", "Đoài Dương", "Xã Trung Phúc, Xã Cao Thăng, Xã Đoài Dương"],
    },
    {
      columns: ["Cao Bằng", "Độc Lập", "Xã Quảng Hưng, Xã Cai Bộ, Xã Độc Lập"],
    },
    {
      columns: ["Cao Bằng", "Đông Khê", "Thị trấn Đông Khê, Xã Đức Xuân, Xã Trọng Con"],
    },
    {
      columns: ["Cao Bằng", "Đức Long", "Xã Đức Long (huyện Thạch An), Xã Thụy Hùng, Xã Lê Lợi"],
    },
    {
      columns: ["Cao Bằng", "Hạ Lang", "Thị trấn Thanh Nhật, Xã Thống Nhất, Xã Thị Hoa"],
    },
    {
      columns: ["Cao Bằng", "Hà Quảng", "Xã Hồng Sỹ, Xã Ngọc Đào, Xã Mã Ba"],
    },
    {
      columns: ["Cao Bằng", "Hạnh Phúc", "Xã Ngọc Động (huyện Quảng Hòa), Xã Tự Do, Xã Hạnh Phúc"],
    },
    {
      columns: ["Cao Bằng", "Hòa An", "Thị trấn Nước Hai, Xã Đại Tiến, Xã Hồng Việt"],
    },
    {
      columns: ["Cao Bằng", "Huy Giáp", "Xã Đình Phùng, Xã Huy Giáp"],
    },
    {
      columns: ["Cao Bằng", "Hưng Đạo", "Xã Hưng Thịnh, Xã Kim Cúc, Xã Hưng Đạo (huyện Bảo Lạc)"],
    },
    {
      columns: ["Cao Bằng", "Khánh Xuân", "Xã Phan Thanh (huyện Bảo Lạc), Xã Khánh Xuân"],
    },
    {
      columns: ["Cao Bằng", "Kim Đồng", "Xã Hồng Nam, Xã Thái Cường, Xã Kim Đồng"],
    },
    {
      columns: ["Cao Bằng", "Lũng Nặm", "Xã Thượng Thôn, Xã Lũng Nặm"],
    },
    {
      columns: ["Cao Bằng", "Lý Bôn", "Xã Vĩnh Quang (huyện Bảo Lâm), Xã Lý Bôn"],
    },
    {
      columns: ["Cao Bằng", "Lý Quốc", "Xã Minh Long, Xã Đồng Loan, Xã Lý Quốc"],
    },
    {
      columns: ["Cao Bằng", "Minh Khai", "Xã Quang Trọng, Xã Minh Khai"],
    },
    {
      columns: ["Cao Bằng", "Minh Tâm", "Xã Trương Lương, Xã Minh Tâm"],
    },
    {
      columns: ["Cao Bằng", "Nam Quang", "Xã Nam Cao, Xã Nam Quang"],
    },
    {
      columns: ["Cao Bằng", "Nam Tuấn", "Xã Đức Long (huyện Hòa An), Xã Dân Chủ, Xã Nam Tuấn"],
    },
    {
      columns: ["Cao Bằng", "Nguyên Bình", "Thị trấn Nguyên Bình, Xã Thể Dục, Xã Vũ Minh"],
    },
    {
      columns: [
        "Cao Bằng",
        "Nguyễn Huệ",
        "Xã Quang Trung (huyện Hòa An), Xã Ngũ Lão, Xã Nguyễn Huệ",
      ],
    },
    {
      columns: [
        "Cao Bằng",
        "Nùng Trí Cao",
        "Phường Ngọc Xuân, Phường Sông Bằng, Xã Vĩnh Quang (thành phố Cao Bằng)",
      ],
    },
    {
      columns: ["Cao Bằng", "Phan Thanh", "Xã Phan Thanh (huyện Nguyên Bình), Xã Mai Long"],
    },
    {
      columns: [
        "Cao Bằng",
        "Phục Hòa",
        "Thị trấn Tà Lùng, Thị trấn Hòa Thuận, Xã Mỹ Hưng, Xã Đại Sơn",
      ],
    },
    {
      columns: ["Cao Bằng", "Quang Hán", "Xã Quang Vinh, Xã Quang Hán"],
    },
    {
      columns: ["Cao Bằng", "Quảng Lâm", "Xã Thạch Lâm, Xã Quảng Lâm"],
    },
    {
      columns: ["Cao Bằng", "Quang Long", "Xã Đức Quang, Xã Thắng Lợi, Xã Quang Long"],
    },
    {
      columns: [
        "Cao Bằng",
        "Quang Trung",
        "Xã Quang Trung (huyện Trùng Khánh), Xã Tri Phương, Xã Xuân Nội",
      ],
    },
    {
      columns: [
        "Cao Bằng",
        "Quảng Uyên",
        "Thị trấn Quảng Uyên, Xã Phi Hải, Xã Phúc Sen, Xã Chí Thảo",
      ],
    },
    {
      columns: ["Cao Bằng", "Sơn Lộ", "Xã Sơn Lập, Xã Sơn Lộ"],
    },
    {
      columns: ["Cao Bằng", "Tam Kim", "Xã Hưng Đạo (huyện Nguyên Bình), Xã Hoa Thám, Xã Tam Kim"],
    },
    {
      columns: [
        "Cao Bằng",
        "Tân Giang",
        "Phường Tân Giang, Phường Duyệt Trung, Phường Hòa Chung, Xã Chu Trinh, Xã Lê Chung",
      ],
    },
    {
      columns: ["Cao Bằng", "Thạch An", "Xã Tiên Thành, Xã Vân Trình, Xã Lê Lai"],
    },
    {
      columns: ["Cao Bằng", "Thành Công", "Xã Quang Thành, Xã Thành Công"],
    },
    {
      columns: [
        "Cao Bằng",
        "Thanh Long",
        "Xã Ngọc Động (huyện Hà Quảng), Xã Yên Sơn, Xã Thanh Long",
      ],
    },
    {
      columns: ["Cao Bằng", "Thông Nông", "Thị trấn Thông Nông, Xã Đa Thông, Xã Lương Can"],
    },
    {
      columns: [
        "Cao Bằng",
        "Thục Phán",
        "Phường Sông Hiến, Phường Đề Thám, Phường Hợp Giang, Xã Hưng Đạo (thành phố Cao Bằng), Xã Hoàng Tung",
      ],
    },
    {
      columns: ["Cao Bằng", "Tĩnh Túc", "Thị trấn Tĩnh Túc, Xã Triệu Nguyên, Xã Vũ Nông"],
    },
    {
      columns: ["Cao Bằng", "Tổng Cọt", "Xã Nội Thôn, Xã Cải Viên, Xã Tổng Cọt"],
    },
    {
      columns: ["Cao Bằng", "Trà Lĩnh", "Thị trấn Trà Lĩnh, Xã Cao Chương, Xã Quốc Toản"],
    },
    {
      columns: [
        "Cao Bằng",
        "Trùng Khánh",
        "Thị trấn Trùng Khánh, Xã Đức Hồng, Xã Lăng Hiếu, Xã Khâm Thành",
      ],
    },
    {
      columns: ["Cao Bằng", "Trường Hà", "Thị trấn Xuân Hòa, Xã Quý Quân, Xã Sóc Hà, Xã Trường Hà"],
    },
    {
      columns: ["Cao Bằng", "Vinh Quý", "Xã Cô Ngân, Xã An Lạc, Xã Kim Loan, Xã Vinh Quý"],
    },
    {
      columns: ["Cao Bằng", "Xuân Trường", "Xã Hồng An, Xã Xuân Trường"],
    },
    {
      columns: ["Cao Bằng", "Yên Thổ", "Xã Thái Học, Xã Thái Sơn, Xã Yên Thổ"],
    },
    {
      columns: ["Cần Thơ", "An Bình", "Phường An Bình, Xã Mỹ Khánh, Phường Long Tuyền"],
    },
    {
      columns: ["Cần Thơ", "An Lạc Thôn", "Thị trấn An Lạc Thôn, Xã Xuân Hòa, Xã Trinh Phú"],
    },
    {
      columns: ["Cần Thơ", "An Ninh", "Xã An Hiệp, Xã An Ninh"],
    },
    {
      columns: [
        "Cần Thơ",
        "An Thạnh",
        "Thị trấn Cù Lao Dung, Xã An Thạnh 1, Xã An Thạnh Tây, Xã An Thạnh Đông",
      ],
    },
    {
      columns: [
        "Cần Thơ",
        "Bình Thủy",
        "Phường An Thới, Phường Bình Thủy, Phường Bùi Hữu Nghĩa (phần còn lại sau khi sáp nhập vào phường Cái Khế)",
      ],
    },
    {
      columns: ["Cần Thơ", "Cái Khế", "Phường An Hòa, Phường Cái Khế, Phường Bùi Hữu Nghĩa"],
    },
    {
      columns: [
        "Cần Thơ",
        "Cái Răng",
        "Phường Lê Bình, Phường Thường Thạnh, Phường Ba Láng, Phường Hưng Thạnh",
      ],
    },
    {
      columns: ["Cần Thơ", "Châu Thành", "Thị trấn Mái Dầm, Thị trấn Ngã Sáu, Xã Đông Phú"],
    },
    {
      columns: ["Cần Thơ", "Cờ Đỏ", "Thị trấn Cờ Đỏ, Xã Thới Đông, Xã Thới Xuân"],
    },
    {
      columns: [
        "Cần Thơ",
        "Cù Lao Dung",
        "Xã An Thạnh 2, Xã Đại Ân 1, Xã An Thạnh 3, Xã An Thạnh Nam",
      ],
    },
    {
      columns: ["Cần Thơ", "Đại Hải", "Xã Ba Trinh, Xã Đại Hải"],
    },
    {
      columns: ["Cần Thơ", "Đại Ngãi", "Thị trấn Đại Ngãi, Xã Long Đức"],
    },
    {
      columns: ["Cần Thơ", "Đại Thành", "Phường Hiệp Lợi, Xã Tân Thành, Xã Đại Thành"],
    },
    {
      columns: ["Cần Thơ", "Đông Hiệp", "Xã Đông Thắng, Xã Xuân Thắng, Xã Đông Hiệp"],
    },
    {
      columns: ["Cần Thơ", "Đông Phước", "Thị trấn Cái Tắc, Xã Đông Thạnh, Xã Đông Phước A"],
    },
    {
      columns: ["Cần Thơ", "Đông Thuận", "Xã Đông Bình, Xã Đông Thuận"],
    },
    {
      columns: ["Cần Thơ", "Gia Hòa", "Xã Thạnh Quới, Xã Gia Hòa 2"],
    },
    {
      columns: ["Cần Thơ", "Hiệp Hưng", "Thị trấn Cây Dương, Xã Hiệp Hưng"],
    },
    {
      columns: ["Cần Thơ", "Hòa An", "Thị trấn Kinh Cùng, Xã Hòa An"],
    },
    {
      columns: ["Cần Thơ", "Hỏa Lựu", "Xã Tân Tiến, Xã Hỏa Tiến, Xã Hỏa Lựu"],
    },
    {
      columns: ["Cần Thơ", "Hòa Tú", "Xã Hòa Tú 1, Xã Hòa Tú 2"],
    },
    {
      columns: ["Cần Thơ", "Hồ Đắc Kiện", "Xã Thiện Mỹ, Xã Hồ Đắc Kiện"],
    },
    {
      columns: ["Cần Thơ", "Hưng Phú", "Phường Tân Phú, Phường Phú Thứ, Phường Hưng Phú"],
    },
    {
      columns: ["Cần Thơ", "Kế Sách", "Thị trấn Kế Sách, Xã Kế An, Xã Kế Thành"],
    },
    {
      columns: ["Cần Thơ", "Khánh Hòa", "Phường Khánh Hòa, Xã Vĩnh Hiệp, Xã Hòa Đông"],
    },
    {
      columns: ["Cần Thơ", "Lai Hòa", "Không sáp nhập"],
    },
    {
      columns: ["Cần Thơ", "Lâm Tân", "Xã Tuân Tức, Xã Lâm Kiết, Xã Lâm Tân"],
    },
    {
      columns: ["Cần Thơ", "Lịch Hội Thượng", "Thị trấn Lịch Hội Thượng, Xã Lịch Hội Thượng"],
    },
    {
      columns: ["Cần Thơ", "Liêu Tú", "Xã Viên Bình, Xã Liêu Tú"],
    },
    {
      columns: ["Cần Thơ", "Long Bình", "Phường Bình Thạnh, Phường Vĩnh Tường, Xã Long Bình"],
    },
    {
      columns: ["Cần Thơ", "Long Hưng", "Xã Hưng Phú, Xã Long Hưng"],
    },
    {
      columns: [
        "Cần Thơ",
        "Long Mỹ",
        "Phường Thuận An (thị xã Long Mỹ), Xã Long Trị, Xã Long Trị A",
      ],
    },
    {
      columns: ["Cần Thơ", "Long Phú", "Thị trấn Long Phú, Xã Long Phú"],
    },
    {
      columns: ["Cần Thơ", "Long Phú 1", "Phường Trà Lồng, Xã Tân Phú, Xã Long Phú"],
    },
    {
      columns: [
        "Cần Thơ",
        "Long Tuyền",
        "Phường Long Hòa, Phường Long Tuyền (phần còn lại sau khi sáp nhập vào phường An Bình)",
      ],
    },
    {
      columns: ["Cần Thơ", "Lương Tâm", "Xã Lương Nghĩa, Xã Lương Tâm"],
    },
    {
      columns: ["Cần Thơ", "Mỹ Hương", "Xã Thuận Hưng, Xã Phú Mỹ, Xã Mỹ Hương"],
    },
    {
      columns: ["Cần Thơ", "Mỹ Phước", "Không sáp nhập"],
    },
    {
      columns: ["Cần Thơ", "Mỹ Quới", "Phường 3 (thị xã Ngã Năm), Xã Mỹ Bình, Xã Mỹ Quới"],
    },
    {
      columns: ["Cần Thơ", "Mỹ Tú", "Thị trấn Huỳnh Hữu Nghĩa, Xã Mỹ Thuận, Xã Mỹ Tú"],
    },
    {
      columns: ["Cần Thơ", "Mỹ Xuyên", "Phường 10, Thị trấn Mỹ Xuyên, Xã Đại Tâm"],
    },
    {
      columns: ["Cần Thơ", "Ngã Bảy", "Phường Lái Hiếu, Phường Hiệp Thành, Phường Ngã Bảy"],
    },
    {
      columns: [
        "Cần Thơ",
        "Ngã Năm",
        "Phường 1 (thị xã Ngã Năm), Phường 2 (thị xã Ngã Năm), Xã Vĩnh Quới",
      ],
    },
    {
      columns: ["Cần Thơ", "Ngọc Tố", "Xã Tham Đôn, Xã Ngọc Đông, Xã Ngọc Tố"],
    },
    {
      columns: ["Cần Thơ", "Nhơn Ái", "Xã Nhơn Nghĩa, Xã Nhơn Ái"],
    },
    {
      columns: ["Cần Thơ", "Nhơn Mỹ", "Xã An Mỹ, Xã Song Phụng, Xã Nhơn Mỹ"],
    },
    {
      columns: ["Cần Thơ", "Nhu Gia", "Xã Thạnh Phú, Xã Gia Hòa 1"],
    },
    {
      columns: ["Cần Thơ", "Ninh Kiều", "Phường Tân An, Phường Thới Bình, Phường Xuân Khánh"],
    },
    {
      columns: [
        "Cần Thơ",
        "Ô Môn",
        "Phường Châu Văn Liêm, Phường Thới Hòa, Phường Thới An, Xã Thới Thạnh",
      ],
    },
    {
      columns: ["Cần Thơ", "Phong Điền", "Thị trấn Phong Điền, Xã Tân Thới, Xã Giai Xuân"],
    },
    {
      columns: ["Cần Thơ", "Phong Nẫm", "Không sáp nhập"],
    },
    {
      columns: ["Cần Thơ", "Phú Hữu", "Xã Phú Tân, Xã Đông Phước, Xã Phú Hữu"],
    },
    {
      columns: ["Cần Thơ", "Phú Lộc", "Thị trấn Hưng Lợi, Thị trấn Phú Lộc, Xã Thạnh Trị"],
    },
    {
      columns: [
        "Cần Thơ",
        "Phú Lợi",
        "Phường 1 (thành phố Sóc Trăng), Phường 2 (thành phố Sóc Trăng), Phường 3 (thành phố Sóc Trăng), Phường 4",
      ],
    },
    {
      columns: ["Cần Thơ", "Phú Tâm", "Thị trấn Châu Thành, Xã Phú Tâm"],
    },
    {
      columns: ["Cần Thơ", "Phụng Hiệp", "Xã Hòa Mỹ, Xã Phụng Hiệp"],
    },
    {
      columns: ["Cần Thơ", "Phước Thới", "Phường Trường Lạc, Phường Phước Thới"],
    },
    {
      columns: ["Cần Thơ", "Phương Bình", "Xã Phương Phú, Xã Phương Bình"],
    },
    {
      columns: ["Cần Thơ", "Sóc Trăng", "Phường 5, Phường 6, Phường 7, Phường 8"],
    },
    {
      columns: ["Cần Thơ", "Tài Văn", "Xã Viên An, Xã Tài Văn"],
    },
    {
      columns: ["Cần Thơ", "Tân An", "Phường An Khánh, Phường Hưng Lợi"],
    },
    {
      columns: ["Cần Thơ", "Tân Bình", "Xã Bình Thành, Xã Tân Bình"],
    },
    {
      columns: [
        "Cần Thơ",
        "Tân Hòa",
        "Thị trấn Một Ngàn, Thị trấn Bảy Ngàn, Xã Nhơn Nghĩa A, Xã Tân Hòa",
      ],
    },
    {
      columns: ["Cần Thơ", "Tân Long", "Xã Thạnh Tân, Xã Long Bình, Xã Tân Long"],
    },
    {
      columns: ["Cần Thơ", "Tân Lộc", "Không sáp nhập"],
    },
    {
      columns: ["Cần Thơ", "Tân Phước Hưng", "Thị trấn Búng Tàu, Xã Tân Phước Hưng"],
    },
    {
      columns: ["Cần Thơ", "Tân Thạnh", "Xã Tân Hưng, Xã Châu Khánh, Xã Tân Thạnh"],
    },
    {
      columns: ["Cần Thơ", "Thạnh An", "Thị trấn Thạnh An, Xã Thạnh Lợi, Xã Thạnh Thắng"],
    },
    {
      columns: ["Cần Thơ", "Thạnh Hòa", "Xã Long Thạnh, Xã Tân Long, Xã Thạnh Hòa"],
    },
    {
      columns: ["Cần Thơ", "Thạnh Phú", "Không sáp nhập"],
    },
    {
      columns: ["Cần Thơ", "Thạnh Quới", "Xã Thạnh Tiến, Xã Thạnh An, Xã Thạnh Quới"],
    },
    {
      columns: ["Cần Thơ", "Thạnh Thới An", "Xã Thạnh Thới Thuận, Xã Thạnh Thới An"],
    },
    {
      columns: ["Cần Thơ", "Thạnh Xuân", "Thị trấn Rạch Gòi, Xã Tân Phú Thạnh, Xã Thạnh Xuân"],
    },
    {
      columns: [
        "Cần Thơ",
        "Thốt Nốt",
        "Phường Thuận An (quận Thốt Nốt), Phường Thới Thuận, Phường Thốt Nốt (phần còn lại sau khi sáp nhập vào phường Thuận Hưng)",
      ],
    },
    {
      columns: ["Cần Thơ", "Thới An Đông", "Phường Trà An, Phường Trà Nóc, Phường Thới An Đông"],
    },
    {
      columns: ["Cần Thơ", "Thới An Hội", "Xã An Lạc Tây, Xã Thới An Hội"],
    },
    {
      columns: ["Cần Thơ", "Thới Hưng", "Không sáp nhập"],
    },
    {
      columns: ["Cần Thơ", "Thới Lai", "Thị trấn Thới Lai, Xã Thới Tân, Xã Trường Thắng"],
    },
    {
      columns: ["Cần Thơ", "Thới Long", "Phường Long Hưng, Phường Tân Hưng, Phường Thới Long"],
    },
    {
      columns: ["Cần Thơ", "Thuận Hòa", "Xã Thuận Hòa (huyện Châu Thành), Xã Phú Tân"],
    },
    {
      columns: ["Cần Thơ", "Thuận Hưng", "Phường Trung Kiên, Phường Thuận Hưng, Phường Thốt Nốt"],
    },
    {
      columns: ["Cần Thơ", "Trần Đề", "Thị trấn Trần Đề, Xã Đại Ân 2, Xã Trung Bình"],
    },
    {
      columns: ["Cần Thơ", "Trung Hưng", "Xã Trung Thạnh, Xã Trung Hưng"],
    },
    {
      columns: ["Cần Thơ", "Trung Nhứt", "Phường Thạnh Hòa, Phường Trung Nhứt, Xã Trung An"],
    },
    {
      columns: ["Cần Thơ", "Trường Khánh", "Xã Hậu Thạnh, Xã Phú Hữu, Xã Trường Khánh"],
    },
    {
      columns: ["Cần Thơ", "Trường Long", "Không sáp nhập"],
    },
    {
      columns: ["Cần Thơ", "Trường Long Tây", "Xã Trường Long A, Xã Trường Long Tây"],
    },
    {
      columns: ["Cần Thơ", "Trường Thành", "Xã Tân Thạnh, Xã Định Môn, Xã Trường Thành"],
    },
    {
      columns: ["Cần Thơ", "Trường Xuân", "Xã Trường Xuân A, Xã Trường Xuân B, Xã Trường Xuân"],
    },
    {
      columns: ["Cần Thơ", "Vị Tân", "Phường IV, Phường V, Xã Vị Tân"],
    },
    {
      columns: ["Cần Thơ", "Vị Thanh", "Phường I, Phường III, Phường VII"],
    },
    {
      columns: ["Cần Thơ", "Vị Thanh 1", "Xã Vị Đông, Xã Vị Bình, Xã Vị Thanh"],
    },
    {
      columns: ["Cần Thơ", "Vị Thủy", "Thị trấn Nàng Mau, Xã Vị Thắng, Xã Vị Trung"],
    },
    {
      columns: [
        "Cần Thơ",
        "Vĩnh Châu",
        "Phường 1 (thị xã Vĩnh Châu), Phường 2 (thị xã Vĩnh Châu), Xã Lạc Hòa",
      ],
    },
    {
      columns: ["Cần Thơ", "Vĩnh Hải", "Không sáp nhập"],
    },
    {
      columns: ["Cần Thơ", "Vĩnh Lợi", "Xã Châu Hưng, Xã Vĩnh Thành, Xã Vĩnh Lợi"],
    },
    {
      columns: ["Cần Thơ", "Vĩnh Phước", "Phường Vĩnh Phước, Xã Vĩnh Tân"],
    },
    {
      columns: ["Cần Thơ", "Vĩnh Thạnh", "Thị trấn Vĩnh Thạnh, Xã Thạnh Lộc, Xã Thạnh Mỹ"],
    },
    {
      columns: ["Cần Thơ", "Vĩnh Thuận Đông", "Xã Vĩnh Thuận Tây, Xã Vị Thủy, Xã Vĩnh Thuận Đông"],
    },
    {
      columns: ["Cần Thơ", "Vĩnh Trinh", "Xã Vĩnh Bình, Xã Vĩnh Trinh"],
    },
    {
      columns: ["Cần Thơ", "Vĩnh Tường", "Xã Vĩnh Trung, Xã Vĩnh Tường"],
    },
    {
      columns: ["Cần Thơ", "Vĩnh Viễn", "Thị trấn Vĩnh Viễn, Xã Vĩnh Viễn A"],
    },
    {
      columns: ["Cần Thơ", "Xà Phiên", "Xã Thuận Hòa (huyện Long Mỹ), Xã Thuận Hưng, Xã Xà Phiên"],
    },
    {
      columns: ["Đà Nẵng", "An Hải", "Phường Phước Mỹ, Phường An Hải Bắc, Phường An Hải Nam"],
    },
    {
      columns: ["Đà Nẵng", "An Khê", "Phường Hòa An, Phường Hòa Phát, Phường An Khê"],
    },
    {
      columns: [
        "Đà Nẵng",
        "An Thắng",
        "Phường Điện An, Phường Điện Thắng Nam, Phường Điện Thắng Trung",
      ],
    },
    {
      columns: ["Đà Nẵng", "Avương", "Xã Bhalêê, Xã Avương"],
    },
    {
      columns: ["Đà Nẵng", "Bà Nà", "Xã Hòa Ninh, Xã Hòa Nhơn"],
    },
    {
      columns: ["Đà Nẵng", "Bàn Thạch", "Phường Tân Thạnh, Phường Hòa Thuận, Xã Tam Thăng"],
    },
    {
      columns: ["Đà Nẵng", "Bến Giằng", "Xã Cà Dy, Xã Tà Bhing, Xã Tà Pơơ"],
    },
    {
      columns: ["Đà Nẵng", "Bến Hiên", "Xã Kà Dăng, Xã Mà Cooih"],
    },
    {
      columns: ["Đà Nẵng", "Cẩm Lệ", "Phường Hòa Thọ Tây, Phường Hòa Thọ Đông, Phường Khuê Trung"],
    },
    {
      columns: ["Đà Nẵng", "Chiên Đàn", "Thị trấn Phú Thịnh, Xã Tam Đàn, Xã Tam Thái"],
    },
    {
      columns: ["Đà Nẵng", "Duy Nghĩa", "Xã Duy Thành, Xã Duy Hải, Xã Duy Nghĩa"],
    },
    {
      columns: ["Đà Nẵng", "Duy Xuyên", "Xã Duy Trung, Xã Duy Sơn, Xã Duy Trinh"],
    },
    {
      columns: [
        "Đà Nẵng",
        "Đại Lộc",
        "Thị trấn Ái Nghĩa, Xã Đại Hiệp, Xã Đại Hòa, Xã Đại An, Xã Đại Nghĩa",
      ],
    },
    {
      columns: ["Đà Nẵng", "Đắc Pring", "Xã Đắc Pre, Xã Đắc Pring"],
    },
    {
      columns: ["Đà Nẵng", "Điện Bàn", "Phường Điện Phương, Phường Điện Minh, Phường Vĩnh Điện"],
    },
    {
      columns: ["Đà Nẵng", "Điện Bàn Bắc", "Phường Điện Thắng Bắc, Xã Điện Hòa, Xã Điện Tiến"],
    },
    {
      columns: [
        "Đà Nẵng",
        "Điện Bàn Đông",
        "Phường Điện Nam Đông, Phường Điện Nam Trung, Phường Điện Dương, Phường Điện Ngọc, Phường Điện Nam Bắc",
      ],
    },
    {
      columns: ["Đà Nẵng", "Điện Bàn Tây", "Xã Điện Hồng, Xã Điện Thọ, Xã Điện Phước"],
    },
    {
      columns: ["Đà Nẵng", "Đồng Dương", "Xã Bình Lãnh, Xã Bình Trị, Xã Bình Định"],
    },
    {
      columns: ["Đà Nẵng", "Đông Giang", "Thị trấn Prao, Xã Tà Lu, Xã A Rooi, Xã Zà Hung"],
    },
    {
      columns: ["Đà Nẵng", "Đức Phú", "Xã Tam Sơn, Xã Tam Thạnh"],
    },
    {
      columns: ["Đà Nẵng", "Gò Nổi", "Xã Điện Phong, Xã Điện Trung, Xã Điện Quang"],
    },
    {
      columns: ["Đà Nẵng", "Hà Nha", "Xã Đại Đồng, Xã Đại Hồng, Xã Đại Quang"],
    },
    {
      columns: [
        "Đà Nẵng",
        "Hải Châu",
        "Phường Thanh Bình, Phường Thuận Phước, Phường Thạch Thang, Phường Phước Ninh, Phường Hải Châu",
      ],
    },
    {
      columns: [
        "Đà Nẵng",
        "Hải Vân",
        "Phường Hòa Hiệp Bắc, Phường Hòa Hiệp Nam, Xã Hòa Bắc, Xã Hòa Liên",
      ],
    },
    {
      columns: ["Đà Nẵng", "Hiệp Đức", "Thị trấn Tân Bình, Xã Quế Tân, Xã Quế Lưu"],
    },
    {
      columns: [
        "Đà Nẵng",
        "Hòa Cường",
        "Phường Bình Thuận, Phường Hòa Thuận Tây, Phường Hòa Cường Bắc, Phường Hòa Cường Nam",
      ],
    },
    {
      columns: ["Đà Nẵng", "Hòa Khánh", "Phường Hòa Khánh Nam, Phường Hòa Minh, Xã Hòa Sơn"],
    },
    {
      columns: ["Đà Nẵng", "Hòa Tiến", "Xã Hòa Khương, Xã Hòa Tiến"],
    },
    {
      columns: ["Đà Nẵng", "Hòa Vang", "Xã Hòa Phong, Xã Hòa Phú"],
    },
    {
      columns: ["Đà Nẵng", "Hòa Xuân", "Phường Hòa Xuân, Xã Hòa Châu, Xã Hòa Phước"],
    },
    {
      columns: ["Đà Nẵng", "Hoàng Sa", "Huyện Hoàng Sa"],
    },
    {
      columns: [
        "Đà Nẵng",
        "Hội An",
        "Phường Minh An, Phường Cẩm Phô, Phường Sơn Phong, Phường Cẩm Nam, Xã Cẩm Kim",
      ],
    },
    {
      columns: ["Đà Nẵng", "Hội An Đông", "Phường Cẩm Châu, Phường Cửa Đại, Xã Cẩm Thanh"],
    },
    {
      columns: [
        "Đà Nẵng",
        "Hội An Tây",
        "Phường Thanh Hà, Phường Tân An, Phường Cẩm An, Xã Cẩm Hà",
      ],
    },
    {
      columns: ["Đà Nẵng", "Hùng Sơn", "Xã Ch’ơm, Xã Gari, Xã Tr’hy, Xã Axan"],
    },
    {
      columns: ["Đà Nẵng", "Hương Trà", "Phường An Sơn, Phường Hòa Hương, Xã Tam Ngọc"],
    },
    {
      columns: ["Đà Nẵng", "Khâm Đức", "Thị trấn Khâm Đức, Xã Phước Xuân"],
    },
    {
      columns: ["Đà Nẵng", "La Dêê", "Xã Đắc Tôi, Xã La Dêê"],
    },
    {
      columns: ["Đà Nẵng", "La Êê", "Xã Chơ Chun, Xã La Êê"],
    },
    {
      columns: ["Đà Nẵng", "Lãnh Ngọc", "Xã Tiên Lãnh, Xã Tiên Ngọc, Xã Tiên Hiệp"],
    },
    {
      columns: [
        "Đà Nẵng",
        "Liên Chiểu",
        "Phường Hòa Khánh Bắc, Xã Hòa Liên (phần còn lại sau khi sáp nhập vào phường Hải Vân)",
      ],
    },
    {
      columns: ["Đà Nẵng", "Nam Giang", "Xã Zuôih, Xã Chà Vàl"],
    },
    {
      columns: ["Đà Nẵng", "Nam Phước", "Thị trấn Nam Phước, Xã Duy Phước, Xã Duy Vinh"],
    },
    {
      columns: ["Đà Nẵng", "Nam Trà My", "Xã Trà Mai, Xã Trà Don"],
    },
    {
      columns: [
        "Đà Nẵng",
        "Ngũ Hành Sơn",
        "Phường Mỹ An, Phường Khuê Mỹ, Phường Hòa Hải, Phường Hòa Quý",
      ],
    },
    {
      columns: ["Đà Nẵng", "Nông Sơn", "Thị trấn Trung Phước, Xã Quế Lộc"],
    },
    {
      columns: [
        "Đà Nẵng",
        "Núi Thành",
        "Thị trấn Núi Thành, Xã Tam Quang, Xã Tam Nghĩa, Xã Tam Hiệp, Xã Tam Giang",
      ],
    },
    {
      columns: ["Đà Nẵng", "Phú Ninh", "Xã Tam Dân, Xã Tam Đại, Xã Tam Lãnh"],
    },
    {
      columns: ["Đà Nẵng", "Phú Thuận", "Xã Đại Tân, Xã Đại Thắng, Xã Đại Chánh, Xã Đại Thạnh"],
    },
    {
      columns: ["Đà Nẵng", "Phước Chánh", "Xã Phước Công, Xã Phước Chánh"],
    },
    {
      columns: ["Đà Nẵng", "Phước Hiệp", "Xã Phước Hòa, Xã Phước Hiệp"],
    },
    {
      columns: ["Đà Nẵng", "Phước Năng", "Xã Phước Đức, Xã Phước Mỹ, Xã Phước Năng"],
    },
    {
      columns: ["Đà Nẵng", "Phước Thành", "Xã Phước Lộc, Xã Phước Kim, Xã Phước Thành"],
    },
    {
      columns: ["Đà Nẵng", "Phước Trà", "Xã Sông Trà, Xã Phước Gia, Xã Phước Trà"],
    },
    {
      columns: ["Đà Nẵng", "Quảng Phú", "Phường An Phú, Xã Tam Thanh, Xã Tam Phú"],
    },
    {
      columns: ["Đà Nẵng", "Quế Phước", "Xã Quế Lâm, Xã Phước Ninh, Xã Ninh Phước"],
    },
    {
      columns: [
        "Đà Nẵng",
        "Quế Sơn",
        "Thị trấn Đông Phú, Xã Quế Minh, Xã Quế An, Xã Quế Long, Xã Quế Phong",
      ],
    },
    {
      columns: ["Đà Nẵng", "Quế Sơn Trung", "Xã Quế Mỹ, Xã Quế Hiệp, Xã Quế Thuận, Xã Quế Châu"],
    },
    {
      columns: ["Đà Nẵng", "Sông Kôn", "Xã A Ting, Xã Jơ Ngây, Xã Sông Kôn"],
    },
    {
      columns: ["Đà Nẵng", "Sông Vàng", "Xã Tư, Xã Ba"],
    },
    {
      columns: ["Đà Nẵng", "Sơn Cẩm Hà", "Xã Tiên Sơn, Xã Tiên Hà, Xã Tiên Châu"],
    },
    {
      columns: ["Đà Nẵng", "Sơn Trà", "Phường Thọ Quang, Phường Nại Hiên Đông, Phường Mân Thái"],
    },
    {
      columns: ["Đà Nẵng", "Tam Anh", "Xã Tam Hòa, Xã Tam Anh Bắc, Xã Tam Anh Nam"],
    },
    {
      columns: ["Đà Nẵng", "Tam Hải", "Không sáp nhập"],
    },
    {
      columns: ["Đà Nẵng", "Tam Kỳ", "Phường An Mỹ, Phường An Xuân, Phường Trường Xuân"],
    },
    {
      columns: ["Đà Nẵng", "Tam Mỹ", "Xã Tam Mỹ Đông, Xã Tam Mỹ Tây, Xã Tam Trà"],
    },
    {
      columns: ["Đà Nẵng", "Tam Xuân", "Xã Tam Xuân I, Xã Tam Xuân II, Xã Tam Tiến"],
    },
    {
      columns: ["Đà Nẵng", "Tân Hiệp", "Không sáp nhập"],
    },
    {
      columns: ["Đà Nẵng", "Tây Giang", "Xã Atiêng, Xã Dang, Xã Anông, Xã Lăng"],
    },
    {
      columns: ["Đà Nẵng", "Tây Hồ", "Xã Tam An, Xã Tam Thành, Xã Tam Phước, Xã Tam Lộc"],
    },
    {
      columns: ["Đà Nẵng", "Thạnh Bình", "Xã Tiên Lập, Xã Tiên Lộc, Xã Tiên An, Xã Tiên Cảnh"],
    },
    {
      columns: [
        "Đà Nẵng",
        "Thanh Khê",
        "Phường Xuân Hà, Phường Chính Gián, Phường Thạc Gián, Phường Thanh Khê Tây, Phường Thanh Khê Đông",
      ],
    },
    {
      columns: ["Đà Nẵng", "Thạnh Mỹ", "Thị trấn Thạnh Mỹ"],
    },
    {
      columns: [
        "Đà Nẵng",
        "Thăng An",
        "Xã Bình Triều, Xã Bình Giang, Xã Bình Đào, Xã Bình Minh, Xã Bình Dương",
      ],
    },
    {
      columns: [
        "Đà Nẵng",
        "Thăng Bình",
        "Thị trấn Hà Lam, Xã Bình Nguyên, Xã Bình Quý, Xã Bình Phục",
      ],
    },
    {
      columns: ["Đà Nẵng", "Thăng Điền", "Xã Bình An, Xã Bình Trung, Xã Bình Tú"],
    },
    {
      columns: ["Đà Nẵng", "Thăng Phú", "Xã Bình Phú, Xã Bình Quế"],
    },
    {
      columns: ["Đà Nẵng", "Thăng Trường", "Xã Bình Nam, Xã Bình Hải, Xã Bình Sa"],
    },
    {
      columns: ["Đà Nẵng", "Thu Bồn", "Xã Duy Châu, Xã Duy Hoà, Xã Duy Phú, Xã Duy Tân"],
    },
    {
      columns: ["Đà Nẵng", "Thượng Đức", "Xã Đại Lãnh, Xã Đại Hưng, Xã Đại Sơn"],
    },
    {
      columns: [
        "Đà Nẵng",
        "Tiên Phước",
        "Thị trấn Tiên Kỳ, Xã Tiên Mỹ, Xã Tiên Phong, Xã Tiên Thọ",
      ],
    },
    {
      columns: ["Đà Nẵng", "Trà Đốc", "Xã Trà Bui, Xã Trà Đốc"],
    },
    {
      columns: ["Đà Nẵng", "Trà Giáp", "Xã Trà Ka, Xã Trà Giáp"],
    },
    {
      columns: ["Đà Nẵng", "Trà Leng", "Xã Trà Dơn, Xã Trà Leng"],
    },
    {
      columns: ["Đà Nẵng", "Trà Liên", "Xã Trà Đông, Xã Trà Nú, Xã Trà Kót"],
    },
    {
      columns: ["Đà Nẵng", "Trà Linh", "Xã Trà Nam, Xã Trà Linh"],
    },
    {
      columns: ["Đà Nẵng", "Trà My", "Thị trấn Trà My, Xã Trà Sơn, Xã Trà Giang, Xã Trà Dương"],
    },
    {
      columns: ["Đà Nẵng", "Trà Tân", "Xã Trà Giác, Xã Trà Tân"],
    },
    {
      columns: ["Đà Nẵng", "Trà Tập", "Xã Trà Cang, Xã Trà Tập"],
    },
    {
      columns: ["Đà Nẵng", "Trà Vân", "Xã Trà Vinh, Xã Trà Vân"],
    },
    {
      columns: ["Đà Nẵng", "Việt An", "Xã Thăng Phước, Xã Bình Sơn, Xã Quế Thọ, Xã Bình Lâm"],
    },
    {
      columns: ["Đà Nẵng", "Vu Gia", "Xã Đại Phong, Xã Đại Minh, Xã Đại Cường"],
    },
    {
      columns: [
        "Đà Nẵng",
        "Xuân Phú",
        "Thị trấn Hương An, Xã Quế Xuân 1, Xã Quế Xuân 2, Xã Quế Phú",
      ],
    },
    {
      columns: [
        "Đắk Lắk",
        "Bình Kiến",
        "Xã An Phú, Xã Hòa Kiến, Xã Bình Kiến, Phường 9 (phần còn lại sau khi sáp nhập vào phường Tuy Hòa)",
      ],
    },
    {
      columns: ["Đắk Lắk", "Buôn Đôn", "Krông Na"],
    },
    {
      columns: [
        "Đắk Lắk",
        "Buôn Hồ",
        "Phường Đạt Hiếu, Phường An Bình, Phường An Lạc, Phường Thiện An, Phường Thống Nhất, Phường Đoàn Kết",
      ],
    },
    {
      columns: [
        "Đắk Lắk",
        "Buôn Ma Thuột",
        "Phường Thành Công, Phường Tân Tiến, Phường Tân Thành, Phường Tự An, Phường Tân Lợi, Xã Cư Êbur",
      ],
    },
    {
      columns: ["Đắk Lắk", "Cuôr Đăng", "Xã Ea Drơng, Xã Cuôr Đăng"],
    },
    {
      columns: ["Đắk Lắk", "Cư Bao", "Phường Bình Tân, Xã Bình Thuận, Xã Cư Bao"],
    },
    {
      columns: ["Đắk Lắk", "Cư M’gar", "Xã Ea H’đing, Xã Ea Kpam, Xã Cư M’gar"],
    },
    {
      columns: ["Đắk Lắk", "Cư M’ta", "Xã Cư Króa, Xã Cư M’ta"],
    },
    {
      columns: ["Đắk Lắk", "Cư Pơng", "Xã Ea Sin, Xã Cư Pơng"],
    },
    {
      columns: ["Đắk Lắk", "Cư Prao", "Xã Ea Pil, Xã Cư Prao"],
    },
    {
      columns: ["Đắk Lắk", "Cư Pui", "Xã Hòa Phong (huyện Krông Bông), Xã Cư Pui"],
    },
    {
      columns: ["Đắk Lắk", "Cư Yang", "Xã Cư Bông, Xã Cư Yang"],
    },
    {
      columns: ["Đắk Lắk", "Dang Kang", "Xã Hòa Thành (huyện Krông Bông), Xã Cư Kty, Xã Dang Kang"],
    },
    {
      columns: ["Đắk Lắk", "Dliê Ya", "Xã Ea Tóh, Xã Ea Tân, Xã Dliê Ya"],
    },
    {
      columns: ["Đắk Lắk", "Dray Bhăng", "Xã Hòa Hiệp, Xã Dray Bhăng, Xã Ea Bhốk"],
    },
    {
      columns: ["Đắk Lắk", "Dur Kmăl", "Xã Băng A Drênh, Xã Dur Kmăl"],
    },
    {
      columns: ["Đắk Lắk", "Đắk Liêng", "Xã Buôn Tría, Xã Buôn Triết, Xã Đắk Liêng"],
    },
    {
      columns: ["Đắk Lắk", "Đắk Phơi", "Xã Đắk Nuê, Xã Đắk Phơi"],
    },
    {
      columns: ["Đắk Lắk", "Đông Hòa", "Phường Hòa Vinh, Phường Hòa Xuân Tây, Xã Hòa Tân Đông"],
    },
    {
      columns: [
        "Đắk Lắk",
        "Đồng Xuân",
        "Thị trấn La Hai, Xã Xuân Sơn Nam, Xã Xuân Sơn Bắc, Xã Xuân Long, Xã Xuân Quang 2",
      ],
    },
    {
      columns: [
        "Đắk Lắk",
        "Đức Bình",
        "Xã Sơn Giang, Xã Đức Bình Đông, Xã Đức Bình Tây, Xã Ea Bia",
      ],
    },
    {
      columns: [
        "Đắk Lắk",
        "Ea Bá",
        "Xã Ea Bá, Xã Ea Bar (huyện Sông Hinh) (phần còn lại sau khi sáp nhập vào xã Ea Ly)",
      ],
    },
    {
      columns: ["Đắk Lắk", "Ea Bung", "Xã Ya Tờ Mốt, Xã Ea Bung"],
    },
    {
      columns: ["Đắk Lắk", "Ea Drăng", "Thị trấn Ea Drăng, Xã Ea Ral, Xã Dliê Yang"],
    },
    {
      columns: ["Đắk Lắk", "Ea Drông", "Xã Ea Siên, Xã Ea Drông"],
    },
    {
      columns: ["Đắk Lắk", "Ea H’Leo", "Không sáp nhập"],
    },
    {
      columns: ["Đắk Lắk", "Ea Hiao", "Xã Ea Sol, Xã Ea Hiao"],
    },
    {
      columns: ["Đắk Lắk", "Ea Kao", "Phường Ea Tam, Xã Ea Kao"],
    },
    {
      columns: [
        "Đắk Lắk",
        "Ea Kar",
        "Thị trấn Ea Kar, Xã Cư Huê, Xã Ea Đar, Xã Ea Kmút, Xã Cư Ni, Xã Xuân Phú",
      ],
    },
    {
      columns: ["Đắk Lắk", "Ea Khăl", "Xã Ea Nam, Xã Ea Tir, Xã Ea Khăl"],
    },
    {
      columns: ["Đắk Lắk", "Ea Kiết", "Xã Ea Kuêh, Xã Ea Kiết"],
    },
    {
      columns: ["Đắk Lắk", "Ea Kly", "Xã Krông Búk, Xã Ea Kly"],
    },
    {
      columns: ["Đắk Lắk", "Ea Knốp", "Thị trấn Ea Knốp, Xã Ea Tih, Xã Ea Sô, Xã Ea Sar"],
    },
    {
      columns: ["Đắk Lắk", "Ea Knuếc", "Xã Hòa Đông, Xã Ea Kênh, Xã Ea Knuếc"],
    },
    {
      columns: [
        "Đắk Lắk",
        "Ea Ktur",
        "Xã Ea Tiêu, Xã Ea Ktur, Xã Ea Bhốk (phần còn lại sau khi sáp nhập vào xã Dray Bhăng)",
      ],
    },
    {
      columns: ["Đắk Lắk", "Ea Ly", "Xã Ea Lâm, Xã Ea Ly, Xã Ea Bar (huyện Sông Hinh)"],
    },
    {
      columns: ["Đắk Lắk", "Ea M’Droh", "Xã Quảng Hiệp, Xã Ea M’nang, Xã Ea M’Droh"],
    },
    {
      columns: ["Đắk Lắk", "Ea Na", "Xã Ea Bông, Xã Dray Sáp, Xã Ea Na"],
    },
    {
      columns: ["Đắk Lắk", "Ea Ning", "Xã Cư Êwi, Xã Ea Hu, Xã Ea Ning"],
    },
    {
      columns: ["Đắk Lắk", "Ea Nuôl", "Xã Ea Bar (huyện Buôn Đôn), Xã Cuôr Knia, Xã Ea Nuôl"],
    },
    {
      columns: ["Đắk Lắk", "Ea Ô", "Xã Cư Elang, Xã Ea Ô"],
    },
    {
      columns: ["Đắk Lắk", "Ea Păl", "Xã Cư Prông, Xã Ea Păl"],
    },
    {
      columns: ["Đắk Lắk", "Ea Phê", "Xã Ea Kuăng, Xã Ea Hiu, Xã Ea Phê"],
    },
    {
      columns: ["Đắk Lắk", "Ea Riêng", "Xã Ea H’Mlay, Xã Ea M’Doal, Xã Ea Riêng"],
    },
    {
      columns: ["Đắk Lắk", "Ea Rốk", "Xã Ia Jlơi, Xã Cư Kbang, Xã Ea Rốk"],
    },
    {
      columns: ["Đắk Lắk", "Ea Súp", "Thị trấn Ea Súp, Xã Cư M’Lan, Xã Ea Lê"],
    },
    {
      columns: ["Đắk Lắk", "Ea Trang", "Không sáp nhập"],
    },
    {
      columns: ["Đắk Lắk", "Ea Tul", "Xã Ea Tar, Xã Cư Dliê Mnông, Xã Ea Tul"],
    },
    {
      columns: ["Đắk Lắk", "Ea Wer", "Xã Ea Huar, Xã Tân Hòa, Xã Ea Wer"],
    },
    {
      columns: ["Đắk Lắk", "Ea Wy", "Xã Cư A Mung, Xã Cư Mốt, Xã Ea Wy"],
    },
    {
      columns: [
        "Đắk Lắk",
        "Hòa Hiệp",
        "Phường Hòa Hiệp Trung, Phường Hòa Hiệp Nam, Phường Hòa Hiệp Bắc (phần còn lại sau khi sáp nhập vào phường Phú Yên)",
      ],
    },
    {
      columns: ["Đắk Lắk", "Hòa Mỹ", "Xã Hòa Mỹ Đông, Xã Hòa Mỹ Tây"],
    },
    {
      columns: [
        "Đắk Lắk",
        "Hòa Phú",
        "Xã Hòa Phú (thành phố Buôn Ma Thuột), Xã Hòa Xuân, Xã Hòa Khánh",
      ],
    },
    {
      columns: ["Đắk Lắk", "Hòa Sơn", "Xã Yang Reh, Xã Ea Trul, Xã Hòa Sơn"],
    },
    {
      columns: ["Đắk Lắk", "Hòa Thịnh", "Xã Hòa Đồng, Xã Hòa Thịnh"],
    },
    {
      columns: ["Đắk Lắk", "Hòa Xuân", "Xã Hòa Tâm, Xã Hòa Xuân Đông, Xã Hòa Xuân Nam"],
    },
    {
      columns: ["Đắk Lắk", "Ia Lốp", "Không sáp nhập"],
    },
    {
      columns: ["Đắk Lắk", "Ia Rvê", "Không sáp nhập"],
    },
    {
      columns: ["Đắk Lắk", "Krông Á", "Xã Cư San, Xã Krông Á"],
    },
    {
      columns: ["Đắk Lắk", "Krông Ana", "Thị trấn Buôn Trấp, Xã Bình Hòa, Xã Quảng Điền"],
    },
    {
      columns: ["Đắk Lắk", "Krông Bông", "Thị trấn Krông Kmar, Xã Hòa Lễ, Xã Khuê Ngọc Điền"],
    },
    {
      columns: ["Đắk Lắk", "Krông Búk", "Xã Cư Né, Xã Chứ Kbô"],
    },
    {
      columns: ["Đắk Lắk", "Krông Năng", "Thị trấn Krông Năng, Xã Phú Lộc, Xã Ea Hồ"],
    },
    {
      columns: ["Đắk Lắk", "Krông Nô", "Không sáp nhập"],
    },
    {
      columns: [
        "Đắk Lắk",
        "Krông Pắc",
        "Thị trấn Phước An, Xã Hòa An (huyện Krông Pắc), Xã Ea Yông, Xã Hòa Tiến",
      ],
    },
    {
      columns: ["Đắk Lắk", "Liên Sơn Lắk", "Thị trấn Liên Sơn, Xã Yang Tao, Xã Bông Krang"],
    },
    {
      columns: ["Đắk Lắk", "M’Drắk", "Thị trấn M’Drắk, Xã Krông Jing, Xã Ea Lai"],
    },
    {
      columns: ["Đắk Lắk", "Nam Ka", "Xã Ea Rbin, Xã Nam Ka"],
    },
    {
      columns: ["Đắk Lắk", "Ô Loan", "Xã An Hiệp, Xã An Hòa Hải, Xã An Cư"],
    },
    {
      columns: [
        "Đắk Lắk",
        "Phú Hòa 1",
        "Thị trấn Phú Hòa, Xã Hòa Thắng (huyện Phú Hòa), Xã Hòa Định Đông, Xã Hòa Định Tây, Xã Hòa Hội, Xã Hòa An (huyện Phú Hòa)",
      ],
    },
    {
      columns: ["Đắk Lắk", "Phú Hòa 2", "Xã Hòa Quang Nam, Xã Hòa Quang Bắc, Xã Hòa Trị"],
    },
    {
      columns: ["Đắk Lắk", "Phú Mỡ", "Xã Xuân Quang 1, Xã Phú Mỡ"],
    },
    {
      columns: ["Đắk Lắk", "Phú Xuân", "Xã Ea Púk, Xã Ea Dăh, Xã Phú Xuân"],
    },
    {
      columns: [
        "Đắk Lắk",
        "Phú Yên",
        "Phường Phú Đông, Phường Phú Lâm, Phường Phú Thạnh, Xã Hòa Thành (thị xã Đông Hòa), Phường Hòa Hiệp Bắc, Xã Hòa Bình 1 (phần còn lại sau khi sáp nhập vào xã Tây Hòa)",
      ],
    },
    {
      columns: ["Đắk Lắk", "Pơng Drang", "Thị trấn Pơng Drang, Xã Ea Ngai, Xã Tân Lập"],
    },
    {
      columns: [
        "Đắk Lắk",
        "Quảng Phú",
        "Thị trấn Quảng Phú, Thị trấn Ea Pốk, Xã Cư Suê, Xã Quảng Tiến",
      ],
    },
    {
      columns: [
        "Đắk Lắk",
        "Sông Cầu",
        "Phường Xuân Yên, Phường Xuân Phú, Xã Xuân Phương, Xã Xuân Thịnh",
      ],
    },
    {
      columns: [
        "Đắk Lắk",
        "Sông Hinh",
        "Thị trấn Hai Riêng, Xã Ea Trol, Xã Sông Hinh, Xã Ea Bia (phần còn lại sau khi sáp nhập vào xã Đức Bình)",
      ],
    },
    {
      columns: [
        "Đắk Lắk",
        "Sơn Hòa",
        "Thị trấn Củng Sơn, Xã Suối Bạc, Xã Sơn Hà, Xã Sơn Nguyên, Xã Sơn Phước",
      ],
    },
    {
      columns: [
        "Đắk Lắk",
        "Sơn Thành",
        "Xã Hòa Phú (huyện Tây Hòa), Xã Sơn Thành Đông, Xã Sơn Thành Tây",
      ],
    },
    {
      columns: ["Đắk Lắk", "Suối Trai", "Xã Ea Chà Rang, Xã Krông Pa, Xã Suối Trai"],
    },
    {
      columns: ["Đắk Lắk", "Tam Giang", "Xã Ea Tam, Xã Cư Klông, Xã Tam Giang"],
    },
    {
      columns: ["Đắk Lắk", "Tân An", "Phường Tân An, Xã Ea Tu, Xã Hòa Thuận"],
    },
    {
      columns: [
        "Đắk Lắk",
        "Tân Lập",
        "Phường Tân Hòa, Phường Tân Lập, Xã Hòa Thắng (thành phố Buôn Ma Thuột)",
      ],
    },
    {
      columns: ["Đắk Lắk", "Tân Tiến", "Xã Ea Yiêng, Xã Ea Uy, Xã Tân Tiến"],
    },
    {
      columns: [
        "Đắk Lắk",
        "Tây Hòa",
        "Thị trấn Phú Thứ, Xã Hòa Phong (huyện Tây Hòa), Xã Hòa Tân Tây, Xã Hòa Bình 1",
      ],
    },
    {
      columns: ["Đắk Lắk", "Tây Sơn", "Xã Sơn Hội, Xã Cà Lúi, Xã Phước Tân"],
    },
    {
      columns: ["Đắk Lắk", "Thành Nhất", "Phường Khánh Xuân, Phường Thành Nhất"],
    },
    {
      columns: ["Đắk Lắk", "Tuy An Bắc", "Thị trấn Chí Thạnh, Xã An Dân, Xã An Định"],
    },
    {
      columns: ["Đắk Lắk", "Tuy An Đông", "Xã An Ninh Đông, Xã An Ninh Tây, Xã An Thạch"],
    },
    {
      columns: ["Đắk Lắk", "Tuy An Nam", "Xã An Thọ, Xã An Mỹ, Xã An Chấn"],
    },
    {
      columns: ["Đắk Lắk", "Tuy An Tây", "Xã An Nghiệp, Xã An Xuân, Xã An Lĩnh"],
    },
    {
      columns: [
        "Đắk Lắk",
        "Tuy Hòa",
        "Phường 1, Phường 2, Phường 4, Phường 5, Phường 7, Phường 9, Xã Hòa An (huyện Phú Hòa) (phần còn lại sau khi sáp nhập vào xã Phú Hòa 1), Xã Hòa Trị (phần còn lại sau khi sáp nhập vào xã Phú Hòa 2)",
      ],
    },
    {
      columns: ["Đắk Lắk", "Vân Hòa", "Xã Sơn Long, Xã Sơn Xuân, Xã Sơn Định"],
    },
    {
      columns: ["Đắk Lắk", "Vụ Bổn", "Không sáp nhập"],
    },
    {
      columns: ["Đắk Lắk", "Xuân Cảnh", "Xã Xuân Bình, Xã Xuân Cảnh"],
    },
    {
      columns: ["Đắk Lắk", "Xuân Đài", "Phường Xuân Thành, Phường Xuân Đài"],
    },
    {
      columns: ["Đắk Lắk", "Xuân Lãnh", "Xã Đa Lộc, Xã Xuân Lãnh"],
    },
    {
      columns: ["Đắk Lắk", "Xuân Lộc", "Xã Xuân Hải, Xã Xuân Lộc"],
    },
    {
      columns: ["Đắk Lắk", "Xuân Phước", "Xã Xuân Quang 3, Xã Xuân Phước"],
    },
    {
      columns: ["Đắk Lắk", "Xuân Thọ", "Xã Xuân Lâm, Xã Xuân Thọ 1, Xã Xuân Thọ 2"],
    },
    {
      columns: ["Đắk Lắk", "Yang Mao", "Xã Cư Drăm, Xã Yang Mao"],
    },
    {
      columns: ["Điện Biên", "Búng Lao", "Xã Ẳng Tở, Xã Chiềng Đông, Xã Búng Lao"],
    },
    {
      columns: ["Điện Biên", "Chà Tở", "Xã Nậm Khăn, Xã Chà Tở"],
    },
    {
      columns: [
        "Điện Biên",
        "Chiềng Sinh",
        "Xã Nà Sáy, Xã Mường Thín, Xã Mường Khong, Xã Chiềng Sinh",
      ],
    },
    {
      columns: [
        "Điện Biên",
        "Điện Biên Phủ",
        "Phường Him Lam, Phường Tân Thanh, Phường Mường Thanh, Phường Thanh Bình, Phường Thanh Trường, Xã Thanh Minh",
      ],
    },
    {
      columns: ["Điện Biên", "Mường Ảng", "Thị trấn Mường Ảng, Xã Ẳng Nưa, Xã Ẳng Cang"],
    },
    {
      columns: ["Điện Biên", "Mường Chà", "Xã Chà Cang, Xã Chà Nưa, Xã Nậm Tin, Xã Pa Tần"],
    },
    {
      columns: ["Điện Biên", "Mường Lạn", "Xã Nặm Lịch, Xã Xuân Lao, Xã Mường Lạn"],
    },
    {
      columns: ["Điện Biên", "Mường Lay", "Phường Sông Đà, Phường Na Lay, Xã Lay Nưa, Xã Sá Tổng"],
    },
    {
      columns: ["Điện Biên", "Mường Luân", "Xã Chiềng Sơ, Xã Luân Giói, Xã Mường Luân"],
    },
    {
      columns: ["Điện Biên", "Mường Mùn", "Xã Mùn Chung, Xã Pú Xi, Xã Mường Mùn"],
    },
    {
      columns: ["Điện Biên", "Mường Nhà", "Xã Mường Lói, Xã Phu Luông, Xã Mường Nhà"],
    },
    {
      columns: ["Điện Biên", "Mường Nhé", "Xã Nậm Vì, Xã Chung Chải, Xã Mường Nhé"],
    },
    {
      columns: ["Điện Biên", "Mường Phăng", "Xã Nà Nhạn, Xã Pá Khoang, Xã Mường Phăng"],
    },
    {
      columns: ["Điện Biên", "Mường Pồn", "Xã Mường Mươn, Xã Mường Pồn"],
    },
    {
      columns: ["Điện Biên", "Mường Thanh", "Phường Noong Bua, Phường Nam Thanh, Xã Thanh Xương"],
    },
    {
      columns: ["Điện Biên", "Mường Toong", "Xã Huổi Lếch, Xã Mường Toong"],
    },
    {
      columns: ["Điện Biên", "Mường Tùng", "Xã Huổi Lèng, Xã Mường Tùng"],
    },
    {
      columns: ["Điện Biên", "Nà Bủng", "Xã Vàng Đán, Xã Nà Bủng"],
    },
    {
      columns: ["Điện Biên", "Nà Hỳ", "Xã Nà Khoa, Xã Nậm Nhừ, Xã Nậm Chua, Xã Nà Hỳ"],
    },
    {
      columns: ["Điện Biên", "Na Sang", "Thị trấn Mường Chà, Xã Ma Thì Hồ, Xã Sa Lông, Xã Na Sang"],
    },
    {
      columns: ["Điện Biên", "Na Son", "Thị trấn Điện Biên Đông, Xã Keo Lôm, Xã Na Son"],
    },
    {
      columns: ["Điện Biên", "Nà Tấu", "Xã Mường Đăng, Xã Ngối Cáy, Xã Nà Tấu"],
    },
    {
      columns: ["Điện Biên", "Nậm Kè", "Xã Pá Mỳ, Xã Nậm Kè"],
    },
    {
      columns: ["Điện Biên", "Nậm Nèn", "Xã Huổi Mí, Xã Nậm Nèn"],
    },
    {
      columns: ["Điện Biên", "Núa Ngam", "Xã Hẹ Muông, Xã Na Tông, Xã Núa Ngam"],
    },
    {
      columns: ["Điện Biên", "Pa Ham", "Xã Hừa Ngài, Xã Pa Ham"],
    },
    {
      columns: ["Điện Biên", "Phình Giàng", "Xã Pú Hồng, Xã Phình Giàng"],
    },
    {
      columns: ["Điện Biên", "Pu Nhi", "Xã Nong U, Xã Pu Nhi"],
    },
    {
      columns: ["Điện Biên", "Pú Nhung", "Xã Rạng Đông, Xã Ta Ma, Xã Pú Nhung"],
    },
    {
      columns: ["Điện Biên", "Quài Tở", "Xã Tỏa Tình, Xã Tênh Phông, Xã Quài Tở"],
    },
    {
      columns: ["Điện Biên", "Quảng Lâm", "Xã Na Cô Sa, Xã Quảng Lâm"],
    },
    {
      columns: ["Điện Biên", "Sam Mứn", "Xã Pom Lót, Xã Na Ư"],
    },
    {
      columns: ["Điện Biên", "Sáng Nhè", "Xã Xá Nhè, Xã Mường Đun, Xã Phình Sáng"],
    },
    {
      columns: ["Điện Biên", "Si Pa Phìn", "Xã Phìn Hồ, Xã Si Pa Phìn"],
    },
    {
      columns: ["Điện Biên", "Sín Chải", "Xã Tả Sìn Thàng, Xã Lao Xả Phình, Xã Sín Chải"],
    },
    {
      columns: ["Điện Biên", "Sín Thầu", "Xã Sen Thượng, Xã Leng Su Sìn, Xã Sín Thầu"],
    },
    {
      columns: ["Điện Biên", "Sính Phình", "Xã Trung Thu, Xã Tả Phìn, Xã Sính Phình"],
    },
    {
      columns: ["Điện Biên", "Thanh An", "Xã Noong Hẹt, Xã Sam Mứn, Xã Thanh An"],
    },
    {
      columns: [
        "Điện Biên",
        "Thanh Nưa",
        "Xã Hua Thanh, Xã Thanh Luông, Xã Thanh Hưng, Xã Thanh Chăn, Xã Thanh Nưa",
      ],
    },
    {
      columns: ["Điện Biên", "Thanh Yên", "Xã Noong Luống, Xã Pa Thơm, Xã Thanh Yên"],
    },
    {
      columns: ["Điện Biên", "Tìa Dình", "Xã Háng Lìa, Xã Tìa Dình"],
    },
    {
      columns: ["Điện Biên", "Tủa Chùa", "Thị trấn Tủa Chùa, Xã Mường Báng, Xã Nà Tòng"],
    },
    {
      columns: ["Điện Biên", "Tủa Thàng", "Xã Huổi Só, Xã Tủa Thàng"],
    },
    {
      columns: ["Điện Biên", "Tuần Giáo", "Thị trấn Tuần Giáo, Xã Quài Cang, Xã Quài Nưa"],
    },
    {
      columns: ["Điện Biên", "Xa Dung", "Xã Phì Nhừ, Xã Xa Dung"],
    },
    {
      columns: ["Đồng Nai", "An Lộc", "Phường Phú Thịnh, Xã Thanh Phú, Xã Thanh Lương"],
    },
    {
      columns: ["Đồng Nai", "An Phước", "Xã Tam An, Xã An Phước"],
    },
    {
      columns: ["Đồng Nai", "An Viễn", "Xã Đồi 61, Xã An Viễn"],
    },
    {
      columns: ["Đồng Nai", "Bảo Vinh", "Phường Bảo Vinh, Xã Bảo Quang"],
    },
    {
      columns: [
        "Đồng Nai",
        "Bàu Hàm",
        "Xã Thanh Bình (huyện Trảng Bom), Xã Cây Gáo, Xã Sông Thao, Xã Bàu Hàm",
      ],
    },
    {
      columns: [
        "Đồng Nai",
        "Biên Hòa",
        "Phường Tân Hạnh, Phường Hóa An, Phường Bửu Hòa, Phường Tân Vạn",
      ],
    },
    {
      columns: ["Đồng Nai", "Bình An", "Xã Long Đức, Xã Bình An"],
    },
    {
      columns: [
        "Đồng Nai",
        "Bình Long",
        "Phường An Lộc, Phường Hưng Chiến, Phường Phú Đức, Xã Thanh Bình (huyện Hớn Quản)",
      ],
    },
    {
      columns: ["Đồng Nai", "Bình Lộc", "Phường Suối Tre, Xã Xuân Thiện, Xã Bình Lộc"],
    },
    {
      columns: ["Đồng Nai", "Bình Minh", "Xã Bình Minh (huyện Trảng Bom), Xã Bắc Sơn"],
    },
    {
      columns: [
        "Đồng Nai",
        "Bình Phước",
        "Phường Tân Phú, Phường Tân Đồng, Phường Tân Thiện, Phường Tân Bình, Phường Tân Xuân, Xã Tiến Hưng",
      ],
    },
    {
      columns: [
        "Đồng Nai",
        "Bình Tân",
        "Xã Long Hưng (huyện Phú Riềng), Xã Long Bình, Xã Bình Tân",
      ],
    },
    {
      columns: ["Đồng Nai", "Bom Bo", "Xã Bình Minh (huyện Bù Đăng), Xã Bom Bo"],
    },
    {
      columns: ["Đồng Nai", "Bù Đăng", "Thị trấn Đức Phong, Xã Đoàn Kết, Xã Minh Hưng"],
    },
    {
      columns: ["Đồng Nai", "Bù Gia Mập", "Không sáp nhập"],
    },
    {
      columns: ["Đồng Nai", "Cẩm Mỹ", "Thị trấn Long Giao, Xã Nhân Nghĩa, Xã Xuân Mỹ, Xã Bảo Bình"],
    },
    {
      columns: ["Đồng Nai", "Chơn Thành", "Phường Hưng Long, Phường Thành Tâm, Phường Minh Thành"],
    },
    {
      columns: ["Đồng Nai", "Dầu Giây", "Thị trấn Dầu Giây, Xã Hưng Lộc, Xã Bàu Hàm 2, Xã Lộ 25"],
    },
    {
      columns: ["Đồng Nai", "Đa Kia", "Xã Phước Minh, Xã Bình Thắng, Xã Đa Kia"],
    },
    {
      columns: ["Đồng Nai", "Đại Phước", "Xã Phú Hữu, Xã Phú Đông, Xã Phước Khánh, Xã Đại Phước"],
    },
    {
      columns: ["Đồng Nai", "Đak Lua", "Không sáp nhập"],
    },
    {
      columns: ["Đồng Nai", "Đak Nhau", "Xã Đường 10, Xã Đak Nhau"],
    },
    {
      columns: ["Đồng Nai", "Đăk Ơ", "Không sáp nhập"],
    },
    {
      columns: [
        "Đồng Nai",
        "Định Quán",
        "Thị trấn Định Quán, Xã Phú Ngọc, Xã Gia Canh, Xã Ngọc Định",
      ],
    },
    {
      columns: [
        "Đồng Nai",
        "Đồng Phú",
        "Thị trấn Tân Phú, Xã Tân Tiến (huyện Đồng Phú), Xã Tân Lập",
      ],
    },
    {
      columns: ["Đồng Nai", "Đồng Tâm", "Xã Đồng Tiến, Xã Tân Phước, Xã Đồng Tâm"],
    },
    {
      columns: ["Đồng Nai", "Đồng Xoài", "Phường Tiến Thành, Xã Tân Thành (thành phố Đồng Xoài)"],
    },
    {
      columns: ["Đồng Nai", "Gia Kiệm", "Xã Quang Trung, Xã Gia Tân 3, Xã Gia Kiệm"],
    },
    {
      columns: ["Đồng Nai", "Hàng Gòn", "Phường Xuân Tân, Xã Hàng Gòn"],
    },
    {
      columns: ["Đồng Nai", "Hố Nai", "Phường Tân Hòa, Xã Hố Nai 3"],
    },
    {
      columns: ["Đồng Nai", "Hưng Phước", "Xã Phước Thiện, Xã Hưng Phước"],
    },
    {
      columns: ["Đồng Nai", "Hưng Thịnh", "Xã Đông Hòa, Xã Tây Hòa, Xã Trung Hòa, Xã Hưng Thịnh"],
    },
    {
      columns: ["Đồng Nai", "La Ngà", "Xã Túc Trưng, Xã La Ngà"],
    },
    {
      columns: ["Đồng Nai", "Long Bình", "Phường Hố Nai, Phường Tân Biên, Phường Long Bình"],
    },
    {
      columns: ["Đồng Nai", "Long Hà", "Xã Long Tân (huyện Phú Riềng), Xã Long Hà"],
    },
    {
      columns: [
        "Đồng Nai",
        "Long Hưng",
        "Phường Long Bình Tân, Phường An Hòa, Xã Long Hưng (thành phố Biên Hòa)",
      ],
    },
    {
      columns: [
        "Đồng Nai",
        "Long Khánh",
        "Xã Xuân An, Xã Xuân Bình, Xã Xuân Hòa, Xã Phú Bình, Xã Bàu Trâm",
      ],
    },
    {
      columns: ["Đồng Nai", "Long Phước", "Xã Bàu Cạn, Xã Long Phước"],
    },
    {
      columns: [
        "Đồng Nai",
        "Long Thành",
        "Thị trấn Long Thành, Xã Lộc An, Xã Bình Sơn (huyện Long Thành), Xã Long An",
      ],
    },
    {
      columns: ["Đồng Nai", "Lộc Hưng", "Xã Lộc Khánh, Xã Lộc Điền, Xã Lộc Hưng"],
    },
    {
      columns: ["Đồng Nai", "Lộc Ninh", "Thị trấn Lộc Ninh, Xã Lộc Thái, Xã Lộc Thuận"],
    },
    {
      columns: ["Đồng Nai", "Lộc Quang", "Xã Lộc Phú, Xã Lộc Hiệp, Xã Lộc Quang"],
    },
    {
      columns: ["Đồng Nai", "Lộc Tấn", "Xã Lộc Thiện, Xã Lộc Tấn"],
    },
    {
      columns: ["Đồng Nai", "Lộc Thành", "Xã Lộc Thịnh, Xã Lộc Thành"],
    },
    {
      columns: ["Đồng Nai", "Lộc Thạnh", "Xã Lộc Hòa, Xã Lộc Thạnh"],
    },
    {
      columns: ["Đồng Nai", "Minh Đức", "Xã An Phú, Xã Minh Tâm, Xã Minh Đức"],
    },
    {
      columns: ["Đồng Nai", "Minh Hưng", "Phường Minh Long, Phường Minh Hưng"],
    },
    {
      columns: ["Đồng Nai", "Nam Cát Tiên", "Xã Phú An, Xã Nam Cát Tiên"],
    },
    {
      columns: ["Đồng Nai", "Nghĩa Trung", "Xã Đức Liễu, Xã Nghĩa Bình, Xã Nghĩa Trung"],
    },
    {
      columns: ["Đồng Nai", "Nha Bích", "Xã Minh Thắng, Xã Minh Lập, Xã Nha Bích"],
    },
    {
      columns: [
        "Đồng Nai",
        "Nhơn Trạch",
        "Thị trấn Hiệp Phước, Xã Long Tân (huyện Nhơn Trạch), Xã Phú Thạnh, Xã Phú Hội, Xã Phước Thiền",
      ],
    },
    {
      columns: ["Đồng Nai", "Phú Hòa", "Xã Phú Điền, Xã Phú Lợi, Xã Phú Hòa"],
    },
    {
      columns: [
        "Đồng Nai",
        "Phú Lâm",
        "Xã Thanh Sơn, Xã Phú Sơn (huyện Tân Phú), Xã Phú Bình, Xã Phú Lâm",
      ],
    },
    {
      columns: ["Đồng Nai", "Phú Lý", "Không sáp nhập"],
    },
    {
      columns: ["Đồng Nai", "Phú Nghĩa", "Xã Phú Văn, Xã Đức Hạnh, Xã Phú Nghĩa"],
    },
    {
      columns: ["Đồng Nai", "Phú Riềng", "Xã Bù Nho, Xã Phú Riềng"],
    },
    {
      columns: ["Đồng Nai", "Phú Trung", "Xã Phước Tân, Xã Phú Trung"],
    },
    {
      columns: ["Đồng Nai", "Phú Vinh", "Xã Phú Tân, Xã Phú Vinh"],
    },
    {
      columns: [
        "Đồng Nai",
        "Phước An",
        "Xã Phước An (huyện Nhơn Trạch), Xã Vĩnh Thanh, Xã Long Thọ",
      ],
    },
    {
      columns: [
        "Đồng Nai",
        "Phước Bình",
        "Phường Long Phước, Phường Phước Bình, Xã Bình Sơn (huyện Phú Riềng), Xã Long Giang",
      ],
    },
    {
      columns: [
        "Đồng Nai",
        "Phước Long",
        "Phường Long Thủy, Phường Thác Mơ, Phường Sơn Giang, Xã Phước Tín",
      ],
    },
    {
      columns: ["Đồng Nai", "Phước Sơn", "Xã Đăng Hà, Xã Thống Nhất, Xã Phước Sơn"],
    },
    {
      columns: ["Đồng Nai", "Phước Tân", "Không sáp nhập"],
    },
    {
      columns: [
        "Đồng Nai",
        "Phước Thái",
        "Xã Tân Hiệp (huyện Long Thành), Xã Phước Bình, Xã Phước Thái",
      ],
    },
    {
      columns: ["Đồng Nai", "Sông Ray", "Xã Lâm San, Xã Sông Ray"],
    },
    {
      columns: ["Đồng Nai", "Tà Lài", "Xã Phú Thịnh, Xã Phú Lập, Xã Tà Lài"],
    },
    {
      columns: [
        "Đồng Nai",
        "Tam Hiệp",
        "Phường Tân Hiệp, Phường Tân Mai, Phường Bình Đa, Phường Tam Hiệp",
      ],
    },
    {
      columns: ["Đồng Nai", "Tam Phước", "Không sáp nhập"],
    },
    {
      columns: ["Đồng Nai", "Tân An", "Xã Vĩnh Tân, Xã Tân An"],
    },
    {
      columns: ["Đồng Nai", "Tân Hưng", "Xã Tân Hưng (huyện Hớn Quản), Xã An Khương, Xã Thanh An"],
    },
    {
      columns: [
        "Đồng Nai",
        "Tân Khai",
        "Thị trấn Tân Khai, Xã Tân Hiệp (huyện Hớn Quản), Xã Đồng Nơ",
      ],
    },
    {
      columns: ["Đồng Nai", "Tân Lợi", "Xã Tân Hưng, Xã Tân Lợi (huyện Đồng Phú), Xã Tân Hòa"],
    },
    {
      columns: [
        "Đồng Nai",
        "Tân Phú",
        "Thị trấn Tân Phú (huyện Tân Phú), Xã Phú Lộc, Xã Trà Cổ, Xã Phú Thanh, Xã Phú Xuân",
      ],
    },
    {
      columns: [
        "Đồng Nai",
        "Tân Quan",
        "Xã Phước An, Xã Tân Lợi (huyện Hớn Quản), Xã Quang Minh, Xã Tân Quan",
      ],
    },
    {
      columns: [
        "Đồng Nai",
        "Tân Tiến",
        "Xã Tân Thành, Xã Tân Tiến (huyện Bù Đốp), Xã Lộc An (huyện Lộc Ninh)",
      ],
    },
    {
      columns: [
        "Đồng Nai",
        "Tân Triều",
        "Phường Tân Phong, Xã Tân Bình, Xã Bình Lợi, Xã Thạnh Phú",
      ],
    },
    {
      columns: ["Đồng Nai", "Thanh Sơn", "Không sáp nhập"],
    },
    {
      columns: ["Đồng Nai", "Thiện Hưng", "Thị trấn Thanh Bình, Xã Thanh Hòa, Xã Thiện Hưng"],
    },
    {
      columns: ["Đồng Nai", "Thọ Sơn", "Xã Phú Sơn (huyện Bù Đăng), Xã Đồng Nai, Xã Thọ Sơn"],
    },
    {
      columns: ["Đồng Nai", "Thống Nhất", "Xã Gia Tân 1, Xã Gia Tân 2, Xã Phú Cường, Xã Phú Túc"],
    },
    {
      columns: ["Đồng Nai", "Thuận Lợi", "Xã Thuận Phú, Xã Thuận Lợi"],
    },
    {
      columns: [
        "Đồng Nai",
        "Trảng Bom",
        "Thị trấn Trảng Bom, Xã Quảng Tiến, Xã Sông Trầu, Xã Giang Điền",
      ],
    },
    {
      columns: ["Đồng Nai", "Trảng Dài", "Phường Trảng Dài, Xã Thiện Tân"],
    },
    {
      columns: [
        "Đồng Nai",
        "Trấn Biên",
        "Phường Bửu Long, Phường Quang Vinh, Phường Trung Dũng, Phường Thống Nhất, Phường Hiệp Hòa, Phường An Bình",
      ],
    },
    {
      columns: ["Đồng Nai", "Trị An", "Thị trấn Vĩnh An, Xã Mã Đà, Xã Trị An"],
    },
    {
      columns: ["Đồng Nai", "Xuân Bắc", "Xã Suối Nho, Xã Xuân Bắc"],
    },
    {
      columns: ["Đồng Nai", "Xuân Định", "Xã Xuân Bảo, Xã Bảo Hòa, Xã Xuân Định"],
    },
    {
      columns: ["Đồng Nai", "Xuân Đông", "Xã Xuân Tây, Xã Xuân Đông, Xã Xuân Tâm"],
    },
    {
      columns: ["Đồng Nai", "Xuân Đường", "Xã Cẩm Đường, Xã Thừa Đức, Xã Xuân Đường"],
    },
    {
      columns: [
        "Đồng Nai",
        "Xuân Hòa",
        "Xã Xuân Hưng, Xã Xuân Hòa, Xã Xuân Tâm (phần còn lại sau khi sáp nhập vào xã Xuân Đông)",
      ],
    },
    {
      columns: ["Đồng Nai", "Xuân Lập", "Phường Bàu Sen, Phường Xuân Lập"],
    },
    {
      columns: [
        "Đồng Nai",
        "Xuân Lộc",
        "Thị trấn Gia Ray, Xã Xuân Thọ, Xã Xuân Trường, Xã Suối Cát, Xã Xuân Hiệp",
      ],
    },
    {
      columns: ["Đồng Nai", "Xuân Phú", "Xã Lang Minh, Xã Xuân Phú"],
    },
    {
      columns: ["Đồng Nai", "Xuân Quế", "Xã Sông Nhạn, Xã Xuân Quế"],
    },
    {
      columns: ["Đồng Nai", "Xuân Thành", "Xã Suối Cao, Xã Xuân Thành"],
    },
    {
      columns: ["Đồng Tháp", "An Bình", "Phường An Lộc, Phường An Bình A, Phường An Bình B"],
    },
    {
      columns: ["Đồng Tháp", "An Hòa", "Xã Phú Thành B, Xã An Hòa"],
    },
    {
      columns: ["Đồng Tháp", "An Hữu", "Xã Hòa Hưng, Xã Mỹ Lương, Xã An Hữu"],
    },
    {
      columns: ["Đồng Tháp", "An Long", "Xã An Phong, Xã Phú Ninh, Xã An Long"],
    },
    {
      columns: ["Đồng Tháp", "An Phước", "Xã Tân Phước (huyện Tân Hồng), Xã An Phước"],
    },
    {
      columns: ["Đồng Tháp", "An Thạnh Thủy", "Xã Bình Phan, Xã Bình Phục Nhứt, Xã An Thạnh Thủy"],
    },
    {
      columns: ["Đồng Tháp", "Ba Sao", "Xã Phương Trà, Xã Ba Sao"],
    },
    {
      columns: [
        "Đồng Tháp",
        "Bình Hàng Trung",
        "Xã Tân Hội Trung, Xã Bình Hàng Tây, Xã Bình Hàng Trung",
      ],
    },
    {
      columns: ["Đồng Tháp", "Bình Ninh", "Xã Xuân Đông, Xã Hòa Định, Xã Bình Ninh"],
    },
    {
      columns: ["Đồng Tháp", "Bình Phú", "Thị trấn Bình Phú, Xã Phú An, Xã Cẩm Sơn"],
    },
    {
      columns: ["Đồng Tháp", "Bình Thành", "Xã Bình Thành (huyện Thanh Bình), Xã Bình Tấn"],
    },
    {
      columns: ["Đồng Tháp", "Bình Trưng", "Xã Điềm Hy, Xã Bình Trưng"],
    },
    {
      columns: ["Đồng Tháp", "Bình Xuân", "Phường Long Chánh, Xã Bình Xuân"],
    },
    {
      columns: ["Đồng Tháp", "Cái Bè", "Thị trấn Cái Bè, Xã Đông Hòa Hiệp, Xã Hòa Khánh"],
    },
    {
      columns: [
        "Đồng Tháp",
        "Cai Lậy",
        "Phường 4 (thị xã Cai Lậy), Phường 5 (thị xã Cai Lậy), Xã Long Khánh",
      ],
    },
    {
      columns: [
        "Đồng Tháp",
        "Cao Lãnh",
        "Phường 1 (thành phố Cao Lãnh), Phường 3, Phường 4, Phường 6, Phường Hòa Thuận, Xã Hòa An, Xã Tịnh Thới, Xã Tân Thuận Tây, Xã Tân Thuận Đông",
      ],
    },
    {
      columns: ["Đồng Tháp", "Châu Thành", "Thị trấn Tân Hiệp, Xã Thân Cửu Nghĩa, Xã Long An"],
    },
    {
      columns: ["Đồng Tháp", "Chợ Gạo", "Thị trấn Chợ Gạo, Xã Long Bình Điền, Xã Song Bình"],
    },
    {
      columns: [
        "Đồng Tháp",
        "Đạo Thạnh",
        "Phường 4 (thành phố Mỹ Tho), Phường 5 (thành phố Mỹ Tho), Xã Đạo Thạnh",
      ],
    },
    {
      columns: ["Đồng Tháp", "Đốc Binh Kiều", "Xã Tân Kiều, Xã Đốc Binh Kiều"],
    },
    {
      columns: ["Đồng Tháp", "Đồng Sơn", "Xã Bình Nhì, Xã Đồng Thạnh, Xã Đồng Sơn"],
    },
    {
      columns: ["Đồng Tháp", "Gia Thuận", "Thị trấn Vàm Láng, Xã Kiểng Phước, Xã Gia Thuận"],
    },
    {
      columns: [
        "Đồng Tháp",
        "Gò Công",
        "Phường 1 (thành phố Gò Công), Phường 5 (thành phố Gò Công), Phường Long Hòa",
      ],
    },
    {
      columns: ["Đồng Tháp", "Gò Công Đông", "Xã Tân Thành (huyện Gò Công Đông), Xã Tăng Hòa"],
    },
    {
      columns: ["Đồng Tháp", "Hậu Mỹ", "Xã Hậu Mỹ Bắc A, Xã Hậu Mỹ Bắc B, Xã Hậu Mỹ Trinh"],
    },
    {
      columns: ["Đồng Tháp", "Hiệp Đức", "Xã Tân Phong, Xã Hội Xuân, Xã Hiệp Đức"],
    },
    {
      columns: [
        "Đồng Tháp",
        "Hòa Long",
        "Thị trấn Lai Vung, Xã Long Hậu, Xã Long Thắng, Xã Hòa Long",
      ],
    },
    {
      columns: [
        "Đồng Tháp",
        "Hội Cư",
        "Xã Mỹ Hội (huyện Cái Bè), Xã An Cư, Xã Hậu Thành, Xã Hậu Mỹ Phú",
      ],
    },
    {
      columns: [
        "Đồng Tháp",
        "Hồng Ngự",
        "Phường An Thạnh, Xã Bình Thạnh, Xã Tân Hội (thành phố Hồng Ngự)",
      ],
    },
    {
      columns: [
        "Đồng Tháp",
        "Hưng Thạnh",
        "Xã Hưng Thạnh (huyện Tân Phước), Xã Phú Mỹ, Xã Tân Hòa Thành",
      ],
    },
    {
      columns: ["Đồng Tháp", "Kim Sơn", "Xã Song Thuận, Xã Bình Đức, Xã Kim Sơn"],
    },
    {
      columns: [
        "Đồng Tháp",
        "Lai Vung",
        "Xã Tân Thành, Xã Tân Phước (huyện Lai Vung), Xã Định An, Xã Định Yên",
      ],
    },
    {
      columns: [
        "Đồng Tháp",
        "Lấp Vò",
        "Thị trấn Lấp Vò, Xã Bình Thành (huyện Lấp Vò), Xã Vĩnh Thạnh, Xã Bình Thạnh Trung",
      ],
    },
    {
      columns: ["Đồng Tháp", "Long Bình", "Xã Bình Tân, Xã Long Bình"],
    },
    {
      columns: ["Đồng Tháp", "Long Định", "Xã Nhị Bình, Xã Đông Hòa, Xã Long Định"],
    },
    {
      columns: ["Đồng Tháp", "Long Hưng", "Xã Tam Hiệp, Xã Thạnh Phú, Xã Long Hưng"],
    },
    {
      columns: ["Đồng Tháp", "Long Khánh", "Xã Long Khánh A, Xã Long Khánh B"],
    },
    {
      columns: ["Đồng Tháp", "Long Phú Thuận", "Xã Long Thuận, Xã Phú Thuận A, Xã Phú Thuận B"],
    },
    {
      columns: ["Đồng Tháp", "Long Thuận", "Phường 2 (thành phố Gò Công), Phường Long Thuận"],
    },
    {
      columns: [
        "Đồng Tháp",
        "Long Tiên",
        "Xã Mỹ Long (huyện Cai Lậy), Xã Long Trung, Xã Long Tiên",
      ],
    },
    {
      columns: ["Đồng Tháp", "Lương Hòa Lạc", "Xã Thanh Bình, Xã Phú Kiết, Xã Lương Hòa Lạc"],
    },
    {
      columns: [
        "Đồng Tháp",
        "Mỹ An Hưng",
        "Xã Tân Mỹ (huyện Lấp Vò), Xã Hội An Đông, Xã Mỹ An Hưng A, Xã Mỹ An Hưng B",
      ],
    },
    {
      columns: ["Đồng Tháp", "Mỹ Đức Tây", "Xã Thiện Trí, Xã Mỹ Đức Đông, Xã Mỹ Đức Tây"],
    },
    {
      columns: ["Đồng Tháp", "Mỹ Hiệp", "Xã Mỹ Long, Xã Bình Thạnh (huyện Cao Lãnh), Xã Mỹ Hiệp"],
    },
    {
      columns: ["Đồng Tháp", "Mỹ Lợi", "Xã An Thái Đông, Xã Mỹ Lợi A, Xã Mỹ Lợi B"],
    },
    {
      columns: [
        "Đồng Tháp",
        "Mỹ Ngãi",
        "Phường Mỹ Ngãi, Xã Mỹ Tân (thành phố Cao Lãnh), Xã Tân Nghĩa",
      ],
    },
    {
      columns: [
        "Đồng Tháp",
        "Mỹ Phong",
        "Phường 9 (thành phố Mỹ Tho), Xã Tân Mỹ Chánh, Xã Mỹ Phong",
      ],
    },
    {
      columns: [
        "Đồng Tháp",
        "Mỹ Phước Tây",
        "Phường 1 (thị xã Cai Lậy), Phường 3 (thị xã Cai Lậy), Xã Mỹ Hạnh Trung, Xã Mỹ Phước Tây",
      ],
    },
    {
      columns: ["Đồng Tháp", "Mỹ Quí", "Xã Láng Biển, Xã Mỹ Đông, Xã Mỹ Quí"],
    },
    {
      columns: ["Đồng Tháp", "Mỹ Thành", "Xã Phú Nhuận, Xã Mỹ Thành Bắc, Xã Mỹ Thành Nam"],
    },
    {
      columns: ["Đồng Tháp", "Mỹ Thiện", "Xã Mỹ Tân (huyện Cái Bè), Xã Mỹ Trung, Xã Thiện Trung"],
    },
    {
      columns: [
        "Đồng Tháp",
        "Mỹ Tho",
        "Phường 1 (thành phố Mỹ Tho), Phường 2 (thành phố Mỹ Tho), Phường Tân Long",
      ],
    },
    {
      columns: [
        "Đồng Tháp",
        "Mỹ Thọ",
        "Thị trấn Mỹ Thọ, Xã Mỹ Hội (huyện Cao Lãnh), Xã Mỹ Xương, Xã Mỹ Thọ",
      ],
    },
    {
      columns: [
        "Đồng Tháp",
        "Mỹ Tịnh An",
        "Xã Trung Hòa, Xã Hòa Tịnh, Xã Tân Bình Thạnh, Xã Mỹ Tịnh An",
      ],
    },
    {
      columns: ["Đồng Tháp", "Mỹ Trà", "Phường Mỹ Phú, Xã Nhị Mỹ, Xã An Bình, Xã Mỹ Trà"],
    },
    {
      columns: ["Đồng Tháp", "Ngũ Hiệp", "Xã Tam Bình, Xã Ngũ Hiệp"],
    },
    {
      columns: ["Đồng Tháp", "Nhị Quý", "Phường Nhị Mỹ, Xã Phú Quý, Xã Nhị Quý"],
    },
    {
      columns: [
        "Đồng Tháp",
        "Phong Hòa",
        "Xã Tân Hòa (huyện Lai Vung), Xã Định Hòa, Xã Vĩnh Thới, Xã Phong Hòa",
      ],
    },
    {
      columns: [
        "Đồng Tháp",
        "Phong Mỹ",
        "Xã Phong Mỹ, Xã Gáo Giồng (phần còn lại sau khi sáp nhập vào xã Phú Cường)",
      ],
    },
    {
      columns: [
        "Đồng Tháp",
        "Phú Cường",
        "Xã Phú Cường (huyện Tam Nông), Xã Hòa Bình, Xã Gáo Giồng",
      ],
    },
    {
      columns: [
        "Đồng Tháp",
        "Phú Hựu",
        "Thị trấn Cái Tàu Hạ, Xã An Phú Thuận, Xã An Hiệp, Xã An Nhơn, Xã Phú Hựu",
      ],
    },
    {
      columns: [
        "Đồng Tháp",
        "Phú Thành",
        "Xã Bình Phú (huyện Gò Công Tây), Xã Thành Công, Xã Yên Luông",
      ],
    },
    {
      columns: ["Đồng Tháp", "Phú Thọ", "Xã Phú Thành A, Xã Phú Thọ"],
    },
    {
      columns: ["Đồng Tháp", "Phương Thịnh", "Xã Hưng Thạnh (huyện Tháp Mười), Xã Phương Thịnh"],
    },
    {
      columns: [
        "Đồng Tháp",
        "Sa Đéc",
        "Phường 1, Phường 2, Phường 3, Phường 4 (thành phố Sa Đéc), Phường An Hòa, Phường Tân Quy Đông, Xã Tân Khánh Đông, Xã Tân Quy Tây",
      ],
    },
    {
      columns: ["Đồng Tháp", "Sơn Qui", "Phường Long Hưng, Xã Tân Trung, Xã Bình Đông"],
    },
    {
      columns: ["Đồng Tháp", "Tam Nông", "Xã Phú Đức, Xã Phú Hiệp"],
    },
    {
      columns: ["Đồng Tháp", "Tân Dương", "Xã Tân Phú Đông, Xã Hòa Thành, Xã Tân Dương"],
    },
    {
      columns: ["Đồng Tháp", "Tân Điền", "Xã Bình Ân, Xã Tân Điền"],
    },
    {
      columns: [
        "Đồng Tháp",
        "Tân Đông",
        "Xã Tân Phước (huyện Gò Công Đông), Xã Tân Tây, Xã Tân Đông",
      ],
    },
    {
      columns: ["Đồng Tháp", "Tân Hòa", "Thị trấn Tân Hòa, Xã Phước Trung, Xã Bình Nghị"],
    },
    {
      columns: ["Đồng Tháp", "Tân Hộ Cơ", "Xã Tân Thành B, Xã Tân Hộ Cơ"],
    },
    {
      columns: [
        "Đồng Tháp",
        "Tân Hồng",
        "Thị trấn Sa Rài, Xã Bình Phú (huyện Tân Hồng), Xã Tân Công Chí",
      ],
    },
    {
      columns: ["Đồng Tháp", "Tân Hương", "Xã Tân Lý Đông, Xã Tân Hội Đông, Xã Tân Hương"],
    },
    {
      columns: [
        "Đồng Tháp",
        "Tân Khánh Trung",
        "Xã Long Hưng A, Xã Long Hưng B, Xã Tân Khánh Trung",
      ],
    },
    {
      columns: [
        "Đồng Tháp",
        "Tân Long",
        "Xã Tân Bình, Xã Tân Hòa (huyện Thanh Bình), Xã Tân Quới, Xã Tân Huề, Xã Tân Long, Xã Phú Thuận B (phần còn lại sau khi sáp nhập vào xã Long Phú Thuận)",
      ],
    },
    {
      columns: ["Đồng Tháp", "Tân Nhuận Đông", "Xã Hòa Tân, Xã An Khánh, Xã Tân Nhuận Đông"],
    },
    {
      columns: ["Đồng Tháp", "Tân Phú", "Xã Tân Hội, Xã Tân Phú (thị xã Cai Lậy), Xã Mỹ Hạnh Đông"],
    },
    {
      columns: ["Đồng Tháp", "Tân Phú Đông", "Xã Phú Thạnh, Xã Phú Đông, Xã Phú Tân"],
    },
    {
      columns: [
        "Đồng Tháp",
        "Tân Phú Trung",
        "Xã Tân Bình, Xã Tân Phú (huyện Châu Thành), Xã Phú Long, Xã Tân Phú Trung",
      ],
    },
    {
      columns: ["Đồng Tháp", "Tân Phước 1", "Thị trấn Mỹ Phước, Xã Thạnh Mỹ, Xã Tân Hòa Đông"],
    },
    {
      columns: ["Đồng Tháp", "Tân Phước 2", "Xã Thạnh Tân, Xã Thạnh Hòa, Xã Tân Hòa Tây"],
    },
    {
      columns: ["Đồng Tháp", "Tân Phước 3", "Xã Phước Lập, Xã Tân Lập 1, Xã Tân Lập 2"],
    },
    {
      columns: ["Đồng Tháp", "Tân Thành", "Xã Thông Bình, Xã Tân Thành A"],
    },
    {
      columns: [
        "Đồng Tháp",
        "Tân Thạnh",
        "Xã Phú Lợi, Xã Tân Thạnh (huyện Thanh Bình) (phần còn lại sau khi sáp nhập vào xã Thanh Bình)",
      ],
    },
    {
      columns: [
        "Đồng Tháp",
        "Tân Thới",
        "Xã Tân Phú, Xã Tân Thạnh (huyện Tân Phú Đông), Xã Tân Thới",
      ],
    },
    {
      columns: [
        "Đồng Tháp",
        "Tân Thuận Bình",
        "Xã Đăng Hưng Phước, Xã Quơn Long, Xã Tân Thuận Bình",
      ],
    },
    {
      columns: [
        "Đồng Tháp",
        "Thanh Bình",
        "Xã Tân Mỹ, Xã Tân Phú (huyện Thanh Bình), Thị trấn Thanh Bình, Xã Tân Thạnh (huyện Thanh Bình)",
      ],
    },
    {
      columns: [
        "Đồng Tháp",
        "Thanh Hòa",
        "Phường 2 (thị xã Cai Lậy), Xã Tân Bình (thị xã Cai Lậy), Xã Thanh Hòa",
      ],
    },
    {
      columns: ["Đồng Tháp", "Thanh Hưng", "Xã Tân Thanh, Xã Tân Hưng, Xã An Thái Trung"],
    },
    {
      columns: ["Đồng Tháp", "Thanh Mỹ", "Xã Phú Điền, Xã Thanh Mỹ"],
    },
    {
      columns: ["Đồng Tháp", "Thạnh Phú", "Xã Phú Cường (huyện Cai Lậy), Xã Thạnh Lộc"],
    },
    {
      columns: ["Đồng Tháp", "Tháp Mười", "Thị trấn Mỹ An, Xã Mỹ An, Xã Mỹ Hòa"],
    },
    {
      columns: ["Đồng Tháp", "Thới Sơn", "Phường 6 (thành phố Mỹ Tho), Xã Thới Sơn"],
    },
    {
      columns: ["Đồng Tháp", "Thường Lạc", "Phường An Lạc, Xã Thường Thới Hậu A, Xã Thường Lạc"],
    },
    {
      columns: [
        "Đồng Tháp",
        "Thường Phước",
        "Thị trấn Thường Thới Tiền, Xã Thường Phước 1, Xã Thường Phước 2",
      ],
    },
    {
      columns: ["Đồng Tháp", "Tràm Chim", "Thị trấn Tràm Chim, Xã Tân Công Sính"],
    },
    {
      columns: ["Đồng Tháp", "Trung An", "Phường 10, Xã Phước Thạnh, Xã Trung An"],
    },
    {
      columns: ["Đồng Tháp", "Trường Xuân", "Xã Thạnh Lợi, Xã Trường Xuân"],
    },
    {
      columns: ["Đồng Tháp", "Vĩnh Bình", "Thị trấn Vĩnh Bình, Xã Thạnh Nhựt, Xã Thạnh Trị"],
    },
    {
      columns: ["Đồng Tháp", "Vĩnh Hựu", "Xã Long Vĩnh, Xã Vĩnh Hựu"],
    },
    {
      columns: ["Đồng Tháp", "Vĩnh Kim", "Xã Phú Phong, Xã Bàn Long, Xã Vĩnh Kim"],
    },
    {
      columns: ["Gia Lai", "Al Bá", "Xã Ayun (huyện Chư Sê), Xã Kông Htok, Xã Al Bá"],
    },
    {
      columns: ["Gia Lai", "An Bình", "Phường An Bình, Xã Tân An, Xã Cư An"],
    },
    {
      columns: ["Gia Lai", "An Hòa", "Xã An Hòa, Xã An Quang, Xã An Nghĩa"],
    },
    {
      columns: [
        "Gia Lai",
        "An Khê",
        "Phường Ngô Mây, Phường Tây Sơn (thị xã An Khê), Phường An Phú, Phường An Phước, Phường An Tân, Xã Thành An",
      ],
    },
    {
      columns: ["Gia Lai", "An Lão", "Thị trấn An Lão, Xã An Tân, Xã An Hưng"],
    },
    {
      columns: ["Gia Lai", "An Lương", "Xã Mỹ Chánh, Xã Mỹ Thành, Xã Mỹ Cát"],
    },
    {
      columns: ["Gia Lai", "An Nhơn", "Phường Đập Đá, Xã Nhơn Mỹ, Xã Nhơn Hậu"],
    },
    {
      columns: ["Gia Lai", "An Nhơn Bắc", "Phường Nhơn Thành, Xã Nhơn Phong, Xã Nhơn Hạnh"],
    },
    {
      columns: ["Gia Lai", "An Nhơn Đông", "Phường Nhơn Hưng, Xã Nhơn An"],
    },
    {
      columns: ["Gia Lai", "An Nhơn Nam", "Phường Nhơn Hòa, Xã Nhơn Thọ"],
    },
    {
      columns: ["Gia Lai", "An Nhơn Tây", "Xã Nhơn Lộc, Xã Nhơn Tân"],
    },
    {
      columns: ["Gia Lai", "An Phú", "Phường Thắng Lợi, Xã Chư Á, Xã An Phú"],
    },
    {
      columns: [
        "Gia Lai",
        "An Toàn",
        "Xã An Toàn, Xã An Nghĩa (phần còn lại sau khi sáp nhập vào xã An Hòa)",
      ],
    },
    {
      columns: ["Gia Lai", "An Vinh", "Xã An Trung (huyện An Lão), Xã An Dũng, Xã An Vinh"],
    },
    {
      columns: ["Gia Lai", "Ayun", "Xã Đak Jơ Ta, Xã Ayun (huyện Mang Yang)"],
    },
    {
      columns: [
        "Gia Lai",
        "Ayun Pa",
        "Phường Đoàn Kết, Phường Sông Bờ, Phường Cheo Reo, Phường Hòa Bình",
      ],
    },
    {
      columns: ["Gia Lai", "Ân Hảo", "Xã Ân Hảo Tây, Xã Ân Hảo Đông, Xã Ân Mỹ"],
    },
    {
      columns: ["Gia Lai", "Ân Tường", "Xã Ân Tường Tây, Xã Ân Hữu, Xã Đak Mang"],
    },
    {
      columns: ["Gia Lai", "Bàu Cạn", "Xã Thăng Hưng, Xã Bình Giáo, Xã Bàu Cạn"],
    },
    {
      columns: ["Gia Lai", "Biển Hồ", "Xã Nghĩa Hưng, Xã Chư Đang Ya, Xã Hà Bầu, Xã Biển Hồ"],
    },
    {
      columns: ["Gia Lai", "Bình An", "Xã Tây Vinh, Xã Tây Bình, Xã Bình Hòa, Xã Bình Thành"],
    },
    {
      columns: ["Gia Lai", "Bình Dương", "Thị trấn Bình Dương, Xã Mỹ Lợi, Xã Mỹ Phong"],
    },
    {
      columns: ["Gia Lai", "Bình Định", "Phường Bình Định, Xã Nhơn Khánh, Xã Nhơn Phúc"],
    },
    {
      columns: ["Gia Lai", "Bình Hiệp", "Xã Bình Thuận, Xã Bình Tân, Xã Tây An"],
    },
    {
      columns: ["Gia Lai", "Bình Khê", "Xã Tây Giang, Xã Tây Thuận"],
    },
    {
      columns: ["Gia Lai", "Bình Phú", "Xã Vĩnh An, Xã Bình Tường, Xã Tây Phú"],
    },
    {
      columns: ["Gia Lai", "Bồng Sơn", "Phường Hoài Đức, Phường Bồng Sơn"],
    },
    {
      columns: ["Gia Lai", "Bờ Ngoong", "Xã Bar Măih, Xã Ia Tiêm, Xã Chư Pơng, Xã Bờ Ngoong"],
    },
    {
      columns: [
        "Gia Lai",
        "Canh Liên",
        "-, Xã Canh Liên (phần còn lại sau khi sáp nhập vào xã Canh Vinh)",
      ],
    },
    {
      columns: [
        "Gia Lai",
        "Canh Vinh",
        "Xã Canh Vinh, Xã Canh Hiển, Xã Canh Liên, Xã Canh Hiệp (phần còn lại sau khi sáp nhập vào xã Vân Canh)",
      ],
    },
    {
      columns: ["Gia Lai", "Cát Tiến", "Thị trấn Cát Tiến, Xã Cát Thành, Xã Cát Hải"],
    },
    {
      columns: ["Gia Lai", "Chơ Long", "Xã Đăk Pơ Pho, Xã Chơ GLong"],
    },
    {
      columns: ["Gia Lai", "Chư A Thai", "Xã Ayun Hạ, Xã Ia Ake, Xã Chư A Thai"],
    },
    {
      columns: ["Gia Lai", "Chư Krey", "Xã An Trung (huyện Kông Chro), Xã Chư Krey"],
    },
    {
      columns: ["Gia Lai", "Chư Păh", "Thị trấn Phú Hòa, Xã Nghĩa Hòa, Xã Hòa Phú"],
    },
    {
      columns: ["Gia Lai", "Chư Prông", "Thị trấn Chư Prông, Xã Ia Phìn, Xã Ia Kly, Xã Ia Drang"],
    },
    {
      columns: ["Gia Lai", "Chư Pưh", "Thị trấn Nhơn Hòa, Xã Chư Don, Xã Ia Phang"],
    },
    {
      columns: ["Gia Lai", "Chư Sê", "Thị trấn Chư Sê, Xã Dun, Xã Ia Blang, Xã Ia Pal, Xã Ia Glai"],
    },
    {
      columns: ["Gia Lai", "Cửu An", "Xã Tú An, Xã Xuân An, Xã Song An, Xã Cửu An"],
    },
    {
      columns: [
        "Gia Lai",
        "Diên Hồng",
        "Phường Yên Đỗ, Phường Ia Kring, Phường Diên Hồng, Xã Diên Phú",
      ],
    },
    {
      columns: ["Gia Lai", "Đak Đoa", "Thị trấn Đak Đoa, Xã Tân Bình, Xã Glar"],
    },
    {
      columns: ["Gia Lai", "Đak Pơ", "Thị trấn Đak Pơ, Xã Hà Tam, Xã An Thành, Xã Yang Bắc"],
    },
    {
      columns: ["Gia Lai", "Đak Rong", "Xã Kon Pne, Xã Đak Rong"],
    },
    {
      columns: ["Gia Lai", "Đak Sơmei", "Xã Hà Đông, Xã Đak Sơmei"],
    },
    {
      columns: ["Gia Lai", "Đăk Song", "Xã Đăk Pling, Xã Đăk Song"],
    },
    {
      columns: ["Gia Lai", "Đề Gi", "Thị trấn Cát Khánh, Xã Cát Minh, Xã Cát Tài"],
    },
    {
      columns: ["Gia Lai", "Đức Cơ", "Thị trấn Chư Ty, Xã Ia Kriêng"],
    },
    {
      columns: ["Gia Lai", "Gào", "Xã Ia Kênh, Xã Ia Pếch, Xã Gào"],
    },
    {
      columns: ["Gia Lai", "Hòa Hội", "Xã Cát Hanh, Xã Cát Hiệp"],
    },
    {
      columns: [
        "Gia Lai",
        "Hoài Ân",
        "Thị trấn Tăng Bạt Hổ, Xã Ân Phong, Xã Ân Đức, Xã Ân Tường Đông",
      ],
    },
    {
      columns: [
        "Gia Lai",
        "Hoài Nhơn",
        "Phường Hoài Thanh, Phường Tam Quan Nam, Phường Hoài Thanh Tây",
      ],
    },
    {
      columns: ["Gia Lai", "Hoài Nhơn Bắc", "Phường Tam Quan Bắc, Xã Hoài Sơn, Xã Hoài Châu Bắc"],
    },
    {
      columns: ["Gia Lai", "Hoài Nhơn Đông", "Phường Hoài Hương, Xã Hoài Hải, Xã Hoài Mỹ"],
    },
    {
      columns: ["Gia Lai", "Hoài Nhơn Nam", "Phường Hoài Tân, Phường Hoài Xuân"],
    },
    {
      columns: ["Gia Lai", "Hoài Nhơn Tây", "Phường Hoài Hảo, Xã Hoài Phú"],
    },
    {
      columns: ["Gia Lai", "Hội Phú", "Phường Trà Bá, Phường Chi Lăng, Phường Hội Phú"],
    },
    {
      columns: ["Gia Lai", "Hội Sơn", "Xã Cát Lâm, Xã Cát Sơn"],
    },
    {
      columns: ["Gia Lai", "Hra", "Xã Đak Ta Ley, Xã Hra"],
    },
    {
      columns: ["Gia Lai", "Ia Băng", "Xã Ia Băng (huyện Đak Đoa), Xã Adơk, Xã Ia Pết"],
    },
    {
      columns: ["Gia Lai", "Ia Boòng", "Xã Ia O (huyện Chư Prông), Xã Ia Me, Xã Ia Boòng"],
    },
    {
      columns: ["Gia Lai", "Ia Chia", "Không sáp nhập"],
    },
    {
      columns: ["Gia Lai", "Ia Dom", "Không sáp nhập"],
    },
    {
      columns: ["Gia Lai", "Ia Dơk", "Xã Ia Kla, Xã Ia Dơk"],
    },
    {
      columns: ["Gia Lai", "Ia Dreh", "Xã Ia Rmok, Xã Krông Năng, Xã Ia Dreh"],
    },
    {
      columns: ["Gia Lai", "Ia Grai", "Thị trấn Ia Kha, Xã Ia Bă, Xã Ia Grăng"],
    },
    {
      columns: ["Gia Lai", "Ia Hiao", "Xã Chrôh Pơnan, Xã Ia Peng, Xã Ia Hiao"],
    },
    {
      columns: ["Gia Lai", "Ia Hrú", "Xã Ia Dreng, Xã Ia Rong, Xã HBông, Xã Ia Hrú"],
    },
    {
      columns: [
        "Gia Lai",
        "Ia Hrung",
        "Xã Ia Sao (huyện Ia Grai), Xã Ia Yok, Xã Ia Dêr, Xã Ia Hrung",
      ],
    },
    {
      columns: ["Gia Lai", "Ia Khươl", "Xã Đăk Tơ Ver, Xã Hà Tây, Xã Ia Khươl"],
    },
    {
      columns: ["Gia Lai", "Ia Ko", "Xã Ia Hlốp, Xã Ia Hla, Xã Ia Ko"],
    },
    {
      columns: ["Gia Lai", "Ia Krái", "Xã Ia Tô, Xã Ia Khai, Xã Ia Krái"],
    },
    {
      columns: ["Gia Lai", "Ia Krêl", "Xã Ia Lang, Xã Ia Din, Xã Ia Krêl"],
    },
    {
      columns: ["Gia Lai", "Ia Lâu", "Xã Ia Piơr, Xã Ia Lâu"],
    },
    {
      columns: ["Gia Lai", "Ia Le", "Xã Ia Blứ, Xã Ia Le"],
    },
    {
      columns: ["Gia Lai", "Ia Ly", "Thị trấn Ia Ly, Xã Ia Mơ Nông, Xã Ia Kreng"],
    },
    {
      columns: ["Gia Lai", "Ia Mơ", "Không sáp nhập"],
    },
    {
      columns: ["Gia Lai", "Ia Nan", "Không sáp nhập"],
    },
    {
      columns: ["Gia Lai", "Ia O", "Không sáp nhập"],
    },
    {
      columns: ["Gia Lai", "Ia Pa", "Xã Ia Mrơn, Xã Kim Tân, Xã Ia Trôk"],
    },
    {
      columns: ["Gia Lai", "Ia Phí", "Xã Ia Ka, Xã Ia Nhin, Xã Ia Phí"],
    },
    {
      columns: ["Gia Lai", "Ia Pia", "Xã Ia Ga, Xã Ia Vê, Xã Ia Pia"],
    },
    {
      columns: ["Gia Lai", "Ia Pnôn", "Không sáp nhập"],
    },
    {
      columns: ["Gia Lai", "Ia Púch", "Không sáp nhập"],
    },
    {
      columns: ["Gia Lai", "Ia Rbol", "Xã Chư Băh, Xã Ia Rbol"],
    },
    {
      columns: ["Gia Lai", "Ia Rsai", "Xã Chư RCăm, Xã Chư Gu, Xã Ia Rsai"],
    },
    {
      columns: ["Gia Lai", "Ia Sao", "Xã Ia Sao (thị xã Ayun Pa), Xã Ia Rtô"],
    },
    {
      columns: ["Gia Lai", "Ia Tôr", "Xã Ia Băng (huyện Chư Prông), Xã Ia Bang, Xã Ia Tôr"],
    },
    {
      columns: ["Gia Lai", "Ia Tul", "Xã Chư Mố, Xã Ia Broăi, Xã Ia Kdăm, Xã Ia Tul"],
    },
    {
      columns: ["Gia Lai", "Kbang", "Thị trấn Kbang, Xã Lơ Ku, Xã Đak Smar"],
    },
    {
      columns: ["Gia Lai", "KDang", "Xã Hnol, Xã Trang, Xã KDang"],
    },
    {
      columns: ["Gia Lai", "Kim Sơn", "Xã Ân Nghĩa, Xã Bok Tới"],
    },
    {
      columns: ["Gia Lai", "Kon Chiêng", "Xã Đak Trôi, Xã Kon Chiêng"],
    },
    {
      columns: ["Gia Lai", "Kon Gang", "Xã Đak Krong, Xã Hneng, Xã Nam Yang, Xã Kon Gang"],
    },
    {
      columns: ["Gia Lai", "Kông Bơ La", "Xã Đông, Xã Nghĩa An, Xã Kông Bơ La"],
    },
    {
      columns: ["Gia Lai", "Kông Chro", "Thị trấn Kông Chro, Xã Yang Trung, Xã Yang Nam"],
    },
    {
      columns: ["Gia Lai", "Krong", "Không sáp nhập"],
    },
    {
      columns: ["Gia Lai", "Lơ Pang", "Xã Đê Ar, Xã Kon Thụp, Xã Lơ Pang"],
    },
    {
      columns: ["Gia Lai", "Mang Yang", "Thị trấn Kon Dơng, Xã Đăk Yă, Xã Đak Djrăng, Xã Hải Yang"],
    },
    {
      columns: ["Gia Lai", "Ngô Mây", "Xã Cát Hưng, Xã Cát Thắng, Xã Cát Chánh"],
    },
    {
      columns: ["Gia Lai", "Nhơn Châu", "Không sáp nhập"],
    },
    {
      columns: ["Gia Lai", "Phù Cát", "Thị trấn Ngô Mây, Xã Cát Trinh, Xã Cát Tân"],
    },
    {
      columns: ["Gia Lai", "Phù Mỹ", "Thị trấn Phù Mỹ, Xã Mỹ Quang, Xã Mỹ Chánh Tây"],
    },
    {
      columns: ["Gia Lai", "Phù Mỹ Bắc", "Xã Mỹ Đức, Xã Mỹ Châu, Xã Mỹ Lộc"],
    },
    {
      columns: ["Gia Lai", "Phù Mỹ Đông", "Xã Mỹ An, Xã Mỹ Thọ, Xã Mỹ Thắng"],
    },
    {
      columns: ["Gia Lai", "Phù Mỹ Nam", "Xã Mỹ Tài, Xã Mỹ Hiệp"],
    },
    {
      columns: ["Gia Lai", "Phù Mỹ Tây", "Xã Mỹ Trinh, Xã Mỹ Hòa"],
    },
    {
      columns: ["Gia Lai", "Phú Thiện", "Thị trấn Phú Thiện, Xã Ia Sol, Xã Ia Piar, Xã Ia Yeng"],
    },
    {
      columns: [
        "Gia Lai",
        "Phú Túc",
        "Thị trấn Phú Túc, Xã Phú Cần, Xã Chư Ngọc, Xã Ia Mlah, Xã Đất Bằng",
      ],
    },
    {
      columns: [
        "Gia Lai",
        "Pleiku",
        "Phường Tây Sơn (thành phố Pleiku), Phường Hội Thương, Phường Hoa Lư, Phường Phù Đổng, Xã Trà Đa",
      ],
    },
    {
      columns: ["Gia Lai", "Pờ Tó", "Xã Chư Răng, Xã Pờ Tó"],
    },
    {
      columns: [
        "Gia Lai",
        "Quy Nhơn",
        "Phường Đống Đa (thành phố Quy Nhơn), Phường Hải Cảng, Phường Thị Nại, Phường Trần Phú",
      ],
    },
    {
      columns: ["Gia Lai", "Quy Nhơn Bắc", "Phường Trần Quang Diệu, Phường Nhơn Phú"],
    },
    {
      columns: [
        "Gia Lai",
        "Quy Nhơn Đông",
        "Phường Nhơn Bình, Xã Nhơn Hội, Xã Nhơn Lý, Xã Nhơn Hải",
      ],
    },
    {
      columns: [
        "Gia Lai",
        "Quy Nhơn Nam",
        "Phường Ngô Mây (thành phố Quy Nhơn), Phường Nguyễn Văn Cừ, Phường Quang Trung, Phường Ghềnh Ráng",
      ],
    },
    {
      columns: ["Gia Lai", "Quy Nhơn Tây", "Phường Bùi Thị Xuân, Xã Phước Mỹ"],
    },
    {
      columns: ["Gia Lai", "Sơn Lang", "Xã Sơ Pai, Xã Sơn Lang"],
    },
    {
      columns: ["Gia Lai", "SRó", "Xã Đăk Kơ Ning, Xã SRó"],
    },
    {
      columns: ["Gia Lai", "Tam Quan", "Phường Tam Quan, Xã Hoài Châu"],
    },
    {
      columns: ["Gia Lai", "Tây Sơn", "Thị trấn Phú Phong, Xã Tây Xuân, Xã Bình Nghi"],
    },
    {
      columns: [
        "Gia Lai",
        "Thống Nhất",
        "Phường Đống Đa (thành phố Pleiku), Phường Yên Thế, Phường Thống Nhất",
      ],
    },
    {
      columns: ["Gia Lai", "Tơ Tung", "Xã Kông Lơng Khơng, Xã Tơ Tung"],
    },
    {
      columns: [
        "Gia Lai",
        "Tuy Phước",
        "Thị trấn Tuy Phước, Thị trấn Diêu Trì, Xã Phước Thuận, Xã Phước Nghĩa, Xã Phước Lộc",
      ],
    },
    {
      columns: ["Gia Lai", "Tuy Phước Bắc", "Xã Phước Hiệp, Xã Phước Hưng, Xã Phước Quang"],
    },
    {
      columns: ["Gia Lai", "Tuy Phước Đông", "Xã Phước Sơn, Xã Phước Hòa, Xã Phước Thắng"],
    },
    {
      columns: ["Gia Lai", "Tuy Phước Tây", "Xã Phước An, Xã Phước Thành"],
    },
    {
      columns: ["Gia Lai", "Uar", "Xã Ia Rsươm, Xã Chư Drăng, Xã Uar"],
    },
    {
      columns: ["Gia Lai", "Vạn Đức", "Xã Ân Sơn, Xã Ân Tín, Xã Ân Thạnh"],
    },
    {
      columns: [
        "Gia Lai",
        "Vân Canh",
        "Thị trấn Vân Canh, Xã Canh Thuận, Xã Canh Hòa, Xã Canh Hiệp",
      ],
    },
    {
      columns: ["Gia Lai", "Vĩnh Quang", "Xã Vĩnh Thuận, Xã Vĩnh Hòa, Xã Vĩnh Quang"],
    },
    {
      columns: ["Gia Lai", "Vĩnh Sơn", "Xã Vĩnh Kim, Xã Vĩnh Sơn"],
    },
    {
      columns: ["Gia Lai", "Vĩnh Thạnh", "Thị trấn Vĩnh Thạnh, Xã Vĩnh Hảo"],
    },
    {
      columns: ["Gia Lai", "Vĩnh Thịnh", "Xã Vĩnh Hiệp, Xã Vĩnh Thịnh"],
    },
    {
      columns: ["Gia Lai", "Xuân An", "Xã Cát Nhơn, Xã Cát Tường"],
    },
    {
      columns: ["Gia Lai", "Ya Hội", "Xã Phú An, Xã Ya Hội"],
    },
    {
      columns: ["Gia Lai", "Ya Ma", "Xã Đăk Tơ Pang, Xã Kông Yang, Xã Ya Ma"],
    },
    {
      columns: [
        "Hà Nội",
        "An Khánh",
        "Xã Đông La, Phường Dương Nội (phần còn lại sau khi sáp nhập vào phường Tây Mỗ, phường Đại Mỗ, phường Dương Nội), Xã An Khánh (phần còn lại sau khi sáp nhập vào phường Tây Mỗ, xã Sơn Đồng), Xã La Phù (phần còn lại sau khi sáp nhập vào phường Dương Nội), Xã Song Phương (phần còn lại sau khi sáp nhập vào xã Sơn Đồng), Xã Vân Côn (phần còn lại sau khi sáp nhập vào xã Sơn Đồng), Xã An Thượng (phần còn lại sau khi sáp nhập vào xã Sơn Đồng)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Ba Đình",
        "Phường Quán Thánh, Phường Trúc Bạch, Phường Cửa Nam, Phường Điện Biên, Phường Đội Cấn, Phường Kim Mã, Phường Ngọc Hà, Phường Thụy Khuê, Phường Cửa Đông (phần còn lại sau khi sáp nhập vào phường Hoàn Kiếm), Phường Đồng Xuân (phần còn lại sau khi sáp nhập vào phường Hoàn Kiếm)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Ba Vì",
        "Xã Ba Vì, Xã Khánh Thượng, Xã Minh Quang (phần còn lại sau khi sáp nhập vào xã Bất Bạt)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Bạch Mai",
        "Phường Bạch Mai, Phường Bách Khoa, Phường Quỳnh Mai, Phường Minh Khai (quận Hai Bà Trưng), Phường Đồng Tâm, Phường Lê Đại Hành, Phường Phương Mai, Phường Trương Định, Phường Thanh Nhàn (phần còn lại sau khi sáp nhập vào phường Hai Bà Trưng)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Bát Tràng",
        "Xã Kim Đức, Phường Cự Khối (phần còn lại sau khi sáp nhập vào phường Long Biên), Phường Thạch Bàn (phần còn lại sau khi sáp nhập vào phường Long Biên, phường Phúc Lợi, xã Gia Lâm), Thị trấn Trâu Quỳ (phần còn lại sau khi sáp nhập vào xã Gia Lâm), Xã Đa Tốn (phần còn lại sau khi sáp nhập vào xã Gia Lâm), Xã Bát Tràng (phần còn lại sau khi sáp nhập vào phường Long Biên, xã Gia Lâm)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Bất Bạt",
        "Xã Thuần Mỹ, Xã Tòng Bạt, Xã Sơn Đà, Xã Cẩm Lĩnh, Xã Minh Quang",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Bình Minh",
        "Xã Bích Hòa, Xã Bình Minh, Xã Cao Viên, Xã Thanh Cao, Xã Lam Điền, Xã Cự Khê (phần còn lại sau khi sáp nhập vào phường Phú Lương), Phường Phú Lương (phần còn lại sau khi sáp nhập vào phường Phú Lương, phường Kiến Hưng)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Bồ Đề",
        "Phường Ngọc Lâm, Phường Đức Giang, Phường Gia Thụy, Phường Thượng Thanh, Phường Phúc Đồng, Phường Ngọc Thụy (phần còn lại sau khi sáp nhập vào phường Hồng Hà), Phường Bồ Đề (phần còn lại sau khi sáp nhập vào phường Hồng Hà, phường Long Biên), Phường Long Biên (phần còn lại sau khi sáp nhập vào phường Long Biên)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Cầu Giấy",
        "Phường Dịch Vọng, Phường Dịch Vọng Hậu, Phường Quan Hoa, Phường Mỹ Đình 1, Phường Mỹ Đình 2, Phường Yên Hòa",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Chuyên Mỹ",
        "Xã Tân Dân (huyện Phú Xuyên), Xã Châu Can, Xã Phú Yên, Xã Vân Từ, Xã Chuyên Mỹ",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Chương Dương",
        "Xã Chương Dương, Xã Lê Lợi, Xã Thắng Lợi, Xã Tự Nhiên, Xã Tô Hiệu, Xã Vạn Nhất",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Chương Mỹ",
        "Phường Biên Giang, Thị trấn Chúc Sơn, Xã Đại Yên, Xã Ngọc Hòa, Xã Phụng Châu, Xã Tiên Phương, Xã Thuỵ Hương, Phường Đồng Mai (phần còn lại sau khi sáp nhập vào phường Yên Nghĩa)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Cổ Đô",
        "Xã Phú Cường (huyện Ba Vì), Xã Cổ Đô, Xã Phong Vân, Xã Phú Hồng, Xã Phú Đông, Xã Vạn Thắng",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Cửa Nam",
        "Phường Hàng Bài, Phường Phan Chu Trinh, Phường Trần Hưng Đạo, Phường Cửa Nam, Phường Nguyễn Du, Phường Phạm Đình Hổ, Phường Hàng Bông (phần còn lại sau khi sáp nhập vào phường Hoàn Kiếm), Phường Hàng Trống (phần còn lại sau khi sáp nhập vào phường Hoàn Kiếm), Phường Tràng Tiền (phần còn lại sau khi sáp nhập vào phường Hoàn Kiếm)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Dân Hòa",
        "Xã Cao Xuân Dương, Xã Hồng Dương, Xã Liên Châu, Xã Tân Ước, Xã Dân Hòa",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Dương Hòa",
        "Xã Cát Quế, Xã Dương Liễu, Xã Đắc Sở, Xã Minh Khai, Xã Yên Sở",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Dương Nội",
        "Phường Dương Nội, Phường Phú La, Phường Yên Nghĩa, Xã La Phù, Phường Đại Mỗ (phần còn lại sau khi sáp nhập vào phường Xuân Phương, phường Tây Mỗ, phường Đại Mỗ, phường Hà Đông), Phường La Khê (phần còn lại sau khi sáp nhập vào phường Hà Đông)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Đa Phúc",
        "Xã Bắc Phú, Xã Đức Hoà, Xã Kim Lũ, Xã Tân Hưng, Xã Việt Long, Xã Xuân Giang, Xã Xuân Thu",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Đại Mỗ",
        "Phường Đại Mỗ, Phường Dương Nội, Phường Mộ Lao, Phường Mễ Trì (phần còn lại sau khi sáp nhập vào phường Yên Hòa, phường Từ Liêm), Phường Nhân Chính (phần còn lại sau khi sáp nhập vào phường Thanh Xuân, phường Yên Hòa), Phường Trung Hòa (phần còn lại sau khi sáp nhập vào phường Thanh Xuân, phường Yên Hòa), Phường Phú Đô (phần còn lại sau khi sáp nhập vào phường Từ Liêm), Phường Trung Văn (phần còn lại sau khi sáp nhập vào phường Thanh Xuân)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Đại Thanh",
        "Xã Tam Hiệp (huyện Thanh Trì) (phần còn lại sau khi sáp nhập vào phường Hoàng Liệt), Xã Hữu Hòa (phần còn lại sau khi sáp nhập vào phường Phú Lương), Phường Kiến Hưng (phần còn lại sau khi sáp nhập vào phường Phú Lương, phường Kiến Hưng), Thị trấn Văn Điển (phần còn lại sau khi sáp nhập vào phường Hoàng Liệt, xã Thanh Trì), Xã Tả Thanh Oai (phần còn lại sau khi sáp nhập vào phường Thanh Liệt), Xã Vĩnh Quỳnh (phần còn lại sau khi sáp nhập vào xã Thanh Trì)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Đại Xuyên",
        "Xã Bạch Hạ, Xã Khai Thái, Xã Minh Tân, Xã Phúc Tiến, Xã Quang Lãng, Xã Tri Thủy, Xã Đại Xuyên",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Đan Phượng",
        "Thị trấn Phùng, Xã Đồng Tháp, Xã Song Phượng, Xã Thượng Mỗ, Xã Đan Phượng",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Định Công",
        "Phường Định Công, Phường Hoàng Liệt, Phường Thịnh Liệt, Xã Tân Triều, Xã Thanh Liệt, Phường Đại Kim, Phường Giáp Bát (phần còn lại sau khi sáp nhập vào phường Hoàng Mai, phường Tương Mai)",
      ],
    },
    {
      columns: ["Hà Nội", "Đoài Phương", "Xã Kim Sơn, Xã Sơn Đông, Xã Cổ Đông"],
    },
    {
      columns: [
        "Hà Nội",
        "Đông Anh",
        "Xã Cổ Loa, Xã Đông Hội, Xã Mai Lâm, Thị trấn Đông Anh, Xã Tàm Xá, Xã Tiên Dương, Xã Vĩnh Ngọc, Xã Xuân Canh, Xã Liên Hà (huyện Đông Anh) (phần còn lại sau khi sáp nhập vào xã Thư Lâm), Xã Dục Tú (phần còn lại sau khi sáp nhập vào xã Thư Lâm), Xã Uy Nỗ (phần còn lại sau khi sáp nhập vào xã Thư Lâm), Xã Việt Hùng (phần còn lại sau khi sáp nhập vào xã Thư Lâm)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Đống Đa",
        "Phường Thịnh Quang, Phường Quang Trung (quận Đống Đa), Phường Láng Hạ, Phường Nam Đồng, Phường Ô Chợ Dừa, Phường Trung Liệt",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Đông Ngạc",
        "Phường Đức Thắng, Phường Cổ Nhuế 2, Phường Thụy Phương, Phường Minh Khai (quận Bắc Từ Liêm), Phường Đông Ngạc (phần còn lại sau khi sáp nhập vào phường Phú Thượng), Phường Xuân Đỉnh (phần còn lại sau khi sáp nhập vào phường Phú Thượng, phường Xuân Đỉnh)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Gia Lâm",
        "Xã Dương Xá, Xã Kiêu Kỵ, Thị trấn Trâu Quỳ, Phường Thạch Bàn, Xã Phú Sơn (huyện Gia Lâm), Xã Cổ Bi, Xã Đa Tốn, Xã Bát Tràng",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Giảng Võ",
        "Phường Giảng Võ, Phường Cát Linh, Phường Láng Hạ, Phường Ngọc Khánh, Phường Thành Công, Phường Cống Vị (phần còn lại sau khi sáp nhập vào phường Ngọc Hà), Phường Kim Mã (phần còn lại sau khi sáp nhập vào phường Ba Đình, phường Ngọc Hà)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Hạ Bằng",
        "Xã Cần Kiệm, Xã Đồng Trúc, Xã Bình Yên, Xã Hạ Bằng, Xã Tân Xã, Xã Phú Cát",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Hà Đông",
        "Phường Phúc La, Phường Vạn Phúc, Phường Quang Trung (quận Hà Đông), Phường Đại Mỗ, Phường Hà Cầu, Phường La Khê, Phường Văn Quán, Xã Tân Triều, Phường Mộ Lao (phần còn lại sau khi sáp nhập vào phường Đại Mỗ)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Hai Bà Trưng",
        "Phường Đồng Nhân, Phường Phố Huế, Phường Bạch Đằng, Phường Lê Đại Hành, Phường Nguyễn Du, Phường Thanh Nhàn, Phường Phạm Đình Hổ (phần còn lại sau khi sáp nhập vào phường Cửa Nam)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Hát Môn",
        "Xã Tam Hiệp (huyện Phúc Thọ), Xã Hiệp Thuận, Xã Liên Hiệp, Xã Ngọc Tảo, Xã Tam Thuấn, Xã Thanh Đa, Xã Hát Môn",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Hòa Lạc",
        "Xã Tiến Xuân, Xã Thạch Hòa, Xã Cổ Đông (phần còn lại sau khi sáp nhập vào xã Đoài Phương), Xã Bình Yên (phần còn lại sau khi sáp nhập vào xã Hạ Bằng), Xã Hạ Bằng (phần còn lại sau khi sáp nhập vào xã Hạ Bằng), Xã Tân Xã (phần còn lại sau khi sáp nhập vào xã Hạ Bằng)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Hòa Phú",
        "Xã Hòa Phú (huyện Chương Mỹ), Xã Đồng Lạc, Xã Hồng Phú, Xã Thượng Vực, Xã Văn Võ, Xã Kim Thư (phần còn lại sau khi sáp nhập vào xã Thanh Oai)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Hòa Xá",
        "Xã Hòa Phú, Xã Thái Hòa (huyện Ứng Hòa), Xã Bình Lưu Quang, Xã Phù Lưu",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Hoài Đức",
        "Thị trấn Trạm Trôi, Xã Di Trạch, Xã Đức Giang, Xã Đức Thượng, Phường Tây Tựu, Xã Tân Lập, Xã Kim Chung (huyện Hoài Đức) (phần còn lại sau khi sáp nhập vào phường Tây Tựu)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Hoàn Kiếm",
        "Phường Hàng Bạc, Phường Hàng Bồ, Phường Hàng Buồm, Phường Hàng Đào, Phường Hàng Gai, Phường Hàng Mã, Phường Lý Thái Tổ, Phường Cửa Đông, Phường Cửa Nam, Phường Điện Biên, Phường Đồng Xuân, Phường Hàng Bông, Phường Hàng Trống, Phường Tràng Tiền",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Hoàng Liệt",
        "Phường Hoàng Liệt, Thị trấn Văn Điển, Xã Tam Hiệp (huyện Thanh Trì), Xã Thanh Liệt, Phường Đại Kim",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Hoàng Mai",
        "Phường Giáp Bát, Phường Hoàng Liệt, Phường Hoàng Văn Thụ, Phường Lĩnh Nam, Phường Tân Mai, Phường Thịnh Liệt, Phường Tương Mai, Phường Trần Phú, Phường Vĩnh Hưng, Phường Yên Sở",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Hồng Hà",
        "Phường Chương Dương, Phường Phúc Tân, Phường Phúc Xá, Phường Nhật Tân, Phường Phú Thượng, Phường Quảng An, Phường Thanh Lương, Phường Tứ Liên, Phường Yên Phụ, Phường Bồ Đề, Phường Ngọc Thụy, Phường Bạch Đằng (phần còn lại sau khi sáp nhập vào phường Hai Bà Trưng)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Hồng Sơn",
        "Xã Phùng Xá (huyện Mỹ Đức), Xã An Mỹ, Xã Hợp Tiến, Xã Lê Thanh, Xã Xuy Xá, Xã Hồng Sơn",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Hồng Vân",
        "Xã Hà Hồi, Xã Hồng Vân, Xã Liên Phương, Xã Vân Tảo, Xã Duyên Thái (phần còn lại sau khi sáp nhập vào xã Nam Phù, xã Ngọc Hồi), Xã Ninh Sở (phần còn lại sau khi sáp nhập vào xã Nam Phù), Xã Đông Mỹ (phần còn lại sau khi sáp nhập vào xã Nam Phù)",
      ],
    },
    {
      columns: ["Hà Nội", "Hưng Đạo", "Xã Cộng Hoà, Xã Đồng Quang, Xã Hưng Đạo"],
    },
    {
      columns: ["Hà Nội", "Hương Sơn", "Xã An Tiến, Xã Hùng Tiến, Xã Vạn Tín, Xã Hương Sơn"],
    },
    {
      columns: [
        "Hà Nội",
        "Khương Đình",
        "Phường Hạ Đình, Phường Khương Đình, Phường Khương Trung, Phường Đại Kim, Xã Tân Triều, Phường Thanh Xuân Trung (phần còn lại sau khi sáp nhập vào phường Thanh Xuân), Phường Thượng Đình (phần còn lại sau khi sáp nhập vào phường Thanh Xuân)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Kiến Hưng",
        "Phường Kiến Hưng, Phường Phú Lương, Phường Quang Trung (quận Hà Đông) (phần còn lại sau khi sáp nhập vào phường Hà Đông), Phường Hà Cầu (phần còn lại sau khi sáp nhập vào phường Hà Đông), Phường Phú La (phần còn lại sau khi sáp nhập vào phường Dương Nội)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Kiều Phú",
        "Xã Cấn Hữu, Xã Liệp Nghĩa, Xã Tuyết Nghĩa, Xã Ngọc Liệp (phần còn lại sau khi sáp nhập vào xã Tây Phương), Xã Quang Trung (phần còn lại sau khi sáp nhập vào xã Tây Phương), Xã Ngọc Mỹ (phần còn lại sau khi sáp nhập vào xã Quốc Oai)",
      ],
    },
    {
      columns: ["Hà Nội", "Kim Anh", "Xã Tân Dân (huyện Sóc Sơn), Xã Minh Phú, Xã Minh Trí"],
    },
    {
      columns: [
        "Hà Nội",
        "Kim Liên",
        "Phường Kim Liên, Phường Khương Thượng, Phường Nam Đồng, Phường Phương Liên Trung Tự, Phường Trung Liệt, Phường Phương Mai (phần còn lại sau khi sáp nhập vào phường Bạch Mai), Phường Quang Trung (quận Đống Đa) (phần còn lại sau khi sáp nhập vào phường Đống Đa)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Láng",
        "Phường Láng Thượng, Phường Láng Hạ (phần còn lại sau khi sáp nhập vào phường Giảng Võ, phường Đống Đa), Phường Ngọc Khánh (phần còn lại sau khi sáp nhập vào phường Ngọc Hà, phường Giảng Võ)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Liên Minh",
        "Xã Phương Đình, Xã Trung Châu, Xã Thọ Xuân, Xã Thọ An, Xã Hồng Hà, Xã Tiến Thịnh",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Lĩnh Nam",
        "Phường Lĩnh Nam, Phường Thanh Trì, Phường Trần Phú, Phường Yên Sở, Phường Thanh Lương (phần còn lại sau khi sáp nhập vào phường Vĩnh Tuy, phường Hồng Hà)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Long Biên",
        "Phường Cự Khối, Phường Phúc Đồng, Phường Thạch Bàn, Xã Bát Tràng, Phường Long Biên, Phường Bồ Đề, Phường Gia Thụy",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Mê Linh",
        "Xã Tráng Việt, Xã Tiền Phong (huyện Mê Linh), Xã Văn Khê, Xã Mê Linh, Xã Đại Thịnh, Xã Hồng Hà, Xã Liên Hà (huyện Đan Phượng) (phần còn lại sau khi sáp nhập vào xã Ô Diên), Xã Liên Hồng (phần còn lại sau khi sáp nhập vào xã Ô Diên), Xã Liên Trung (phần còn lại sau khi sáp nhập vào xã Ô Diên), Xã Đại Mạch (phần còn lại sau khi sáp nhập vào xã Thiên Lộc)",
      ],
    },
    {
      columns: ["Hà Nội", "Minh Châu", "Xã Minh Châu, Thị trấn Tây Đằng, Xã Chu Minh"],
    },
    {
      columns: [
        "Hà Nội",
        "Mỹ Đức",
        "Thị trấn Đại Nghĩa, Xã An Phú, Xã Đại Hưng, Xã Hợp Thanh, Xã Phù Lưu Tế",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Nam Phù",
        "Xã Vạn Phúc, Xã Liên Ninh, Xã Ninh Sở, Xã Đông Mỹ, Xã Duyên Thái, Xã Ngũ Hiệp (phần còn lại sau khi sáp nhập vào xã Thanh Trì), Xã Yên Mỹ (phần còn lại sau khi sáp nhập vào xã Thanh Trì), Xã Duyên Hà (phần còn lại sau khi sáp nhập vào xã Thanh Trì)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Nghĩa Đô",
        "Phường Nghĩa Tân, Phường Cổ Nhuế 1, Phường Mai Dịch, Phường Nghĩa Đô, Phường Xuân La, Phường Xuân Tảo, Phường Dịch Vọng (phần còn lại sau khi sáp nhập vào phường Cầu Giấy), Phường Dịch Vọng Hậu (phần còn lại sau khi sáp nhập vào phường Cầu Giấy), Phường Quan Hoa (phần còn lại sau khi sáp nhập vào phường Cầu Giấy)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Ngọc Hà",
        "Phường Vĩnh Phúc, Phường Liễu Giai, Phường Cống Vị, Phường Kim Mã, Phường Ngọc Khánh, Phường Nghĩa Đô, Phường Đội Cấn (phần còn lại sau khi sáp nhập vào phường Ba Đình), Phường Ngọc Hà (phần còn lại sau khi sáp nhập vào phường Ba Đình)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Ngọc Hồi",
        "Xã Ngọc Hồi, Xã Duyên Thái, Xã Đại Áng, Xã Khánh Hà, Xã Liên Ninh (phần còn lại sau khi sáp nhập vào xã Nam Phù)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Nội Bài",
        "Xã Phú Cường (huyện Sóc Sơn), Xã Hiền Ninh, Xã Thanh Xuân, Xã Mai Đình (phần còn lại sau khi sáp nhập vào xã Sóc Sơn), Xã Phú Minh (phần còn lại sau khi sáp nhập vào xã Sóc Sơn), Xã Quang Tiến (phần còn lại sau khi sáp nhập vào xã Sóc Sơn)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Ô Chợ Dừa",
        "Phường Cát Linh (phần còn lại sau khi sáp nhập vào phường Giảng Võ), Phường Điện Biên (phần còn lại sau khi sáp nhập vào phường Hoàn Kiếm, phường Ba Đình, phường Văn Miếu Quốc Tử Giám), Phường Thành Công (phần còn lại sau khi sáp nhập vào phường Giảng Võ), Phường Ô Chợ Dừa (phần còn lại sau khi sáp nhập vào phường Đống Đa), Phường Trung Liệt (phần còn lại sau khi sáp nhập vào phường Đống Đa, phường Kim Liên), Phường Hàng Bột (phần còn lại sau khi sáp nhập vào phường Văn Miếu Quốc Tử Giám), Phường Văn Miếu Quốc Tử Giám (phần còn lại sau khi sáp nhập vào phường Văn Miếu Quốc Tử Giám)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Ô Diên",
        "Xã Hạ Mỗ, Xã Tân Hội, Xã Liên Hà (huyện Đan Phượng), Xã Hồng Hà, Xã Liên Hồng, Xã Liên Trung, Phường Tây Tựu (phần còn lại sau khi sáp nhập vào phường Tây Tựu, phường Đông Ngạc, phường Thượng Cát, xã Hoài Đức), Xã Tân Lập (phần còn lại sau khi sáp nhập vào xã Hoài Đức)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Phú Cát",
        "Xã Đông Yên, Xã Hoà Thạch, Xã Phú Mãn, Xã Phú Cát (phần còn lại sau khi sáp nhập vào xã Hạ Bằng)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Phú Diễn",
        "Phường Phú Diễn, Phường Cổ Nhuế 1, Phường Mai Dịch, Phường Phúc Diễn",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Phù Đổng",
        "Thị trấn Yên Viên, Xã Ninh Hiệp, Xã Phù Đổng, Xã Thiên Đức, Xã Yên Thường, Xã Yên Viên, Xã Cổ Bi (phần còn lại sau khi sáp nhập vào phường Phúc Lợi, xã Gia Lâm), Xã Đặng Xá (phần còn lại sau khi sáp nhập vào xã Thuận An)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Phú Lương",
        "Phường Phú Lãm, Phường Kiến Hưng, Phường Phú Lương, Xã Cự Khê, Xã Hữu Hòa",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Phú Nghĩa",
        "Xã Đông Phương Yên, Xã Đông Sơn, Xã Thanh Bình, Xã Trung Hòa, Xã Trường Yên, Xã Phú Nghĩa",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Phú Thượng",
        "Phường Đông Ngạc, Phường Xuân La, Phường Xuân Đỉnh, Phường Xuân Tảo, Phường Phú Thượng (phần còn lại sau khi sáp nhập vào phường Hồng Hà, phường Tây Hồ)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Phú Xuyên",
        "Thị trấn Phú Minh, Thị trấn Phú Xuyên, Xã Hồng Thái, Xã Minh Cường, Xã Nam Phong, Xã Nam Tiến, Xã Quang Hà, Xã Văn Tự, Xã Tô Hiệu (phần còn lại sau khi sáp nhập vào xã Chương Dương), Xã Vạn Nhất (phần còn lại sau khi sáp nhập vào xã Chương Dương)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Phúc Lộc",
        "Xã Nam Hà, Xã Sen Phương, Xã Vân Phúc, Xã Võng Xuyên, Xã Xuân Đình",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Phúc Lợi",
        "Phường Thạch Bàn, Xã Cổ Bi, Phường Giang Biên (phần còn lại sau khi sáp nhập vào phường Việt Hưng), Phường Việt Hưng (phần còn lại sau khi sáp nhập vào phường Việt Hưng), Phường Phúc Lợi (phần còn lại sau khi sáp nhập vào phường Việt Hưng), Phường Phúc Đồng (phần còn lại sau khi sáp nhập vào phường Long Biên, phường Bồ Đề, phường Việt Hưng)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Phúc Sơn",
        "Xã Mỹ Xuyên, Xã Phúc Lâm, Xã Thượng Lâm, Xã Tuy Lai, Xã Đồng Tâm",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Phúc Thịnh",
        "Xã Bắc Hồng, Xã Nam Hồng, Xã Vân Nội, Xã Vĩnh Ngọc, Xã Nguyên Khê (phần còn lại sau khi sáp nhập vào xã Thư Lâm), Xã Xuân Nộn (phần còn lại sau khi sáp nhập vào xã Thư Lâm), Xã Tiên Dương (phần còn lại sau khi sáp nhập vào xã Đông Anh), Thị trấn Đông Anh (phần còn lại sau khi sáp nhập vào xã Thư Lâm, xã Đông Anh)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Phúc Thọ",
        "Thị trấn Phúc Thọ, Xã Long Thượng, Xã Phúc Hòa, Xã Phụng Thượng, Xã Tích Lộc, Xã Trạch Mỹ Lộc",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Phượng Dực",
        "Xã Hoàng Long, Xã Hồng Minh, Xã Phú Túc, Xã Văn Hoàng, Xã Phượng Dực",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Phương Liệt",
        "Phường Khương Mai, Phường Thịnh Liệt (phần còn lại sau khi sáp nhập vào phường Hoàng Mai, phường Định Công, phường Yên Sở), Phường Phương Liệt (phần còn lại sau khi sáp nhập vào phường Tương Mai), Phường Định Công (phần còn lại sau khi sáp nhập vào phường Định Công), Phường Khương Đình (phần còn lại sau khi sáp nhập vào phường Khương Đình), Phường Khương Trung (phần còn lại sau khi sáp nhập vào phường Khương Đình)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Quảng Bị",
        "Xã Hoàng Diệu, Xã Hợp Đồng, Xã Quảng Bị, Xã Tốt Động, Xã Lam Điền (phần còn lại sau khi sáp nhập vào xã Bình Minh)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Quang Minh",
        "Thị trấn Chi Đông, Thị trấn Quang Minh, Xã Mê Linh (phần còn lại sau khi sáp nhập vào xã Mê Linh), Xã Tiền Phong (huyện Mê Linh) (phần còn lại sau khi sáp nhập vào xã Thiên Lộc, xã Mê Linh), Xã Đại Thịnh (phần còn lại sau khi sáp nhập vào xã Mê Linh, xã Tiến Thắng), Xã Kim Hoa (phần còn lại sau khi sáp nhập vào xã Tiến Thắng), Xã Thanh Lâm (phần còn lại sau khi sáp nhập vào xã Tiến Thắng)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Quảng Oai",
        "Xã Cam Thượng, Xã Đông Quang, Xã Tiên Phong, Xã Thụy An, Thị trấn Tây Đằng (phần còn lại sau khi sáp nhập vào xã Minh Châu), Xã Chu Minh (phần còn lại sau khi sáp nhập vào xã Minh Châu)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Quốc Oai",
        "Xã Thạch Thán, Xã Sài Sơn, Xã Ngọc Mỹ, Thị trấn Quốc Oai (phần còn lại sau khi sáp nhập vào xã Tây Phương), Xã Phượng Sơn (phần còn lại sau khi sáp nhập vào xã Tây Phương)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Sóc Sơn",
        "Thị trấn Sóc Sơn, Xã Tân Minh, Xã Đông Xuân (huyện Sóc Sơn), Xã Phù Lỗ, Xã Phù Linh, Xã Tiên Dược, Xã Mai Đình, Xã Phú Minh, Xã Quang Tiến",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Sơn Đồng",
        "Xã Lại Yên, Xã Sơn Đồng, Xã Tiền Yên, Xã An Khánh, Xã Song Phương, Xã Vân Côn, Xã An Thượng, Xã Vân Canh (phần còn lại sau khi sáp nhập vào phường Xuân Phương)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Sơn Tây",
        "Phường Ngô Quyền, Phường Phú Thịnh, Phường Viên Sơn, Xã Đường Lâm, Phường Trung Hưng, Phường Sơn Lộc, Xã Thanh Mỹ",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Suối Hai",
        "Xã Ba Trại, Xã Tản Lĩnh, Xã Thụy An (phần còn lại sau khi sáp nhập vào xã Quảng Oai), Xã Cẩm Lĩnh (phần còn lại sau khi sáp nhập vào xã Bất Bạt)",
      ],
    },
    {
      columns: ["Hà Nội", "Tam Hưng", "Xã Mỹ Hưng, Xã Thanh Thùy, Xã Thanh Văn, Xã Tam Hưng"],
    },
    {
      columns: [
        "Hà Nội",
        "Tây Hồ",
        "Phường Bưởi, Phường Phú Thượng, Phường Xuân La, Phường Nhật Tân (phần còn lại sau khi sáp nhập vào phường Hồng Hà), Phường Quảng An (phần còn lại sau khi sáp nhập vào phường Hồng Hà), Phường Tứ Liên (phần còn lại sau khi sáp nhập vào phường Hồng Hà), Phường Yên Phụ (phần còn lại sau khi sáp nhập vào phường Hồng Hà), Phường Nghĩa Đô (phần còn lại sau khi sáp nhập vào phường Ngọc Hà, phường Nghĩa Đô), Phường Thụy Khuê (phần còn lại sau khi sáp nhập vào phường Ba Đình)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Tây Mỗ",
        "Phường Đại Mỗ, Phường Dương Nội, Xã An Khánh, Phường Tây Mỗ (phần còn lại sau khi sáp nhập vào phường Xuân Phương)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Tây Phương",
        "Xã Phùng Xá (huyện Thạch Thất), Xã Hương Ngải, Xã Lam Sơn, Xã Thạch Xá, Xã Quang Trung, Thị trấn Quốc Oai, Xã Ngọc Liệp, Xã Phượng Sơn",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Tây Tựu",
        "Phường Minh Khai (quận Bắc Từ Liêm), Phường Tây Tựu, Xã Kim Chung (huyện Hoài Đức)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Thạch Thất",
        "Thị trấn Liên Quan, Xã Cẩm Yên, Xã Đại Đồng, Xã Kim Quan, Xã Lại Thượng, Xã Phú Kim",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Thanh Liệt",
        "Xã Tả Thanh Oai, Phường Đại Kim (phần còn lại sau khi sáp nhập vào phường Định Công, phường Hoàng Liệt, phường Khương Đình), Phường Thanh Xuân Bắc (phần còn lại sau khi sáp nhập vào phường Thanh Xuân), Phường Hạ Đình (phần còn lại sau khi sáp nhập vào phường Khương Đình), Phường Văn Quán (phần còn lại sau khi sáp nhập vào phường Hà Đông), Xã Thanh Liệt (phần còn lại sau khi sáp nhập vào phường Định Công, phường Hoàng Liệt), Xã Tân Triều (phần còn lại sau khi sáp nhập vào phường Định Công, phường Khương Đình, phường Hà Đông)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Thanh Oai",
        "Thị trấn Kim Bài, Xã Đỗ Động, Xã Kim An, Xã Phương Trung, Xã Thanh Mai, Xã Kim Thư",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Thanh Trì",
        "Thị trấn Văn Điển, Xã Ngũ Hiệp, Xã Vĩnh Quỳnh, Xã Yên Mỹ, Xã Duyên Hà, Xã Tứ Hiệp (phần còn lại sau khi sáp nhập vào phường Yên Sở), Phường Yên Sở (phần còn lại sau khi sáp nhập vào phường Lĩnh Nam, phường Hoàng Mai, phường Yên Sở)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Thanh Xuân",
        "Phường Nhân Chính, Phường Thanh Xuân Bắc, Phường Thanh Xuân Trung, Phường Thượng Đình, Phường Trung Hoà, Phường Trung Văn",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Thiên Lộc",
        "Xã Võng La, Xã Kim Chung (huyện Đông Anh), Xã Đại Mạch, Xã Kim Nỗ, Xã Tiền Phong (huyện Mê Linh), Xã Hải Bối",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Thuận An",
        "Xã Dương Quang, Xã Lệ Chi, Xã Đặng Xá, Xã Phú Sơn (huyện Gia Lâm) (phần còn lại sau khi sáp nhập vào xã Gia Lâm)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Thư Lâm",
        "Xã Thụy Lâm, Xã Vân Hà, Xã Xuân Nộn, Thị trấn Đông Anh, Xã Liên Hà (huyện Đông Anh), Xã Dục Tú, Xã Nguyên Khê, Xã Uy Nỗ, Xã Việt Hùng",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Thượng Cát",
        "Phường Liên Mạc, Phường Thượng Cát, Phường Minh Khai (quận Bắc Từ Liêm), Phường Tây Tựu, Phường Cổ Nhuế 2 (phần còn lại sau khi sáp nhập vào phường Đông Ngạc), Phường Thụy Phương (phần còn lại sau khi sáp nhập vào phường Đông Ngạc)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Thượng Phúc",
        "Xã Tân Minh (huyện Thường Tín), Xã Dũng Tiến, Xã Quất Động, Xã Nghiêm Xuyên, Xã Nguyễn Trãi",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Thường Tín",
        "Thị trấn Thường Tín, Xã Tiền Phong (huyện Thường Tín), Xã Hiền Giang, Xã Hòa Bình, Xã Nhị Khê, Xã Văn Bình, Xã Văn Phú, Xã Đại Áng (phần còn lại sau khi sáp nhập vào xã Ngọc Hồi), Xã Khánh Hà (phần còn lại sau khi sáp nhập vào xã Ngọc Hồi)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Tiến Thắng",
        "Xã Tam Đồng, Xã Tiến Thắng, Xã Tự Lập, Xã Đại Thịnh, Xã Kim Hoa, Xã Thanh Lâm, Xã Văn Khê (phần còn lại sau khi sáp nhập vào xã Ô Diên, xã Mê Linh, xã Yên Lãng), Xã Thạch Đà (phần còn lại sau khi sáp nhập vào xã Yên Lãng)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Trần Phú",
        "Xã Hoàng Văn Thụ, Xã Hữu Văn, Xã Mỹ Lương, Xã Trần Phú, Xã Đồng Tâm (phần còn lại sau khi sáp nhập vào xã Phúc Sơn), Xã Tân Tiến (phần còn lại sau khi sáp nhập vào xã Xuân Mai)",
      ],
    },
    {
      columns: ["Hà Nội", "Trung Giã", "Xã Bắc Sơn, Xã Hồng Kỳ, Xã Nam Sơn, Xã Trung Giã"],
    },
    {
      columns: [
        "Hà Nội",
        "Tùng Thiện",
        "Phường Xuân Khanh, Phường Trung Sơn Trầm, Xã Xuân Sơn, Phường Trung Hưng (phần còn lại sau khi sáp nhập vào phường Sơn Tây), Phường Sơn Lộc (phần còn lại sau khi sáp nhập vào phường Sơn Tây), Xã Thanh Mỹ (phần còn lại sau khi sáp nhập vào phường Sơn Tây)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Từ Liêm",
        "Phường Cầu Diễn, Phường Mễ Trì, Phường Phú Đô, Phường Mai Dịch (phần còn lại sau khi sáp nhập vào phường Nghĩa Đô, phường Phú Diễn), Phường Mỹ Đình 1 (phần còn lại sau khi sáp nhập vào phường Cầu Giấy), Phường Mỹ Đình 2 (phần còn lại sau khi sáp nhập vào phường Cầu Giấy)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Tương Mai",
        "Phường Giáp Bát, Phường Phương Liệt, Phường Mai Động (phần còn lại sau khi sáp nhập vào phường Vĩnh Tuy), Phường Minh Khai (quận Hai Bà Trưng) (phần còn lại sau khi sáp nhập vào phường Bạch Mai), Phường Đồng Tâm (phần còn lại sau khi sáp nhập vào phường Bạch Mai), Phường Trương Định (phần còn lại sau khi sáp nhập vào phường Bạch Mai), Phường Hoàng Văn Thụ (phần còn lại sau khi sáp nhập vào phường Hoàng Mai), Phường Tân Mai (phần còn lại sau khi sáp nhập vào phường Hoàng Mai), Phường Tương Mai (phần còn lại sau khi sáp nhập vào phường Hoàng Mai), Phường Vĩnh Hưng (phần còn lại sau khi sáp nhập vào phường Vĩnh Tuy, phường Hoàng Mai, phường Vĩnh Hưng)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Ứng Hòa",
        "Xã Đại Cường, Xã Đại Hùng, Xã Đông Lỗ, Xã Đồng Tân, Xã Kim Đường, Xã Minh Đức, Xã Trầm Lộng, Xã Trung Tú",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Ứng Thiên",
        "Xã Hoa Viên, Xã Liên Bạt, Xã Quảng Phú Cầu, Xã Trường Thịnh",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Văn Miếu - Quốc Tử Giám",
        "Phường Khâm Thiên, Phường Thổ Quan, Phường Văn Chương, Phường Điện Biên, Phường Hàng Bột, Phường Văn Miếu Quốc Tử Giám, Phường Cửa Nam (phần còn lại sau khi sáp nhập vào phường Hoàn Kiếm, phường Cửa Nam, phường Ba Đình), Phường Lê Đại Hành (phần còn lại sau khi sáp nhập vào phường Hai Bà Trưng, phường Bạch Mai), Phường Nam Đồng (phần còn lại sau khi sáp nhập vào phường Đống Đa, phường Kim Liên), Phường Nguyễn Du (phần còn lại sau khi sáp nhập vào phường Cửa Nam, phường Hai Bà Trưng), Phường Phương Liên Trung Tự (phần còn lại sau khi sáp nhập vào phường Kim Liên)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Vân Đình",
        "Thị trấn Vân Đình, Xã Cao Sơn Tiến, Xã Phương Tú, Xã Tảo Dương Văn",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Vật Lại",
        "Xã Thái Hòa, Xã Phú Sơn (huyện Ba Vì), Xã Đồng Thái, Xã Phú Châu, Xã Vật Lại",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Việt Hưng",
        "Phường Giang Biên, Phường Phúc Đồng, Phường Việt Hưng, Phường Phúc Lợi, Phường Gia Thụy (phần còn lại sau khi sáp nhập vào phường Long Biên, phường Bồ Đề), Phường Đức Giang (phần còn lại sau khi sáp nhập vào phường Bồ Đề), Phường Thượng Thanh (phần còn lại sau khi sáp nhập vào phường Bồ Đề)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Vĩnh Hưng",
        "Phường Vĩnh Hưng, Phường Lĩnh Nam (phần còn lại sau khi sáp nhập vào phường Lĩnh Nam, phường Hoàng Mai), Phường Thanh Trì (phần còn lại sau khi sáp nhập vào phường Lĩnh Nam), Phường Vĩnh Tuy (phần còn lại sau khi sáp nhập vào phường Vĩnh Tuy)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Vĩnh Thanh",
        "Xã Tàm Xá (phần còn lại sau khi sáp nhập vào xã Đông Anh), Xã Xuân Canh (phần còn lại sau khi sáp nhập vào xã Đông Anh), Xã Vĩnh Ngọc (phần còn lại sau khi sáp nhập vào xã Đông Anh, xã Phúc Thịnh), Xã Kim Chung (huyện Đông Anh) (phần còn lại sau khi sáp nhập vào xã Thiên Lộc), Xã Hải Bối (phần còn lại sau khi sáp nhập vào xã Thiên Lộc), Xã Kim Nỗ (phần còn lại sau khi sáp nhập vào xã Thiên Lộc)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Vĩnh Tuy",
        "Phường Mai Động, Phường Thanh Lương, Phường Vĩnh Hưng, Phường Vĩnh Tuy",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Xuân Đỉnh",
        "Phường Xuân Đỉnh, Phường Cổ Nhuế 1 (phần còn lại sau khi sáp nhập vào phường Nghĩa Đô, phường Phú Diễn), Phường Xuân La (phần còn lại sau khi sáp nhập vào phường Nghĩa Đô, phường Tây Hồ, phường Phú Thượng), Phường Xuân Tảo (phần còn lại sau khi sáp nhập vào phường Nghĩa Đô, phường Phú Thượng)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Xuân Mai",
        "Thị trấn Xuân Mai, Xã Nam Phương Tiến, Xã Thủy Xuân Tiên, Xã Tân Tiến",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Xuân Phương",
        "Phường Phương Canh, Phường Xuân Phương, Phường Đại Mỗ, Phường Tây Mỗ, Xã Vân Canh, Phường Minh Khai (quận Bắc Từ Liêm) (phần còn lại sau khi sáp nhập vào phường Tây Tựu, phường Đông Ngạc, phường Thượng Cát), Phường Phúc Diễn (phần còn lại sau khi sáp nhập vào phường Phú Diễn)",
      ],
    },
    {
      columns: ["Hà Nội", "Yên Bài", "Xã Vân Hòa, Xã Yên Bài, Xã Thạch Hòa"],
    },
    {
      columns: [
        "Hà Nội",
        "Yên Hòa",
        "Phường Mễ Trì, Phường Nhân Chính, Phường Trung Hòa, Phường Yên Hòa (phần còn lại sau khi sáp nhập vào phường Cầu Giấy)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Yên Lãng",
        "Xã Chu Phan, Xã Hoàng Kim, Xã Liên Mạc, Xã Thạch Đà, Xã Văn Khê, Xã Tiến Thịnh (phần còn lại sau khi sáp nhập vào xã Liên Minh), Xã Trung Châu (phần còn lại sau khi sáp nhập vào xã Liên Minh), Xã Thọ Xuân (phần còn lại sau khi sáp nhập vào xã Liên Minh), Xã Thọ An (phần còn lại sau khi sáp nhập vào xã Liên Minh), Xã Hồng Hà (phần còn lại sau khi sáp nhập vào xã Liên Minh, xã Mê Linh)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Yên Nghĩa",
        "Phường Đồng Mai, Phường Yên Nghĩa (phần còn lại sau khi sáp nhập vào phường Dương Nội)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Yên Sở",
        "Phường Thịnh Liệt, Phường Yên Sở, Xã Tứ Hiệp, Phường Hoàng Liệt (phần còn lại sau khi sáp nhập vào phường Hoàng Mai, phường Định Công, phường Hoàng Liệt), Phường Trần Phú (phần còn lại sau khi sáp nhập vào phường Lĩnh Nam, phường Hoàng Mai)",
      ],
    },
    {
      columns: [
        "Hà Nội",
        "Yên Xuân",
        "Xã Đông Xuân (huyện Quốc Oai), Xã Yên Bình, Xã Yên Trung, Xã Tiến Xuân (phần còn lại sau khi sáp nhập vào xã Hòa Lạc), Xã Thạch Hòa (phần còn lại sau khi sáp nhập vào xã Yên Bài, xã Hòa Lạc)",
      ],
    },
    {
      columns: [
        "Hà Tĩnh",
        "Bắc Hồng Lĩnh",
        "Phường Bắc Hồng, Phường Đức Thuận, Phường Trung Lương, Xã Xuân Lam",
      ],
    },
    {
      columns: ["Hà Tĩnh", "Can Lộc", "Thị trấn Nghèn, Xã Thiên Lộc, Xã Vượng Lộc"],
    },
    {
      columns: ["Hà Tĩnh", "Cẩm Bình", "Xã Cẩm Vịnh, Xã Thạch Bình, Xã Cẩm Thành, Xã Cẩm Bình"],
    },
    {
      columns: ["Hà Tĩnh", "Cẩm Duệ", "Xã Cẩm Mỹ, Xã Cẩm Thạch, Xã Cẩm Duệ"],
    },
    {
      columns: ["Hà Tĩnh", "Cẩm Hưng", "Xã Cẩm Thịnh, Xã Cẩm Hà, Xã Cẩm Hưng"],
    },
    {
      columns: ["Hà Tĩnh", "Cẩm Lạc", "Xã Cẩm Minh, Xã Cẩm Sơn, Xã Cẩm Lạc"],
    },
    {
      columns: ["Hà Tĩnh", "Cẩm Trung", "Xã Cẩm Lĩnh, Xã Cẩm Lộc, Xã Cẩm Trung"],
    },
    {
      columns: ["Hà Tĩnh", "Cẩm Xuyên", "Thị trấn Cẩm Xuyên, Xã Cẩm Quang, Xã Cẩm Quan"],
    },
    {
      columns: ["Hà Tĩnh", "Cổ Đạm", "Xã Cương Gián, Xã Xuân Liên, Xã Cổ Đạm"],
    },
    {
      columns: ["Hà Tĩnh", "Đan Hải", "Xã Đan Trường, Xã Xuân Hải, Xã Xuân Hội, Xã Xuân Phổ"],
    },
    {
      columns: ["Hà Tĩnh", "Đông Kinh", "Xã Thạch Kênh, Xã Thạch Liên, Xã Ích Hậu"],
    },
    {
      columns: ["Hà Tĩnh", "Đồng Lộc", "Thị trấn Đồng Lộc, Xã Thượng Lộc, Xã Mỹ Lộc"],
    },
    {
      columns: ["Hà Tĩnh", "Đồng Tiến", "Xã Thạch Trị, Xã Thạch Hội, Xã Thạch Văn"],
    },
    {
      columns: ["Hà Tĩnh", "Đức Đồng", "Xã Đức Lạng, Xã Tân Hương, Xã Đức Đồng"],
    },
    {
      columns: ["Hà Tĩnh", "Đức Minh", "Xã Trường Sơn, Xã Tùng Châu, Xã Liên Minh"],
    },
    {
      columns: ["Hà Tĩnh", "Đức Quang", "Xã Quang Vĩnh, Xã Bùi La Nhân, Xã Yên Hồ"],
    },
    {
      columns: ["Hà Tĩnh", "Đức Thịnh", "Xã Thanh Bình Thịnh, Xã Lâm Trung Thủy, Xã An Dũng"],
    },
    {
      columns: ["Hà Tĩnh", "Đức Thọ", "Thị trấn Đức Thọ, Xã Tùng Ảnh, Xã Hòa Lạc, Xã Tân Dân"],
    },
    {
      columns: ["Hà Tĩnh", "Gia Hanh", "Xã Khánh Vĩnh Yên, Xã Thanh Lộc, Xã Gia Hanh"],
    },
    {
      columns: ["Hà Tĩnh", "Hà Huy Tập", "Xã Tân Lâm Hương, Xã Thạch Đài, Phường Đại Nài"],
    },
    {
      columns: ["Hà Tĩnh", "Hà Linh", "Xã Điền Mỹ, Xã Hà Linh"],
    },
    {
      columns: ["Hà Tĩnh", "Hải Ninh", "Phường Kỳ Ninh, Xã Kỳ Hà, Xã Kỳ Hải"],
    },
    {
      columns: [
        "Hà Tĩnh",
        "Hoành Sơn",
        "Phường Kỳ Nam, Phường Kỳ Phương, Phường Kỳ Liên, Xã Kỳ Lợi",
      ],
    },
    {
      columns: ["Hà Tĩnh", "Hồng Lộc", "Xã Tân Lộc, Xã Hồng Lộc"],
    },
    {
      columns: ["Hà Tĩnh", "Hương Bình", "Xã Hòa Hải, Xã Phúc Đồng, Xã Hương Bình"],
    },
    {
      columns: ["Hà Tĩnh", "Hương Đô", "Xã Lộc Yên, Xã Hương Trà, Xã Hương Đô"],
    },
    {
      columns: ["Hà Tĩnh", "Hương Khê", "Thị trấn Hương Khê, Xã Hương Long, Xã Phú Gia"],
    },
    {
      columns: ["Hà Tĩnh", "Hương Phố", "Xã Hương Giang, Xã Hương Thủy, Xã Gia Phố"],
    },
    {
      columns: [
        "Hà Tĩnh",
        "Hương Sơn",
        "Thị trấn Phố Châu, Xã Sơn Phú, Xã Sơn Bằng, Xã Sơn Ninh, Xã Sơn Trung",
      ],
    },
    {
      columns: ["Hà Tĩnh", "Hương Xuân", "Xã Hương Lâm, Xã Hương Vĩnh, Xã Hương Xuân"],
    },
    {
      columns: ["Hà Tĩnh", "Kim Hoa", "Xã Hàm Trường, Xã Kim Hoa"],
    },
    {
      columns: ["Hà Tĩnh", "Kỳ Anh", "Thị trấn Kỳ Đồng, Xã Kỳ Giang, Xã Kỳ Tiến, Xã Kỳ Phú"],
    },
    {
      columns: ["Hà Tĩnh", "Kỳ Hoa", "Xã Kỳ Tân, Xã Kỳ Hoa"],
    },
    {
      columns: ["Hà Tĩnh", "Kỳ Khang", "Xã Kỳ Thọ, Xã Kỳ Thư, Xã Kỳ Khang"],
    },
    {
      columns: ["Hà Tĩnh", "Kỳ Lạc", "Xã Lâm Hợp, Xã Kỳ Lạc"],
    },
    {
      columns: ["Hà Tĩnh", "Kỳ Thượng", "Xã Kỳ Sơn, Xã Kỳ Thượng"],
    },
    {
      columns: ["Hà Tĩnh", "Kỳ Văn", "Xã Kỳ Tây, Xã Kỳ Trung, Xã Kỳ Văn"],
    },
    {
      columns: ["Hà Tĩnh", "Kỳ Xuân", "Xã Kỳ Phong, Xã Kỳ Bắc, Xã Kỳ Xuân"],
    },
    {
      columns: ["Hà Tĩnh", "Lộc Hà", "Thị trấn Lộc Hà, Xã Bình An, Xã Thịnh Lộc, Xã Thạch Kim"],
    },
    {
      columns: ["Hà Tĩnh", "Mai Hoa", "Xã Ân Phú, Xã Đức Giang, Xã Đức Lĩnh"],
    },
    {
      columns: ["Hà Tĩnh", "Mai Phụ", "Xã Thạch Mỹ, Xã Thạch Châu, Xã Phù Lưu, Xã Mai Phụ"],
    },
    {
      columns: ["Hà Tĩnh", "Nam Hồng Lĩnh", "Phường Nam Hồng, Phường Đậu Liêu, Xã Thuận Lộc"],
    },
    {
      columns: [
        "Hà Tĩnh",
        "Nghi Xuân",
        "Thị trấn Xuân An, Xã Xuân Giang, Xã Xuân Hồng, Xã Xuân Viên, Xã Xuân Lĩnh",
      ],
    },
    {
      columns: ["Hà Tĩnh", "Phúc Trạch", "Xã Hương Trạch, Xã Hương Liên, Xã Phúc Trạch"],
    },
    {
      columns: ["Hà Tĩnh", "Sông Trí", "Phường Hưng Trí, Phường Kỳ Trinh, Xã Kỳ Châu, Xã Kỳ Lợi"],
    },
    {
      columns: ["Hà Tĩnh", "Sơn Giang", "Xã Sơn Lâm, Xã Quang Diệm, Xã Sơn Giang"],
    },
    {
      columns: ["Hà Tĩnh", "Sơn Hồng", "Xã Sơn Lĩnh, Xã Sơn Hồng"],
    },
    {
      columns: ["Hà Tĩnh", "Sơn Kim 1", "Không sáp nhập"],
    },
    {
      columns: ["Hà Tĩnh", "Sơn Kim 2", "Không sáp nhập"],
    },
    {
      columns: ["Hà Tĩnh", "Sơn Tây", "Thị trấn Tây Sơn, Xã Sơn Tây"],
    },
    {
      columns: ["Hà Tĩnh", "Sơn Tiến", "Xã Sơn Lễ, Xã An Hòa Thịnh, Xã Sơn Tiến"],
    },
    {
      columns: ["Hà Tĩnh", "Thạch Hà", "Thị trấn Thạch Hà, Xã Thạch Long, Xã Thạch Sơn"],
    },
    {
      columns: ["Hà Tĩnh", "Thạch Khê", "Xã Đỉnh Bàn, Xã Thạch Hải, Xã Thạch Khê"],
    },
    {
      columns: ["Hà Tĩnh", "Thạch Lạc", "Xã Tượng Sơn, Xã Thạch Thắng, Xã Thạch Lạc"],
    },
    {
      columns: ["Hà Tĩnh", "Thạch Xuân", "Xã Nam Điền, Xã Thạch Xuân"],
    },
    {
      columns: [
        "Hà Tĩnh",
        "Thành Sen",
        "Phường Bắc Hà, Phường Thạch Quý, Phường Tân Giang, Phường Thạch Hưng, Phường Nam Hà, Phường Trần Phú, Phường Hà Huy Tập, Phường Văn Yên, Phường Đại Nài",
      ],
    },
    {
      columns: ["Hà Tĩnh", "Thiên Cầm", "Thị trấn Thiên Cầm, Xã Nam Phúc Thăng, Xã Cẩm Nhượng"],
    },
    {
      columns: ["Hà Tĩnh", "Thượng Đức", "Xã Đức Bồng, Xã Đức Hương, Xã Đức Liên"],
    },
    {
      columns: [
        "Hà Tĩnh",
        "Tiên Điền",
        "Thị trấn Tiên Điền, Xã Xuân Yên, Xã Xuân Mỹ, Xã Xuân Thành",
      ],
    },
    {
      columns: ["Hà Tĩnh", "Toàn Lưu", "Xã Ngọc Sơn, Xã Lưu Vĩnh Sơn"],
    },
    {
      columns: [
        "Hà Tĩnh",
        "Trần Phú",
        "Phường Thạch Trung, Phường Đồng Môn, Phường Thạch Hạ, Xã Hộ Độ",
      ],
    },
    {
      columns: ["Hà Tĩnh", "Trường Lưu", "Xã Kim Song Trường, Xã Thường Nga, Xã Phú Lộc"],
    },
    {
      columns: ["Hà Tĩnh", "Tùng Lộc", "Xã Thuần Thiện, Xã Tùng Lộc"],
    },
    {
      columns: ["Hà Tĩnh", "Tứ Mỹ", "Xã Châu Bình, Xã Tân Mỹ Hà, Xã Mỹ Long"],
    },
    {
      columns: ["Hà Tĩnh", "Việt Xuyên", "Xã Việt Tiến, Xã Thạch Ngọc"],
    },
    {
      columns: [
        "Hà Tĩnh",
        "Vũ Quang",
        "Thị trấn Vũ Quang, Xã Hương Minh, Xã Quang Thọ, Xã Thọ Điền",
      ],
    },
    {
      columns: ["Hà Tĩnh", "Vũng Áng", "Phường Kỳ Long, Phường Kỳ Thịnh, Xã Kỳ Lợi"],
    },
    {
      columns: ["Hà Tĩnh", "Xuân Lộc", "Xã Sơn Lộc, Xã Quang Lộc, Xã Xuân Lộc"],
    },
    {
      columns: ["Hà Tĩnh", "Yên Hòa", "Xã Cẩm Dương, Xã Yên Hòa"],
    },
    {
      columns: ["Hải Phòng", "Ái Quốc", "Phường Ái Quốc, Xã Quyết Thắng, Xã Hồng Lạc"],
    },
    {
      columns: [
        "Hải Phòng",
        "An Biên",
        "Phường An Dương, Phường An Biên, Phường Trần Nguyên Hãn, Phường Vĩnh Niệm",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "An Dương",
        "Phường Nam Sơn (quận An Dương), Phường An Hải, Phường Lê Lợi, Phường Đồng Thái, Phường Tân Tiến, Phường An Hưng",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "An Hải",
        "Phường An Đồng, Phường Hồng Thái, Phường Lê Lợi, Phường An Hải, Phường Đồng Thái",
      ],
    },
    {
      columns: ["Hải Phòng", "An Hưng", "Xã An Thái, Xã An Thọ, Xã Chiến Thắng"],
    },
    {
      columns: ["Hải Phòng", "An Khánh", "Xã Tân Viên, Xã Mỹ Đức, Xã Thái Sơn"],
    },
    {
      columns: [
        "Hải Phòng",
        "An Lão",
        "Thị trấn An Lão, Xã An Thắng, Xã Tân Dân, Xã An Tiến, Thị trấn Trường Sơn, Xã Thái Sơn",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "An Phong",
        "Phường An Hòa, Phường Hồng Phong, Phường Đại Bản, Phường Lê Thiện, Phường Tân Tiến, Phường Lê Lợi",
      ],
    },
    {
      columns: ["Hải Phòng", "An Phú", "Xã An Bình, Xã An Phú, Xã Cộng Hòa"],
    },
    {
      columns: [
        "Hải Phòng",
        "An Quang",
        "Xã Quốc Tuấn, Xã Quang Trung (huyện An Lão), Xã Quang Hưng",
      ],
    },
    {
      columns: ["Hải Phòng", "An Thành", "Xã Ngũ Phúc (huyện Kim Thành), Xã Kim Tân, Xã Kim Đính"],
    },
    {
      columns: ["Hải Phòng", "An Trường", "Xã Bát Trang, Xã Trường Thọ, Xã Trường Thành"],
    },
    {
      columns: [
        "Hải Phòng",
        "Bạch Đằng",
        "Phường Minh Đức, Xã Bạch Đằng (thành phố Thủy Nguyên), Phường Phạm Ngũ Lão",
      ],
    },
    {
      columns: ["Hải Phòng", "Bạch Long Vĩ", "Huyện Bạch Long Vĩ"],
    },
    {
      columns: [
        "Hải Phòng",
        "Bắc An Phụ",
        "Phường Thất Hùng, Xã Bạch Đằng (thị xã Kinh Môn), Xã Lê Ninh, Phường Văn Đức",
      ],
    },
    {
      columns: ["Hải Phòng", "Bắc Thanh Miện", "Xã Hồng Quang, Xã Lam Sơn, Xã Lê Hồng"],
    },
    {
      columns: [
        "Hải Phòng",
        "Bình Giang",
        "Xã Tân Việt (huyện Bình Giang), Xã Long Xuyên, Xã Hồng Khê, Xã Cổ Bì, Xã Vĩnh Hồng",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Cát Hải",
        "Thị trấn Cát Hải, Thị trấn Cát Bà, Xã Đồng Bài, Xã Hoàng Châu, Xã Nghĩa Lộ, Xã Văn Phong, Xã Gia Luận, Xã Hiền Hào, Xã Phù Long, Xã Trân Châu, Xã Việt Hải, Xã Xuân Đám",
      ],
    },
    {
      columns: ["Hải Phòng", "Cẩm Giang", "Thị trấn Cẩm Giang, Xã Định Sơn, Xã Cẩm Hoàng"],
    },
    {
      columns: ["Hải Phòng", "Cẩm Giàng", "Xã Lương Điền, Xã Ngọc Liên, Xã Cẩm Hưng, Xã Phúc Điền"],
    },
    {
      columns: [
        "Hải Phòng",
        "Chấn Hưng",
        "Xã Nam Hưng (huyện Tiên Lãng), Xã Bắc Hưng, Xã Đông Hưng, Xã Tây Hưng",
      ],
    },
    {
      columns: ["Hải Phòng", "Chí Linh", "Phường Phả Lại, Phường Cổ Thành, Xã Nhân Huệ"],
    },
    {
      columns: ["Hải Phòng", "Chí Minh", "Xã An Thanh, Xã Văn Tố, Xã Chí Minh"],
    },
    {
      columns: [
        "Hải Phòng",
        "Chu Văn An",
        "Phường Sao Đỏ, Phường Văn An, Phường Chí Minh, Phường Thái Học, Phường Cộng Hòa, Phường Văn Đức",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Dương Kinh",
        "Phường Hòa Nghĩa, Phường Tân Thành, Phường Anh Dũng, Phường Hải Thành",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Đại Sơn",
        "Xã Bình Lãng, Xã Đại Sơn, Xã Thanh Hải, Xã Hưng Đạo (huyện Tứ Kỳ)",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Đồ Sơn",
        "Phường Hải Sơn, Phường Tân Thành, Phường Vạn Hương, Phường Ngọc Xuyên",
      ],
    },
    {
      columns: ["Hải Phòng", "Đông Hải", "Phường Đông Hải 1, Phường Đông Hải 2, Phường Nam Hải"],
    },
    {
      columns: [
        "Hải Phòng",
        "Đường An",
        "-, Xã Thúc Kháng, Xã Thái Minh, Xã Tân Hồng, Xã Thái Dương, Xã Thái Hòa",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Gia Lộc",
        "Xã Gia Tiến, Thị trấn Gia Lộc, Xã Gia Phúc, Xã Yết Kiêu, Xã Lê Lợi (huyện Gia Lộc)",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Gia Phúc",
        "Xã Toàn Thắng, Xã Hoàng Diệu, Xã Hồng Hưng, Xã Thống Kênh, Xã Đoàn Thượng, Xã Quang Đức, Thị trấn Gia Lộc, Xã Gia Phúc",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Gia Viên",
        "Phường Đằng Giang, Phường Cầu Đất, Phường Lạch Tray, Phường Gia Viên, Phường Đông Khê",
      ],
    },
    {
      columns: ["Hải Phòng", "Hà Bắc", "Xã Tân Việt (huyện Thanh Hà), Xã Cẩm Việt, Xã Hồng Lạc"],
    },
    {
      columns: ["Hải Phòng", "Hà Đông", "Xã Thanh Hồng, Xã Vĩnh Cường, Xã Thanh Quang"],
    },
    {
      columns: [
        "Hải Phòng",
        "Hà Nam",
        "Xã Thanh Xuân, Xã Liên Mạc, Xã Thanh Lang, Xã Thanh An, Xã Hòa Bình",
      ],
    },
    {
      columns: ["Hải Phòng", "Hà Tây", "Xã Tân An, Xã An Phượng, Xã Thanh Hải"],
    },
    {
      columns: [
        "Hải Phòng",
        "Hải An",
        "Phường Cát Bi, Phường Đằng Lâm, Phường Thành Tô, Phường Đằng Hải, Phường Tràng Cát, Phường Nam Hải, Phường Đông Hải 2",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Hải Dương",
        "Phường Trần Hưng Đạo (thành phố Hải Dương), Phường Nhị Châu, Phường Ngọc Châu, Phường Quang Trung",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Hải Hưng",
        "Xã Tân Trào (huyện Thanh Miện), Xã Ngô Quyền, Xã Đoàn Kết",
      ],
    },
    {
      columns: ["Hải Phòng", "Hòa Bình", "Phường Hòa Bình, Phường An Lư, Phường Thủy Hà"],
    },
    {
      columns: [
        "Hải Phòng",
        "Hồng An",
        "Phường Quán Toan, Phường An Hồng, Phường An Hưng, Phường Đại Bản, Phường Lê Thiện, Phường Tân Tiến",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Hồng Bàng",
        "Phường Hoàng Văn Thụ, Phường Minh Khai, Phường Phan Bội Châu, Phường Thượng Lý, Phường Sở Dầu, Phường Hùng Vương, Phường Gia Viên",
      ],
    },
    {
      columns: ["Hải Phòng", "Hồng Châu", "Xã Tân Quang, Xã Văn Hội, Xã Hưng Long"],
    },
    {
      columns: ["Hải Phòng", "Hợp Tiến", "Xã Nam Hưng (huyện Nam Sách), Xã Nam Tân, Xã Hợp Tiến"],
    },
    {
      columns: ["Hải Phòng", "Hùng Thắng", "Xã Hùng Thắng (huyện Tiên Lãng), Xã Vinh Quang"],
    },
    {
      columns: [
        "Hải Phòng",
        "Hưng Đạo",
        "Phường Đa Phúc, Phường Hưng Đạo, Phường Anh Dũng, Phường Hải Thành",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Kẻ Sặt",
        "Xã Vĩnh Hưng, Xã Hùng Thắng (huyện Bình Giang), Thị trấn Kẻ Sặt, Xã Vĩnh Hồng",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Khúc Thừa Dụ",
        "Xã Bình Xuyên, Xã Hồng Phong (huyện Ninh Giang), Xã Kiến Phúc",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Kiến An",
        "-, Phường Nam Sơn (quận Kiến An), Phường Đồng Hòa, Phường Bắc Sơn, Phường Trần Thành Ngọ, Phường Văn Đẩu",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Kiến Hải",
        "Xã Tân Phong, Xã Đại Hợp (huyện Kiến Thụy), Xã Tú Sơn, Xã Đoàn Xá",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Kiến Hưng",
        "Xã Tân Trào (huyện Kiến Thụy), Xã Kiến Hưng, Xã Đoàn Xá",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Kiến Minh",
        "Xã Minh Tân (huyện Kiến Thụy), Xã Đại Đồng, Xã Đông Phương",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Kiến Thụy",
        "Thị trấn Núi Đối, Xã Thanh Sơn (huyện Kiến Thụy), Xã Thuận Thiên, Xã Hữu Bằng, Xã Kiến Hưng",
      ],
    },
    {
      columns: ["Hải Phòng", "Kim Thành", "Xã Đồng Cẩm, Xã Tam Kỳ, Xã Đại Đức, Xã Hòa Bình"],
    },
    {
      columns: ["Hải Phòng", "Kinh Môn", "Phường An Lưu, Phường Hiệp An, Phường Long Xuyên"],
    },
    {
      columns: [
        "Hải Phòng",
        "Lạc Phượng",
        "Xã Quang Trung (huyện Tứ Kỳ), Xã Lạc Phượng, Xã Tiên Động",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Lai Khê",
        "Xã Lai Khê, Xã Vũ Dũng, Xã Tuấn Việt, Xã Cộng Hoà, Xã Thanh An, Xã Cẩm Việt",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Lê Chân",
        "Phường Hàng Kênh, Phường Dư Hàng Kênh, Phường Kênh Dương, Phường An Biên, Phường Trần Nguyên Hãn, Phường Vĩnh Niệm, Phường Cầu Đất, Phường Lạch Tray",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Lê Đại Hành",
        "Phường Tân Dân (thành phố Chí Linh), Phường An Lạc, Phường Đồng Lạc",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Lê Ích Mộc",
        "Phường Quảng Thanh, Phường Lê Hồng Phong, Xã Quang Trung (thành phố Thủy Nguyên)",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Lê Thanh Nghị",
        "Phường Tân Bình, Phường Thanh Bình, Phường Lê Thanh Nghị, Phường Trần Phú",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Lưu Kiếm",
        "Phường Trần Hưng Đạo (thành phố Thủy Nguyên), Phường Lưu Kiếm, Xã Liên Xuân, Xã Quang Trung (thành phố Thủy Nguyên)",
      ],
    },
    {
      columns: ["Hải Phòng", "Mao Điền", "Xã Tân Trường, Xã Cẩm Đông, Xã Phúc Điền"],
    },
    {
      columns: [
        "Hải Phòng",
        "Nam An Phụ",
        "Xã Quang Thành, Xã Lạc Long, Xã Thăng Long, Xã Tuấn Việt, Xã Vũ Dũng, Xã Cộng Hòa",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Nam Đồ Sơn",
        "Phường Minh Đức (quận Đồ Sơn), Phường Bàng La, Phường Hợp Đức, Phường Vạn Hương, Phường Ngọc Xuyên",
      ],
    },
    {
      columns: ["Hải Phòng", "Nam Đồng", "Phường Nam Đồng, Xã Tiền Tiến"],
    },
    {
      columns: [
        "Hải Phòng",
        "Nam Sách",
        "Thị trấn Nam Sách, Xã Hồng Phong (huyện Nam Sách), Xã Đồng Lạc",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Nam Thanh Miện",
        "Xã Hồng Phong (huyện Thanh Miện), Xã Thanh Giang, Xã Chi Lăng Bắc, Xã Chi Lăng Nam",
      ],
    },
    {
      columns: ["Hải Phòng", "Nam Triệu", "Phường Nam Triệu Giang, Phường Lập Lễ, Phường Tam Hưng"],
    },
    {
      columns: ["Hải Phòng", "Nghi Dương", "Xã Ngũ Phúc (huyện Kiến Thụy), Xã Kiến Quốc, Xã Du Lễ"],
    },
    {
      columns: [
        "Hải Phòng",
        "Ngô Quyền",
        "Phường Máy Chai, Phường Vạn Mỹ, Phường Cầu Tre, Phường Gia Viên, Phường Đông Khê",
      ],
    },
    {
      columns: ["Hải Phòng", "Nguyễn Bỉnh Khiêm", "Xã Trấn Dương, Xã Hòa Bình, Xã Lý Học"],
    },
    {
      columns: [
        "Hải Phòng",
        "Nguyễn Đại Năng",
        "Phường Thái Thịnh, Phường Hiến Thành, Xã Minh Hòa",
      ],
    },
    {
      columns: ["Hải Phòng", "Nguyên Giáp", "Xã Hà Kỳ, Xã Nguyên Giáp, Xã Hà Thanh, Xã Tiên Động"],
    },
    {
      columns: [
        "Hải Phòng",
        "Nguyễn Lương Bằng",
        "Xã Phạm Kha, Xã Nhân Quyền, Xã Thanh Tùng, Xã Đoàn Tùng",
      ],
    },
    {
      columns: ["Hải Phòng", "Nguyễn Trãi", "Phường Bến Tắm, Xã Bắc An, Xã Hoàng Hoa Thám"],
    },
    {
      columns: [
        "Hải Phòng",
        "Nhị Chiểu",
        "Phường Tân Dân (thị xã Kinh Môn), Phường Minh Tân, Phường Duy Tân, Phường Phú Thứ",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Ninh Giang",
        "Thị trấn Ninh Giang, Xã Vĩnh Hòa (huyện Ninh Giang), Xã Hồng Dụ, Xã Hiệp Lực",
      ],
    },
    {
      columns: ["Hải Phòng", "Phạm Sư Mạnh", "Phường Phạm Thái, Phường An Sinh, Phường Hiệp Sơn"],
    },
    {
      columns: [
        "Hải Phòng",
        "Phù Liễn",
        "Phường Bắc Hà, Phường Ngọc Sơn, Thị trấn Trường Sơn, Phường Nam Sơn (quận Kiến An), Phường Đồng Hòa, Phường Bắc Sơn, Phường Trần Thành Ngọ, Phường Văn Đẩu",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Phú Thái",
        "Thị trấn Phú Thái, Xã Kim Xuyên, Xã Kim Anh, Xã Kim Liên, Xã Thượng Quận",
      ],
    },
    {
      columns: ["Hải Phòng", "Quyết Thắng", "Xã Đại Thắng, Xã Tiên Cường, Xã Tự Cường"],
    },
    {
      columns: ["Hải Phòng", "Tân An", "Xã Tân Phong (huyện Ninh Giang), Xã An Đức, Xã Đức Phúc"],
    },
    {
      columns: [
        "Hải Phòng",
        "Tân Hưng",
        "Phường Hải Tân, Phường Tân Hưng, Xã Ngọc Sơn, Phường Trần Phú",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Tân Kỳ",
        "Xã Đại Hợp (huyện Tứ Kỳ), Xã Tân Kỳ, Xã Dân An, Xã Kỳ Sơn, Xã Hưng Đạo (huyện Tứ Kỳ)",
      ],
    },
    {
      columns: ["Hải Phòng", "Tân Minh", "Xã Cấp Tiến, Xã Kiến Thiết, Xã Đoàn Lập, Xã Tân Minh"],
    },
    {
      columns: [
        "Hải Phòng",
        "Thạch Khôi",
        "Phường Thạch Khôi, Xã Gia Xuyên, Xã Liên Hồng, Xã Thống Nhất",
      ],
    },
    {
      columns: ["Hải Phòng", "Thái Tân", "Xã Minh Tân (huyện Nam Sách), Xã An Sơn, Xã Thái Tân"],
    },
    {
      columns: [
        "Hải Phòng",
        "Thành Đông",
        "Phường Cẩm Thượng, Phường Bình Hàn, Phường Nguyễn Trãi, Xã An Thượng",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Thanh Hà",
        "Thị trấn Thanh Hà, Xã Thanh Sơn (huyện Thanh Hà), Xã Thanh Tân",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Thanh Miện",
        "Xã Cao Thắng, Xã Ngũ Hùng, Xã Tứ Cường, Thị trấn Thanh Miện",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Thiên Hương",
        "Phường Thiên Hương, Phường Hoàng Lâm, Phường Lê Hồng Phong, Phường Hoa Động",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Thủy Nguyên",
        "Phường Dương Quan, Phường Thủy Đường, Phường Hoa Động, Phường An Lư, Phường Thủy Hà",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Thượng Hồng",
        "Xã Bình Xuyên (huyện Bình Giang), Xã Thanh Tùng, Xã Đoàn Tùng, Xã Thúc Kháng, Xã Thái Minh, Xã Tân Hồng, Xã Thái Dương, Xã Thái Hòa",
      ],
    },
    {
      columns: [
        "Hải Phòng",
        "Tiên Lãng",
        "Thị trấn Tiên Lãng, Xã Quyết Tiến, Xã Tiên Thanh, Xã Khởi Nghĩa",
      ],
    },
    {
      columns: ["Hải Phòng", "Tiên Minh", "Xã Tiên Thắng, Xã Tiên Minh, Xã Tân Minh"],
    },
    {
      columns: [
        "Hải Phòng",
        "Trần Hưng Đạo",
        "Xã Lê Lợi, Xã Hưng Đạo (thành phố Chí Linh), Phường Cộng Hòa",
      ],
    },
    {
      columns: ["Hải Phòng", "Trần Liễu", "Phường An Phụ, Xã Hiệp Hòa, Xã Thượng Quận"],
    },
    {
      columns: [
        "Hải Phòng",
        "Trần Nhân Tông",
        "Phường Hoàng Tân, Phường Hoàng Tiến, Phường Văn Đức",
      ],
    },
    {
      columns: ["Hải Phòng", "Trần Phú", "Xã Quốc Tuấn (huyện Nam Sách), Xã Hiệp Cát, Xã Trần Phú"],
    },
    {
      columns: [
        "Hải Phòng",
        "Trường Tân",
        "Xã Phạm Trấn, Xã Nhật Quang, Xã Thống Kênh, Xã Đoàn Thượng, Xã Quang Đức, Thị trấn Thanh Miện",
      ],
    },
    {
      columns: ["Hải Phòng", "Tuệ Tĩnh", "Xã Đức Chính, Xã Cẩm Vũ, Xã Cẩm Văn"],
    },
    {
      columns: ["Hải Phòng", "Tứ Kỳ", "Thị trấn Tứ Kỳ, Xã Minh Đức, Xã Quang Khải, Xã Quang Phục"],
    },
    {
      columns: ["Hải Phòng", "Tứ Minh", "Xã Cẩm Đoài, Phường Tứ Minh, Thị trấn Lai Cách"],
    },
    {
      columns: [
        "Hải Phòng",
        "Việt Hòa",
        "Phường Việt Hòa, Xã Cao An, Phường Tứ Minh, Thị trấn Lai Cách",
      ],
    },
    {
      columns: ["Hải Phòng", "Việt Khê", "Xã Ninh Sơn, Xã Liên Xuân"],
    },
    {
      columns: ["Hải Phòng", "Vĩnh Am", "Xã Tam Cường, Xã Cao Minh, Xã Liên Am"],
    },
    {
      columns: [
        "Hải Phòng",
        "Vĩnh Bảo",
        "Thị trấn Vĩnh Bảo, Xã Vĩnh Hưng (huyện Vĩnh Bảo), Xã Tân Hưng, Xã Tân Liên",
      ],
    },
    {
      columns: ["Hải Phòng", "Vĩnh Hải", "Xã Tiền Phong, Xã Vĩnh Hải"],
    },
    {
      columns: ["Hải Phòng", "Vĩnh Hòa", "Xã Vĩnh Hòa (huyện Vĩnh Bảo), Xã Hùng Tiến"],
    },
    {
      columns: ["Hải Phòng", "Vĩnh Lại", "Xã Ứng Hòe, Xã Tân Hương, Xã Nghĩa An"],
    },
    {
      columns: ["Hải Phòng", "Vĩnh Thịnh", "Xã Thắng Thủy, Xã Trung Lập, Xã Việt Tiến"],
    },
    {
      columns: ["Hải Phòng", "Vĩnh Thuận", "Xã Vĩnh An, Xã Giang Biên, Xã Dũng Tiến"],
    },
    {
      columns: ["Hải Phòng", "Yết Kiêu", "Xã Thống Nhất, Xã Lê Lợi (huyện Gia Lộc), Xã Yết Kiêu"],
    },
    {
      columns: ["Huế", "A Lưới 1", "Xã Hồng Thủy, Xã Hồng Vân, Xã Trung Sơn, Xã Hồng Kim"],
    },
    {
      columns: ["Huế", "A Lưới 2", "Thị trấn A Lưới, Xã Hồng Bắc, Xã Quảng Nhâm, Xã A Ngo"],
    },
    {
      columns: ["Huế", "A Lưới 3", "Xã Sơn Thủy, Xã Hồng Thượng, Xã Phú Vinh, Xã Hồng Thái"],
    },
    {
      columns: ["Huế", "A Lưới 4", "Xã Hương Phong, Xã A Roàng, Xã Đông Sơn, Xã Lâm Đớt"],
    },
    {
      columns: ["Huế", "A Lưới 5", "Xã Hương Nguyên, Xã Hồng Hạ"],
    },
    {
      columns: ["Huế", "An Cựu", "Phường An Đông, Phường An Tây, Phường An Cựu"],
    },
    {
      columns: ["Huế", "Bình Điền", "Xã Hương Bình, Xã Bình Thành, Xã Bình Tiến"],
    },
    {
      columns: [
        "Huế",
        "Chân Mây - Lăng Cô",
        "Thị trấn Lăng Cô, Xã Lộc Tiến, Xã Lộc Vĩnh, Xã Lộc Thủy",
      ],
    },
    {
      columns: ["Huế", "Dương Nỗ", "Không sáp nhập"],
    },
    {
      columns: ["Huế", "Đan Điền", "Xã Quảng Thái, Xã Quảng Lợi, Xã Quảng Vinh, Xã Quảng Phú"],
    },
    {
      columns: ["Huế", "Hóa Châu", "Phường Hương Phong, Phường Hương Vinh, Xã Quảng Thành"],
    },
    {
      columns: ["Huế", "Hưng Lộc", "Thị trấn Lộc Sơn, Xã Lộc Bổn, Xã Xuân Lộc"],
    },
    {
      columns: ["Huế", "Hương An", "Phường An Hòa, Phường Hương Sơ, Phường Hương An"],
    },
    {
      columns: ["Huế", "Hương Thủy", "Phường Thủy Lương, Phường Thủy Châu, Xã Thủy Tân"],
    },
    {
      columns: ["Huế", "Hương Trà", "Phường Tứ Hạ, Phường Hương Văn, Phường Hương Vân"],
    },
    {
      columns: ["Huế", "Khe Tre", "Thị trấn Khe Tre, Xã Hương Phú, Xã Hương Lộc, Xã Thượng Lộ"],
    },
    {
      columns: ["Huế", "Kim Long", "Phường Long Hồ, Phường Hương Long, Phường Kim Long"],
    },
    {
      columns: ["Huế", "Kim Trà", "Phường Hương Xuân, Phường Hương Chữ, Xã Hương Toàn"],
    },
    {
      columns: ["Huế", "Long Quảng", "Xã Thượng Quảng, Xã Thượng Long, Xã Hương Hữu"],
    },
    {
      columns: ["Huế", "Lộc An", "Xã Lộc Hòa, Xã Lộc Điền, Xã Lộc An"],
    },
    {
      columns: ["Huế", "Mỹ Thượng", "Phường Phú Thượng, Xã Phú An, Xã Phú Mỹ"],
    },
    {
      columns: ["Huế", "Nam Đông", "Xã Hương Xuân, Xã Thượng Nhật, Xã Hương Sơn"],
    },
    {
      columns: ["Huế", "Phong Dinh", "Phường Phong Hòa, Xã Phong Bình, Xã Phong Chương"],
    },
    {
      columns: ["Huế", "Phong Điền", "Phường Phong Thu, Xã Phong Mỹ, Xã Phong Xuân"],
    },
    {
      columns: ["Huế", "Phong Phú", "Phường Phong Phú, Xã Phong Thạnh"],
    },
    {
      columns: ["Huế", "Phong Quảng", "Phường Phong Hải, Xã Quảng Công, Xã Quảng Ngạn"],
    },
    {
      columns: ["Huế", "Phong Thái", "Phường Phong An, Phường Phong Hiền, Xã Phong Sơn"],
    },
    {
      columns: ["Huế", "Phú Bài", "Phường Phú Bài, Xã Thủy Phù, Xã Phú Sơn, Xã Dương Hòa"],
    },
    {
      columns: ["Huế", "Phú Hồ", "Xã Phú Xuân, Xã Phú Lương, Xã Phú Hồ"],
    },
    {
      columns: ["Huế", "Phú Lộc", "Thị trấn Phú Lộc, Xã Lộc Trì, Xã Lộc Bình"],
    },
    {
      columns: ["Huế", "Phú Vang", "Thị trấn Phú Đa, Xã Phú Gia, Xã Vinh Hà"],
    },
    {
      columns: ["Huế", "Phú Vinh", "Xã Phú Diên, Xã Vinh Xuân, Xã Vinh An, Xã Vinh Thanh"],
    },
    {
      columns: [
        "Huế",
        "Phú Xuân",
        "Phường Gia Hội, Phường Phú Hậu, Phường Tây Lộc, Phường Thuận Lộc, Phường Thuận Hòa, Phường Đông Ba",
      ],
    },
    {
      columns: ["Huế", "Quảng Điền", "Thị trấn Sịa, Xã Quảng Phước, Xã Quảng An, Xã Quảng Thọ"],
    },
    {
      columns: ["Huế", "Thanh Thủy", "Phường Thủy Dương, Phường Thủy Phương, Xã Thủy Thanh"],
    },
    {
      columns: ["Huế", "Thuận An", "Phường Thuận An, Xã Phú Hải, Xã Phú Thuận"],
    },
    {
      columns: [
        "Huế",
        "Thuận Hóa",
        "Phường Phú Hội, Phường Phú Nhuận, Phường Đúc, Phường Vĩnh Ninh, Phường Phước Vĩnh, Phường Trường An",
      ],
    },
    {
      columns: ["Huế", "Thủy Xuân", "Phường Thủy Biều, Phường Thủy Bằng, Phường Thủy Xuân"],
    },
    {
      columns: ["Huế", "Vinh Lộc", "Xã Vinh Hưng, Xã Vinh Mỹ, Xã Giang Hải, Xã Vinh Hiền"],
    },
    {
      columns: ["Huế", "Vỹ Dạ", "Phường Thủy Vân, Phường Xuân Phú, Phường Vỹ Dạ"],
    },
    {
      columns: ["Hưng Yên", "A Sào", "Xã An Đồng, Xã An Hiệp, Xã An Thái, Xã An Khê"],
    },
    {
      columns: ["Hưng Yên", "Ái Quốc", "Xã Tây Giang, Xã Ái Quốc"],
    },
    {
      columns: ["Hưng Yên", "Ân Thi", "Thị trấn Ân Thi, Xã Quang Vinh, Xã Hoàng Hoa Thám"],
    },
    {
      columns: ["Hưng Yên", "Bắc Đông Hưng", "Xã Đông Cường, Xã Đông Xá, Xã Đông Phương"],
    },
    {
      columns: ["Hưng Yên", "Bắc Đông Quan", "Xã Hà Giang, Xã Đông Kinh, Xã Đông Vinh"],
    },
    {
      columns: ["Hưng Yên", "Bắc Thái Ninh", "Xã Thái Phúc, Xã Dương Hồng Thủy"],
    },
    {
      columns: ["Hưng Yên", "Bắc Thụy Anh", "Xã Thụy Quỳnh, Xã Thụy Văn, Xã Thụy Việt"],
    },
    {
      columns: [
        "Hưng Yên",
        "Bắc Tiên Hưng",
        "Xã Liên An Đô, Xã Lô Giang, Xã Mê Linh, Xã Phú Lương",
      ],
    },
    {
      columns: ["Hưng Yên", "Bình Định", "Xã Hồng Tiến, Xã Nam Bình, Xã Bình Định"],
    },
    {
      columns: ["Hưng Yên", "Bình Nguyên", "Xã Thanh Tân, Xã An Bình, Xã Bình Nguyên"],
    },
    {
      columns: [
        "Hưng Yên",
        "Bình Thanh",
        "Xã Minh Tân, Xã Minh Quang (huyện Kiến Xương), Xã Bình Thanh",
      ],
    },
    {
      columns: ["Hưng Yên", "Châu Ninh", "Xã Đại Tập, Xã Tứ Dân, Xã Tân Châu, Xã Đông Ninh"],
    },
    {
      columns: ["Hưng Yên", "Chí Minh", "Xã Thuần Hưng, Xã Nguyễn Huệ, Xã Chí Minh"],
    },
    {
      columns: ["Hưng Yên", "Diên Hà", "Xã Quang Trung (huyện Hưng Hà), Xã Văn Cẩm, Xã Duyên Hải"],
    },
    {
      columns: [
        "Hưng Yên",
        "Đại Đồng",
        "Xã Việt Hưng, Xã Lương Tài, Xã Đại Đồng, Xã Đình Dù, Xã Lạc Đạo",
      ],
    },
    {
      columns: ["Hưng Yên", "Đoàn Đào", "Xã Phan Sào Nam, Xã Minh Hoàng, Xã Đoàn Đào"],
    },
    {
      columns: ["Hưng Yên", "Đồng Bằng", "Xã An Cầu, Xã An Ấp, Xã An Lễ, Xã An Quý"],
    },
    {
      columns: [
        "Hưng Yên",
        "Đồng Châu",
        "Xã Đông Hoàng (huyện Tiền Hải), Xã Đông Cơ, Xã Đông Lâm, Xã Đông Minh",
      ],
    },
    {
      columns: [
        "Hưng Yên",
        "Đông Hưng",
        "Thị trấn Đông Hưng, Xã Nguyên Xá (huyện Đông Hưng), Xã Đông La, Xã Đông Các, Xã Đông Sơn, Xã Đông Hợp",
      ],
    },
    {
      columns: ["Hưng Yên", "Đông Quan", "Xã Đông Á, Xã Đông Tân, Xã Đông Quan"],
    },
    {
      columns: ["Hưng Yên", "Đông Thái Ninh", "Xã Mỹ Lộc, Xã Tân Học, Xã Thái Đô, Xã Thái Xuyên"],
    },
    {
      columns: [
        "Hưng Yên",
        "Đông Thụy Anh",
        "Xã Thụy Trường, Xã Thụy Xuân, Xã An Tân, Xã Hồng Dũng",
      ],
    },
    {
      columns: [
        "Hưng Yên",
        "Đông Tiền Hải",
        "Xã Đông Xuyên, Xã Đông Quang, Xã Đông Long, Xã Đông Trà",
      ],
    },
    {
      columns: ["Hưng Yên", "Đông Tiên Hưng", "Xã Phong Dương Tiến, Xã Phú Châu"],
    },
    {
      columns: ["Hưng Yên", "Đức Hợp", "Xã Phú Thọ, Xã Mai Động, Xã Đức Hợp"],
    },
    {
      columns: [
        "Hưng Yên",
        "Đường Hào",
        "Phường Dị Sử, Phường Phùng Chí Kiên, Xã Xuân Dục, Xã Hưng Long, Xã Ngọc Lâm",
      ],
    },
    {
      columns: ["Hưng Yên", "Hiệp Cường", "Xã Song Mai, Xã Hùng An, Xã Hiệp Cường, Xã Ngọc Thanh"],
    },
    {
      columns: ["Hưng Yên", "Hoàn Long", "Xã Đông Tảo, Xã Đồng Than, Xã Hoàn Long"],
    },
    {
      columns: [
        "Hưng Yên",
        "Hoàng Hoa Thám",
        "Thị trấn Vương, Xã Hưng Đạo, Xã Nhật Tân, Xã An Viên",
      ],
    },
    {
      columns: ["Hưng Yên", "Hồng Châu", "Phường Hồng Châu, Xã Quảng Châu, Xã Hoàng Hanh"],
    },
    {
      columns: ["Hưng Yên", "Hồng Minh", "Xã Chí Hòa, Xã Minh Hòa, Xã Hồng Minh"],
    },
    {
      columns: ["Hưng Yên", "Hồng Quang", "Xã Hồ Tùng Mậu, Xã Tiền Phong, Xã Hạ Lễ, Xã Hồng Quang"],
    },
    {
      columns: ["Hưng Yên", "Hồng Vũ", "Xã Vũ Công, Xã Hồng Vũ"],
    },
    {
      columns: [
        "Hưng Yên",
        "Hưng Hà",
        "Xã Hòa Bình, Xã Minh Khai, Xã Thống Nhất (huyện Hưng Hà), Xã Kim Trung, Xã Hồng Lĩnh, Xã Văn Lang, Thị trấn Hưng Hà",
      ],
    },
    {
      columns: ["Hưng Yên", "Hưng Phú", "Xã Nam Phú, Xã Nam Hưng, Xã Nam Trung"],
    },
    {
      columns: [
        "Hưng Yên",
        "Khoái Châu",
        "Thị trấn Khoái Châu, Xã Liên Khê, Xã Phùng Hưng, Xã Đông Kết",
      ],
    },
    {
      columns: [
        "Hưng Yên",
        "Kiến Xương",
        "Xã Bình Minh, Xã Quang Trung (huyện Kiến Xương), Xã Quang Minh, Xã Quang Bình, Thị trấn Kiến Xương",
      ],
    },
    {
      columns: ["Hưng Yên", "Lạc Đạo", "Xã Chỉ Đạo, Xã Minh Hải, Xã Lạc Đạo"],
    },
    {
      columns: ["Hưng Yên", "Lê Lợi", "Xã Thống Nhất (huyện Kiến Xương), Xã Lê Lợi"],
    },
    {
      columns: ["Hưng Yên", "Lê Quý Đôn", "Xã Minh Tân (huyện Hưng Hà), Xã Độc Lập, Xã Hồng An"],
    },
    {
      columns: [
        "Hưng Yên",
        "Long Hưng",
        "Thị trấn Hưng Nhân, Xã Thái Hưng (huyện Hưng Hà), Xã Tân Lễ, Xã Tiến Đức, Xã Liên Hiệp",
      ],
    },
    {
      columns: [
        "Hưng Yên",
        "Lương Bằng",
        "Thị trấn Lương Bằng, Xã Phạm Ngũ Lão, Xã Chính Nghĩa, Xã Diên Hồng",
      ],
    },
    {
      columns: ["Hưng Yên", "Mễ Sở", "Xã Bình Minh (huyện Khoái Châu), Xã Thắng Lợi, Xã Mễ Sở"],
    },
    {
      columns: ["Hưng Yên", "Minh Thọ", "Xã Quỳnh Hoa, Xã Quỳnh Minh, Xã Quỳnh Giao, Xã Quỳnh Thọ"],
    },
    {
      columns: [
        "Hưng Yên",
        "Mỹ Hào",
        "Phường Bần Yên Nhân, Phường Nhân Hòa, Phường Phan Đình Phùng, Xã Cẩm Xá",
      ],
    },
    {
      columns: ["Hưng Yên", "Nam Cường", "Xã Nam Thịnh, Xã Nam Tiến, Xã Nam Chính, Xã Nam Cường"],
    },
    {
      columns: ["Hưng Yên", "Nam Đông Hưng", "Xã Đông Hoàng (huyện Đông Hưng), Xã Xuân Quang Động"],
    },
    {
      columns: ["Hưng Yên", "Nam Thái Ninh", "Xã Thái Thọ, Xã Thái Thịnh, Xã Thuần Thành"],
    },
    {
      columns: ["Hưng Yên", "Nam Thụy Anh", "Xã Thụy Thanh, Xã Thụy Phong, Xã Thụy Duyên"],
    },
    {
      columns: ["Hưng Yên", "Nam Tiền Hải", "Xã Nam Hồng, Xã Nam Hà, Xã Nam Hải"],
    },
    {
      columns: [
        "Hưng Yên",
        "Nam Tiên Hưng",
        "Xã Liên Hoa, Xã Hồng Giang, Xã Trọng Quan, Xã Minh Phú",
      ],
    },
    {
      columns: [
        "Hưng Yên",
        "Nghĩa Dân",
        "Xã Đồng Thanh (huyện Kim Động), Xã Vĩnh Xá, Xã Toàn Thắng, Xã Nghĩa Dân",
      ],
    },
    {
      columns: ["Hưng Yên", "Nghĩa Trụ", "Xã Long Hưng, Xã Vĩnh Khúc, Xã Nghĩa Trụ"],
    },
    {
      columns: ["Hưng Yên", "Ngọc Lâm", "Xã Quỳnh Hoàng, Xã Quỳnh Lâm, Xã Quỳnh Ngọc"],
    },
    {
      columns: ["Hưng Yên", "Nguyễn Du", "Xã Châu Sơn, Xã Quỳnh Khê, Xã Quỳnh Nguyên"],
    },
    {
      columns: ["Hưng Yên", "Nguyễn Trãi", "Xã Đặng Lễ, Xã Cẩm Ninh, Xã Đa Lộc, Xã Nguyễn Trãi"],
    },
    {
      columns: ["Hưng Yên", "Nguyễn Văn Linh", "Xã Ngọc Long, Xã Liêu Xá, Xã Nguyễn Văn Linh"],
    },
    {
      columns: [
        "Hưng Yên",
        "Ngự Thiên",
        "Xã Tân Hòa (huyện Hưng Hà), Xã Canh Tân, Xã Cộng Hòa, Xã Hòa Tiến",
      ],
    },
    {
      columns: [
        "Hưng Yên",
        "Như Quỳnh",
        "Thị trấn Như Quỳnh, Xã Tân Quang, Xã Lạc Hồng, Xã Trưng Trắc, Xã Đình Dù",
      ],
    },
    {
      columns: [
        "Hưng Yên",
        "Phạm Ngũ Lão",
        "Xã Bắc Sơn (huyện Ân Thi), Xã Phù Ủng, Xã Đào Dương, Xã Bãi Sậy",
      ],
    },
    {
      columns: [
        "Hưng Yên",
        "Phố Hiến",
        "Phường An Tảo, Phường Lê Lợi, Phường Hiến Nam, Phường Minh Khai, Xã Trung Nghĩa, Xã Liên Phương",
      ],
    },
    {
      columns: [
        "Hưng Yên",
        "Phụ Dực",
        "Thị trấn An Bài, Xã An Ninh (huyện Quỳnh Phụ), Xã An Vũ, Xã An Mỹ, Xã An Thanh",
      ],
    },
    {
      columns: ["Hưng Yên", "Phụng Công", "Xã Xuân Quan, Xã Cửu Cao, Xã Phụng Công"],
    },
    {
      columns: [
        "Hưng Yên",
        "Quang Hưng",
        "Thị trấn Trần Cao, Xã Minh Tân (huyện Phù Cừ), Xã Tống Phan, Xã Quang Hưng",
      ],
    },
    {
      columns: [
        "Hưng Yên",
        "Quang Lịch",
        "Xã Hòa Bình (huyện Kiến Xương), Xã Vũ Lễ, Xã Quang Lịch",
      ],
    },
    {
      columns: ["Hưng Yên", "Quỳnh An", "Xã Trang Bảo Xá, Xã An Vinh, Xã Đông Hải"],
    },
    {
      columns: [
        "Hưng Yên",
        "Quỳnh Phụ",
        "Thị trấn Quỳnh Côi, Xã Quỳnh Hải, Xã Quỳnh Hội, Xã Quỳnh Hồng, Xã Quỳnh Mỹ, Xã Quỳnh Hưng",
      ],
    },
    {
      columns: [
        "Hưng Yên",
        "Sơn Nam",
        "Phường Lam Sơn, Xã Phú Cường, Xã Hùng Cường, Xã Bảo Khê, Xã Ngọc Thanh",
      ],
    },
    {
      columns: ["Hưng Yên", "Tân Hưng", "Xã Thủ Sỹ, Xã Phương Nam, Xã Tân Hưng"],
    },
    {
      columns: ["Hưng Yên", "Tân Thuận", "Xã Tân Lập (huyện Vũ Thư), Xã Tự Tân, Xã Bách Thuận"],
    },
    {
      columns: ["Hưng Yên", "Tân Tiến", "Xã Đồng Tiến (huyện Quỳnh Phụ), Xã An Dục, Xã An Tràng"],
    },
    {
      columns: ["Hưng Yên", "Tây Thái Ninh", "Xã Sơn Hà, Xã Thái Giang"],
    },
    {
      columns: ["Hưng Yên", "Tây Thụy Anh", "Xã Thụy Chính, Xã Thụy Dân, Xã Thụy Ninh"],
    },
    {
      columns: ["Hưng Yên", "Tây Tiền Hải", "Xã Phương Công, Xã Vân Trường, Xã Bắc Hải"],
    },
    {
      columns: [
        "Hưng Yên",
        "Thái Bình",
        "Phường Lê Hồng Phong, Phường Bồ Xuyên, Phường Tiền Phong, Xã Tân Hòa (huyện Vũ Thư), Xã Phúc Thành, Xã Tân Phong, Xã Tân Bình",
      ],
    },
    {
      columns: [
        "Hưng Yên",
        "Thái Ninh",
        "Xã Thái Hưng (huyện Thái Thụy), Xã Thái Thượng, Xã Hòa An, Xã Thái Nguyên",
      ],
    },
    {
      columns: [
        "Hưng Yên",
        "Thái Thụy",
        "Thị trấn Diêm Điền, Xã Thụy Hải, Xã Thụy Trình, Xã Thụy Bình, Xã Thụy Liên",
      ],
    },
    {
      columns: [
        "Hưng Yên",
        "Thần Khê",
        "Xã Bắc Sơn (huyện Hưng Hà), Xã Đông Đô, Xã Tây Đô, Xã Chi Lăng",
      ],
    },
    {
      columns: ["Hưng Yên", "Thụy Anh", "Xã Thụy Sơn, Xã Dương Phúc, Xã Thụy Hưng"],
    },
    {
      columns: ["Hưng Yên", "Thư Trì", "Xã Song Lãng, Xã Hiệp Hòa, Xã Minh Lãng"],
    },
    {
      columns: ["Hưng Yên", "Thư Vũ", "Xã Việt Thuận, Xã Vũ Hội, Xã Vũ Vinh, Xã Vũ Vân"],
    },
    {
      columns: [
        "Hưng Yên",
        "Thượng Hồng",
        "Phường Bạch Sam, Phường Minh Đức, Xã Dương Quang, Xã Hòa Phong",
      ],
    },
    {
      columns: [
        "Hưng Yên",
        "Tiền Hải",
        "Thị trấn Tiền Hải, Xã An Ninh (huyện Tiền Hải), Xã Tây Ninh, Xã Tây Lương, Xã Vũ Lăng",
      ],
    },
    {
      columns: ["Hưng Yên", "Tiên Hoa", "Xã Lệ Xá, Xã Trung Dũng, Xã Cương Chính"],
    },
    {
      columns: [
        "Hưng Yên",
        "Tiên Hưng",
        "Xã Minh Tân (huyện Đông Hưng), Xã Hồng Bạch, Xã Thăng Long, Xã Hồng Việt",
      ],
    },
    {
      columns: [
        "Hưng Yên",
        "Tiên La",
        "Xã Tân Tiến (huyện Hưng Hà), Xã Thái Phương, Xã Đoan Hùng, Xã Phúc Khánh",
      ],
    },
    {
      columns: ["Hưng Yên", "Tiên Lữ", "Xã Thiện Phiến, Xã Hải Thắng, Xã Thụy Lôi"],
    },
    {
      columns: ["Hưng Yên", "Tiên Tiến", "Xã Đình Cao, Xã Nhật Quang, Xã Tiên Tiến"],
    },
    {
      columns: ["Hưng Yên", "Tống Trân", "Xã Tam Đa, Xã Nguyên Hòa, Xã Tống Trân"],
    },
    {
      columns: ["Hưng Yên", "Trà Giang", "Xã Hồng Thái, Xã Quốc Tuấn, Xã Trà Giang"],
    },
    {
      columns: [
        "Hưng Yên",
        "Trà Lý",
        "Phường Hoàng Diệu, Xã Đông Mỹ, Xã Đông Hoà, Xã Đông Thọ, Xã Đông Dương",
      ],
    },
    {
      columns: [
        "Hưng Yên",
        "Trần Hưng Đạo",
        "Phường Trần Hưng Đạo, Phường Đề Thám, Phường Quang Trung, Xã Phú Xuân",
      ],
    },
    {
      columns: [
        "Hưng Yên",
        "Trần Lãm",
        "Phường Trần Lãm, Phường Kỳ Bá, Xã Vũ Đông, Xã Vũ Lạc, Xã Vũ Chính, Xã Tây Sơn",
      ],
    },
    {
      columns: [
        "Hưng Yên",
        "Triệu Việt Vương",
        "Xã Phạm Hồng Thái, Xã Tân Dân, Xã Ông Đình, Xã An Vĩ",
      ],
    },
    {
      columns: [
        "Hưng Yên",
        "Vạn Xuân",
        "Xã Đồng Thanh (huyện Vũ Thư), Xã Hồng Lý, Xã Việt Hùng, Xã Xuân Hòa",
      ],
    },
    {
      columns: [
        "Hưng Yên",
        "Văn Giang",
        "Xã Tân Tiến (huyện Văn Giang), Xã Liên Nghĩa, Thị trấn Văn Giang",
      ],
    },
    {
      columns: [
        "Hưng Yên",
        "Việt Tiến",
        "Xã Đồng Tiến (huyện Khoái Châu), Xã Dân Tiến, Xã Việt Hòa",
      ],
    },
    {
      columns: ["Hưng Yên", "Việt Yên", "Xã Yên Phú, Xã Thanh Long, Xã Việt Yên"],
    },
    {
      columns: [
        "Hưng Yên",
        "Vũ Phúc",
        "Phường Phú Khánh, Xã Nguyên Xá (huyện Vũ Thư), Xã Song An, Xã Trung An, Xã Vũ Phúc",
      ],
    },
    {
      columns: ["Hưng Yên", "Vũ Quý", "Xã Vũ An, Xã Vũ Ninh, Xã Vũ Trung, Xã Vũ Quý"],
    },
    {
      columns: [
        "Hưng Yên",
        "Vũ Thư",
        "Xã Hòa Bình, Xã Minh Khai, Xã Minh Quang (huyện Vũ Thư), Xã Tam Quang, Xã Dũng Nghĩa, Thị trấn Vũ Thư",
      ],
    },
    {
      columns: ["Hưng Yên", "Vũ Tiên", "Xã Vũ Đoài, Xã Duy Nhất, Xã Hồng Phong, Xã Vũ Tiến"],
    },
    {
      columns: ["Hưng Yên", "Xuân Trúc", "Xã Vân Du, Xã Quảng Lãng, Xã Xuân Trúc"],
    },
    {
      columns: [
        "Hưng Yên",
        "Yên Mỹ",
        "Thị trấn Yên Mỹ, Xã Tân Lập (huyện Yên Mỹ), Xã Trung Hòa, Xã Tân Minh",
      ],
    },
    {
      columns: ["Khánh Hòa", "Anh Dũng", "Xã Ma Nới, Xã Hòa Sơn"],
    },
    {
      columns: ["Khánh Hòa", "Ba Ngòi", "Phường Ba Ngòi, Xã Cam Phước Đông"],
    },
    {
      columns: ["Khánh Hòa", "Bác Ái", "Xã Phước Tiến, Xã Phước Thắng, Xã Phước Chính"],
    },
    {
      columns: ["Khánh Hòa", "Bác Ái Đông", "Xã Phước Đại, Xã Phước Thành"],
    },
    {
      columns: ["Khánh Hòa", "Bác Ái Tây", "Xã Phước Hòa, Xã Phước Tân, Xã Phước Bình"],
    },
    {
      columns: ["Khánh Hòa", "Bảo An", "Phường Phước Mỹ, Phường Bảo An, Xã Thành Hải"],
    },
    {
      columns: [
        "Khánh Hòa",
        "Bắc Cam Ranh",
        "Phường Cam Nghĩa, Phường Cam Phúc Bắc, Xã Cam Thành Nam",
      ],
    },
    {
      columns: ["Khánh Hòa", "Bắc Khánh Vĩnh", "Xã Khánh Bình, Xã Khánh Đông"],
    },
    {
      columns: [
        "Khánh Hòa",
        "Bắc Nha Trang",
        "Phường Vĩnh Hòa, Phường Vĩnh Hải, Phường Vĩnh Phước, Phường Vĩnh Thọ, Xã Vĩnh Lương, Xã Vĩnh Phương",
      ],
    },
    {
      columns: ["Khánh Hòa", "Bắc Ninh Hòa", "Xã Ninh An, Xã Ninh Sơn, Xã Ninh Thọ"],
    },
    {
      columns: ["Khánh Hòa", "Cà Ná", "Xã Phước Diêm, Xã Cà Ná"],
    },
    {
      columns: ["Khánh Hòa", "Cam An", "Xã Cam Phước Tây, Xã Cam An Bắc, Xã Cam An Nam"],
    },
    {
      columns: [
        "Khánh Hòa",
        "Cam Hiệp",
        "Xã Sơn Tân, Xã Cam Hiệp Bắc, Xã Cam Hiệp Nam, Xã Cam Hòa, Xã Cam Tân, Xã Suối Tân",
      ],
    },
    {
      columns: [
        "Khánh Hòa",
        "Cam Lâm",
        "Thị trấn Cam Đức, Xã Cam Hải Đông, Xã Cam Hải Tây, Xã Cam Thành Bắc, Xã Cam Hiệp Bắc, Xã Cam Hiệp Nam, Xã Cam Hòa, Xã Cam Tân, Xã Cam An Bắc, Xã Cam An Nam, Xã Suối Tân",
      ],
    },
    {
      columns: ["Khánh Hòa", "Cam Linh", "Phường Cam Thuận, Phường Cam Lợi, Phường Cam Linh"],
    },
    {
      columns: ["Khánh Hòa", "Cam Ranh", "Phường Cam Phú, Phường Cam Lộc, Phường Cam Phúc Nam"],
    },
    {
      columns: ["Khánh Hòa", "Công Hải", "Xã Phước Chiến, Xã Công Hải"],
    },
    {
      columns: ["Khánh Hòa", "Diên Điền", "Xã Diên Sơn, Xã Diên Phú, Xã Diên Điền"],
    },
    {
      columns: ["Khánh Hòa", "Diên Khánh", "Thị trấn Diên Khánh, Xã Diên An, Xã Diên Toàn"],
    },
    {
      columns: ["Khánh Hòa", "Diên Lạc", "Xã Diên Thạnh, Xã Diên Lạc, Xã Diên Hòa"],
    },
    {
      columns: ["Khánh Hòa", "Diên Lâm", "Xã Xuân Đồng, Xã Diên Lâm"],
    },
    {
      columns: ["Khánh Hòa", "Diên Thọ", "Xã Diên Tân, Xã Diên Phước, Xã Diên Thọ"],
    },
    {
      columns: ["Khánh Hòa", "Đại Lãnh", "Xã Vạn Thạnh, Xã Vạn Thọ, Xã Đại Lãnh"],
    },
    {
      columns: ["Khánh Hòa", "Đô Vinh", "Phường Đô Vinh, Xã Nhơn Sơn"],
    },
    {
      columns: [
        "Khánh Hòa",
        "Đông Hải",
        "Phường Mỹ Bình, Phường Mỹ Đông, Phường Mỹ Hải, Phường Đông Hải",
      ],
    },
    {
      columns: ["Khánh Hòa", "Đông Khánh Sơn", "Xã Sơn Trung, Xã Ba Cụm Bắc, Xã Ba Cụm Nam"],
    },
    {
      columns: [
        "Khánh Hòa",
        "Đông Ninh Hòa",
        "Phường Ninh Diêm, Phường Ninh Hải, Phường Ninh Thủy, Xã Ninh Phước",
      ],
    },
    {
      columns: ["Khánh Hòa", "Hòa Thắng", "Phường Ninh Giang, Phường Ninh Hà, Xã Ninh Phú"],
    },
    {
      columns: ["Khánh Hòa", "Hòa Trí", "Xã Ninh Thượng, Xã Ninh Trung, Xã Ninh Thân"],
    },
    {
      columns: ["Khánh Hòa", "Khánh Sơn", "Thị trấn Tô Hạp, Xã Sơn Hiệp, Xã Sơn Bình"],
    },
    {
      columns: ["Khánh Hòa", "Khánh Vĩnh", "Thị trấn Khánh Vĩnh, Xã Sông Cầu, Xã Khánh Phú"],
    },
    {
      columns: ["Khánh Hòa", "Lâm Sơn", "Xã Lương Sơn, Xã Lâm Sơn"],
    },
    {
      columns: ["Khánh Hòa", "Mỹ Sơn", "Xã Phước Trung, Xã Mỹ Sơn"],
    },
    {
      columns: [
        "Khánh Hòa",
        "Nam Cam Ranh",
        "Xã Cam Lập, Xã Cam Bình, Xã Cam Thịnh Đông, Xã Cam Thịnh Tây",
      ],
    },
    {
      columns: [
        "Khánh Hòa",
        "Nam Khánh Vĩnh",
        "Xã Cầu Bà, Xã Khánh Thành, Xã Liên Sang, Xã Sơn Thái",
      ],
    },
    {
      columns: [
        "Khánh Hòa",
        "Nam Nha Trang",
        "Phường Phước Hải, Phường Phước Long, Phường Vĩnh Trường, Xã Vĩnh Thái, Xã Phước Đồng",
      ],
    },
    {
      columns: ["Khánh Hòa", "Nam Ninh Hòa", "Xã Ninh Lộc, Xã Ninh Ích, Xã Ninh Hưng, Xã Ninh Tân"],
    },
    {
      columns: [
        "Khánh Hòa",
        "Nha Trang",
        "Phường Vạn Thạnh, Phường Lộc Thọ, Phường Vĩnh Nguyên, Phường Tân Tiến, Phường Phước Hòa",
      ],
    },
    {
      columns: ["Khánh Hòa", "Ninh Chử", "Phường Văn Hải, Thị trấn Khánh Hải"],
    },
    {
      columns: ["Khánh Hòa", "Ninh Hải", "Xã Phương Hải, Xã Tri Hải, Xã Bắc Sơn"],
    },
    {
      columns: [
        "Khánh Hòa",
        "Ninh Hòa",
        "Phường Ninh Hiệp, Phường Ninh Đa, Xã Ninh Đông, Xã Ninh Phụng",
      ],
    },
    {
      columns: ["Khánh Hòa", "Ninh Phước", "Thị trấn Phước Dân, Xã Phước Thuận, Xã Phước Hải"],
    },
    {
      columns: ["Khánh Hòa", "Ninh Sơn", "Thị trấn Tân Sơn, Xã Quảng Sơn"],
    },
    {
      columns: [
        "Khánh Hòa",
        "Phan Rang",
        "Phường Kinh Dinh, Phường Phủ Hà, Phường Đài Sơn, Phường Đạo Long",
      ],
    },
    {
      columns: ["Khánh Hòa", "Phước Dinh", "Xã An Hải, Xã Phước Dinh, Phường Đông Hải"],
    },
    {
      columns: ["Khánh Hòa", "Phước Hà", "Xã Nhị Hà, Xã Phước Hà"],
    },
    {
      columns: ["Khánh Hòa", "Phước Hậu", "Xã Phước Vinh, Xã Phước Sơn, Xã Phước Hậu"],
    },
    {
      columns: ["Khánh Hòa", "Phước Hữu", "Xã Phước Thái, Xã Phước Hữu"],
    },
    {
      columns: ["Khánh Hòa", "Suối Dầu", "Xã Suối Cát, Xã Cam Hòa, Xã Cam Tân, Xã Suối Tân"],
    },
    {
      columns: ["Khánh Hòa", "Suối Hiệp", "Xã Suối Tiên, Xã Bình Lộc, Xã Suối Hiệp"],
    },
    {
      columns: ["Khánh Hòa", "Tân Định", "Xã Ninh Xuân, Xã Ninh Quang, Xã Ninh Bình"],
    },
    {
      columns: ["Khánh Hòa", "Tây Khánh Sơn", "Xã Sơn Lâm, Xã Thành Sơn"],
    },
    {
      columns: ["Khánh Hòa", "Tây Khánh Vĩnh", "Xã Giang Ly, Xã Khánh Thượng, Xã Khánh Nam"],
    },
    {
      columns: [
        "Khánh Hòa",
        "Tây Nha Trang",
        "Phường Ngọc Hiệp, Phường Phương Sài, Xã Vĩnh Ngọc, Xã Vĩnh Thạnh, Xã Vĩnh Hiệp, Xã Vĩnh Trung",
      ],
    },
    {
      columns: ["Khánh Hòa", "Tây Ninh Hòa", "Xã Ninh Tây, Xã Ninh Sim"],
    },
    {
      columns: ["Khánh Hòa", "Thuận Bắc", "Xã Bắc Phong, Xã Phước Kháng, Xã Lợi Hải"],
    },
    {
      columns: ["Khánh Hòa", "Thuận Nam", "Xã Phước Nam, Xã Phước Ninh, Xã Phước Minh"],
    },
    {
      columns: ["Khánh Hòa", "Trung Khánh Vĩnh", "Xã Khánh Trung, Xã Khánh Hiệp"],
    },
    {
      columns: ["Khánh Hòa", "Trường Sa", "Thị trấn Trường Sa, Xã Song Tử Tây, Xã Sinh Tồn"],
    },
    {
      columns: ["Khánh Hòa", "Tu Bông", "Xã Vạn Khánh, Xã Vạn Long, Xã Vạn Phước"],
    },
    {
      columns: ["Khánh Hòa", "Vạn Hưng", "Xã Xuân Sơn, Xã Vạn Hưng"],
    },
    {
      columns: ["Khánh Hòa", "Vạn Ninh", "Thị trấn Vạn Giã, Xã Vạn Phú, Xã Vạn Lương"],
    },
    {
      columns: ["Khánh Hòa", "Vạn Thắng", "Xã Vạn Bình, Xã Vạn Thắng"],
    },
    {
      columns: ["Khánh Hòa", "Vĩnh Hải", "Xã Nhơn Hải, Xã Thanh Hải, Xã Vĩnh Hải"],
    },
    {
      columns: ["Khánh Hòa", "Xuân Hải", "Xã Hộ Hải, Xã Tân Hải, Xã Xuân Hải"],
    },
    {
      columns: ["Lai Châu", "Bản Bo", "Xã Nà Tăm, Xã Bản Bo"],
    },
    {
      columns: ["Lai Châu", "Bình Lư", "Thị trấn Tam Đường, Xã Sơn Bình, Xã Bình Lư"],
    },
    {
      columns: ["Lai Châu", "Bum Nưa", "Xã Pa Vệ Sủ, Xã Bum Nưa"],
    },
    {
      columns: ["Lai Châu", "Bum Tở", "Thị trấn Mường Tè, Xã Can Hồ, Xã Bum Tở"],
    },
    {
      columns: ["Lai Châu", "Dào San", "Xã Tung Qua Lìn, Xã Mù Sang, Xã Dào San"],
    },
    {
      columns: [
        "Lai Châu",
        "Đoàn Kết",
        "Phường Đoàn Kết, Phường Quyết Tiến, Phường Quyết Thắng, Xã Lản Nhì Thàng, Xã Sùng Phài",
      ],
    },
    {
      columns: ["Lai Châu", "Hồng Thu", "Xã Phìn Hồ, Xã Ma Quai, Xã Hồng Thu"],
    },
    {
      columns: ["Lai Châu", "Hua Bum", "Xã Vàng San, Xã Hua Bum"],
    },
    {
      columns: ["Lai Châu", "Khoen On", "Xã Ta Gia, Xã Khoen On"],
    },
    {
      columns: ["Lai Châu", "Khổng Lào", "Xã Hoang Thèn, Xã Bản Lang, Xã Khổng Lào"],
    },
    {
      columns: ["Lai Châu", "Khun Há", "Xã Bản Hon, Xã Khun Há"],
    },
    {
      columns: ["Lai Châu", "Lê Lợi", "Xã Nậm Pì, Xã Pú Đao, Xã Chăn Nưa, Xã Lê Lợi"],
    },
    {
      columns: ["Lai Châu", "Mù Cả", "Không sáp nhập"],
    },
    {
      columns: ["Lai Châu", "Mường Khoa", "Xã Phúc Khoa, Xã Mường Khoa"],
    },
    {
      columns: ["Lai Châu", "Mường Kim", "Xã Tà Mung, Xã Tà Hừa, Xã Pha Mu, Xã Mường Kim"],
    },
    {
      columns: ["Lai Châu", "Mường Mô", "Xã Nậm Chà, Xã Mường Mô"],
    },
    {
      columns: ["Lai Châu", "Mường Tè", "Xã Nậm Khao, Xã Mường Tè"],
    },
    {
      columns: ["Lai Châu", "Mường Than", "Xã Phúc Than, Xã Mường Mít"],
    },
    {
      columns: ["Lai Châu", "Nậm Cuổi", "Xã Nậm Hăn, Xã Nậm Cuổi"],
    },
    {
      columns: ["Lai Châu", "Nậm Hàng", "Thị trấn Nậm Nhùn, Xã Nậm Manh, Xã Nậm Hàng"],
    },
    {
      columns: ["Lai Châu", "Nậm Mạ", "Xã Căn Co, Xã Nậm Mạ"],
    },
    {
      columns: ["Lai Châu", "Nậm Sỏ", "Xã Tà Mít, Xã Nậm Sỏ"],
    },
    {
      columns: ["Lai Châu", "Nậm Tăm", "Xã Lùng Thàng, Xã Nậm Cha, Xã Nậm Tăm"],
    },
    {
      columns: ["Lai Châu", "Pa Tần", "Xã Nậm Ban, Xã Trung Chải, Xã Pa Tần"],
    },
    {
      columns: ["Lai Châu", "Pa Ủ", "Xã Tá Bạ, Xã Pa Ủ"],
    },
    {
      columns: ["Lai Châu", "Pắc Ta", "Xã Hố Mít, Xã Pắc Ta"],
    },
    {
      columns: [
        "Lai Châu",
        "Phong Thổ",
        "Thị trấn Phong Thổ, Xã Huổi Luông, Xã Ma Li Pho, Xã Mường So",
      ],
    },
    {
      columns: ["Lai Châu", "Pu Sam Cáp", "Xã Pa Khóa, Xã Noong Hẻo, Xã Pu Sam Cáp"],
    },
    {
      columns: [
        "Lai Châu",
        "Sì Lở Lầu",
        "Xã Vàng Ma Chải, Xã Mồ Sì San, Xã Pa Vây Sử, Xã Sì Lở Lầu",
      ],
    },
    {
      columns: [
        "Lai Châu",
        "Sìn Hồ",
        "Thị trấn Sìn Hồ, Xã Sà Dề Phìn, Xã Phăng Sô Lin, Xã Tả Phìn",
      ],
    },
    {
      columns: ["Lai Châu", "Sin Suối Hồ", "Xã Nậm Xe, Xã Thèn Sin, Xã Sin Suối Hồ"],
    },
    {
      columns: ["Lai Châu", "Tả Lèng", "Xã Giang Ma, Xã Hồ Thầu, Xã Tả Lèng"],
    },
    {
      columns: ["Lai Châu", "Tà Tổng", "Không sáp nhập"],
    },
    {
      columns: [
        "Lai Châu",
        "Tân Phong",
        "Phường Tân Phong, Phường Đông Phong, Xã San Thàng, Xã Nùng Nàng, Xã Bản Giang",
      ],
    },
    {
      columns: [
        "Lai Châu",
        "Tân Uyên",
        "Thị trấn Tân Uyên, Xã Trung Đồng, Xã Thân Thuộc, Xã Nậm Cần",
      ],
    },
    {
      columns: [
        "Lai Châu",
        "Than Uyên",
        "Thị trấn Than Uyên, Xã Mường Than, Xã Hua Nà, Xã Mường Cang",
      ],
    },
    {
      columns: ["Lai Châu", "Thu Lũm", "Xã Ka Lăng, Xã Thu Lũm"],
    },
    {
      columns: ["Lai Châu", "Tủa Sín Chải", "Xã Làng Mô, Xã Tả Ngảo, Xã Tủa Sín Chải"],
    },
    {
      columns: ["Lạng Sơn", "Ba Sơn", "Xã Mẫu Sơn (huyện Cao Lộc), Xã Cao Lâu, Xã Xuất Lễ"],
    },
    {
      columns: ["Lạng Sơn", "Bắc Sơn", "Thị trấn Bắc Sơn, Xã Long Đống, Xã Bắc Quỳnh"],
    },
    {
      columns: ["Lạng Sơn", "Bằng Mạc", "Xã Gia Lộc, Xã Bằng Hữu, Xã Thượng Cường, Xã Bằng Mạc"],
    },
    {
      columns: [
        "Lạng Sơn",
        "Bình Gia",
        "Xã Hoàng Văn Thụ (huyện Bình Gia), Xã Mông Ân, Thị trấn Bình Gia",
      ],
    },
    {
      columns: ["Lạng Sơn", "Cai Kinh", "Xã Yên Vượng, Xã Yên Sơn, Xã Cai Kinh"],
    },
    {
      columns: ["Lạng Sơn", "Cao Lộc", "Xã Lộc Yên, Xã Thanh Lòa, Xã Thạch Đạn"],
    },
    {
      columns: [
        "Lạng Sơn",
        "Châu Sơn",
        "Xã Bắc Lãng, Xã Đồng Thắng, Xã Cường Lợi, Xã Châu Sơn, Xã Kiên Mộc",
      ],
    },
    {
      columns: [
        "Lạng Sơn",
        "Chi Lăng",
        "Xã Chi Lăng (huyện Chi Lăng), Thị trấn Chi Lăng, Thị trấn Đồng Mỏ",
      ],
    },
    {
      columns: [
        "Lạng Sơn",
        "Chiến Thắng",
        "Xã Chiến Thắng (huyện Chi Lăng), Xã Vân An, Xã Liên Sơn, Xã Vân Thủy",
      ],
    },
    {
      columns: ["Lạng Sơn", "Công Sơn", "Xã Hòa Cư, Xã Hải Yến, Xã Công Sơn"],
    },
    {
      columns: ["Lạng Sơn", "Điềm He", "Xã Trấn Ninh, Xã Liên Hội, Xã Điềm He"],
    },
    {
      columns: ["Lạng Sơn", "Đình Lập", "Thị trấn Đình Lập, Xã Đình Lập, Xã Bính Xá"],
    },
    {
      columns: ["Lạng Sơn", "Đoàn Kết", "Xã Khánh Long, Xã Cao Minh, Xã Đoàn Kết"],
    },
    {
      columns: [
        "Lạng Sơn",
        "Đồng Đăng",
        "Thị trấn Đồng Đăng, Xã Thụy Hùng (huyện Cao Lộc), Xã Phú Xá, Xã Hồng Phong, Xã Bảo Lâm",
      ],
    },
    {
      columns: [
        "Lạng Sơn",
        "Đông Kinh",
        "Phường Vĩnh Trại, Phường Đông Kinh, Xã Yên Trạch, Xã Mai Pha",
      ],
    },
    {
      columns: ["Lạng Sơn", "Hoa Thám", "Xã Hưng Đạo, Xã Hoa Thám"],
    },
    {
      columns: [
        "Lạng Sơn",
        "Hoàng Văn Thụ",
        "Xã Hồng Thái, Xã Hoàng Văn Thụ (huyện Văn Lãng), Xã Tân Mỹ, Xã Nhạc Kỳ, Xã Tân Thanh",
      ],
    },
    {
      columns: ["Lạng Sơn", "Hội Hoan", "Xã Gia Miễn, Xã Hội Hoan"],
    },
    {
      columns: ["Lạng Sơn", "Hồng Phong", "Xã Hồng Phong (huyện Bình Gia), Xã Minh Khai"],
    },
    {
      columns: ["Lạng Sơn", "Hưng Vũ", "Xã Trấn Yên, Xã Hưng Vũ"],
    },
    {
      columns: ["Lạng Sơn", "Hữu Liên", "Xã Yên Thịnh, Xã Hữu Liên"],
    },
    {
      columns: ["Lạng Sơn", "Hữu Lũng", "Thị trấn Hữu Lũng, Xã Đồng Tân, Xã Hồ Sơn"],
    },
    {
      columns: ["Lạng Sơn", "Kháng Chiến", "Xã Trung Thành, Xã Tân Minh, Xã Kháng Chiến"],
    },
    {
      columns: ["Lạng Sơn", "Khánh Khê", "Xã Xuân Long, Xã Bình Trung, Xã Khánh Khê"],
    },
    {
      columns: ["Lạng Sơn", "Khuất Xá", "Xã Tam Gia, Xã Khuất Xá"],
    },
    {
      columns: ["Lạng Sơn", "Kiên Mộc", "Xã Bắc Xa, Xã Bính Xá, Xã Kiên Mộc"],
    },
    {
      columns: [
        "Lạng Sơn",
        "Kỳ Lừa",
        "Phường Hoàng Văn Thụ, Thị trấn Cao Lộc, Xã Hợp Thành, Xã Tân Liên, Xã Gia Cát",
      ],
    },
    {
      columns: [
        "Lạng Sơn",
        "Lộc Bình",
        "Thị trấn Lộc Bình, Xã Khánh Xuân, Xã Đồng Bục, Xã Hữu Khánh",
      ],
    },
    {
      columns: ["Lạng Sơn", "Lợi Bác", "Xã Sàn Viên, Xã Lợi Bác"],
    },
    {
      columns: ["Lạng Sơn", "Lương Văn Tri", "Phường Chi Lăng, Xã Quảng Lạc"],
    },
    {
      columns: ["Lạng Sơn", "Mẫu Sơn", "Xã Mẫu Sơn (huyện Lộc Bình), Xã Yên Khoái, Xã Tú Mịch"],
    },
    {
      columns: ["Lạng Sơn", "Na Dương", "Thị trấn Na Dương, Xã Đông Quan, Xã Tú Đoạn"],
    },
    {
      columns: ["Lạng Sơn", "Na Sầm", "Thị trấn Na Sầm, Xã Hoàng Việt, Xã Bắc Hùng"],
    },
    {
      columns: ["Lạng Sơn", "Nhân Lý", "Xã Mai Sao, Xã Bắc Thủy, Xã Lâm Sơn, Xã Nhân Lý"],
    },
    {
      columns: ["Lạng Sơn", "Nhất Hòa", "Xã Tân Thành (huyện Bắc Sơn), Xã Nhất Tiến, Xã Nhất Hòa"],
    },
    {
      columns: ["Lạng Sơn", "Quan Sơn", "Xã Hữu Kiên, Xã Quan Sơn"],
    },
    {
      columns: ["Lạng Sơn", "Quốc Khánh", "Xã Tri Phương, Xã Đội Cấn, Xã Quốc Khánh"],
    },
    {
      columns: ["Lạng Sơn", "Quốc Việt", "Xã Đào Viên, Xã Quốc Việt"],
    },
    {
      columns: ["Lạng Sơn", "Quý Hòa", "Xã Vĩnh Yên, Xã Quý Hòa"],
    },
    {
      columns: ["Lạng Sơn", "Tam Thanh", "Phường Tam Thanh, Xã Hoàng Đồng"],
    },
    {
      columns: ["Lạng Sơn", "Tân Đoàn", "Xã Tân Thành (huyện Cao Lộc), Xã Tràng Phái, Xã Tân Đoàn"],
    },
    {
      columns: ["Lạng Sơn", "Tân Thành", "Xã Tân Thành (huyện Hữu Lũng), Xã Hòa Lạc, Xã Hòa Sơn"],
    },
    {
      columns: ["Lạng Sơn", "Tân Tiến", "Xã Tân Yên, Xã Kim Đồng, Xã Tân Tiến"],
    },
    {
      columns: ["Lạng Sơn", "Tân Tri", "Xã Đồng Ý, Xã Vạn Thủy, Xã Tân Tri"],
    },
    {
      columns: ["Lạng Sơn", "Tân Văn", "Xã Hồng Thái (huyện Bình Gia), Xã Bình La, Xã Tân Văn"],
    },
    {
      columns: ["Lạng Sơn", "Thái Bình", "Thị trấn Nông Trường Thái Bình, Xã Lâm Ca, Xã Thái Bình"],
    },
    {
      columns: [
        "Lạng Sơn",
        "Thất Khê",
        "Xã Chi Lăng (huyện Tràng Định), Xã Chí Minh, Thị trấn Thất Khê",
      ],
    },
    {
      columns: ["Lạng Sơn", "Thiện Hòa", "Xã Yên Lỗ, Xã Thiện Hòa"],
    },
    {
      columns: [
        "Lạng Sơn",
        "Thiện Long",
        "Xã Hòa Bình (huyện Bình Gia), Xã Tân Hòa, Xã Thiện Long",
      ],
    },
    {
      columns: ["Lạng Sơn", "Thiện Tân", "Xã Thanh Sơn, Xã Đồng Tiến, Xã Thiện Tân"],
    },
    {
      columns: ["Lạng Sơn", "Thiện Thuật", "Xã Quang Trung, Xã Thiện Thuật"],
    },
    {
      columns: ["Lạng Sơn", "Thống Nhất", "Xã Minh Hiệp, Xã Hữu Lân, Xã Thống Nhất"],
    },
    {
      columns: [
        "Lạng Sơn",
        "Thụy Hùng",
        "Xã Thụy Hùng (huyện Văn Lãng), Xã Thanh Long, Xã Trùng Khánh",
      ],
    },
    {
      columns: ["Lạng Sơn", "Tràng Định", "Xã Đề Thám, Xã Hùng Sơn, Xã Hùng Việt"],
    },
    {
      columns: ["Lạng Sơn", "Tri Lễ", "Xã Lương Năng, Xã Hữu Lễ, Xã Tri Lễ"],
    },
    {
      columns: ["Lạng Sơn", "Tuấn Sơn", "Xã Minh Sơn, Xã Minh Hòa, Xã Hòa Thắng"],
    },
    {
      columns: ["Lạng Sơn", "Vạn Linh", "Xã Hòa Bình (huyện Chi Lăng), Xã Y Tịch, Xã Vạn Linh"],
    },
    {
      columns: ["Lạng Sơn", "Văn Lãng", "Xã Bắc Việt, Xã Bắc La, Xã Tân Tác, Xã Thành Hòa"],
    },
    {
      columns: [
        "Lạng Sơn",
        "Văn Quan",
        "Xã Hòa Bình (huyện Văn Quan), Xã Tú Xuyên, Thị trấn Văn Quan",
      ],
    },
    {
      columns: ["Lạng Sơn", "Vân Nham", "Xã Minh Tiến, Xã Nhật Tiến, Xã Vân Nham"],
    },
    {
      columns: ["Lạng Sơn", "Vũ Lăng", "Xã Tân Lập, Xã Tân Hương, Xã Chiêu Vũ, Xã Vũ Lăng"],
    },
    {
      columns: ["Lạng Sơn", "Vũ Lễ", "Xã Chiến Thắng (huyện Bắc Sơn), Xã Vũ Sơn, Xã Vũ Lễ"],
    },
    {
      columns: ["Lạng Sơn", "Xuân Dương", "Xã Nam Quan, Xã Ái Quốc, Xã Xuân Dương"],
    },
    {
      columns: [
        "Lạng Sơn",
        "Yên Bình",
        "Xã Hòa Bình (huyện Hữu Lũng), Xã Quyết Thắng, Xã Yên Bình",
      ],
    },
    {
      columns: ["Lạng Sơn", "Yên Phúc", "Xã An Sơn, Xã Bình Phúc, Xã Yên Phúc"],
    },
    {
      columns: ["Lào Cai", "A Mú Sung", "Xã Nậm Chạc, Xã A Mú Sung"],
    },
    {
      columns: ["Lào Cai", "Âu Lâu", "Phường Hợp Minh, Xã Giới Phiên, Xã Minh Quân, Xã Âu Lâu"],
    },
    {
      columns: ["Lào Cai", "Bản Hồ", "Xã Thanh Bình (thị xã Sa Pa), Xã Bản Hồ"],
    },
    {
      columns: ["Lào Cai", "Bản Lầu", "Xã Bản Sen, Xã Lùng Vai, Xã Bản Lầu"],
    },
    {
      columns: ["Lào Cai", "Bản Liền", "Xã Nậm Khánh, Xã Bản Liền"],
    },
    {
      columns: ["Lào Cai", "Bản Xèo", "Xã Pa Cheo, Xã Mường Vi, Xã Bản Xèo"],
    },
    {
      columns: ["Lào Cai", "Bảo Ái", "Xã Cảm Ân, Xã Mông Sơn, Xã Tân Nguyên, Xã Bảo Ái"],
    },
    {
      columns: ["Lào Cai", "Bảo Hà", "Xã Kim Sơn, Xã Cam Cọn, Xã Tân An, Xã Tân Thượng, Xã Bảo Hà"],
    },
    {
      columns: ["Lào Cai", "Bảo Nhai", "Xã Nậm Đét, Xã Cốc Ly, Xã Bảo Nhai"],
    },
    {
      columns: ["Lào Cai", "Bảo Thắng", "Thị trấn Phố Lu, Xã Sơn Hà, Xã Sơn Hải, Xã Thái Niên"],
    },
    {
      columns: [
        "Lào Cai",
        "Bảo Yên",
        "Thị trấn Phố Ràng, Xã Yên Sơn, Xã Lương Sơn, Xã Xuân Thượng",
      ],
    },
    {
      columns: [
        "Lào Cai",
        "Bát Xát",
        "Thị trấn Bát Xát, Xã Bản Vược, Xã Bản Qua, Xã Phìn Ngan, Xã Quang Kim",
      ],
    },
    {
      columns: [
        "Lào Cai",
        "Bắc Hà",
        "Thị trấn Bắc Hà, Xã Na Hối, Xã Thải Giàng Phố, Xã Bản Phố, Xã Hoàng Thu Phố, Xã Nậm Mòn",
      ],
    },
    {
      columns: [
        "Lào Cai",
        "Cam Đường",
        "Phường Nam Cường (thành phố Lào Cai), Phường Xuân Tăng, Phường Pom Hán, Phường Bắc Cường, Phường Bắc Lệnh, Phường Bình Minh, Xã Cam Đường",
      ],
    },
    {
      columns: ["Lào Cai", "Cảm Nhân", "Xã Xuân Long, Xã Ngọc Chấn, Xã Cảm Nhân"],
    },
    {
      columns: ["Lào Cai", "Cao Sơn", "Xã Lùng Khấu Nhin, Xã Tả Thàng, Xã La Pan Tẩn, Xã Cao Sơn"],
    },
    {
      columns: ["Lào Cai", "Cát Thịnh", "Không sáp nhập"],
    },
    {
      columns: [
        "Lào Cai",
        "Cầu Thia",
        "Phường Cầu Thia, Xã Thanh Lương, Xã Thạch Lương, Xã Phúc Sơn, Xã Hạnh Sơn",
      ],
    },
    {
      columns: [
        "Lào Cai",
        "Chấn Thịnh",
        "Xã Tân Thịnh (huyện Văn Chấn), Xã Đại Lịch, Xã Chấn Thịnh",
      ],
    },
    {
      columns: ["Lào Cai", "Châu Quế", "Xã Châu Quế Thượng, Xã Châu Quế Hạ"],
    },
    {
      columns: ["Lào Cai", "Chế Tạo", "Không sáp nhập"],
    },
    {
      columns: ["Lào Cai", "Chiềng Ken", "Xã Nậm Tha, Xã Chiềng Ken"],
    },
    {
      columns: ["Lào Cai", "Cốc Lầu", "Xã Nậm Lúc, Xã Bản Cái, Xã Cốc Lầu"],
    },
    {
      columns: ["Lào Cai", "Cốc San", "Xã Đồng Tuyển, Xã Tòng Sành, Xã Cốc San"],
    },
    {
      columns: ["Lào Cai", "Dền Sáng", "Xã Dền Thàng, Xã Sàng Ma Sáo, Xã Dền Sáng"],
    },
    {
      columns: ["Lào Cai", "Dương Quỳ", "Xã Thẳm Dương, Xã Dương Quỳ"],
    },
    {
      columns: ["Lào Cai", "Đông Cuông", "Xã Quang Minh, Xã An Bình, Xã Đông An, Xã Đông Cuông"],
    },
    {
      columns: ["Lào Cai", "Gia Hội", "Xã Nậm Búng, Xã Nậm Lành, Xã Gia Hội"],
    },
    {
      columns: ["Lào Cai", "Gia Phú", "Xã Xuân Giao, Xã Thống Nhất, Xã Gia Phú"],
    },
    {
      columns: ["Lào Cai", "Hạnh Phúc", "Thị trấn Trạm Tấu, Xã Bản Công, Xã Hát Lừu, Xã Xà Hồ"],
    },
    {
      columns: ["Lào Cai", "Hợp Thành", "Xã Tả Phời, Xã Hợp Thành"],
    },
    {
      columns: ["Lào Cai", "Hưng Khánh", "Xã Hồng Ca, Xã Hưng Khánh"],
    },
    {
      columns: ["Lào Cai", "Khánh Hòa", "Xã Tô Mậu, Xã An Lạc, Xã Động Quan, Xã Khánh Hòa"],
    },
    {
      columns: ["Lào Cai", "Khánh Yên", "Xã Khánh Yên Trung, Xã Liêm Phú, Xã Khánh Yên Hạ"],
    },
    {
      columns: ["Lào Cai", "Khao Mang", "Xã Hồ Bốn, Xã Khao Mang"],
    },
    {
      columns: [
        "Lào Cai",
        "Lào Cai",
        "Phường Duyên Hải, Phường Cốc Lếu, Phường Kim Tân, Phường Lào Cai, Xã Vạn Hòa, Xã Bản Phiệt",
      ],
    },
    {
      columns: ["Lào Cai", "Lao Chải", "Không sáp nhập"],
    },
    {
      columns: ["Lào Cai", "Lâm Giang", "Xã Lang Thíp, Xã Lâm Giang"],
    },
    {
      columns: [
        "Lào Cai",
        "Lâm Thượng",
        "Xã Mai Sơn, Xã Khánh Thiện, Xã Tân Phượng, Xã Lâm Thượng",
      ],
    },
    {
      columns: ["Lào Cai", "Liên Sơn", "Thị trấn Nông trường Liên Sơn, Xã Sơn A, Xã Nghĩa Phúc"],
    },
    {
      columns: ["Lào Cai", "Lục Yên", "Thị trấn Yên Thế, Xã Minh Xuân, Xã Yên Thắng, Xã Liễu Đô"],
    },
    {
      columns: ["Lào Cai", "Lùng Phình", "Xã Tả Van Chư, Xã Lùng Phình, Xã Lùng Thẩn"],
    },
    {
      columns: ["Lào Cai", "Lương Thịnh", "Xã Hưng Thịnh, Xã Lương Thịnh"],
    },
    {
      columns: [
        "Lào Cai",
        "Mậu A",
        "Thị trấn Mậu A, Xã Yên Thái, Xã An Thịnh, Xã Mậu Đông, Xã Ngòi A",
      ],
    },
    {
      columns: ["Lào Cai", "Minh Lương", "Xã Nậm Xây, Xã Minh Lương"],
    },
    {
      columns: ["Lào Cai", "Mỏ Vàng", "Xã An Lương, Xã Mỏ Vàng"],
    },
    {
      columns: [
        "Lào Cai",
        "Mù Cang Chải",
        "Thị trấn Mù Cang Chải, Xã Kim Nọi, Xã Mồ Dề, Xã Chế Cu Nha",
      ],
    },
    {
      columns: ["Lào Cai", "Mường Bo", "Xã Liên Minh, Xã Mường Bo"],
    },
    {
      columns: ["Lào Cai", "Mường Hum", "Xã Nậm Pung, Xã Trung Lèng Hồ, Xã Mường Hum"],
    },
    {
      columns: [
        "Lào Cai",
        "Mường Khương",
        "Thị trấn Mường Khương, Xã Thanh Bình (huyện Mường Khương), Xã Nậm Chảy, Xã Tung Chung Phố, Xã Nấm Lư",
      ],
    },
    {
      columns: ["Lào Cai", "Mường Lai", "Xã An Phú, Xã Vĩnh Lạc, Xã Minh Tiến, Xã Mường Lai"],
    },
    {
      columns: [
        "Lào Cai",
        "Nam Cường",
        "Phường Nam Cường (thành phố Yên Bái), Xã Minh Bảo, Xã Tuy Lộc, Xã Cường Thịnh",
      ],
    },
    {
      columns: ["Lào Cai", "Nậm Chày", "Xã Dần Thàng, Xã Nậm Chày"],
    },
    {
      columns: ["Lào Cai", "Nậm Có", "Không sáp nhập"],
    },
    {
      columns: ["Lào Cai", "Nậm Xé", "Không sáp nhập"],
    },
    {
      columns: ["Lào Cai", "Nghĩa Đô", "Xã Tân Tiến, Xã Vĩnh Yên, Xã Nghĩa Đô"],
    },
    {
      columns: ["Lào Cai", "Nghĩa Lộ", "Phường Tân An, Phường Pú Trạng, Xã Nghĩa An, Xã Nghĩa Sơn"],
    },
    {
      columns: ["Lào Cai", "Nghĩa Tâm", "Xã Bình Thuận, Xã Minh An, Xã Nghĩa Tâm"],
    },
    {
      columns: ["Lào Cai", "Ngũ Chỉ Sơn", "Không sáp nhập"],
    },
    {
      columns: ["Lào Cai", "Pha Long", "Xã Tả Ngài Chồ, Xã Dìn Chin, Xã Tả Gia Khâu, Xã Pha Long"],
    },
    {
      columns: ["Lào Cai", "Phình Hồ", "Xã Làng Nhì, Xã Bản Mù, Xã Phình Hồ"],
    },
    {
      columns: ["Lào Cai", "Phong Dụ Hạ", "Xã Xuân Tầm, Xã Phong Dụ Hạ"],
    },
    {
      columns: ["Lào Cai", "Phong Dụ Thượng", "Không sáp nhập"],
    },
    {
      columns: ["Lào Cai", "Phong Hải", "Thị trấn Nông trường Phong Hải, Xã Bản Cầm"],
    },
    {
      columns: ["Lào Cai", "Phúc Khánh", "Xã Việt Tiến, Xã Phúc Khánh"],
    },
    {
      columns: ["Lào Cai", "Phúc Lợi", "Xã Trúc Lâu, Xã Trung Tâm, Xã Phúc Lợi"],
    },
    {
      columns: [
        "Lào Cai",
        "Púng Luông",
        "Xã Nậm Khắt, Xã La Pán Tẩn, Xã Dế Xu Phình, Xã Púng Luông",
      ],
    },
    {
      columns: ["Lào Cai", "Quy Mông", "Xã Kiên Thành, Xã Y Can, Xã Quy Mông"],
    },
    {
      columns: [
        "Lào Cai",
        "Sa Pa",
        "Phường Hàm Rồng, Phường Ô Quý Hồ, Phường Sa Pả, Phường Cầu Mây, Phường Phan Si Păng, Phường Sa Pa",
      ],
    },
    {
      columns: [
        "Lào Cai",
        "Si Ma Cai",
        "Thị trấn Si Ma Cai, Xã Sán Chải, Xã Nàn Sán, Xã Cán Cấu, Xã Quan Hồ Thẩn",
      ],
    },
    {
      columns: ["Lào Cai", "Sín Chéng", "Xã Bản Mế, Xã Thào Chư Phìn, Xã Nàn Sín, Xã Sín Chéng"],
    },
    {
      columns: ["Lào Cai", "Sơn Lương", "Xã Nậm Mười, Xã Sùng Đô, Xã Suối Quyền, Xã Sơn Lương"],
    },
    {
      columns: ["Lào Cai", "Tả Củ Tỷ", "Xã Lùng Cải, Xã Tả Củ Tỷ"],
    },
    {
      columns: ["Lào Cai", "Tả Phìn", "Xã Trung Chải, Xã Tả Phìn"],
    },
    {
      columns: ["Lào Cai", "Tả Van", "Xã Hoàng Liên, Xã Mường Hoa, Xã Tả Van"],
    },
    {
      columns: ["Lào Cai", "Tà Xi Láng", "Không sáp nhập"],
    },
    {
      columns: ["Lào Cai", "Tằng Loỏng", "Thị trấn Tằng Loỏng, Xã Phú Nhuận"],
    },
    {
      columns: ["Lào Cai", "Tân Hợp", "Xã Đại Sơn, Xã Nà Hẩu, Xã Tân Hợp"],
    },
    {
      columns: [
        "Lào Cai",
        "Tân Lĩnh",
        "Xã Minh Chuẩn, Xã Tân Lập, Xã Phan Thanh, Xã Khai Trung, Xã Tân Lĩnh",
      ],
    },
    {
      columns: [
        "Lào Cai",
        "Thác Bà",
        "Thị trấn Thác Bà, Xã Vũ Linh, Xã Bạch Hà, Xã Hán Đà, Xã Vĩnh Kiên, Xã Đại Minh",
      ],
    },
    {
      columns: ["Lào Cai", "Thượng Bằng La", "Thị trấn Nông trường Trần Phú, Xã Thượng Bằng La"],
    },
    {
      columns: ["Lào Cai", "Thượng Hà", "Xã Điện Quan, Xã Minh Tân, Xã Thượng Hà"],
    },
    {
      columns: ["Lào Cai", "Trạm Tấu", "Xã Pá Lau, Xã Pá Hu, Xã Túc Đán, Xã Trạm Tấu"],
    },
    {
      columns: [
        "Lào Cai",
        "Trấn Yên",
        "Thị trấn Cổ Phúc, Xã Báo Đáp, Xã Tân Đồng, Xã Thành Thịnh, Xã Hòa Cuông, Xã Minh Quán",
      ],
    },
    {
      columns: ["Lào Cai", "Trịnh Tường", "Xã Cốc Mỳ, Xã Trịnh Tường"],
    },
    {
      columns: ["Lào Cai", "Trung Tâm", "Phường Trung Tâm, Xã Phù Nham, Xã Nghĩa Lợi, Xã Nghĩa Lộ"],
    },
    {
      columns: ["Lào Cai", "Tú Lệ", "Xã Cao Phạ, Xã Tú Lệ"],
    },
    {
      columns: [
        "Lào Cai",
        "Văn Bàn",
        "Thị trấn Khánh Yên, Xã Khánh Yên Thượng, Xã Sơn Thuỷ, Xã Làng Giàng, Xã Hòa Mạc",
      ],
    },
    {
      columns: [
        "Lào Cai",
        "Văn Chấn",
        "Thị trấn Sơn Thịnh, Xã Đồng Khê, Xã Suối Bu, Xã Suối Giàng",
      ],
    },
    {
      columns: [
        "Lào Cai",
        "Văn Phú",
        "Phường Yên Thịnh, Xã Tân Thịnh (thành phố Yên Bái), Xã Văn Phú, Xã Phú Thịnh",
      ],
    },
    {
      columns: ["Lào Cai", "Việt Hồng", "Xã Việt Cường, Xã Vân Hội, Xã Việt Hồng"],
    },
    {
      columns: ["Lào Cai", "Võ Lao", "Xã Nậm Mả, Xã Nậm Dạng, Xã Võ Lao"],
    },
    {
      columns: [
        "Lào Cai",
        "Xuân Ái",
        "Xã Đại Phác, Xã Yên Phú, Xã Yên Hợp, Xã Viễn Sơn, Xã Xuân Ái",
      ],
    },
    {
      columns: ["Lào Cai", "Xuân Hòa", "Xã Tân Dương, Xã Xuân Hòa"],
    },
    {
      columns: ["Lào Cai", "Xuân Quang", "Xã Phong Niên, Xã Trì Quang, Xã Xuân Quang"],
    },
    {
      columns: ["Lào Cai", "Y Tý", "Xã A Lù, Xã Y Tý"],
    },
    {
      columns: [
        "Lào Cai",
        "Yên Bái",
        "Phường Đồng Tâm, Phường Yên Ninh, Phường Minh Tân, Phường Nguyễn Thái Học, Phường Hồng Hà",
      ],
    },
    {
      columns: [
        "Lào Cai",
        "Yên Bình",
        "Thị trấn Yên Bình, Xã Tân Hương, Xã Thịnh Hưng, Xã Đại Đồng",
      ],
    },
    {
      columns: [
        "Lào Cai",
        "Yên Thành",
        "Xã Phúc Ninh, Xã Mỹ Gia, Xã Xuân Lai, Xã Phúc An, Xã Yên Thành",
      ],
    },
    {
      columns: [
        "Lâm Đồng",
        "1 Bảo Lộc",
        "Phường 1 (thành phố Bảo Lộc), Phường Lộc Phát, Xã Lộc Thanh",
      ],
    },
    {
      columns: ["Lâm Đồng", "2 Bảo Lộc", "Phường 2 (thành phố Bảo Lộc), Xã Lộc Tân, Xã ĐamBri"],
    },
    {
      columns: ["Lâm Đồng", "3 Bảo Lộc", "Phường Lộc Tiến, Xã Lộc Châu, Xã Đại Lào"],
    },
    {
      columns: ["Lâm Đồng", "B’Lao", "Phường Lộc Sơn, Phường B’Lao, Xã Lộc Nga"],
    },
    {
      columns: ["Lâm Đồng", "Bảo Lâm 1", "Thị trấn Lộc Thắng, Xã Lộc Quảng, Xã Lộc Ngãi"],
    },
    {
      columns: ["Lâm Đồng", "Bảo Lâm 2", "Xã Lộc An, Xã Lộc Đức, Xã Tân Lạc"],
    },
    {
      columns: ["Lâm Đồng", "Bảo Lâm 3", "Xã Lộc Thành, Xã Lộc Nam"],
    },
    {
      columns: ["Lâm Đồng", "Bảo Lâm 4", "Xã Lộc Phú, Xã Lộc Lâm, Xã B’Lá"],
    },
    {
      columns: ["Lâm Đồng", "Bảo Lâm 5", "Xã Lộc Bảo, Xã Lộc Bắc"],
    },
    {
      columns: ["Lâm Đồng", "Bảo Thuận", "Xã Đinh Lạc, Xã Tân Nghĩa, Xã Bảo Thuận"],
    },
    {
      columns: [
        "Lâm Đồng",
        "Bắc Bình",
        "Thị trấn Chợ Lầu, Xã Phan Hòa, Xã Phan Hiệp, Xã Phan Rí Thành",
      ],
    },
    {
      columns: [
        "Lâm Đồng",
        "Bắc Gia Nghĩa",
        "Phường Quảng Thành, Phường Nghĩa Thành, Phường Nghĩa Đức, Xã Đắk Ha",
      ],
    },
    {
      columns: ["Lâm Đồng", "Bắc Ruộng", "Xã Măng Tố, Xã Bắc Ruộng"],
    },
    {
      columns: ["Lâm Đồng", "Bình Thuận", "Phường Phú Tài, Xã Phong Nẫm, Xã Hàm Hiệp"],
    },
    {
      columns: ["Lâm Đồng", "Cam Ly - Đà Lạt", "Phường 5, Phường 6, Xã Tà Nung"],
    },
    {
      columns: ["Lâm Đồng", "Cát Tiên", "Thị trấn Cát Tiên, Xã Nam Ninh, Xã Quảng Ngãi"],
    },
    {
      columns: ["Lâm Đồng", "Cát Tiên 2", "Thị trấn Phước Cát, Xã Phước Cát 2, Xã Đức Phổ"],
    },
    {
      columns: ["Lâm Đồng", "Cát Tiên 3", "Xã Gia Viễn, Xã Tiên Hoàng, Xã Đồng Nai Thượng"],
    },
    {
      columns: ["Lâm Đồng", "Cư Jút", "Thị trấn Ea T’ling, Xã Trúc Sơn, Xã Tâm Thắng, Xã Cư K’nia"],
    },
    {
      columns: ["Lâm Đồng", "D’Ran", "Thị trấn D’Ran, Xã Lạc Xuân"],
    },
    {
      columns: ["Lâm Đồng", "Di Linh", "Thị trấn Di Linh, Xã Liên Đầm, Xã Tân Châu, Xã Gung Ré"],
    },
    {
      columns: ["Lâm Đồng", "Đạ Huoai", "Thị trấn Mađaguôi, Xã Mađaguôi, Xã Đạ Oai"],
    },
    {
      columns: ["Lâm Đồng", "Đạ Huoai 2", "Thị trấn Đạ M’ri, Xã Hà Lâm"],
    },
    {
      columns: ["Lâm Đồng", "Đạ Huoai 3", "xã Bà Gia"],
    },
    {
      columns: ["Lâm Đồng", "Đạ Tẻh", "Thị trấn Đạ Tẻh, Xã An Nhơn, Xã Đạ Lây"],
    },
    {
      columns: ["Lâm Đồng", "Đạ Tẻh 2", "Xã Quảng Trị, Xã Đạ Pal, Xã Đạ Kho"],
    },
    {
      columns: ["Lâm Đồng", "Đạ Tẻh 3", "Xã Mỹ Đức, Xã Quốc Oai"],
    },
    {
      columns: ["Lâm Đồng", "Đam Rông 1", "Xã Phi Liêng, Xã Đạ K’Nàng"],
    },
    {
      columns: ["Lâm Đồng", "Đam Rông 2", "Xã Rô Men, Xã Liêng Srônh"],
    },
    {
      columns: ["Lâm Đồng", "Đam Rông 3", "Xã Đạ Rsal, Xã Đạ M’Rông"],
    },
    {
      columns: ["Lâm Đồng", "Đam Rông 4", "Xã Đạ Tông, Xã Đạ Long, Xã Đưng K’Nớ"],
    },
    {
      columns: ["Lâm Đồng", "Đắk Mil", "Xã Đắk Gằn, Xã Đắk N’Drót, Xã Đắk R’La"],
    },
    {
      columns: ["Lâm Đồng", "Đắk Sắk", "Xã Nam Xuân, Xã Long Sơn, Xã Đắk Sắk"],
    },
    {
      columns: ["Lâm Đồng", "Đắk Song", "Xã Đắk Môl, Xã Đắk Hòa"],
    },
    {
      columns: ["Lâm Đồng", "Đắk Wil", "Xã Ea Pô, Xã Đắk Wil"],
    },
    {
      columns: ["Lâm Đồng", "Đinh Trang Thượng", "Xã Tân Lâm, Xã Tân Thượng, Xã Đinh Trang Thượng"],
    },
    {
      columns: [
        "Lâm Đồng",
        "Đinh Văn Lâm Hà",
        "Xã Bình Thạnh (huyện Đức Trọng), Xã Tân Văn, Thị trấn Đinh Văn",
      ],
    },
    {
      columns: ["Lâm Đồng", "Đông Gia Nghĩa", "Phường Nghĩa Trung, Xã Đắk Nia"],
    },
    {
      columns: ["Lâm Đồng", "Đông Giang", "Xã Đông Tiến, Xã Đông Giang"],
    },
    {
      columns: ["Lâm Đồng", "Đồng Kho", "Xã Huy Khiêm, Xã La Ngâu, Xã Đức Bình, Xã Đồng Kho"],
    },
    {
      columns: ["Lâm Đồng", "Đơn Dương", "Thị trấn Thạnh Mỹ, Xã Đạ Ròn, Xã Tu Tra"],
    },
    {
      columns: ["Lâm Đồng", "Đức An", "Thị trấn Đức An, Xã Đắk N’Drung, Xã Nam Bình"],
    },
    {
      columns: ["Lâm Đồng", "Đức Lập", "Thị trấn Đắk Mil, Xã Đức Mạnh, Xã Đức Minh"],
    },
    {
      columns: ["Lâm Đồng", "Đức Linh", "Thị trấn Võ Xu, Xã Nam Chính, Xã Vũ Hòa"],
    },
    {
      columns: ["Lâm Đồng", "Đức Trọng", "Thị trấn Liên Nghĩa, Xã Phú Hội"],
    },
    {
      columns: ["Lâm Đồng", "Gia Hiệp", "Xã Tam Bố, Xã Gia Hiệp"],
    },
    {
      columns: ["Lâm Đồng", "Hải Ninh", "Xã Bình An, Xã Phan Điền, Xã Hải Ninh"],
    },
    {
      columns: ["Lâm Đồng", "Hàm Kiệm", "Xã Mương Mán, Xã Hàm Cường, Xã Hàm Kiệm"],
    },
    {
      columns: ["Lâm Đồng", "Hàm Liêm", "Xã Hàm Chính, Xã Hàm Liêm"],
    },
    {
      columns: [
        "Lâm Đồng",
        "Hàm Tân",
        "Xã Tân Hà (huyện Hàm Tân), Xã Tân Xuân, Thị trấn Tân Nghĩa",
      ],
    },
    {
      columns: ["Lâm Đồng", "Hàm Thạnh", "Xã Mỹ Thạnh, Xã Hàm Cần, Xã Hàm Thạnh"],
    },
    {
      columns: ["Lâm Đồng", "Hàm Thắng", "Phường Xuân An, Thị trấn Phú Long, Xã Hàm Thắng"],
    },
    {
      columns: ["Lâm Đồng", "Hàm Thuận", "Thị trấn Ma Lâm, Xã Thuận Minh, Xã Hàm Đức"],
    },
    {
      columns: ["Lâm Đồng", "Hàm Thuận Bắc", "Xã Thuận Hòa, Xã Hàm Trí, Xã Hàm Phú"],
    },
    {
      columns: ["Lâm Đồng", "Hàm Thuận Nam", "Thị trấn Thuận Nam, Xã Hàm Minh"],
    },
    {
      columns: ["Lâm Đồng", "Hiệp Thạnh", "Xã Hiệp An, Xã Liên Hiệp, Xã Hiệp Thạnh"],
    },
    {
      columns: ["Lâm Đồng", "Hòa Bắc", "Xã Hòa Nam, Xã Hòa Bắc"],
    },
    {
      columns: ["Lâm Đồng", "Hòa Ninh", "Xã Đinh Trang Hòa, Xã Hòa Trung, Xã Hòa Ninh"],
    },
    {
      columns: ["Lâm Đồng", "Hòa Thắng", "Xã Hồng Phong, Xã Hòa Thắng"],
    },
    {
      columns: ["Lâm Đồng", "Hoài Đức", "Thị trấn Đức Tài, Xã Đức Tín, Xã Đức Hạnh"],
    },
    {
      columns: ["Lâm Đồng", "Hồng Sơn", "Xã Hồng Liêm, Xã Hồng Sơn"],
    },
    {
      columns: ["Lâm Đồng", "Hồng Thái", "Xã Phan Thanh, Xã Hồng Thái, Xã Hòa Thắng"],
    },
    {
      columns: ["Lâm Đồng", "Ka Đô", "Xã Lạc Lâm, Xã Ka Đô"],
    },
    {
      columns: [
        "Lâm Đồng",
        "Kiến Đức",
        "Thị trấn Kiến Đức, Xã Đạo Nghĩa, Xã Nghĩa Thắng, Xã Kiến Thành",
      ],
    },
    {
      columns: [
        "Lâm Đồng",
        "Krông Nô",
        "Xã Tân Thành (huyện Krông Nô), Xã Đắk Drô, Thị trấn Đắk Mâm",
      ],
    },
    {
      columns: ["Lâm Đồng", "La Dạ", "Xã Đa Mi, Xã La Dạ"],
    },
    {
      columns: [
        "Lâm Đồng",
        "La Gi",
        "Phường Tân An, Phường Bình Tân, Phường Tân Thiện, Xã Tân Bình",
      ],
    },
    {
      columns: ["Lâm Đồng", "Lạc Dương", "Xã Đạ Sar, Xã Đạ Nhim, Xã Đạ Chais"],
    },
    {
      columns: ["Lâm Đồng", "Lang Biang - Đà Lạt", "Phường 7, Thị trấn Lạc Dương, Xã Lát"],
    },
    {
      columns: ["Lâm Đồng", "Lâm Viên - Đà Lạt", "Phường 8, Phường 9, Phường 12"],
    },
    {
      columns: [
        "Lâm Đồng",
        "Liên Hương",
        "Thị trấn Liên Hương, Xã Bình Thạnh (huyện Tuy Phong), Xã Phước Thể, Xã Phú Lạc",
      ],
    },
    {
      columns: ["Lâm Đồng", "Lương Sơn", "Thị trấn Lương Sơn, Xã Sông Bình"],
    },
    {
      columns: ["Lâm Đồng", "Mũi Né", "Phường Hàm Tiến, Phường Mũi Né, Xã Thiện Nghiệp"],
    },
    {
      columns: [
        "Lâm Đồng",
        "Nam Ban Lâm Hà",
        "Thị trấn Nam Ban, Xã Đông Thanh, Xã Mê Linh, Xã Gia Lâm",
      ],
    },
    {
      columns: ["Lâm Đồng", "Nam Dong", "Xã Đắk D’rông, Xã Nam Dong"],
    },
    {
      columns: ["Lâm Đồng", "Nam Đà", "Xã Buôn Choáh, Xã Đắk Sôr, Xã Nam Đà"],
    },
    {
      columns: ["Lâm Đồng", "Nam Gia Nghĩa", "Phường Nghĩa Phú, Phường Nghĩa Tân, Xã Đắk R’Moan"],
    },
    {
      columns: ["Lâm Đồng", "Nam Hà Lâm Hà", "Xã Nam Hà, Xã Phi Tô"],
    },
    {
      columns: ["Lâm Đồng", "Nam Thành", "Xã Mê Pu, Xã Sùng Nhơn, Xã Đa Kai"],
    },
    {
      columns: ["Lâm Đồng", "Nâm Nung", "Xã Nâm N’Đir, Xã Nâm Nung"],
    },
    {
      columns: ["Lâm Đồng", "Nghị Đức", "Xã Đức Phú, Xã Nghị Đức"],
    },
    {
      columns: ["Lâm Đồng", "Nhân Cơ", "Xã Nhân Đạo, Xã Đắk Wer, Xã Nhân Cơ"],
    },
    {
      columns: ["Lâm Đồng", "Ninh Gia", "Không sáp nhập"],
    },
    {
      columns: [
        "Lâm Đồng",
        "Phan Rí Cửa",
        "Thị trấn Phan Rí Cửa, Xã Chí Công, Xã Hòa Minh, Xã Phong Phú",
      ],
    },
    {
      columns: ["Lâm Đồng", "Phan Sơn", "Xã Phan Lâm, Xã Phan Sơn"],
    },
    {
      columns: ["Lâm Đồng", "Phan Thiết", "Phường Phú Trinh, Phường Lạc Đạo, Phường Bình Hưng"],
    },
    {
      columns: ["Lâm Đồng", "Phú Quý", "Xã Long Hải, Xã Ngũ Phụng, Xã Tam Thanh"],
    },
    {
      columns: ["Lâm Đồng", "Phú Sơn Lâm Hà", "Xã Phú Sơn, Xã Đạ Đờn"],
    },
    {
      columns: ["Lâm Đồng", "Phú Thủy", "Phường Thanh Hải, Phường Phú Hài, Phường Phú Thủy"],
    },
    {
      columns: ["Lâm Đồng", "Phúc Thọ Lâm Hà", "Xã Phúc Thọ, Xã Tân Thanh"],
    },
    {
      columns: ["Lâm Đồng", "Phước Hội", "Phường Phước Lộc, Phường Phước Hội, Xã Tân Phước"],
    },
    {
      columns: ["Lâm Đồng", "Quảng Hòa", "Không sáp nhập"],
    },
    {
      columns: ["Lâm Đồng", "Quảng Khê", "Xã Đắk Plao, Xã Quảng Khê"],
    },
    {
      columns: ["Lâm Đồng", "Quảng Lập", "Xã Ka Đơn, Xã Quảng Lập"],
    },
    {
      columns: ["Lâm Đồng", "Quảng Phú", "Xã Đức Xuyên, Xã Đắk Nang, Xã Quảng Phú"],
    },
    {
      columns: ["Lâm Đồng", "Quảng Sơn", "Không sáp nhập"],
    },
    {
      columns: ["Lâm Đồng", "Quảng Tân", "Xã Đắk Ngo, Xã Quảng Tân"],
    },
    {
      columns: ["Lâm Đồng", "Quảng Tín", "Xã Đắk Sin, Xã Hưng Bình, Xã Đắk Ru, Xã Quảng Tín"],
    },
    {
      columns: ["Lâm Đồng", "Quảng Trực", "Không sáp nhập"],
    },
    {
      columns: ["Lâm Đồng", "Sông Lũy", "Xã Phan Tiến, Xã Bình Tân, Xã Sông Lũy"],
    },
    {
      columns: ["Lâm Đồng", "Sơn Điền", "Xã Gia Bắc, Xã Sơn Điền"],
    },
    {
      columns: ["Lâm Đồng", "Sơn Mỹ", "Xã Tân Thắng, Xã Thắng Hải, Xã Sơn Mỹ"],
    },
    {
      columns: ["Lâm Đồng", "Suối Kiết", "Xã Gia Huynh, Xã Suối Kiết"],
    },
    {
      columns: ["Lâm Đồng", "Tà Đùng", "Xã Đắk Som, Xã Đắk R’Măng"],
    },
    {
      columns: ["Lâm Đồng", "Tà Hine", "Xã Ninh Loan, Xã Đà Loan, Xã Tà Hine"],
    },
    {
      columns: ["Lâm Đồng", "Tà Năng", "Xã Đa Quyn, Xã Tà Năng"],
    },
    {
      columns: ["Lâm Đồng", "Tánh Linh", "Thị trấn Lạc Tánh, Xã Gia An, Xã Đức Thuận"],
    },
    {
      columns: [
        "Lâm Đồng",
        "Tân Hà Lâm Hà",
        "Xã Tân Hà (huyện Lâm Hà), Xã Hoài Đức, Xã Đan Phượng, Xã Liên Hà",
      ],
    },
    {
      columns: ["Lâm Đồng", "Tân Hải", "Xã Tân Tiến, Xã Tân Hải"],
    },
    {
      columns: ["Lâm Đồng", "Tân Hội", "Xã Tân Thành (huyện Đức Trọng), Xã N’ Thôn Hạ, Xã Tân Hội"],
    },
    {
      columns: ["Lâm Đồng", "Tân Lập", "Xã Sông Phan, Xã Tân Lập"],
    },
    {
      columns: ["Lâm Đồng", "Tân Minh", "Thị trấn Tân Minh, Xã Tân Đức, Xã Tân Phúc"],
    },
    {
      columns: [
        "Lâm Đồng",
        "Tân Thành",
        "Xã Tân Thành (huyện Hàm Thuận Nam), Xã Thuận Quý, Xã Tân Thuận",
      ],
    },
    {
      columns: ["Lâm Đồng", "Thuận An", "Xã Đắk Lao, Xã Thuận An"],
    },
    {
      columns: ["Lâm Đồng", "Thuận Hạnh", "Xã Thuận Hà, Xã Thuận Hạnh"],
    },
    {
      columns: ["Lâm Đồng", "Tiến Thành", "Phường Đức Long, Xã Tiến Thành"],
    },
    {
      columns: ["Lâm Đồng", "Trà Tân", "Xã Tân Hà (huyện Đức Linh), Xã Đông Hà, Xã Trà Tân"],
    },
    {
      columns: ["Lâm Đồng", "Trường Xuân", "Xã Nâm N’Jang, Xã Trường Xuân"],
    },
    {
      columns: ["Lâm Đồng", "Tuy Đức", "Xã Quảng Tâm, Xã Đắk R’Tíh, Xã Đắk Búk So"],
    },
    {
      columns: ["Lâm Đồng", "Tuy Phong", "Xã Phan Dũng, Xã Phong Phú"],
    },
    {
      columns: ["Lâm Đồng", "Tuyên Quang", "Xã Tiến Lợi, Xã Hàm Mỹ"],
    },
    {
      columns: ["Lâm Đồng", "Vĩnh Hảo", "Xã Vĩnh Tân, Xã Vĩnh Hảo"],
    },
    {
      columns: [
        "Lâm Đồng",
        "Xuân Hương - Đà Lạt",
        "Phường 1 (thành phố Đà Lạt), Phường 2 (thành phố Đà Lạt), Phường 3, Phường 4, Phường 10",
      ],
    },
    {
      columns: [
        "Lâm Đồng",
        "Xuân Trường - Đà Lạt",
        "Phường 11, Xã Xuân Thọ, Xã Xuân Trường, Xã Trạm Hành",
      ],
    },
    {
      columns: ["Nghệ An", "An Châu", "Xã Diễn An, Xã Diễn Tân, Xã Diễn Thịnh, Xã Diễn Trung"],
    },
    {
      columns: ["Nghệ An", "Anh Sơn", "Thị trấn Kim Nhan, Xã Đức Sơn, Xã Phúc Sơn"],
    },
    {
      columns: ["Nghệ An", "Anh Sơn Đông", "Xã Lạng Sơn, Xã Tào Sơn, Xã Vĩnh Sơn"],
    },
    {
      columns: ["Nghệ An", "Bạch Hà", "Xã Đại Sơn, Xã Hiến Sơn, Xã Mỹ Sơn, Xã Trù Sơn"],
    },
    {
      columns: [
        "Nghệ An",
        "Bạch Ngọc",
        "Xã Bồi Sơn, Xã Giang Sơn Đông, Xã Giang Sơn Tây, Xã Bạch Ngọc",
      ],
    },
    {
      columns: ["Nghệ An", "Bắc Lý", "Không sáp nhập"],
    },
    {
      columns: ["Nghệ An", "Bích Hào", "Xã Mai Giang, Xã Thanh Lâm, Xã Thanh Tùng, Xã Thanh Xuân"],
    },
    {
      columns: ["Nghệ An", "Bình Chuẩn", "Không sáp nhập"],
    },
    {
      columns: ["Nghệ An", "Bình Minh", "Xã Đức Thành, Xã Mã Thành, Xã Tân Thành, Xã Tiến Thành"],
    },
    {
      columns: ["Nghệ An", "Cam Phục", "Xã Cam Lâm, Xã Đôn Phục"],
    },
    {
      columns: [
        "Nghệ An",
        "Cát Ngạn",
        "Xã Minh Sơn (huyện Thanh Chương), Xã Cát Văn, Xã Phong Thịnh",
      ],
    },
    {
      columns: ["Nghệ An", "Châu Bình", "Không sáp nhập"],
    },
    {
      columns: [
        "Nghệ An",
        "Châu Hồng",
        "Xã Châu Tiến (huyện Quỳ Hợp), Xã Châu Thành, Xã Châu Hồng",
      ],
    },
    {
      columns: ["Nghệ An", "Châu Khê", "Xã Lạng Khê, Xã Châu Khê"],
    },
    {
      columns: ["Nghệ An", "Châu Lộc", "Xã Liên Hợp, Xã Châu Lộc"],
    },
    {
      columns: [
        "Nghệ An",
        "Châu Tiến",
        "Xã Châu Tiến (huyện Quỳ Châu), Xã Châu Bính, Xã Châu Thắng, Xã Châu Thuận",
      ],
    },
    {
      columns: ["Nghệ An", "Chiêu Lưu", "Xã Bảo Thắng, Xã Chiêu Lưu"],
    },
    {
      columns: ["Nghệ An", "Con Cuông", "Thị trấn Trà Lân, Xã Chi Khê, Xã Yên Khê"],
    },
    {
      columns: [
        "Nghệ An",
        "Cửa Lò",
        "Phường Nghi Hải, Phường Nghi Hòa, Phường Nghi Hương, Phường Nghi Tân, Phường Nghi Thu, Phường Nghi Thủy, Xã Thu Thủy",
      ],
    },
    {
      columns: [
        "Nghệ An",
        "Diễn Châu",
        "Thị trấn Diễn Thành, Xã Diễn Hoa, Xã Diễn Phúc, Xã Ngọc Bích",
      ],
    },
    {
      columns: [
        "Nghệ An",
        "Đại Đồng",
        "Thị trấn Dùng, Xã Đồng Văn (huyện Thanh Chương), Xã Thanh Ngọc, Xã Thanh Phong, Xã Đại Đồng",
      ],
    },
    {
      columns: ["Nghệ An", "Đại Huệ", "Xã Nam Anh, Xã Nam Lĩnh, Xã Nam Xuân"],
    },
    {
      columns: [
        "Nghệ An",
        "Đô Lương",
        "Xã Bắc Sơn, Xã Nam Sơn (huyện Đô Lương), Xã Đà Sơn, Xã Đặng Sơn, Xã Lưu Sơn, Xã Thịnh Sơn, Xã Văn Sơn, Xã Yên Sơn, Thị trấn Đô Lương",
      ],
    },
    {
      columns: ["Nghệ An", "Đông Hiếu", "Xã Nghĩa Mỹ, Xã Nghĩa Thuận, Xã Đông Hiếu"],
    },
    {
      columns: ["Nghệ An", "Đông Lộc", "Xã Khánh Hợp, Xã Nghi Thạch, Xã Thịnh Trường"],
    },
    {
      columns: ["Nghệ An", "Đông Thành", "Xã Đô Thành, Xã Phú Thành, Xã Thọ Thành"],
    },
    {
      columns: ["Nghệ An", "Đức Châu", "Xã Diễn Hồng, Xã Diễn Kỷ, Xã Diễn Phong, Xã Diễn Vạn"],
    },
    {
      columns: ["Nghệ An", "Giai Lạc", "Xã Hậu Thành, Xã Lăng Thành, Xã Phúc Thành"],
    },
    {
      columns: ["Nghệ An", "Giai Xuân", "Xã Tân Hợp, Xã Giai Xuân"],
    },
    {
      columns: ["Nghệ An", "Hải Châu", "Xã Diễn Hoàng, Xã Diễn Kim, Xã Diễn Mỹ, Xã Hùng Hải"],
    },
    {
      columns: ["Nghệ An", "Hải Lộc", "Xã Nghi Thiết, Xã Nghi Tiến, Xã Nghi Yên"],
    },
    {
      columns: ["Nghệ An", "Hạnh Lâm", "Xã Thanh Đức, Xã Hạnh Lâm"],
    },
    {
      columns: ["Nghệ An", "Hoa Quân", "Xã Thanh An, Xã Thanh Hương, Xã Thanh Quả, Xã Thanh Thịnh"],
    },
    {
      columns: ["Nghệ An", "Hoàng Mai", "Phường Quỳnh Thiện, Xã Quỳnh Trang, Xã Quỳnh Vinh"],
    },
    {
      columns: [
        "Nghệ An",
        "Hợp Minh",
        "Xã Bảo Thành, Xã Long Thành, Xã Sơn Thành, Xã Viên Thành, Xã Vĩnh Thành",
      ],
    },
    {
      columns: ["Nghệ An", "Hùng Chân", "Xã Châu Hoàn, Xã Châu Phong, Xã Diên Lãm"],
    },
    {
      columns: ["Nghệ An", "Hùng Châu", "Xã Diễn Đoài, Xã Diễn Lâm, Xã Diễn Trường, Xã Diễn Yên"],
    },
    {
      columns: ["Nghệ An", "Huồi Tụ", "Không sáp nhập"],
    },
    {
      columns: [
        "Nghệ An",
        "Hưng Nguyên",
        "Thị trấn Hưng Nguyên, Xã Hưng Đạo, Xã Hưng Tây, Xã Thịnh Mỹ",
      ],
    },
    {
      columns: [
        "Nghệ An",
        "Hưng Nguyên Nam",
        "Xã Hưng Lĩnh, Xã Long Xá, Xã Thông Tân, Xã Xuân Lam",
      ],
    },
    {
      columns: ["Nghệ An", "Hữu Khuông", "Không sáp nhập"],
    },
    {
      columns: ["Nghệ An", "Hữu Kiệm", "Xã Bảo Nam, Xã Hữu Lập, Xã Hữu Kiệm"],
    },
    {
      columns: ["Nghệ An", "Keng Đu", "Không sáp nhập"],
    },
    {
      columns: ["Nghệ An", "Kim Bảng", "Xã Thanh Hà, Xã Thanh Thủy, Xã Kim Bảng"],
    },
    {
      columns: [
        "Nghệ An",
        "Kim Liên",
        "Xã Hùng Tiến, Xã Nam Cát, Xã Nam Giang, Xã Xuân Hồng, Xã Kim Liên",
      ],
    },
    {
      columns: ["Nghệ An", "Lam Thành", "Xã Châu Nhân, Xã Hưng Nghĩa, Xã Hưng Thành, Xã Phúc Lợi"],
    },
    {
      columns: ["Nghệ An", "Lượng Minh", "Không sáp nhập"],
    },
    {
      columns: ["Nghệ An", "Lương Sơn", "Xã Bài Sơn, Xã Đông Sơn, Xã Hồng Sơn, Xã Tràng Sơn"],
    },
    {
      columns: ["Nghệ An", "Mậu Thạch", "Xã Mậu Đức, Xã Thạch Ngàn"],
    },
    {
      columns: ["Nghệ An", "Minh Châu", "Xã Diễn Cát, Xã Diễn Nguyên, Xã Hạnh Quảng, Xã Minh Châu"],
    },
    {
      columns: ["Nghệ An", "Minh Hợp", "Xã Hạ Sơn, Xã Văn Lợi, Xã Minh Hợp"],
    },
    {
      columns: ["Nghệ An", "Môn Sơn", "Xã Lục Dạ, Xã Môn Sơn"],
    },
    {
      columns: ["Nghệ An", "Mường Chọng", "Xã Bắc Sơn, Xã Nam Sơn (huyện Quỳ Hợp), Xã Châu Lý"],
    },
    {
      columns: ["Nghệ An", "Mường Ham", "Xã Châu Cường, Xã Châu Thái"],
    },
    {
      columns: ["Nghệ An", "Mường Lống", "Không sáp nhập"],
    },
    {
      columns: ["Nghệ An", "Mường Quàng", "Xã Cắm Muộn, Xã Châu Thôn, Xã Quang Phong"],
    },
    {
      columns: ["Nghệ An", "Mường Típ", "Xã Mường Ải, Xã Mường Típ"],
    },
    {
      columns: ["Nghệ An", "Mường Xén", "Thị trấn Mường Xén, Xã Tà Cạ, Xã Tây Sơn"],
    },
    {
      columns: ["Nghệ An", "Mỹ Lý", "Không sáp nhập"],
    },
    {
      columns: ["Nghệ An", "Na Loi", "Xã Đoọc Mạy, Xã Na Loi"],
    },
    {
      columns: ["Nghệ An", "Na Ngoi", "Xã Nậm Càn, Xã Na Ngoi"],
    },
    {
      columns: ["Nghệ An", "Nam Đàn", "Xã Nghĩa Thái (huyện Nam Đàn), Xã Nam Hưng, Xã Nam Thanh"],
    },
    {
      columns: ["Nghệ An", "Nậm Cắn", "Xã Phà Đánh, Xã Nậm Cắn"],
    },
    {
      columns: ["Nghệ An", "Nga My", "Xã Xiêng My, Xã Nga My"],
    },
    {
      columns: [
        "Nghệ An",
        "Nghi Lộc",
        "Thị trấn Quán Hành, Xã Diên Hoa, Xã Nghi Trung, Xã Nghi Vạn",
      ],
    },
    {
      columns: ["Nghệ An", "Nghĩa Đàn", "Thị trấn Nghĩa Đàn, Xã Nghĩa Bình, Xã Nghĩa Trung"],
    },
    {
      columns: ["Nghệ An", "Nghĩa Đồng", "Xã Bình Hợp, Xã Nghĩa Đồng"],
    },
    {
      columns: ["Nghệ An", "Nghĩa Hành", "Xã Phú Sơn, Xã Tân Hương, Xã Nghĩa Hành"],
    },
    {
      columns: ["Nghệ An", "Nghĩa Hưng", "Xã Nghĩa Thành, Xã Nghĩa Hưng"],
    },
    {
      columns: ["Nghệ An", "Nghĩa Khánh", "Xã Nghĩa An, Xã Nghĩa Đức, Xã Nghĩa Khánh"],
    },
    {
      columns: ["Nghệ An", "Nghĩa Lâm", "Xã Nghĩa Lạc, Xã Nghĩa Sơn, Xã Nghĩa Yên, Xã Nghĩa Lâm"],
    },
    {
      columns: ["Nghệ An", "Nghĩa Lộc", "Xã Nghĩa Long, Xã Nghĩa Lộc"],
    },
    {
      columns: ["Nghệ An", "Nghĩa Mai", "Xã Nghĩa Hồng, Xã Nghĩa Minh, Xã Nghĩa Mai"],
    },
    {
      columns: ["Nghệ An", "Nghĩa Thọ", "Xã Nghĩa Hội, Xã Nghĩa Lợi, Xã Nghĩa Thọ"],
    },
    {
      columns: ["Nghệ An", "Nhân Hòa", "Xã Cẩm Sơn, Xã Hùng Sơn, Xã Tam Đỉnh"],
    },
    {
      columns: ["Nghệ An", "Nhôn Mai", "Xã Mai Sơn, Xã Nhôn Mai"],
    },
    {
      columns: [
        "Nghệ An",
        "Phúc Lộc",
        "Xã Nghi Công Bắc, Xã Nghi Công Nam, Xã Nghi Lâm, Xã Nghi Mỹ",
      ],
    },
    {
      columns: [
        "Nghệ An",
        "Quan Thành",
        "Xã Bắc Thành, Xã Nam Thành, Xã Trung Thành, Xã Xuân Thành",
      ],
    },
    {
      columns: ["Nghệ An", "Quảng Châu", "Xã Diễn Đồng, Xã Diễn Liên, Xã Diễn Thái, Xã Xuân Tháp"],
    },
    {
      columns: ["Nghệ An", "Quang Đồng", "Xã Đồng Thành, Xã Kim Thành, Xã Quang Thành"],
    },
    {
      columns: ["Nghệ An", "Quế Phong", "Thị trấn Kim Sơn, Xã Châu Kim, Xã Mường Nọc, Xã Nậm Giải"],
    },
    {
      columns: ["Nghệ An", "Quỳ Châu", "Thị trấn Tân Lạc, Xã Châu Hạnh, Xã Châu Hội, Xã Châu Nga"],
    },
    {
      columns: ["Nghệ An", "Quỳ Hợp", "Thị trấn Quỳ Hợp, Xã Châu Đình, Xã Châu Quang, Xã Thọ Hợp"],
    },
    {
      columns: [
        "Nghệ An",
        "Quỳnh Anh",
        "Xã Minh Lương, Xã Quỳnh Bảng, Xã Quỳnh Đôi, Xã Quỳnh Thanh, Xã Quỳnh Yên",
      ],
    },
    {
      columns: [
        "Nghệ An",
        "Quỳnh Lưu",
        "Thị trấn Cầu Giát, Xã Bình Sơn (huyện Quỳnh Lưu), Xã Quỳnh Diễn, Xã Quỳnh Giang, Xã Quỳnh Hậu",
      ],
    },
    {
      columns: [
        "Nghệ An",
        "Quỳnh Mai",
        "Phường Mai Hùng, Phường Quỳnh Phương, Phường Quỳnh Xuân, Xã Quỳnh Liên",
      ],
    },
    {
      columns: ["Nghệ An", "Quỳnh Phú", "Xã An Hòa, Xã Phú Nghĩa, Xã Thuận Long, Xã Văn Hải"],
    },
    {
      columns: [
        "Nghệ An",
        "Quỳnh Sơn",
        "Xã Ngọc Sơn (huyện Quỳnh Lưu), Xã Quỳnh Lâm, Xã Quỳnh Sơn",
      ],
    },
    {
      columns: [
        "Nghệ An",
        "Quỳnh Tam",
        "Xã Tân Sơn (huyện Quỳnh Lưu), Xã Quỳnh Châu, Xã Quỳnh Tam",
      ],
    },
    {
      columns: ["Nghệ An", "Quỳnh Thắng", "Xã Tân Thắng, Xã Quỳnh Thắng"],
    },
    {
      columns: ["Nghệ An", "Quỳnh Văn", "Xã Quỳnh Tân, Xã Quỳnh Thạch, Xã Quỳnh Văn"],
    },
    {
      columns: ["Nghệ An", "Sơn Lâm", "Xã Ngọc Lâm, Xã Thanh Sơn"],
    },
    {
      columns: ["Nghệ An", "Tam Đồng", "Xã Thanh Liên, Xã Thanh Mỹ, Xã Thanh Tiên"],
    },
    {
      columns: [
        "Nghệ An",
        "Tam Hợp",
        "Xã Tam Hợp (huyện Quỳ Hợp), Xã Đồng Hợp, Xã Nghĩa Xuân, Xã Yên Hợp",
      ],
    },
    {
      columns: ["Nghệ An", "Tam Quang", "Xã Tam Đình, Xã Tam Quang"],
    },
    {
      columns: ["Nghệ An", "Tam Thái", "Xã Tam Hợp (huyện Tương Dương), Xã Tam Thái"],
    },
    {
      columns: ["Nghệ An", "Tân An", "Xã Hương Sơn, Xã Nghĩa Phúc, Xã Tân An"],
    },
    {
      columns: ["Nghệ An", "Tân Châu", "Xã Diễn Lộc, Xã Diễn Lợi, Xã Diễn Phú, Xã Diễn Thọ"],
    },
    {
      columns: ["Nghệ An", "Tân Kỳ", "Thị trấn Tân Kỳ, Xã Nghĩa Dũng, Xã Kỳ Tân, Xã Kỳ Sơn"],
    },
    {
      columns: ["Nghệ An", "Tân Mai", "Phường Quỳnh Dị, Xã Quỳnh Lập, Xã Quỳnh Lộc"],
    },
    {
      columns: [
        "Nghệ An",
        "Tân Phú",
        "Xã Nghĩa Thái (huyện Tân Kỳ), Xã Hoàn Long, Xã Tân Xuân, Xã Tân Phú",
      ],
    },
    {
      columns: ["Nghệ An", "Tây Hiếu", "Phường Quang Tiến, Xã Nghĩa Tiến, Xã Tây Hiếu"],
    },
    {
      columns: ["Nghệ An", "Thái Hòa", "Phường Hòa Hiếu, Phường Long Sơn, Phường Quang Phong"],
    },
    {
      columns: [
        "Nghệ An",
        "Thành Bình Thọ",
        "Xã Bình Sơn (huyện Anh Sơn), Xã Thành Sơn, Xã Thọ Sơn",
      ],
    },
    {
      columns: [
        "Nghệ An",
        "Thành Vinh",
        "Phường Cửa Nam, Phường Đông Vĩnh, Phường Hưng Bình, Phường Lê Lợi, Phường Quang Trung, Xã Hưng Chính",
      ],
    },
    {
      columns: ["Nghệ An", "Thần Lĩnh", "Xã Nghi Đồng, Xã Nghi Hưng, Xã Nghi Phương"],
    },
    {
      columns: ["Nghệ An", "Thiên Nhẫn", "Xã Khánh Sơn, Xã Nam Kim, Xã Trung Phúc Cường"],
    },
    {
      columns: ["Nghệ An", "Thông Thụ", "Xã Đồng Văn (huyện Quế Phong), Xã Thông Thụ"],
    },
    {
      columns: [
        "Nghệ An",
        "Thuần Trung",
        "Xã Minh Sơn (huyện Đô Lương), Xã Lạc Sơn, Xã Nhân Sơn, Xã Thuận Sơn, Xã Trung Sơn, Xã Xuân Sơn",
      ],
    },
    {
      columns: ["Nghệ An", "Tiên Đồng", "Xã Đồng Văn (huyện Tân Kỳ), Xã Tiên Kỳ"],
    },
    {
      columns: ["Nghệ An", "Tiền Phong", "Xã Hạnh Dịch, Xã Tiền Phong"],
    },
    {
      columns: ["Nghệ An", "Tri Lễ", "Xã Nậm Nhoóng, Xã Tri Lễ"],
    },
    {
      columns: ["Nghệ An", "Trung Lộc", "Xã Nghi Long, Xã Nghi Quang, Xã Nghi Thuận, Xã Nghi Xá"],
    },
    {
      columns: [
        "Nghệ An",
        "Trường Vinh",
        "Phường Bến Thủy, Phường Hưng Dũng, Phường Hưng Phúc, Phường Trung Đô, Phường Trường Thi, Phường Vinh Tân, Xã Hưng Hòa",
      ],
    },
    {
      columns: ["Nghệ An", "Tương Dương", "Thị trấn Thạch Giám, Xã Lưu Kiền, Xã Xá Lượng"],
    },
    {
      columns: ["Nghệ An", "Vạn An", "Thị trấn Nam Đàn, Xã Thượng Tân Lộc, Xã Xuân Hòa"],
    },
    {
      columns: [
        "Nghệ An",
        "Văn Hiến",
        "Xã Tân Sơn (huyện Đô Lương), Xã Hòa Sơn, Xã Quang Sơn, Xã Thái Sơn, Xã Thượng Sơn",
      ],
    },
    {
      columns: ["Nghệ An", "Văn Kiều", "Xã Nghi Kiều, Xã Nghi Văn"],
    },
    {
      columns: ["Nghệ An", "Vân Du", "Xã Minh Thành, Xã Tây Thành, Xã Thịnh Thành"],
    },
    {
      columns: ["Nghệ An", "Vân Tụ", "Xã Liên Thành, Xã Mỹ Thành, Xã Vân Tụ"],
    },
    {
      columns: [
        "Nghệ An",
        "Vinh Hưng",
        "Phường Hưng Đông, Phường Quán Bàu, Xã Nghi Kim, Xã Nghi Liên",
      ],
    },
    {
      columns: [
        "Nghệ An",
        "Vinh Lộc",
        "Phường Hưng Lộc, Xã Nghi Phong, Xã Nghi Thái, Xã Nghi Xuân, Xã Phúc Thọ",
      ],
    },
    {
      columns: [
        "Nghệ An",
        "Vinh Phú",
        "Phường Hà Huy Tập, Phường Nghi Đức, Phường Nghi Phú, Xã Nghi Ân",
      ],
    },
    {
      columns: ["Nghệ An", "Vĩnh Tường", "Xã Hoa Sơn, Xã Hội Sơn, Xã Tường Sơn"],
    },
    {
      columns: [
        "Nghệ An",
        "Xuân Lâm",
        "Xã Ngọc Sơn (huyện Thanh Chương), Xã Minh Tiến, Xã Xuân Dương",
      ],
    },
    {
      columns: ["Nghệ An", "Yên Hòa", "Xã Yên Thắng, Xã Yên Hòa"],
    },
    {
      columns: ["Nghệ An", "Yên Na", "Xã Yên Tĩnh, Xã Yên Na"],
    },
    {
      columns: [
        "Nghệ An",
        "Yên Thành",
        "Thị trấn Hoa Thành, Xã Đông Thành, Xã Tăng Thành, Xã Văn Thành",
      ],
    },
    {
      columns: ["Nghệ An", "Yên Trung", "Xã Hưng Yên Bắc, Xã Hưng Yên Nam, Xã Hưng Trung"],
    },
    {
      columns: ["Nghệ An", "Yên Xuân", "Xã Cao Sơn, Xã Khai Sơn, Xã Lĩnh Sơn, Xã Long Sơn"],
    },
    {
      columns: ["Ninh Bình", "Bắc Lý", "Xã Chân Lý, Xã Đạo Lý, Xã Bắc Lý"],
    },
    {
      columns: ["Ninh Bình", "Bình An", "Xã Trung Lương, Xã Ngọc Lũ, Xã Bình An"],
    },
    {
      columns: ["Ninh Bình", "Bình Giang", "Xã Bồ Đề, Xã Vũ Bản, Xã An Ninh"],
    },
    {
      columns: ["Ninh Bình", "Bình Lục", "Xã Bình Nghĩa, Xã Tràng An, Xã Đồng Du"],
    },
    {
      columns: ["Ninh Bình", "Bình Minh", "Thị trấn Bình Minh, Xã Cồn Thoi, Xã Kim Mỹ"],
    },
    {
      columns: ["Ninh Bình", "Bình Mỹ", "Thị trấn Bình Mỹ, Xã Đồn Xá, Xã La Sơn"],
    },
    {
      columns: ["Ninh Bình", "Bình Sơn", "Xã Tiêu Động, Xã An Lão, Xã An Đổ"],
    },
    {
      columns: ["Ninh Bình", "Cát Thành", "Thị trấn Cát Thành, Xã Việt Hùng, Xã Trực Đạo"],
    },
    {
      columns: ["Ninh Bình", "Chất Bình", "Xã Xuân Chính, Xã Hồi Ninh, Xã Chất Bình"],
    },
    {
      columns: ["Ninh Bình", "Châu Sơn", "Phường Thanh Tuyền, Phường Châu Sơn, Thị trấn Kiện Khê"],
    },
    {
      columns: ["Ninh Bình", "Cổ Lễ", "Thị trấn Cổ Lễ, Xã Trung Đông, Xã Trực Tuấn"],
    },
    {
      columns: ["Ninh Bình", "Cúc Phương", "Xã Văn Phương, Xã Cúc Phương"],
    },
    {
      columns: ["Ninh Bình", "Duy Hà", "Phường Duy Minh, Phường Duy Hải, Phường Hoàng Đông"],
    },
    {
      columns: ["Ninh Bình", "Duy Tân", "Phường Châu Giang, Xã Mộc Hoàn, Phường Hòa Mạc"],
    },
    {
      columns: [
        "Ninh Bình",
        "Duy Tiên",
        "Xã Chuyên Ngoại, Xã Trác Văn, Xã Yên Nam, Phường Hòa Mạc",
      ],
    },
    {
      columns: [
        "Ninh Bình",
        "Đại Hoàng",
        "Xã Tiến Thắng (huyện Gia Viễn), Xã Gia Phương, Xã Gia Trung",
      ],
    },
    {
      columns: ["Ninh Bình", "Định Hóa", "Xã Văn Hải, Xã Kim Tân, Xã Định Hóa"],
    },
    {
      columns: ["Ninh Bình", "Đông A", "Phường Lộc Hòa, Xã Mỹ Thắng, Xã Mỹ Hà"],
    },
    {
      columns: [
        "Ninh Bình",
        "Đông Hoa Lư",
        "Phường Ninh Phúc, Xã Khánh Hòa, Xã Khánh Phú, Xã Khánh An",
      ],
    },
    {
      columns: ["Ninh Bình", "Đồng Thái", "Xã Yên Đồng (huyện Yên Mô), Xã Yên Thành, Xã Yên Thái"],
    },
    {
      columns: ["Ninh Bình", "Đồng Thịnh", "Xã Hoàng Nam, Xã Đồng Thịnh"],
    },
    {
      columns: ["Ninh Bình", "Đồng Văn", "Phường Bạch Thượng, Phường Yên Bắc, Phường Đồng Văn"],
    },
    {
      columns: ["Ninh Bình", "Gia Hưng", "Xã Liên Sơn (huyện Gia Viễn), Xã Gia Phú, Xã Gia Hưng"],
    },
    {
      columns: ["Ninh Bình", "Gia Lâm", "Xã Gia Sơn, Xã Xích Thổ, Xã Gia Lâm"],
    },
    {
      columns: ["Ninh Bình", "Gia Phong", "Xã Gia Lạc, Xã Gia Minh, Xã Gia Phong"],
    },
    {
      columns: ["Ninh Bình", "Gia Trấn", "Xã Gia Thanh, Xã Gia Xuân, Xã Gia Trấn"],
    },
    {
      columns: ["Ninh Bình", "Gia Tường", "Xã Gia Thủy, Xã Đức Long, Xã Gia Tường"],
    },
    {
      columns: ["Ninh Bình", "Gia Vân", "Xã Gia Lập, Xã Gia Vân, Xã Gia Tân"],
    },
    {
      columns: ["Ninh Bình", "Gia Viễn", "Thị trấn Thịnh Vượng, Xã Gia Hòa"],
    },
    {
      columns: ["Ninh Bình", "Giao Bình", "Xã Giao Yến, Xã Bạch Long, Xã Giao Tân"],
    },
    {
      columns: ["Ninh Bình", "Giao Hòa", "Xã Hồng Thuận, Xã Giao An, Xã Giao Lạc"],
    },
    {
      columns: ["Ninh Bình", "Giao Hưng", "Xã Giao Nhân, Xã Giao Long, Xã Giao Châu"],
    },
    {
      columns: ["Ninh Bình", "Giao Minh", "Xã Giao Thiện, Xã Giao Hương, Xã Giao Thanh"],
    },
    {
      columns: ["Ninh Bình", "Giao Ninh", "Thị trấn Quất Lâm, Xã Giao Phong, Xã Giao Thịnh"],
    },
    {
      columns: ["Ninh Bình", "Giao Phúc", "Xã Giao Xuân, Xã Giao Hà, Xã Giao Hải"],
    },
    {
      columns: ["Ninh Bình", "Giao Thủy", "Thị trấn Giao Thủy, Xã Bình Hòa"],
    },
    {
      columns: [
        "Ninh Bình",
        "Hà Nam",
        "Phường Lam Hạ, Phường Tân Hiệp, Phường Quang Trung (thành phố Phủ Lý), Phường Hoàng Đông, Phường Tiên Nội, Xã Tiên Ngoại",
      ],
    },
    {
      columns: ["Ninh Bình", "Hải An", "Xã Hải Phong, Xã Hải Giang, Xã Hải An"],
    },
    {
      columns: ["Ninh Bình", "Hải Anh", "Xã Hải Minh, Xã Hải Đường, Xã Hải Anh"],
    },
    {
      columns: ["Ninh Bình", "Hải Hậu", "Thị trấn Yên Định, Xã Hải Trung, Xã Hải Long"],
    },
    {
      columns: ["Ninh Bình", "Hải Hưng", "Xã Hải Nam, Xã Hải Lộc, Xã Hải Hưng"],
    },
    {
      columns: ["Ninh Bình", "Hải Quang", "Xã Hải Đông, Xã Hải Tây, Xã Hải Quang"],
    },
    {
      columns: ["Ninh Bình", "Hải Thịnh", "Thị trấn Thịnh Long, Xã Hải Châu, Xã Hải Ninh"],
    },
    {
      columns: ["Ninh Bình", "Hải Tiến", "Thị trấn Cồn, Xã Hải Sơn, Xã Hải Tân"],
    },
    {
      columns: ["Ninh Bình", "Hải Xuân", "Xã Hải Phú, Xã Hải Hòa, Xã Hải Xuân"],
    },
    {
      columns: [
        "Ninh Bình",
        "Hiển Khánh",
        "Xã Hợp Hưng, Xã Trung Thành, Xã Quang Trung, Xã Hiển Khánh",
      ],
    },
    {
      columns: [
        "Ninh Bình",
        "Hoa Lư",
        "Phường Ninh Mỹ, Phường Ninh Khánh, Phường Đông Thành, Phường Tân Thành, Phường Vân Giang, Phường Nam Thành, Phường Nam Bình, Phường Bích Đào, Xã Ninh Khang, Xã Ninh Nhất, Xã Ninh Tiến",
      ],
    },
    {
      columns: ["Ninh Bình", "Hồng Phong", "Xã Nghĩa Hồng, Xã Nghĩa Phong, Xã Nghĩa Phú"],
    },
    {
      columns: [
        "Ninh Bình",
        "Hồng Quang",
        "Xã Hồng Quang (huyện Nam Trực), Xã Nghĩa An, Phường Nam Vân",
      ],
    },
    {
      columns: ["Ninh Bình", "Khánh Hội", "Xã Khánh Mậu, Xã Khánh Thủy, Xã Khánh Hội"],
    },
    {
      columns: ["Ninh Bình", "Khánh Nhạc", "Xã Khánh Hồng, Xã Khánh Nhạc"],
    },
    {
      columns: ["Ninh Bình", "Khánh Thiện", "Xã Khánh Cường, Xã Khánh Lợi, Xã Khánh Thiện"],
    },
    {
      columns: ["Ninh Bình", "Khánh Trung", "Xã Khánh Thành, Xã Khánh Công, Xã Khánh Trung"],
    },
    {
      columns: ["Ninh Bình", "Kim Bảng", "Phường Quế, Phường Ngọc Sơn, Xã Văn Xá"],
    },
    {
      columns: [
        "Ninh Bình",
        "Kim Đông",
        "Xã Kim Trung, Xã Kim Đông, Khu vực bãi bồi ven biển (do huyện Kim Sơn quản lý)",
      ],
    },
    {
      columns: ["Ninh Bình", "Kim Sơn", "Xã Kim Định, Xã Ân Hòa, Xã Hùng Tiến"],
    },
    {
      columns: ["Ninh Bình", "Kim Thanh", "Phường Tân Tựu, Xã Hoàng Tây"],
    },
    {
      columns: ["Ninh Bình", "Lai Thành", "Xã Yên Lộc (huyện Kim Sơn), Xã Tân Thành, Xã Lai Thành"],
    },
    {
      columns: ["Ninh Bình", "Lê Hồ", "Phường Đại Cương, Phường Đồng Hoá, Phường Lê Hồ"],
    },
    {
      columns: ["Ninh Bình", "Liêm Hà", "Xã Liêm Phong, Xã Liêm Cần, Xã Thanh Hà"],
    },
    {
      columns: ["Ninh Bình", "Liêm Tuyền", "Phường Tân Liêm, Xã Đinh Xá, Xã Trịnh Xá"],
    },
    {
      columns: ["Ninh Bình", "Liên Minh", "Xã Vĩnh Hào, Xã Đại Thắng, Xã Liên Minh"],
    },
    {
      columns: ["Ninh Bình", "Lý Nhân", "Xã Chính Lý, Xã Hợp Lý, Xã Văn Lý"],
    },
    {
      columns: [
        "Ninh Bình",
        "Lý Thường Kiệt",
        "Xã Liên Sơn, Xã Thanh Sơn (thị xã Kim Bảng), Phường Thi Sơn",
      ],
    },
    {
      columns: ["Ninh Bình", "Minh Tân", "Xã Cộng Hòa, Xã Minh Tân"],
    },
    {
      columns: ["Ninh Bình", "Minh Thái", "Xã Trực Đại, Xã Trực Thái, Xã Trực Thắng"],
    },
    {
      columns: ["Ninh Bình", "Mỹ Lộc", "Phường Hưng Lộc, Xã Mỹ Thuận, Xã Mỹ Lộc"],
    },
    {
      columns: [
        "Ninh Bình",
        "Nam Định",
        "Phường Quang Trung (thành phố Nam Định), Phường Vị Xuyên, Phường Lộc Vượng, Phường Cửa Bắc, Phường Trần Hưng Đạo, Phường Năng Tĩnh, Phường Cửa Nam, Xã Mỹ Phúc",
      ],
    },
    {
      columns: ["Ninh Bình", "Nam Đồng", "Xã Đồng Sơn, Xã Nam Thái"],
    },
    {
      columns: [
        "Ninh Bình",
        "Nam Hoa Lư",
        "Phường Ninh Phong, Phường Ninh Sơn, Xã Ninh Vân, Xã Ninh An, Xã Ninh Hải",
      ],
    },
    {
      columns: ["Ninh Bình", "Nam Hồng", "Xã Tân Thịnh, Xã Nam Thắng, Xã Nam Hồng"],
    },
    {
      columns: ["Ninh Bình", "Nam Lý", "Xã Tiến Thắng (huyện Lý Nhân), Xã Phú Phúc, Xã Hòa Hậu"],
    },
    {
      columns: ["Ninh Bình", "Nam Minh", "Xã Nam Dương, Xã Bình Minh, Xã Nam Tiến"],
    },
    {
      columns: ["Ninh Bình", "Nam Ninh", "Xã Nam Hoa, Xã Nam Lợi, Xã Nam Hải, Xã Nam Thanh"],
    },
    {
      columns: ["Ninh Bình", "Nam Trực", "Thị trấn Nam Giang, Xã Nam Cường, Xã Nam Hùng"],
    },
    {
      columns: ["Ninh Bình", "Nam Xang", "Xã Công Lý, Xã Nguyên Lý, Xã Đức Lý"],
    },
    {
      columns: [
        "Ninh Bình",
        "Nghĩa Hưng",
        "Thị trấn Liễu Đề, Xã Nghĩa Thái, Xã Nghĩa Châu, Xã Nghĩa Trung",
      ],
    },
    {
      columns: ["Ninh Bình", "Nghĩa Lâm", "Xã Nghĩa Hùng, Xã Nghĩa Hải, Xã Nghĩa Lâm"],
    },
    {
      columns: ["Ninh Bình", "Nghĩa Sơn", "Xã Nghĩa Lạc, Xã Nghĩa Sơn"],
    },
    {
      columns: ["Ninh Bình", "Nguyễn Úy", "Phường Tượng Lĩnh, Phường Tân Sơn, Xã Nguyễn Úy"],
    },
    {
      columns: ["Ninh Bình", "Nhân Hà", "Xã Nhân Thịnh, Xã Nhân Mỹ, Xã Xuân Khê"],
    },
    {
      columns: ["Ninh Bình", "Nho Quan", "Thị trấn Nho Quan, Xã Đồng Phong, Xã Yên Quang"],
    },
    {
      columns: ["Ninh Bình", "Ninh Cường", "Thị trấn Ninh Cường, Xã Trực Cường, Xã Trực Hùng"],
    },
    {
      columns: ["Ninh Bình", "Ninh Giang", "Xã Trực Chính, Xã Phương Định, Xã Liêm Hải"],
    },
    {
      columns: ["Ninh Bình", "Phát Diệm", "Thị trấn Phát Diệm, Xã Thượng Kiệm, Xã Kim Chính"],
    },
    {
      columns: ["Ninh Bình", "Phong Doanh", "Xã Phú Hưng, Xã Yên Thọ, Xã Yên Chính"],
    },
    {
      columns: ["Ninh Bình", "Phú Long", "Xã Kỳ Phú, Xã Phú Long"],
    },
    {
      columns: [
        "Ninh Bình",
        "Phủ Lý",
        "Phường Châu Cầu, Phường Thanh Châu, Phường Liêm Chính, Phường Quang Trung (thành phố Phủ Lý)",
      ],
    },
    {
      columns: ["Ninh Bình", "Phú Sơn", "Xã Thạch Bình, Xã Lạc Vân, Xã Phú Sơn"],
    },
    {
      columns: ["Ninh Bình", "Phù Vân", "Phường Lê Hồng Phong, Xã Kim Bình, Xã Phù Vân"],
    },
    {
      columns: ["Ninh Bình", "Quang Hưng", "Xã Trực Khang, Xã Trực Mỹ, Xã Trực Thuận"],
    },
    {
      columns: ["Ninh Bình", "Quang Thiện", "Xã Như Hòa, Xã Đồng Hướng, Xã Quang Thiện"],
    },
    {
      columns: ["Ninh Bình", "Quỹ Nhất", "Thị trấn Quỹ Nhất, Xã Nghĩa Thành, Xã Nghĩa Lợi"],
    },
    {
      columns: ["Ninh Bình", "Quỳnh Lưu", "Xã Phú Lộc, Xã Quỳnh Lưu"],
    },
    {
      columns: [
        "Ninh Bình",
        "Rạng Đông",
        "Xã Nam Điền (huyện Nghĩa Hưng), Xã Phúc Thắng, Thị trấn Rạng Đông",
      ],
    },
    {
      columns: ["Ninh Bình", "Tam Chúc", "Phường Ba Sao, Xã Khả Phong, Xã Thuỵ Lôi"],
    },
    {
      columns: ["Ninh Bình", "Tam Điệp", "Phường Bắc Sơn, Phường Tây Sơn, Xã Quang Sơn"],
    },
    {
      columns: ["Ninh Bình", "Tân Minh", "Xã Trung Nghĩa, Xã Tân Minh"],
    },
    {
      columns: ["Ninh Bình", "Tân Thanh", "Thị trấn Tân Thanh, Xã Thanh Thủy, Xã Thanh Phong"],
    },
    {
      columns: [
        "Ninh Bình",
        "Tây Hoa Lư",
        "Phường Ninh Giang, Xã Trường Yên, Xã Ninh Hòa, Xã Phúc Sơn, Xã Gia Sinh, Xã Gia Tân",
      ],
    },
    {
      columns: ["Ninh Bình", "Thanh Bình", "Xã Liêm Sơn, Xã Liêm Thuận, Xã Liêm Túc"],
    },
    {
      columns: ["Ninh Bình", "Thanh Lâm", "Xã Thanh Nghị, Xã Thanh Tân, Xã Thanh Hải"],
    },
    {
      columns: ["Ninh Bình", "Thanh Liêm", "Xã Thanh Hương, Xã Thanh Tâm, Xã Thanh Nguyên"],
    },
    {
      columns: ["Ninh Bình", "Thành Nam", "Phường Mỹ Xá, Xã Đại An"],
    },
    {
      columns: [
        "Ninh Bình",
        "Thanh Sơn",
        "Xã Thanh Sơn (huyện Nho Quan), Xã Thượng Hòa, Xã Văn Phú",
      ],
    },
    {
      columns: ["Ninh Bình", "Thiên Trường", "Phường Lộc Hạ, Xã Mỹ Tân, Xã Mỹ Trung"],
    },
    {
      columns: ["Ninh Bình", "Tiên Sơn", "Phường Tiên Sơn, Phường Tiên Nội, Xã Tiên Ngoại"],
    },
    {
      columns: ["Ninh Bình", "Trần Thương", "Xã Trần Hưng Đạo, Xã Nhân Nghĩa, Xã Nhân Bình"],
    },
    {
      columns: ["Ninh Bình", "Trung Sơn", "Phường Nam Sơn, Phường Trung Sơn, Xã Đông Sơn"],
    },
    {
      columns: ["Ninh Bình", "Trực Ninh", "Xã Trực Thanh, Xã Trực Nội, Xã Trực Hưng"],
    },
    {
      columns: ["Ninh Bình", "Trường Thi", "Phường Trường Thi, Xã Thành Lợi"],
    },
    {
      columns: ["Ninh Bình", "Vạn Thắng", "Xã Yên Thắng (huyện Ý Yên), Xã Yên Tiến, Xã Yên Lương"],
    },
    {
      columns: ["Ninh Bình", "Vị Khê", "Xã Nam Điền (huyện Nam Trực), Phường Nam Phong"],
    },
    {
      columns: ["Ninh Bình", "Vĩnh Trụ", "Thị trấn Vĩnh Trụ, Xã Nhân Chính, Xã Nhân Khang"],
    },
    {
      columns: ["Ninh Bình", "Vụ Bản", "Thị trấn Gôi, Xã Kim Thái, Xã Tam Thanh"],
    },
    {
      columns: [
        "Ninh Bình",
        "Vũ Dương",
        "Xã Yên Mỹ (huyện Ý Yên), Xã Yên Bình, Xã Yên Dương, Xã Yên Ninh",
      ],
    },
    {
      columns: ["Ninh Bình", "Xuân Giang", "Xã Xuân Tân, Xã Xuân Phú, Xã Xuân Giang"],
    },
    {
      columns: [
        "Ninh Bình",
        "Xuân Hồng",
        "Xã Xuân Châu, Xã Xuân Thành, Xã Xuân Thượng, Xã Xuân Hồng",
      ],
    },
    {
      columns: ["Ninh Bình", "Xuân Hưng", "Xã Xuân Vinh, Xã Trà Lũ, Xã Thọ Nghiệp"],
    },
    {
      columns: [
        "Ninh Bình",
        "Xuân Trường",
        "Thị trấn Xuân Trường, Xã Xuân Phúc, Xã Xuân Ninh, Xã Xuân Ngọc",
      ],
    },
    {
      columns: [
        "Ninh Bình",
        "Ý Yên",
        "Xã Yên Phong, Xã Hồng Quang (huyện Ý Yên), Xã Yên Khánh, Thị trấn Lâm",
      ],
    },
    {
      columns: [
        "Ninh Bình",
        "Yên Cường",
        "Xã Yên Nhân, Xã Yên Lộc (huyện Ý Yên), Xã Yên Phúc, Xã Yên Cường",
      ],
    },
    {
      columns: ["Ninh Bình", "Yên Đồng", "Xã Yên Đồng (huyện Ý Yên), Xã Yên Trị, Xã Yên Khang"],
    },
    {
      columns: [
        "Ninh Bình",
        "Yên Khánh",
        "Thị trấn Yên Ninh, Xã Khánh Cư, Xã Khánh Vân, Xã Khánh Hải",
      ],
    },
    {
      columns: ["Ninh Bình", "Yên Mạc", "Xã Yên Mỹ (huyện Yên Mô), Xã Yên Lâm, Xã Yên Mạc"],
    },
    {
      columns: ["Ninh Bình", "Yên Mô", "Thị trấn Yên Thịnh, Xã Khánh Dương, Xã Yên Hòa"],
    },
    {
      columns: ["Ninh Bình", "Yên Sơn", "Phường Tân Bình, Xã Quảng Lạc, Xã Yên Sơn"],
    },
    {
      columns: [
        "Ninh Bình",
        "Yên Thắng",
        "Xã Yên Thắng (huyện Yên Mô), Xã Khánh Thượng, Phường Yên Bình",
      ],
    },
    {
      columns: ["Ninh Bình", "Yên Từ", "Xã Yên Phong, Xã Yên Nhân (huyện Yên Mô), Xã Yên Từ"],
    },
    {
      columns: ["Phú Thọ", "An Bình", "Xã Hưng Thi, Xã Thống Nhất, Xã An Bình"],
    },
    {
      columns: ["Phú Thọ", "An Nghĩa", "Thị trấn Ba Hàng Đồi, Xã Phú Nghĩa, Xã Phú Thành"],
    },
    {
      columns: ["Phú Thọ", "Âu Cơ", "Phường Thanh Vinh, Phường Âu Cơ, Xã Thanh Minh"],
    },
    {
      columns: ["Phú Thọ", "Bản Nguyên", "Xã Cao Xá, Xã Vĩnh Lại, Xã Bản Nguyên"],
    },
    {
      columns: ["Phú Thọ", "Bao La", "Xã Mai Hịch, Xã Xăm Khòe, Xã Bao La"],
    },
    {
      columns: ["Phú Thọ", "Bằng Luân", "Xã Bằng Doãn, Xã Phúc Lai, Xã Bằng Luân"],
    },
    {
      columns: [
        "Phú Thọ",
        "Bình Nguyên",
        "Thị trấn Hương Canh, Xã Tam Hợp, Xã Quất Lưu, Xã Sơn Lôi",
      ],
    },
    {
      columns: ["Phú Thọ", "Bình Phú", "Xã Tiên Du, Xã An Đạo, Xã Bình Phú"],
    },
    {
      columns: ["Phú Thọ", "Bình Tuyền", "Thị trấn Bá Hiến, Xã Trung Mỹ"],
    },
    {
      columns: ["Phú Thọ", "Bình Xuyên", "Thị trấn Gia Khánh, Xã Hương Sơn, Xã Thiện Kế"],
    },
    {
      columns: ["Phú Thọ", "Cao Dương", "Xã Thanh Cao, Xã Thanh Sơn, Xã Cao Dương"],
    },
    {
      columns: ["Phú Thọ", "Cao Phong", "Thị trấn Cao Phong, Xã Hợp Phong, Xã Thu Phong"],
    },
    {
      columns: ["Phú Thọ", "Cao Sơn", "Xã Tân Minh, Xã Cao Sơn (huyện Đà Bắc)"],
    },
    {
      columns: ["Phú Thọ", "Cẩm Khê", "Thị trấn Cẩm Khê, Xã Minh Tân, Xã Phong Thịnh"],
    },
    {
      columns: ["Phú Thọ", "Chân Mộng", "Xã Hùng Long, Xã Yên Kiện, Xã Chân Mộng"],
    },
    {
      columns: ["Phú Thọ", "Chí Đám", "Xã Hùng Xuyên, Xã Chí Đám"],
    },
    {
      columns: ["Phú Thọ", "Chí Tiên", "Xã Sơn Cương, Xã Thanh Hà, Xã Chí Tiên"],
    },
    {
      columns: ["Phú Thọ", "Cự Đồng", "Xã Tất Thắng, Xã Thắng Sơn, Xã Cự Đồng"],
    },
    {
      columns: ["Phú Thọ", "Dân Chủ", "Xã Bảo Thanh, Xã Trị Quận, Xã Hạ Giáp, Xã Gia Thanh"],
    },
    {
      columns: ["Phú Thọ", "Dũng Tiến", "Xã Cuối Hạ, Xã Mỵ Hòa, Xã Nuông Dăm"],
    },
    {
      columns: [
        "Phú Thọ",
        "Đà Bắc",
        "Thị trấn Đà Bắc, Xã Hiền Lương (huyện Đà Bắc), Xã Toàn Sơn, Xã Tú Lý",
      ],
    },
    {
      columns: ["Phú Thọ", "Đại Đình", "Thị trấn Đại Đình, Xã Bồ Lý"],
    },
    {
      columns: ["Phú Thọ", "Đại Đồng", "Xã Ân Nghĩa, Xã Tân Mỹ, Xã Yên Nghiệp"],
    },
    {
      columns: ["Phú Thọ", "Đan Thượng", "Xã Tứ Hiệp, Xã Đại Phạm, Xã Hà Lương, Xã Đan Thượng"],
    },
    {
      columns: ["Phú Thọ", "Đạo Trù", "Xã Yên Dương, Xã Đạo Trù"],
    },
    {
      columns: ["Phú Thọ", "Đào Xá", "Xã Xuân Lộc, Xã Thạch Đồng, Xã Tân Phương, Xã Đào Xá"],
    },
    {
      columns: ["Phú Thọ", "Đoan Hùng", "Thị trấn Đoan Hùng, Xã Hợp Nhất, Xã Ngọc Quan"],
    },
    {
      columns: ["Phú Thọ", "Đồng Lương", "Xã Điêu Lương, Xã Yên Dưỡng, Xã Đồng Lương"],
    },
    {
      columns: ["Phú Thọ", "Đông Thành", "Xã Khải Xuân, Xã Võ Lao, Xã Đông Thành"],
    },
    {
      columns: ["Phú Thọ", "Đức Nhàn", "Xã Mường Chiềng, Xã Nánh Nghê"],
    },
    {
      columns: ["Phú Thọ", "Hạ Hòa", "Thị trấn Hạ Hòa, Xã Minh Hạc, Xã Ấm Hạ, Xã Gia Điền"],
    },
    {
      columns: ["Phú Thọ", "Hải Lựu", "Xã Nhân Đạo, Xã Đôn Nhân, Xã Phương Khoan, Xã Hải Lựu"],
    },
    {
      columns: ["Phú Thọ", "Hiền Lương", "Xã Hiền Lương (huyện Hạ Hòa), Xã Xuân Áng"],
    },
    {
      columns: ["Phú Thọ", "Hiền Quan", "Xã Thanh Uyên, Xã Bắc Sơn, Xã Hiền Quan"],
    },
    {
      columns: [
        "Phú Thọ",
        "Hòa Bình",
        "Phường Đồng Tiến, Phường Hữu Nghị, Phường Phương Lâm, Phường Quỳnh Lâm, Phường Tân Thịnh, Phường Thịnh Lang, Phường Trung Minh",
      ],
    },
    {
      columns: ["Phú Thọ", "Hoàng An", "Xã Hoàng Đan, Xã Hoàng Lâu, Xã An Hòa"],
    },
    {
      columns: ["Phú Thọ", "Hoàng Cương", "Xã Ninh Dân, Xã Mạn Lạn, Xã Hoàng Cương"],
    },
    {
      columns: ["Phú Thọ", "Hội Thịnh", "Xã Duy Phiên, Xã Thanh Vân, Xã Hội Thịnh"],
    },
    {
      columns: ["Phú Thọ", "Hợp Kim", "Xã Kim Lập, Xã Nam Thượng, Xã Sào Báy"],
    },
    {
      columns: ["Phú Thọ", "Hợp Lý", "Xã Ngọc Mỹ (huyện Lập Thạch), Xã Quang Sơn, Xã Hợp Lý"],
    },
    {
      columns: ["Phú Thọ", "Hùng Việt", "Xã Nhật Tiến, Xã Hùng Việt"],
    },
    {
      columns: ["Phú Thọ", "Hương Cần", "Xã Yên Lương, Xã Yên Lãng, Xã Hương Cần"],
    },
    {
      columns: ["Phú Thọ", "Hy Cương", "Xã Thanh Đình, Xã Chu Hóa, Xã Hy Cương"],
    },
    {
      columns: ["Phú Thọ", "Khả Cửu", "Xã Đông Cửu, Xã Thượng Cửu, Xã Khả Cửu"],
    },
    {
      columns: ["Phú Thọ", "Kim Bôi", "Thị trấn Bo, Xã Vĩnh Đồng, Xã Kim Bôi"],
    },
    {
      columns: ["Phú Thọ", "Kỳ Sơn", "Phường Kỳ Sơn, Xã Độc Lập, Xã Mông Hóa"],
    },
    {
      columns: ["Phú Thọ", "Lạc Lương", "Xã Bảo Hiệu, Xã Đa Phúc, Xã Lạc Sỹ, Xã Lạc Lương"],
    },
    {
      columns: ["Phú Thọ", "Lạc Sơn", "Thị trấn Vụ Bản, Xã Hương Nhượng, Xã Vũ Bình"],
    },
    {
      columns: ["Phú Thọ", "Lạc Thủy", "Thị trấn Chi Nê, Xã Đồng Tâm, Xã Khoan Dụ, Xã Yên Bồng"],
    },
    {
      columns: ["Phú Thọ", "Lai Đồng", "Xã Kiệt Sơn, Xã Tân Sơn, Xã Đồng Sơn, Xã Lai Đồng"],
    },
    {
      columns: ["Phú Thọ", "Lâm Thao", "Thị trấn Hùng Sơn, Thị trấn Lâm Thao, Xã Thạch Sơn"],
    },
    {
      columns: ["Phú Thọ", "Lập Thạch", "Thị trấn Lập Thạch, Xã Xuân Hòa, Xã Tử Du, Xã Vân Trục"],
    },
    {
      columns: ["Phú Thọ", "Liên Châu", "Xã Đại Tự, Xã Hồng Châu, Xã Liên Châu"],
    },
    {
      columns: ["Phú Thọ", "Liên Hòa", "Thị trấn Hoa Sơn, Xã Bàn Giản, Xã Liên Hòa"],
    },
    {
      columns: ["Phú Thọ", "Liên Minh", "Xã Đỗ Sơn, Xã Đỗ Xuyên, Xã Lương Lỗ"],
    },
    {
      columns: ["Phú Thọ", "Liên Sơn", "Xã Cư Yên, Xã Liên Sơn, Xã Cao Sơn (huyện Lương Sơn)"],
    },
    {
      columns: ["Phú Thọ", "Long Cốc", "Xã Tam Thanh, Xã Vinh Tiền, Xã Long Cốc"],
    },
    {
      columns: [
        "Phú Thọ",
        "Lương Sơn",
        "Thị trấn Lương Sơn, Xã Hòa Sơn, Xã Lâm Sơn, Xã Nhuận Trạch, Xã Tân Vinh, Xã Cao Sơn (huyện Lương Sơn)",
      ],
    },
    {
      columns: [
        "Phú Thọ",
        "Mai Châu",
        "Thị trấn Mai Châu, Xã Nà Phòn, Xã Thành Sơn, Xã Tòng Đậu, Xã Đồng Tân",
      ],
    },
    {
      columns: ["Phú Thọ", "Mai Hạ", "Xã Chiềng Châu, Xã Vạn Mai, Xã Mai Hạ"],
    },
    {
      columns: ["Phú Thọ", "Minh Đài", "Xã Mỹ Thuận, Xã Văn Luông, Xã Minh Đài"],
    },
    {
      columns: ["Phú Thọ", "Minh Hòa", "Xã Ngọc Lập, Xã Ngọc Đồng, Xã Minh Hòa"],
    },
    {
      columns: ["Phú Thọ", "Mường Bi", "Xã Mỹ Hòa, Xã Phong Phú, Xã Phú Cường"],
    },
    {
      columns: ["Phú Thọ", "Mường Động", "Xã Đông Bắc, Xã Hợp Tiến, Xã Tú Sơn, Xã Vĩnh Tiến"],
    },
    {
      columns: ["Phú Thọ", "Mường Hoa", "Xã Phú Vinh, Xã Suối Hoa"],
    },
    {
      columns: [
        "Phú Thọ",
        "Mường Thàng",
        "Xã Dũng Phong, Xã Nam Phong, Xã Tây Phong, Xã Thạch Yên",
      ],
    },
    {
      columns: ["Phú Thọ", "Mường Vang", "Xã Tân Lập (huyện Lạc Sơn), Xã Quý Hòa, Xã Tuân Đạo"],
    },
    {
      columns: [
        "Phú Thọ",
        "Nật Sơn",
        "Xã Xuân Thủy (huyện Kim Bôi), Xã Bình Sơn, Xã Đú Sáng, Xã Hùng Sơn",
      ],
    },
    {
      columns: ["Phú Thọ", "Ngọc Sơn", "Xã Ngọc Lâu, Xã Tự Do, Xã Ngọc Sơn"],
    },
    {
      columns: ["Phú Thọ", "Nguyệt Đức", "Xã Văn Tiến, Xã Trung Kiên, Xã Trung Hà, Xã Nguyệt Đức"],
    },
    {
      columns: ["Phú Thọ", "Nhân Nghĩa", "Xã Mỹ Thành, Xã Văn Nghĩa, Xã Nhân Nghĩa"],
    },
    {
      columns: ["Phú Thọ", "Nông Trang", "Phường Minh Phương, Phường Nông Trang, Xã Thụy Vân"],
    },
    {
      columns: ["Phú Thọ", "Pà Cò", "Xã Cun Pheo, Xã Hang Kia, Xã Pà Cò, Xã Đồng Tân"],
    },
    {
      columns: ["Phú Thọ", "Phong Châu", "Phường Phong Châu, Xã Phú Hộ, Xã Hà Thạch"],
    },
    {
      columns: ["Phú Thọ", "Phú Khê", "Xã Hương Lung, Xã Phú Khê"],
    },
    {
      columns: ["Phú Thọ", "Phú Mỹ", "Xã Liên Hoa, Xã Lệ Mỹ, Xã Phú Mỹ"],
    },
    {
      columns: ["Phú Thọ", "Phù Ninh", "Thị trấn Phong Châu, Xã Phú Nham, Xã Phú Lộc, Xã Phù Ninh"],
    },
    {
      columns: ["Phú Thọ", "Phú Thọ", "Phường Hùng Vương (thị xã Phú Thọ), Xã Văn Lung, Xã Hà Lộc"],
    },
    {
      columns: [
        "Phú Thọ",
        "Phúc Yên",
        "Phường Hùng Vương (thành phố Phúc Yên), Phường Hai Bà Trưng, Phường Phúc Thắng, Phường Tiền Châu, Phường Nam Viêm",
      ],
    },
    {
      columns: ["Phú Thọ", "Phùng Nguyên", "Xã Tứ Xã, Xã Sơn Vi, Xã Phùng Nguyên"],
    },
    {
      columns: ["Phú Thọ", "Quảng Yên", "Xã Đại An, Xã Đông Lĩnh, Xã Quảng Yên"],
    },
    {
      columns: [
        "Phú Thọ",
        "Quy Đức",
        "Xã Đoàn Kết (huyện Đà Bắc), Xã Đồng Ruộng, Xã Trung Thành, Xã Yên Hoà",
      ],
    },
    {
      columns: ["Phú Thọ", "Quyết Thắng", "Xã Chí Đạo, Xã Định Cư, Xã Quyết Thắng"],
    },
    {
      columns: [
        "Phú Thọ",
        "Sông Lô",
        "Xã Đồng Thịnh (huyện Sông Lô), Xã Tứ Yên, Xã Đức Bác, Xã Yên Thạch",
      ],
    },
    {
      columns: ["Phú Thọ", "Sơn Đông", "Xã Tây Sơn, Xã Cao Phong, Xã Sơn Đông"],
    },
    {
      columns: ["Phú Thọ", "Sơn Lương", "Xã Mỹ Lương, Xã Mỹ Lung, Xã Lương Sơn"],
    },
    {
      columns: [
        "Phú Thọ",
        "Tam Dương",
        "Thị trấn Hợp Hòa, Thị trấn Kim Long, Xã Hướng Đạo, Xã Đạo Tú",
      ],
    },
    {
      columns: ["Phú Thọ", "Tam Dương Bắc", "Xã Đồng Tĩnh, Xã Hoàng Hoa, Xã Tam Quan"],
    },
    {
      columns: [
        "Phú Thọ",
        "Tam Đảo",
        "Thị trấn Hợp Châu, Thị trấn Tam Đảo, Xã Hồ Sơn, Xã Minh Quang",
      ],
    },
    {
      columns: ["Phú Thọ", "Tam Hồng", "Thị trấn Tam Hồng, Xã Yên Phương, Xã Yên Đồng"],
    },
    {
      columns: ["Phú Thọ", "Tam Nông", "Thị trấn Hưng Hóa, Xã Dân Quyền, Xã Hương Nộn"],
    },
    {
      columns: ["Phú Thọ", "Tam Sơn", "Xã Tân Lập (huyện Sông Lô), Xã Đồng Quế, Thị trấn Tam Sơn"],
    },
    {
      columns: ["Phú Thọ", "Tân Hòa", "Phường Tân Hòa, Xã Hòa Bình, Xã Yên Mông"],
    },
    {
      columns: [
        "Phú Thọ",
        "Tân Lạc",
        "Thị trấn Mãn Đức, Xã Ngọc Mỹ (huyện Tân Lạc), Xã Đông Lai, Xã Thanh Hối, Xã Tử Nê",
      ],
    },
    {
      columns: ["Phú Thọ", "Tân Mai", "Xã Sơn Thủy (huyện Mai Châu), Xã Tân Thành"],
    },
    {
      columns: ["Phú Thọ", "Tân Pheo", "Xã Đồng Chum, Xã Giáp Đắt, Xã Tân Pheo"],
    },
    {
      columns: ["Phú Thọ", "Tân Sơn", "Thị trấn Tân Phú, Xã Thu Ngạc, Xã Thạch Kiệt"],
    },
    {
      columns: ["Phú Thọ", "Tây Cốc", "Xã Phú Lâm, Xã Ca Đình, Xã Tây Cốc"],
    },
    {
      columns: ["Phú Thọ", "Tề Lỗ", "Xã Đồng Văn, Xã Trung Nguyên, Xã Tề Lỗ"],
    },
    {
      columns: ["Phú Thọ", "Thái Hòa", "Xã Bắc Bình, Xã Liễn Sơn, Xã Thái Hòa"],
    },
    {
      columns: ["Phú Thọ", "Thanh Ba", "Thị trấn Thanh Ba, Xã Đồng Xuân, Xã Hanh Cù, Xã Vân Lĩnh"],
    },
    {
      columns: [
        "Phú Thọ",
        "Thanh Miếu",
        "Phường Thọ Sơn, Phường Tiên Cát, Phường Bạch Hạc, Phường Thanh Miếu, Xã Sông Lô",
      ],
    },
    {
      columns: [
        "Phú Thọ",
        "Thanh Sơn",
        "Thị trấn Thanh Sơn, Xã Sơn Hùng, Xã Giáp Lai, Xã Thạch Khoán, Xã Thục Luyện",
      ],
    },
    {
      columns: [
        "Phú Thọ",
        "Thanh Thủy",
        "Xã Sơn Thủy (huyện Thanh Thủy), Xã Đoan Hạ, Xã Bảo Yên, Thị trấn Thanh Thủy",
      ],
    },
    {
      columns: ["Phú Thọ", "Thịnh Minh", "Xã Hợp Thành, Xã Quang Tiến, Xã Thịnh Minh"],
    },
    {
      columns: ["Phú Thọ", "Thọ Văn", "Xã Dị Nậu, Xã Tề Lễ, Xã Thọ Văn"],
    },
    {
      columns: ["Phú Thọ", "Thổ Tang", "Thị trấn Thổ Tang, Xã Thượng Trưng, Xã Tuân Chính"],
    },
    {
      columns: [
        "Phú Thọ",
        "Thống Nhất",
        "Phường Dân Chủ, Phường Thái Bình, Phường Thống Nhất, Xã Vầy Nưa",
      ],
    },
    {
      columns: ["Phú Thọ", "Thu Cúc", "Không sáp nhập"],
    },
    {
      columns: ["Phú Thọ", "Thung Nai", "Xã Bắc Phong, Xã Bình Thanh, Xã Thung Nai"],
    },
    {
      columns: ["Phú Thọ", "Thượng Cốc", "Xã Miền Đồi, Xã Văn Sơn, Xã Thượng Cốc"],
    },
    {
      columns: ["Phú Thọ", "Thượng Long", "Xã Phúc Khánh, Xã Nga Hoàng, Xã Thượng Long"],
    },
    {
      columns: ["Phú Thọ", "Tiên Lữ", "Xã Xuân Lôi, Xã Văn Quán, Xã Đồng Ích, Xã Tiên Lữ"],
    },
    {
      columns: ["Phú Thọ", "Tiên Lương", "Xã Phượng Vĩ, Xã Minh Thắng, Xã Tiên Lương"],
    },
    {
      columns: ["Phú Thọ", "Tiền Phong", "Xã Tiền Phong, Xã Vầy Nưa"],
    },
    {
      columns: ["Phú Thọ", "Toàn Thắng", "Xã Gia Mô, Xã Lỗ Sơn, Xã Nhân Mỹ"],
    },
    {
      columns: ["Phú Thọ", "Trạm Thản", "Xã Tiên Phú, Xã Trung Giáp, Xã Trạm Thản"],
    },
    {
      columns: ["Phú Thọ", "Trung Sơn", "Không sáp nhập"],
    },
    {
      columns: ["Phú Thọ", "Tu Vũ", "Xã Đồng Trung, Xã Hoàng Xá, Xã Tu Vũ"],
    },
    {
      columns: ["Phú Thọ", "Vạn Xuân", "Xã Quang Húc, Xã Lam Sơn, Xã Vạn Xuân"],
    },
    {
      columns: ["Phú Thọ", "Văn Lang", "Xã Vô Tranh, Xã Bằng Giã, Xã Minh Côi, Xã Văn Lang"],
    },
    {
      columns: ["Phú Thọ", "Văn Miếu", "Xã Tân Lập, Xã Tân Minh (huyện Thanh Sơn), Xã Văn Miếu"],
    },
    {
      columns: ["Phú Thọ", "Vân Bán", "Xã Tùng Khê, Xã Tam Sơn, Xã Văn Bán"],
    },
    {
      columns: ["Phú Thọ", "Vân Phú", "Phường Vân Phú, Xã Phượng Lâu, Xã Hùng Lô, Xã Kim Đức"],
    },
    {
      columns: ["Phú Thọ", "Vân Sơn", "Xã Ngổ Luông, Xã Quyết Chiến, Xã Vân Sơn"],
    },
    {
      columns: [
        "Phú Thọ",
        "Việt Trì",
        "Phường Tân Dân, Phường Gia Cẩm, Phường Minh Nông, Phường Dữu Lâu, Xã Trưng Vương",
      ],
    },
    {
      columns: ["Phú Thọ", "Vĩnh An", "Xã Kim Xá, Xã Yên Bình, Xã Chấn Hưng"],
    },
    {
      columns: ["Phú Thọ", "Vĩnh Chân", "Xã Lang Sơn, Xã Yên Luật, Xã Vĩnh Chân"],
    },
    {
      columns: ["Phú Thọ", "Vĩnh Hưng", "Xã Nghĩa Hưng, Xã Yên Lập, Xã Đại Đồng"],
    },
    {
      columns: ["Phú Thọ", "Vĩnh Phú", "Xã An Nhân, Xã Vĩnh Thịnh, Xã Ngũ Kiên, Xã Vĩnh Phú"],
    },
    {
      columns: [
        "Phú Thọ",
        "Vĩnh Phúc",
        "Phường Định Trung, Phường Liên Bảo, Phường Khai Quang, Phường Ngô Quyền, Phường Đống Đa",
      ],
    },
    {
      columns: ["Phú Thọ", "Vĩnh Thành", "Xã Sao Đại Việt, Xã Lũng Hòa, Xã Tân Phú"],
    },
    {
      columns: [
        "Phú Thọ",
        "Vĩnh Tường",
        "Thị trấn Vĩnh Tường, Thị trấn Tứ Trưng, Xã Lương Điền, Xã Vũ Di",
      ],
    },
    {
      columns: [
        "Phú Thọ",
        "Vĩnh Yên",
        "Phường Tích Sơn, Phường Hội Hợp, Phường Đồng Tâm, Xã Thanh Trù",
      ],
    },
    {
      columns: ["Phú Thọ", "Võ Miếu", "Xã Địch Quả, Xã Cự Thắng, Xã Võ Miếu"],
    },
    {
      columns: ["Phú Thọ", "Xuân Đài", "Xã Kim Thượng, Xã Xuân Sơn, Xã Xuân Đài"],
    },
    {
      columns: [
        "Phú Thọ",
        "Xuân Hòa",
        "Phường Đồng Xuân, Phường Xuân Hòa, Xã Cao Minh, Xã Ngọc Thanh",
      ],
    },
    {
      columns: [
        "Phú Thọ",
        "Xuân Lãng",
        "Thị trấn Thanh Lãng, Thị trấn Đạo Đức, Xã Tân Phong, Xã Phú Xuân",
      ],
    },
    {
      columns: ["Phú Thọ", "Xuân Lũng", "Xã Tiên Kiên, Xã Xuân Huy, Xã Xuân Lũng"],
    },
    {
      columns: ["Phú Thọ", "Xuân Viên", "Xã Xuân Thủy (huyện Yên Lập), Xã Xuân An, Xã Xuân Viên"],
    },
    {
      columns: ["Phú Thọ", "Yên Kỳ", "Xã Hương Xạ, Xã Phương Viên, Xã Yên Kỳ"],
    },
    {
      columns: ["Phú Thọ", "Yên Lạc", "Thị trấn Yên Lạc, Xã Bình Định, Xã Đồng Cương"],
    },
    {
      columns: ["Phú Thọ", "Yên Lãng", "Xã Quang Yên, Xã Lãng Công"],
    },
    {
      columns: [
        "Phú Thọ",
        "Yên Lập",
        "Thị trấn Yên Lập, Xã Đồng Thịnh (huyện Yên Lập), Xã Hưng Long, Xã Đồng Lạc",
      ],
    },
    {
      columns: ["Phú Thọ", "Yên Phú", "Xã Bình Hẻm, Xã Xuất Hóa, Xã Yên Phú"],
    },
    {
      columns: ["Phú Thọ", "Yên Sơn", "Xã Tinh Nhuệ, Xã Lương Nha, Xã Yên Sơn"],
    },
    {
      columns: ["Phú Thọ", "Yên Thủy", "Thị trấn Hàng Trạm, Xã Lạc Thịnh, Xã Phú Lai"],
    },
    {
      columns: [
        "Phú Thọ",
        "Yên Trị",
        "Xã Đoàn Kết (huyện Yên Thủy), Xã Hữu Lợi, Xã Ngọc Lương, Xã Yên Trị",
      ],
    },
    {
      columns: ["Quảng Ngãi", "An Phú", "Xã Nghĩa Hà, Xã Nghĩa Dõng, Xã Nghĩa Dũng, Xã An Phú"],
    },
    {
      columns: ["Quảng Ngãi", "Ba Dinh", "Xã Ba Giang, Xã Ba Dinh"],
    },
    {
      columns: ["Quảng Ngãi", "Ba Động", "Xã Ba Liên, Xã Ba Thành, Xã Ba Động"],
    },
    {
      columns: ["Quảng Ngãi", "Ba Gia", "Xã Tịnh Bắc, Xã Tịnh Hiệp, Xã Tịnh Trà"],
    },
    {
      columns: ["Quảng Ngãi", "Ba Tô", "Xã Ba Lế, Xã Ba Nam, Xã Ba Tô"],
    },
    {
      columns: ["Quảng Ngãi", "Ba Tơ", "Thị trấn Ba Tơ, Xã Ba Cung, Xã Ba Bích"],
    },
    {
      columns: ["Quảng Ngãi", "Ba Vì", "Xã Ba Tiêu, Xã Ba Ngạc, Xã Ba Vì"],
    },
    {
      columns: ["Quảng Ngãi", "Ba Vinh", "Xã Ba Điền, Xã Ba Vinh"],
    },
    {
      columns: ["Quảng Ngãi", "Ba Xa", "Không sáp nhập"],
    },
    {
      columns: ["Quảng Ngãi", "Bình Chương", "Xã Bình Mỹ, Xã Bình Chương"],
    },
    {
      columns: ["Quảng Ngãi", "Bình Minh", "Xã Bình Khương, Xã Bình An, Xã Bình Minh"],
    },
    {
      columns: [
        "Quảng Ngãi",
        "Bình Sơn",
        "Thị trấn Châu Ổ, Xã Bình Thạnh, Xã Bình Chánh, Xã Bình Dương, Xã Bình Nguyên, Xã Bình Trung, Xã Bình Long",
      ],
    },
    {
      columns: ["Quảng Ngãi", "Bờ Y", "Thị trấn Plei Kần, Xã Đăk Xú, Xã Pờ Y"],
    },
    {
      columns: ["Quảng Ngãi", "Cà Đam", "Xã Trà Tân, Xã Trà Bùi"],
    },
    {
      columns: [
        "Quảng Ngãi",
        "Cẩm Thành",
        "Phường Nguyễn Nghiêm, Phường Trần Hưng Đạo (thành phố Quảng Ngãi), Phường Nghĩa Chánh, Phường Chánh Lộ",
      ],
    },
    {
      columns: ["Quảng Ngãi", "Dục Nông", "Xã Đăk Ang, Xã Đăk Dục, Xã Đăk Nông"],
    },
    {
      columns: [
        "Quảng Ngãi",
        "Đăk Bla",
        "Phường Trần Hưng Đạo (thành phố Kon Tum), Lê Lợi, Nguyễn Trãi",
      ],
    },
    {
      columns: ["Quảng Ngãi", "Đăk Cấm", "Phường Ngô Mây, Phường Duy Tân, Xã Đăk Cấm"],
    },
    {
      columns: ["Quảng Ngãi", "Đăk Hà", "Thị trấn Đăk Hà, Xã Hà Mòn, Xã Đăk La"],
    },
    {
      columns: ["Quảng Ngãi", "Đăk Kôi", "Xã Đăk Tơ Lung, Xã Đăk Kôi"],
    },
    {
      columns: ["Quảng Ngãi", "Đăk Long", "Không sáp nhập"],
    },
    {
      columns: ["Quảng Ngãi", "Đăk Mar", "Xã Đăk Hring, Xã Đăk Mar"],
    },
    {
      columns: ["Quảng Ngãi", "Đăk Môn", "Xã Đăk Kroong, Xã Đăk Môn"],
    },
    {
      columns: ["Quảng Ngãi", "Đăk Pék", "Thị trấn Đăk Glei, Xã Đăk Pék"],
    },
    {
      columns: ["Quảng Ngãi", "Đăk Plô", "Xã Đăk Nhoong, Xã Đăk Man, Xã Đăk Plô"],
    },
    {
      columns: ["Quảng Ngãi", "Đăk Pxi", "Xã Đăk Long (thuộc huyện Đăk Hà), Xã Đăk Pxi"],
    },
    {
      columns: ["Quảng Ngãi", "Đăk Rơ Wa", "Xã Hòa Bình, Xã Chư Hreng, Xã Đăk Blà, Xã Đăk Rơ Wa"],
    },
    {
      columns: ["Quảng Ngãi", "Đăk Rve", "Thị trấn Đăk Rve, Xã Đăk Pne"],
    },
    {
      columns: ["Quảng Ngãi", "Đăk Sao", "Xã Đăk Na, Xã Đăk Sao"],
    },
    {
      columns: ["Quảng Ngãi", "Đăk Tô", "Thị trấn Đăk Tô, Xã Tân Cảnh, Xã Pô Kô, Xã Diên Bình"],
    },
    {
      columns: ["Quảng Ngãi", "Đăk Tờ Kan", "Xã Đăk Rơ Ông, Xã Đăk Tờ Kan"],
    },
    {
      columns: ["Quảng Ngãi", "Đăk Ui", "Xã Đăk Ngọk, Xã Đăk Ui"],
    },
    {
      columns: ["Quảng Ngãi", "Đặng Thùy Trâm", "Xã Ba Trang, Xã Ba Khâm"],
    },
    {
      columns: ["Quảng Ngãi", "Đình Cương", "Xã Hành Đức, Xã Hành Phước, Xã Hành Thịnh"],
    },
    {
      columns: [
        "Quảng Ngãi",
        "Đông Sơn",
        "Xã Bình Hiệp, Xã Bình Thanh, Xã Bình Tân Phú, Xã Bình Châu, Xã Tịnh Hòa",
      ],
    },
    {
      columns: ["Quảng Ngãi", "Đông Trà Bồng", "Xã Trà Bình, Xã Trà Phú, Xã Trà Giang"],
    },
    {
      columns: [
        "Quảng Ngãi",
        "Đức Phổ",
        "Phường Nguyễn Nghiêm (thị xã Đức Phổ), Phổ Hòa, Phổ Minh, Phổ Vinh, Phổ Ninh",
      ],
    },
    {
      columns: ["Quảng Ngãi", "Ia Chim", "Xã Đoàn Kết, Xã Đăk Năng, Xã Ia Chim"],
    },
    {
      columns: ["Quảng Ngãi", "Ia Đal", "Không sáp nhập"],
    },
    {
      columns: ["Quảng Ngãi", "Ia Tơi", "Xã Ia Dom, Xã Ia Tơi"],
    },
    {
      columns: ["Quảng Ngãi", "Khánh Cường", "Xã Phổ Khánh, Xã Phổ Cường"],
    },
    {
      columns: ["Quảng Ngãi", "Kon Braih", "Xã Đăk Tờ Re, Xã Đăk Ruồng, Xã Tân Lập"],
    },
    {
      columns: ["Quảng Ngãi", "Kon Đào", "Xã Văn Lem, Xã Đăk Trăm, Xã Kon Đào"],
    },
    {
      columns: ["Quảng Ngãi", "Kon Plông", "Xã Ngọk Tem, Xã Hiếu, Xã Pờ Ê"],
    },
    {
      columns: [
        "Quảng Ngãi",
        "Kon Tum",
        "Phường Quang Trung, Phường Quyết Thắng, Phường Thắng Lợi, Phường Trường Chinh, Phường Thống Nhất",
      ],
    },
    {
      columns: ["Quảng Ngãi", "Lân Phong", "Xã Đức Phong, Xã Đức Lân"],
    },
    {
      columns: ["Quảng Ngãi", "Long Phụng", "Xã Thắng Lợi, Xã Đức Nhuận, Xã Đức Hiệp"],
    },
    {
      columns: ["Quảng Ngãi", "Lý Sơn", "Huyện Lý Sơn"],
    },
    {
      columns: ["Quảng Ngãi", "Măng Bút", "Xã Đăk Nên, Xã Đăk Ring, Xã Măng Bút"],
    },
    {
      columns: ["Quảng Ngãi", "Măng Đen", "Thị trấn Măng Đen, Xã Măng Cành, Xã Đăk Tăng"],
    },
    {
      columns: [
        "Quảng Ngãi",
        "Măng Ri",
        "Xã Ngọk Yêu, Xã Văn Xuôi, Xã Tê Xăng, Xã Ngọk Lây, Xã Măng Ri",
      ],
    },
    {
      columns: ["Quảng Ngãi", "Minh Long", "Xã Long Hiệp, Xã Thanh An, Xã Long Môn"],
    },
    {
      columns: ["Quảng Ngãi", "Mỏ Cày", "Xã Đức Chánh, Xã Đức Thạnh, Xã Đức Minh"],
    },
    {
      columns: ["Quảng Ngãi", "Mộ Đức", "Thị trấn Mộ Đức, Xã Đức Hòa, Xã Đức Phú, Xã Đức Tân"],
    },
    {
      columns: ["Quảng Ngãi", "Mô Rai", "Không sáp nhập"],
    },
    {
      columns: ["Quảng Ngãi", "Nghĩa Giang", "Xã Nghĩa Thuận, Xã Nghĩa Kỳ, Xã Nghĩa Điền"],
    },
    {
      columns: ["Quảng Ngãi", "Nghĩa Hành", "Thị trấn Chợ Chùa, Xã Hành Thuận, Xã Hành Trung"],
    },
    {
      columns: [
        "Quảng Ngãi",
        "Nghĩa Lộ",
        "Phường Lê Hồng Phong, Phường Trần Phú, Phường Quảng Phú, Phường Nghĩa Lộ",
      ],
    },
    {
      columns: ["Quảng Ngãi", "Ngọc Linh", "Xã Mường Hoong, Xã Ngọc Linh"],
    },
    {
      columns: ["Quảng Ngãi", "Ngọk Bay", "Xã Kroong, Xã Vinh Quang, Xã Ngọk Bay"],
    },
    {
      columns: ["Quảng Ngãi", "Ngọk Réo", "Xã Ngọk Wang, Xã Ngọk Réo"],
    },
    {
      columns: ["Quảng Ngãi", "Ngọk Tụ", "Xã Đăk Rơ Nga, Xã Ngọk Tụ"],
    },
    {
      columns: ["Quảng Ngãi", "Nguyễn Nghiêm", "Xã Phổ Nhơn, Xã Phổ Phong"],
    },
    {
      columns: ["Quảng Ngãi", "Phước Giang", "Xã Hành Dũng, Xã Hành Nhân, Xã Hành Minh"],
    },
    {
      columns: ["Quảng Ngãi", "Rờ Kơi", "Không sáp nhập"],
    },
    {
      columns: ["Quảng Ngãi", "Sa Bình", "Xã Sa Nghĩa, Xã Hơ Moong, Xã Sa Bình"],
    },
    {
      columns: ["Quảng Ngãi", "Sa Huỳnh", "Phường Phổ Thạnh, Xã Phổ Châu"],
    },
    {
      columns: ["Quảng Ngãi", "Sa Loong", "Xã Đăk Kan, Xã Sa Loong"],
    },
    {
      columns: ["Quảng Ngãi", "Sa Thầy", "Thị trấn Sa Thầy, Xã Sa Sơn, Xã Sa Nhơn"],
    },
    {
      columns: ["Quảng Ngãi", "Sơn Hà", "Thị trấn Di Lăng, Xã Sơn Bao, Xã Sơn Thượng"],
    },
    {
      columns: ["Quảng Ngãi", "Sơn Hạ", "Xã Sơn Thành, Xã Sơn Nham, Xã Sơn Hạ"],
    },
    {
      columns: ["Quảng Ngãi", "Sơn Kỳ", "Xã Sơn Ba, Xã Sơn Kỳ"],
    },
    {
      columns: ["Quảng Ngãi", "Sơn Linh", "Xã Sơn Giang, Xã Sơn Cao, Xã Sơn Linh"],
    },
    {
      columns: ["Quảng Ngãi", "Sơn Mai", "Xã Long Mai, Xã Long Sơn"],
    },
    {
      columns: ["Quảng Ngãi", "Sơn Tây", "Xã Sơn Long, Xã Sơn Tân, Xã Sơn Dung"],
    },
    {
      columns: ["Quảng Ngãi", "Sơn Tây Hạ", "Xã Sơn Tinh, Xã Sơn Lập, Xã Sơn Màu"],
    },
    {
      columns: ["Quảng Ngãi", "Sơn Tây Thượng", "Xã Sơn Mùa, Xã Sơn Liên, Xã Sơn Bua"],
    },
    {
      columns: ["Quảng Ngãi", "Sơn Thủy", "Xã Sơn Trung, Xã Sơn Hải, Xã Sơn Thủy"],
    },
    {
      columns: ["Quảng Ngãi", "Sơn Tịnh", "Thị trấn Tịnh Hà, Xã Tịnh Bình, Xã Tịnh Sơn"],
    },
    {
      columns: ["Quảng Ngãi", "Tây Trà", "Xã Sơn Trà, Xã Trà Phong, Xã Trà Xinh"],
    },
    {
      columns: ["Quảng Ngãi", "Tây Trà Bồng", "Xã Hương Trà, Xã Trà Tây, Xã Trà Bùi"],
    },
    {
      columns: ["Quảng Ngãi", "Thanh Bồng", "Xã Trà Lâm, Xã Trà Hiệp, Xã Trà Thanh"],
    },
    {
      columns: ["Quảng Ngãi", "Thiện Tín", "Xã Hành Thiện, Xã Hành Tín Tây, Xã Hành Tín Đông"],
    },
    {
      columns: ["Quảng Ngãi", "Thọ Phong", "Xã Tịnh Phong, Xã Tịnh Thọ"],
    },
    {
      columns: [
        "Quảng Ngãi",
        "Tịnh Khê",
        "Xã Tịnh Kỳ, Xã Tịnh Châu, Xã Tịnh Long, Xã Tịnh Thiện, Xã Tịnh Khê",
      ],
    },
    {
      columns: ["Quảng Ngãi", "Trà Bồng", "Thị trấn Trà Xuân, Xã Trà Sơn, Xã Trà Thủy"],
    },
    {
      columns: [
        "Quảng Ngãi",
        "Trà Câu",
        "Phường Phổ Văn, Phường Phổ Quang, Xã Phổ An, Xã Phổ Thuận",
      ],
    },
    {
      columns: ["Quảng Ngãi", "Trà Giang", "Xã Nghĩa Sơn, Xã Nghĩa Lâm, Xã Nghĩa Thắng"],
    },
    {
      columns: ["Quảng Ngãi", "Trường Giang", "Xã Tịnh Giang, Xã Tịnh Đông, Xã Tịnh Minh"],
    },
    {
      columns: [
        "Quảng Ngãi",
        "Trương Quang Trọng",
        "Phường Trương Quang Trọng, Xã Tịnh Ấn Tây, Xã Tịnh Ấn Đông, Xã Tịnh An",
      ],
    },
    {
      columns: ["Quảng Ngãi", "Tu Mơ Rông", "Xã Đăk Hà, Xã Tu Mơ Rông"],
    },
    {
      columns: [
        "Quảng Ngãi",
        "Tư Nghĩa",
        "Thị trấn La Hà, Xã Nghĩa Trung, Xã Nghĩa Thương, Xã Nghĩa Hòa",
      ],
    },
    {
      columns: [
        "Quảng Ngãi",
        "Vạn Tường",
        "Xã Bình Thuận, Xã Bình Đông, Xã Bình Trị, Xã Bình Hải, Xã Bình Hòa, Xã Bình Phước",
      ],
    },
    {
      columns: ["Quảng Ngãi", "Vệ Giang", "Thị trấn Sông Vệ, Xã Nghĩa Hiệp, Xã Nghĩa Phương"],
    },
    {
      columns: ["Quảng Ngãi", "Xốp", "Xã Đăk Choong, Xã Xốp"],
    },
    {
      columns: ["Quảng Ngãi", "Ya Ly", "Xã Ya Xiêr, Xã Ya Tăng, Xã Ya Ly"],
    },
    {
      columns: [
        "Quảng Ninh",
        "An Sinh",
        "Phường Bình Dương, Xã An Sinh, Xã Việt Dân, Phường Đức Chính",
      ],
    },
    {
      columns: [
        "Quảng Ninh",
        "Ba Chẽ",
        "Thị trấn Ba Chẽ, Xã Thanh Sơn, Xã Nam Sơn, Xã Đồn Đạc, Xã Hải Lạng",
      ],
    },
    {
      columns: ["Quảng Ninh", "Bãi Cháy", "Phường Hùng Thắng, Phường Bãi Cháy"],
    },
    {
      columns: ["Quảng Ninh", "Bình Khê", "Phường Tràng An, Phường Bình Khê, Xã Tràng Lương"],
    },
    {
      columns: ["Quảng Ninh", "Bình Liêu", "Thị trấn Bình Liêu, Xã Húc Động, Xã Vô Ngại"],
    },
    {
      columns: ["Quảng Ninh", "Cái Chiên", "Không sáp nhập"],
    },
    {
      columns: ["Quảng Ninh", "Cao Xanh", "Phường Hà Khánh, Phường Cao Xanh"],
    },
    {
      columns: [
        "Quảng Ninh",
        "Cẩm Phả",
        "Phường Cẩm Trung, Phường Cẩm Thành, Phường Cẩm Bình, Phường Cẩm Tây, Phường Cẩm Đông",
      ],
    },
    {
      columns: ["Quảng Ninh", "Cô Tô", "Thị trấn Cô Tô, Xã Đồng Tiến, Xã Thanh Lân"],
    },
    {
      columns: [
        "Quảng Ninh",
        "Cửa Ông",
        "Phường Cẩm Phú, Phường Cẩm Thịnh, Phường Cẩm Sơn, Phường Cửa Ông",
      ],
    },
    {
      columns: [
        "Quảng Ninh",
        "Đầm Hà",
        "Thị trấn Đầm Hà, Xã Tân Bình, Xã Đại Bình, Xã Tân Lập, Xã Đầm Hà",
      ],
    },
    {
      columns: ["Quảng Ninh", "Điền Xá", "Xã Hà Lâu, Xã Điền Xá, Xã Yên Than"],
    },
    {
      columns: ["Quảng Ninh", "Đông Mai", "Phường Minh Thành, Phường Đông Mai"],
    },
    {
      columns: ["Quảng Ninh", "Đông Ngũ", "Xã Đông Hải, Xã Đại Dực, Xã Đông Ngũ"],
    },
    {
      columns: [
        "Quảng Ninh",
        "Đông Triều",
        "Phường Thủy An, Phường Hưng Đạo, Phường Hồng Phong, Xã Nguyễn Huệ, Phường Đức Chính",
      ],
    },
    {
      columns: ["Quảng Ninh", "Đường Hoa", "Xã Quảng Sơn, Xã Đường Hoa, Xã Quảng Long"],
    },
    {
      columns: ["Quảng Ninh", "Hà An", "Phường Tân An, Phường Hà An, Xã Hoàng Tân, Xã Liên Hòa"],
    },
    {
      columns: ["Quảng Ninh", "Hà Lầm", "Phường Cao Thắng, Phường Hà Trung, Phường Hà Lầm"],
    },
    {
      columns: ["Quảng Ninh", "Hạ Long", "Phường Hồng Hà, Phường Hồng Hải"],
    },
    {
      columns: ["Quảng Ninh", "Hà Tu", "Phường Hà Phong, Phường Hà Tu"],
    },
    {
      columns: ["Quảng Ninh", "Hải Hòa", "-, Xã Hải Lạng, Xã Hải Hòa"],
    },
    {
      columns: ["Quảng Ninh", "Hải Lạng", "Xã Đồng Rui, Xã Hải Lạng, Xã Hải Hòa"],
    },
    {
      columns: ["Quảng Ninh", "Hải Ninh", "Xã Quảng Nghĩa, Xã Hải Tiến"],
    },
    {
      columns: ["Quảng Ninh", "Hải Sơn", "Xã Bắc Sơn, Xã Hải Sơn"],
    },
    {
      columns: ["Quảng Ninh", "Hiệp Hòa", "Phường Cộng Hòa, Xã Sông Khoai, Xã Hiệp Hòa"],
    },
    {
      columns: [
        "Quảng Ninh",
        "Hoàng Quế",
        "Phường Yên Đức, Phường Hoàng Quế, Xã Hồng Thái Tây, Xã Hồng Thái Đông",
      ],
    },
    {
      columns: ["Quảng Ninh", "Hoành Bồ", "Phường Hoành Bồ, Xã Sơn Dương, Xã Lê Lợi, Xã Đồng Lâm"],
    },
    {
      columns: ["Quảng Ninh", "Hoành Mô", "Xã Đồng Văn, Xã Hoành Mô"],
    },
    {
      columns: [
        "Quảng Ninh",
        "Hồng Gai",
        "Phường Bạch Đằng, Phường Trần Hưng Đạo, Phường Hồng Gai",
      ],
    },
    {
      columns: ["Quảng Ninh", "Kỳ Thượng", "Xã Thanh Lâm, Xã Đạp Thanh, Xã Kỳ Thượng"],
    },
    {
      columns: [
        "Quảng Ninh",
        "Liên Hòa",
        "Phường Phong Hải, Xã Liên Vị, Xã Tiền Phong, Xã Liên Hòa",
      ],
    },
    {
      columns: ["Quảng Ninh", "Lục Hồn", "Xã Đồng Tâm, Xã Lục Hồn"],
    },
    {
      columns: ["Quảng Ninh", "Lương Minh", "Xã Đồng Sơn, Xã Lương Minh"],
    },
    {
      columns: [
        "Quảng Ninh",
        "Mạo Khê",
        "Phường Xuân Sơn, Phường Kim Sơn, Phường Yên Thọ, Phường Mạo Khê",
      ],
    },
    {
      columns: [
        "Quảng Ninh",
        "Móng Cái 1",
        "Phường Trần Phú, Phường Hải Hòa, Phường Bình Ngọc, Phường Trà Cổ, Xã Hải Xuân",
      ],
    },
    {
      columns: ["Quảng Ninh", "Móng Cái 2", "Phường Ninh Dương, Phường Ka Long, Xã Vạn Ninh"],
    },
    {
      columns: ["Quảng Ninh", "Móng Cái 3", "Phường Hải Yên, Xã Hải Đông"],
    },
    {
      columns: ["Quảng Ninh", "Mông Dương", "Phường Mông Dương, Xã Dương Huy"],
    },
    {
      columns: [
        "Quảng Ninh",
        "Phong Cốc",
        "Phường Nam Hòa, Phường Yên Hải, Phường Phong Cốc, Xã Cẩm La",
      ],
    },
    {
      columns: ["Quảng Ninh", "Quảng Đức", "Xã Quảng Thành, Xã Quảng Thịnh, Xã Quảng Đức"],
    },
    {
      columns: [
        "Quảng Ninh",
        "Quảng Hà",
        "Thị trấn Quảng Hà, Xã Quảng Minh, Xã Quảng Chính, Xã Quảng Phong, Xã Quảng Long",
      ],
    },
    {
      columns: ["Quảng Ninh", "Quang Hanh", "Phường Cẩm Thạch, Phường Cẩm Thủy, Phường Quang Hanh"],
    },
    {
      columns: ["Quảng Ninh", "Quảng La", "Xã Bằng Cả, Xã Dân Chủ, Xã Tân Dân, Xã Quảng La"],
    },
    {
      columns: ["Quảng Ninh", "Quảng Tân", "Xã Quảng An, Xã Dực Yên, Xã Quảng Lâm, Xã Quảng Tân"],
    },
    {
      columns: ["Quảng Ninh", "Quảng Yên", "Phường Yên Giang, Phường Quảng Yên, Xã Tiền An"],
    },
    {
      columns: ["Quảng Ninh", "Thống Nhất", "Xã Vũ Oai, Xã Hòa Bình, Xã Thống Nhất, Xã Đồng Lâm"],
    },
    {
      columns: [
        "Quảng Ninh",
        "Tiên Yên",
        "Thị trấn Tiên Yên, Xã Phong Dụ, Xã Tiên Lãng, Xã Yên Than, Xã Đại Dực, Xã Đông Ngũ, Xã Vô Ngại",
      ],
    },
    {
      columns: ["Quảng Ninh", "Tuần Châu", "Phường Đại Yên, Phường Tuần Châu, Phường Hà Khẩu"],
    },
    {
      columns: [
        "Quảng Ninh",
        "Uông Bí",
        "Phường Quang Trung, Phường Thanh Sơn, Phường Yên Thanh, Phường Trưng Vương",
      ],
    },
    {
      columns: [
        "Quảng Ninh",
        "Vàng Danh",
        "Phường Bắc Sơn, Phường Nam Khê, Phường Vàng Danh, Phường Trưng Vương",
      ],
    },
    {
      columns: [
        "Quảng Ninh",
        "Vân Đồn",
        "Thị trấn Cái Rồng, Xã Bản Sen, Xã Bình Dân, Xã Đài Xuyên, Xã Đoàn Kết, Xã Đông Xá, Xã Hạ Long, Xã Minh Châu, Xã Ngọc Vừng, Xã Quan Lạn, Xã Thắng Lợi, Xã Vạn Yên",
      ],
    },
    {
      columns: ["Quảng Ninh", "Việt Hưng", "Phường Giếng Đáy, Phường Việt Hưng, Phường Hà Khẩu"],
    },
    {
      columns: ["Quảng Ninh", "Vĩnh Thực", "Xã Vĩnh Trung, Xã Vĩnh Thực"],
    },
    {
      columns: [
        "Quảng Ninh",
        "Yên Tử",
        "Phường Phương Đông, Phường Phương Nam, Xã Thượng Yên Công",
      ],
    },
    {
      columns: ["Quảng Trị", "A Dơi", "Xã Ba Tầng, Xã Xy, Xã A Dơi"],
    },
    {
      columns: ["Quảng Trị", "Ái Tử", "Xã Triệu Ái, Xã Triệu Giang, Xã Triệu Long"],
    },
    {
      columns: [
        "Quảng Trị",
        "Ba Đồn",
        "Phường Quảng Phong, Phường Quảng Long, Phường Ba Đồn, Xã Quảng Hải",
      ],
    },
    {
      columns: ["Quảng Trị", "Ba Lòng", "Xã Triệu Nguyên, Xã Ba Lòng"],
    },
    {
      columns: [
        "Quảng Trị",
        "Bắc Gianh",
        "Phường Quảng Phúc, Phường Quảng Thọ, Phường Quảng Thuận",
      ],
    },
    {
      columns: ["Quảng Trị", "Bắc Trạch", "Xã Thanh Trạch, Xã Hạ Mỹ, Xã Liên Trạch, Xã Bắc Trạch"],
    },
    {
      columns: ["Quảng Trị", "Bến Hải", "Xã Trung Hải, Xã Trung Giang, Xã Trung Sơn"],
    },
    {
      columns: ["Quảng Trị", "Bến Quan", "Thị trấn Bến Quan, Xã Vĩnh Ô, Xã Vĩnh Hà, Xã Vĩnh Khê"],
    },
    {
      columns: ["Quảng Trị", "Bố Trạch", "Xã Hưng Trạch, Xã Cự Nẫm, Xã Vạn Trạch, Xã Phú Định"],
    },
    {
      columns: [
        "Quảng Trị",
        "Cam Hồng",
        "Xã Cam Thủy (huyện Lệ Thủy), Xã Thanh Thủy, Xã Hồng Thủy, Xã Ngư Thủy Bắc",
      ],
    },
    {
      columns: ["Quảng Trị", "Cam Lộ", "Thị trấn Cam Lộ, Xã Cam Thành, Xã Cam Chính, Xã Cam Nghĩa"],
    },
    {
      columns: ["Quảng Trị", "Cồn Cỏ", "Huyện Cồn Cỏ"],
    },
    {
      columns: ["Quảng Trị", "Cồn Tiên", "Xã Hải Thái, Xã Linh Trường, Xã Gio An, Xã Gio Sơn"],
    },
    {
      columns: [
        "Quảng Trị",
        "Cửa Tùng",
        "Thị trấn Cửa Tùng, Xã Vĩnh Giang, Xã Hiền Thành, Xã Kim Thạch",
      ],
    },
    {
      columns: ["Quảng Trị", "Cửa Việt", "Thị trấn Cửa Việt, Xã Gio Mai, Xã Gio Hải"],
    },
    {
      columns: ["Quảng Trị", "Dân Hóa", "Xã Trọng Hóa, Xã Dân Hóa"],
    },
    {
      columns: ["Quảng Trị", "Diên Sanh", "Thị trấn Diên Sanh, Xã Hải Trường, Xã Hải Định"],
    },
    {
      columns: ["Quảng Trị", "Đakrông", "Xã Ba Nang, Xã Tà Long, Xã Đakrông"],
    },
    {
      columns: [
        "Quảng Trị",
        "Đông Hà",
        "Phường 1 (thành phố Đông Hà), Phường 3 (thành phố Đông Hà), Phường 4, Phường Đông Giang, Phường Đông Thanh",
      ],
    },
    {
      columns: [
        "Quảng Trị",
        "Đồng Hới",
        "Phường Đức Ninh Đông, Phường Đồng Hải, Phường Đồng Phú, Phường Phú Hải, Phường Hải Thành, Phường Nam Lý, Xã Bảo Ninh, Xã Đức Ninh",
      ],
    },
    {
      columns: [
        "Quảng Trị",
        "Đồng Lê",
        "Thị trấn Đồng Lê, Xã Kim Hóa, Xã Lê Hóa, Xã Thuận Hóa, Xã Sơn Hóa",
      ],
    },
    {
      columns: [
        "Quảng Trị",
        "Đồng Sơn",
        "Phường Bắc Nghĩa, Phường Đồng Sơn, Xã Nghĩa Ninh, Xã Thuận Đức",
      ],
    },
    {
      columns: ["Quảng Trị", "Đồng Thuận", "Phường Bắc Lý, Xã Lộc Ninh, Xã Quang Phú"],
    },
    {
      columns: [
        "Quảng Trị",
        "Đông Trạch",
        "Xã Hải Phú (huyện Bố Trạch), Xã Sơn Lộc, Xã Đức Trạch, Xã Đồng Trạch",
      ],
    },
    {
      columns: [
        "Quảng Trị",
        "Gio Linh",
        "Thị trấn Gio Linh, Xã Gio Quang, Xã Gio Mỹ, Xã Phong Bình",
      ],
    },
    {
      columns: ["Quảng Trị", "Hải Lăng", "Xã Hải Phú (huyện Hải Lăng), Xã Hải Lâm, Xã Hải Thượng"],
    },
    {
      columns: [
        "Quảng Trị",
        "Hiếu Giang",
        "Xã Cam Thủy (huyện Cam Lộ), Xã Cam Hiếu, Xã Cam Tuyền, Xã Thanh An",
      ],
    },
    {
      columns: ["Quảng Trị", "Hòa Trạch", "Xã Quảng Châu, Xã Quảng Tùng, Xã Cảnh Dương"],
    },
    {
      columns: [
        "Quảng Trị",
        "Hoàn Lão",
        "Thị trấn Hoàn Lão, Xã Trung Trạch, Xã Đại Trạch, Xã Tây Trạch, Xã Hòa Trạch",
      ],
    },
    {
      columns: ["Quảng Trị", "Hướng Hiệp", "Thị trấn Krông Klang, Xã Mò Ó, Xã Hướng Hiệp"],
    },
    {
      columns: ["Quảng Trị", "Hướng Lập", "Xã Hướng Việt, Xã Hướng Lập"],
    },
    {
      columns: ["Quảng Trị", "Hướng Phùng", "Xã Hướng Sơn, Xã Hướng Linh, Xã Hướng Phùng"],
    },
    {
      columns: ["Quảng Trị", "Khe Sanh", "Thị trấn Khe Sanh, Xã Tân Hợp, Xã Húc, Xã Hướng Tân"],
    },
    {
      columns: ["Quảng Trị", "Kim Điền", "Xã Hóa Sơn, Xã Hóa Hợp"],
    },
    {
      columns: ["Quảng Trị", "Kim Ngân", "Xã Kim Thủy, Xã Ngân Thủy, Xã Lâm Thủy"],
    },
    {
      columns: ["Quảng Trị", "Kim Phú", "Xã Thượng Hóa, Xã Trung Hóa, Xã Minh Hóa, Xã Tân Hóa"],
    },
    {
      columns: ["Quảng Trị", "La Lay", "Xã A Bung, Xã A Ngo"],
    },
    {
      columns: [
        "Quảng Trị",
        "Lao Bảo",
        "Xã Tân Thành (huyện Hướng Hóa), Xã Tân Long, Thị trấn Lao Bảo",
      ],
    },
    {
      columns: ["Quảng Trị", "Lệ Ninh", "Thị trấn Nông trường Lệ Ninh, Xã Sơn Thủy, Xã Hoa Thủy"],
    },
    {
      columns: [
        "Quảng Trị",
        "Lệ Thủy",
        "Thị trấn Kiến Giang, Xã Liên Thủy, Xã Xuân Thủy, Xã An Thủy, Xã Phong Thủy, Xã Lộc Thủy",
      ],
    },
    {
      columns: ["Quảng Trị", "Lìa", "Xã Thanh, Xã Thuận, Xã Lìa"],
    },
    {
      columns: ["Quảng Trị", "Minh Hóa", "Thị trấn Quy Đạt, Xã Xuân Hóa, Xã Yên Hóa, Xã Hồng Hóa"],
    },
    {
      columns: ["Quảng Trị", "Mỹ Thủy", "Xã Hải Dương, Xã Hải An, Xã Hải Khê"],
    },
    {
      columns: [
        "Quảng Trị",
        "Nam Ba Đồn",
        "Xã Quảng Tân, Xã Quảng Trung, Xã Quảng Tiên, Xã Quảng Sơn, Xã Quảng Thủy",
      ],
    },
    {
      columns: ["Quảng Trị", "Nam Cửa Việt", "Xã Triệu Trạch, Xã Triệu Phước, Xã Triệu Tân"],
    },
    {
      columns: [
        "Quảng Trị",
        "Nam Đông Hà",
        "Phường 2 (thành phố Đông Hà), Phường 5, Phường Đông Lễ, Phường Đông Lương",
      ],
    },
    {
      columns: [
        "Quảng Trị",
        "Nam Gianh",
        "Xã Quảng Hòa, Xã Quảng Lộc, Xã Quảng Văn, Xã Quảng Minh",
      ],
    },
    {
      columns: ["Quảng Trị", "Nam Hải Lăng", "Xã Hải Sơn, Xã Hải Phong, Xã Hải Chánh"],
    },
    {
      columns: [
        "Quảng Trị",
        "Nam Trạch",
        "Thị trấn Nông trường Việt Trung, Xã Nhân Trạch, Xã Lý Nam",
      ],
    },
    {
      columns: ["Quảng Trị", "Ninh Châu", "Xã Tân Ninh, Xã Gia Ninh, Xã Duy Ninh, Xã Hải Ninh"],
    },
    {
      columns: [
        "Quảng Trị",
        "Phong Nha",
        "Thị trấn Phong Nha, Xã Lâm Trạch, Xã Xuân Trạch, Xã Phúc Trạch",
      ],
    },
    {
      columns: [
        "Quảng Trị",
        "Phú Trạch",
        "Xã Quảng Đông, Xã Quảng Phú, Xã Quảng Kim, Xã Quảng Hợp",
      ],
    },
    {
      columns: [
        "Quảng Trị",
        "Quảng Ninh",
        "Thị trấn Quán Hàu, Xã Vĩnh Ninh, Xã Võ Ninh, Xã Hàm Ninh",
      ],
    },
    {
      columns: ["Quảng Trị", "Quảng Trạch", "Xã Quảng Phương, Xã Quảng Xuân, Xã Quảng Hưng"],
    },
    {
      columns: [
        "Quảng Trị",
        "Quảng Trị",
        "Phường 1, Phường 2, Phường 3 (thị xã Quảng Trị), Phường An Đôn, Xã Hải Lệ",
      ],
    },
    {
      columns: ["Quảng Trị", "Sen Ngư", "Xã Hưng Thủy, Xã Sen Thủy, Xã Ngư Thủy"],
    },
    {
      columns: ["Quảng Trị", "Tà Rụt", "Xã A Vao, Xã Húc Nghì, Xã Tà Rụt"],
    },
    {
      columns: ["Quảng Trị", "Tân Gianh", "Xã Phù Cảnh, Xã Liên Trường, Xã Quảng Thanh"],
    },
    {
      columns: ["Quảng Trị", "Tân Lập", "Xã Tân Liên, Xã Hướng Lộc, Xã Tân Lập"],
    },
    {
      columns: ["Quảng Trị", "Tân Mỹ", "Xã Tân Thủy, Xã Dương Thủy, Xã Mỹ Thủy, Xã Thái Thủy"],
    },
    {
      columns: ["Quảng Trị", "Tân Thành", "Không sáp nhập"],
    },
    {
      columns: ["Quảng Trị", "Thượng Trạch", "Xã Tân Trạch, Xã Thượng Trạch"],
    },
    {
      columns: [
        "Quảng Trị",
        "Triệu Bình",
        "Xã Triệu Độ, Xã Triệu Thuận, Xã Triệu Hòa, Xã Triệu Đại",
      ],
    },
    {
      columns: ["Quảng Trị", "Triệu Cơ", "Xã Triệu Trung, Xã Triệu Tài, Xã Triệu Cơ"],
    },
    {
      columns: ["Quảng Trị", "Triệu Phong", "Thị trấn Ái Tử, Xã Triệu Thành, Xã Triệu Thượng"],
    },
    {
      columns: ["Quảng Trị", "Trung Thuần", "Xã Quảng Lưu, Xã Quảng Thạch, Xã Quảng Tiến"],
    },
    {
      columns: ["Quảng Trị", "Trường Ninh", "Xã Vạn Ninh, Xã An Ninh, Xã Xuân Ninh, Xã Hiền Ninh"],
    },
    {
      columns: ["Quảng Trị", "Trường Phú", "Xã Trường Thủy, Xã Mai Thủy, Xã Phú Thủy"],
    },
    {
      columns: ["Quảng Trị", "Trường Sơn", "Xã Trường Xuân, Xã Trường Sơn"],
    },
    {
      columns: ["Quảng Trị", "Tuyên Bình", "Xã Phong Hóa, Xã Ngư Hóa, Xã Mai Hóa"],
    },
    {
      columns: ["Quảng Trị", "Tuyên Hóa", "Xã Tiến Hóa, Xã Châu Hóa, Xã Cao Quảng, Xã Văn Hóa"],
    },
    {
      columns: ["Quảng Trị", "Tuyên Lâm", "Xã Lâm Hóa, Xã Thanh Hóa"],
    },
    {
      columns: ["Quảng Trị", "Tuyên Phú", "Xã Đồng Hóa, Xã Thạch Hóa, Xã Đức Hóa"],
    },
    {
      columns: ["Quảng Trị", "Tuyên Sơn", "Xã Thanh Thạch, Xã Hương Hóa"],
    },
    {
      columns: ["Quảng Trị", "Vĩnh Định", "Xã Hải Quy, Xã Hải Hưng, Xã Hải Bình"],
    },
    {
      columns: ["Quảng Trị", "Vĩnh Hoàng", "Xã Vĩnh Thái, Xã Trung Nam, Xã Vĩnh Hòa, Xã Vĩnh Tú"],
    },
    {
      columns: ["Quảng Trị", "Vĩnh Linh", "Thị trấn Hồ Xá, Xã Vĩnh Long, Xã Vĩnh Chấp"],
    },
    {
      columns: ["Quảng Trị", "Vĩnh Thủy", "Xã Vĩnh Lâm, Xã Vĩnh Sơn, Xã Vĩnh Thủy"],
    },
    {
      columns: ["Sơn La", "Bắc Yên", "Thị trấn Bắc Yên, Xã Phiêng Ban, Xã Hồng Ngài, Xã Song Pe"],
    },
    {
      columns: ["Sơn La", "Bình Thuận", "Xã Phổng Lái, Xã Chiềng Pha"],
    },
    {
      columns: ["Sơn La", "Bó Sinh", "Xã Pú Bẩu, Xã Chiềng En, Xã Bó Sinh"],
    },
    {
      columns: ["Sơn La", "Chiềng An", "Phường Chiềng An, Xã Chiềng Xôm, Xã Chiềng Đen"],
    },
    {
      columns: ["Sơn La", "Chiềng Cơi", "Phường Chiềng Cơi, Xã Hua La, Xã Chiềng Cọ"],
    },
    {
      columns: ["Sơn La", "Chiềng Hặc", "Xã Tú Nang, Xã Mường Lựm, Xã Chiềng Hặc"],
    },
    {
      columns: ["Sơn La", "Chiềng Hoa", "Xã Chiềng Ân, Xã Chiềng Công, Xã Chiềng Hoa"],
    },
    {
      columns: ["Sơn La", "Chiềng Khoong", "Xã Mường Cai, Xã Chiềng Khoong"],
    },
    {
      columns: ["Sơn La", "Chiềng Khương", "Xã Mường Sai, Xã Chiềng Khương"],
    },
    {
      columns: ["Sơn La", "Chiềng La", "Xã Chiềng Ngàm, Xã Nong Lay, Xã Tông Cọ, Xã Chiềng La"],
    },
    {
      columns: ["Sơn La", "Chiềng Lao", "Xã Nậm Giôn, Xã Hua Trai, Xã Chiềng Lao"],
    },
    {
      columns: [
        "Sơn La",
        "Chiềng Mai",
        "Xã Chiềng Ban, Xã Chiềng Kheo, Xã Chiềng Dong, Xã Chiềng Ve, Xã Chiềng Mai",
      ],
    },
    {
      columns: ["Sơn La", "Chiềng Mung", "Xã Mường Bằng, Xã Mường Bon, Xã Chiềng Mung"],
    },
    {
      columns: ["Sơn La", "Chiềng Sại", "Xã Phiêng Côn, Xã Chiềng Sại"],
    },
    {
      columns: ["Sơn La", "Chiềng Sinh", "Phường Chiềng Sinh, Xã Chiềng Ngần"],
    },
    {
      columns: ["Sơn La", "Chiềng Sơ", "Xã Yên Hưng, Xã Chiềng Sơ"],
    },
    {
      columns: ["Sơn La", "Chiềng Sơn", "Xã Chiềng Xuân, Xã Chiềng Sơn"],
    },
    {
      columns: ["Sơn La", "Chiềng Sung", "Xã Chiềng Chăn, Xã Chiềng Sung"],
    },
    {
      columns: ["Sơn La", "Co Mạ", "Xã Co Tòng, Xã Pá Lông, Xã Co Mạ"],
    },
    {
      columns: ["Sơn La", "Đoàn Kết", "Xã Chiềng Chung (thị xã Mộc Châu), Xã Đoàn Kết"],
    },
    {
      columns: ["Sơn La", "Gia Phù", "Xã Tường Phù, Xã Suối Bau, Xã Sập Xa, Xã Gia Phù"],
    },
    {
      columns: ["Sơn La", "Huổi Một", "Xã Nậm Mằn, Xã Huổi Một"],
    },
    {
      columns: ["Sơn La", "Kim Bon", "Xã Đá Đỏ, Xã Kim Bon"],
    },
    {
      columns: ["Sơn La", "Long Hẹ", "Xã É Tòng, Xã Long Hẹ"],
    },
    {
      columns: ["Sơn La", "Lóng Phiêng", "Xã Chiềng Tương, Xã Lóng Phiêng"],
    },
    {
      columns: ["Sơn La", "Lóng Sập", "Xã Chiềng Khừa, Xã Lóng Sập"],
    },
    {
      columns: ["Sơn La", "Mai Sơn", "Thị trấn Hát Lót, Xã Hát Lót, Xã Cò Nòi"],
    },
    {
      columns: ["Sơn La", "Mộc Châu", "Phường Mộc Lỵ, Phường Mường Sang, Xã Chiềng Hắc"],
    },
    {
      columns: ["Sơn La", "Mộc Sơn", "Phường Đông Sang, Phường Mộc Sơn"],
    },
    {
      columns: ["Sơn La", "Muổi Nọi", "Xã Bản Lầm, Xã Bon Phặng, Xã Muổi Nọi"],
    },
    {
      columns: ["Sơn La", "Mường Bám", "Không sáp nhập"],
    },
    {
      columns: ["Sơn La", "Mường Bang", "Xã Mường Do, Xã Mường Lang, Xã Mường Bang"],
    },
    {
      columns: ["Sơn La", "Mường Bú", "Xã Mường Chùm, Xã Tạ Bú, Xã Mường Bú"],
    },
    {
      columns: ["Sơn La", "Mường Chanh", "Xã Chiềng Chung (huyện Mai Sơn), Xã Mường Chanh"],
    },
    {
      columns: ["Sơn La", "Mường Chiên", "Xã Chiềng Khay, Xã Cà Nàng, Xã Mường Chiên"],
    },
    {
      columns: ["Sơn La", "Mường Cơi", "Xã Mường Thải, Xã Tân Lang, Xã Mường Cơi"],
    },
    {
      columns: ["Sơn La", "Mường É", "Xã Phổng Lập, Xã Mường É"],
    },
    {
      columns: ["Sơn La", "Mường Giôn", "Xã Pá Ma Pha Khinh, Xã Mường Giôn"],
    },
    {
      columns: ["Sơn La", "Mường Hung", "Xã Chiềng Cang, Xã Mường Hung"],
    },
    {
      columns: ["Sơn La", "Mường Khiêng", "Xã Liệp Tè, Xã Bó Mười, Xã Mường Khiêng"],
    },
    {
      columns: [
        "Sơn La",
        "Mường La",
        "Thị trấn Ít Ong, Xã Nặm Păm, Xã Chiềng San, Xã Chiềng Muôn, Xã Mường Trai, Xã Pi Toong",
      ],
    },
    {
      columns: ["Sơn La", "Mường Lạn", "Không sáp nhập"],
    },
    {
      columns: ["Sơn La", "Mường Lầm", "Xã Đứa Mòn, Xã Mường Lầm"],
    },
    {
      columns: ["Sơn La", "Mường Lèo", "Không sáp nhập"],
    },
    {
      columns: ["Sơn La", "Mường Sại", "Xã Nặm Ét, Xã Mường Sại"],
    },
    {
      columns: ["Sơn La", "Nậm Lầu", "Xã Chiềng Bôm, Xã Púng Tra, Xã Nậm Lầu"],
    },
    {
      columns: ["Sơn La", "Nậm Ty", "Xã Chiềng Phung, Xã Nậm Ty"],
    },
    {
      columns: ["Sơn La", "Ngọc Chiến", "Không sáp nhập"],
    },
    {
      columns: ["Sơn La", "Pắc Ngà", "Xã Chim Vàn, Xã Pắc Ngà"],
    },
    {
      columns: ["Sơn La", "Phiêng Cằm", "Xã Chiềng Nơi, Xã Phiêng Cằm"],
    },
    {
      columns: ["Sơn La", "Phiêng Khoài", "Không sáp nhập"],
    },
    {
      columns: ["Sơn La", "Phiêng Pằn", "Xã Nà Ớt, Xã Chiềng Lương, Xã Phiêng Pằn"],
    },
    {
      columns: [
        "Sơn La",
        "Phù Yên",
        "Thị trấn Quang Huy, Xã Huy Hạ, Xã Huy Tường, Xã Huy Tân, Xã Huy Thượng",
      ],
    },
    {
      columns: ["Sơn La", "Púng Bánh", "Xã Dồm Cang, Xã Sam Kha, Xã Púng Bánh"],
    },
    {
      columns: [
        "Sơn La",
        "Quỳnh Nhai",
        "Thị trấn Mường Giàng, Xã Chiềng Bằng, Xã Chiềng Khoang, Xã Chiềng Ơn",
      ],
    },
    {
      columns: ["Sơn La", "Song Khủa", "Xã Mường Tè, Xã Liên Hòa, Xã Quang Minh, Xã Song Khủa"],
    },
    {
      columns: ["Sơn La", "Sông Mã", "Thị trấn Sông Mã, Xã Nà Nghịu"],
    },
    {
      columns: ["Sơn La", "Sốp Cộp", "Xã Mường Và, Xã Nậm Lạnh, Xã Sốp Cộp"],
    },
    {
      columns: ["Sơn La", "Suối Tọ", "Không sáp nhập"],
    },
    {
      columns: ["Sơn La", "Tà Hộc", "Xã Nà Bó, Xã Tà Hộc"],
    },
    {
      columns: ["Sơn La", "Tạ Khoa", "Xã Mường Khoa, Xã Hua Nhàn, Xã Tạ Khoa"],
    },
    {
      columns: ["Sơn La", "Tà Xùa", "Xã Làng Chếu, Xã Háng Đồng, Xã Tà Xùa"],
    },
    {
      columns: ["Sơn La", "Tân Phong", "Xã Bắc Phong, Xã Nam Phong, Xã Tân Phong"],
    },
    {
      columns: ["Sơn La", "Tân Yên", "Không sáp nhập"],
    },
    {
      columns: ["Sơn La", "Thảo Nguyên", "Phường Cờ Đỏ, Phường Thảo Ngu yên"],
    },
    {
      columns: [
        "Sơn La",
        "Thuận Châu",
        "Thị trấn Thuận Châu, Xã Phổng Ly, Xã Thôm Mòn, Xã Tông Lạnh, Xã Chiềng Pấc",
      ],
    },
    {
      columns: [
        "Sơn La",
        "Tô Hiệu",
        "Phường Quyết Thắng, Phường Quyết Tâm, Phường Chiềng Lề, Phường Tô Hiệu",
      ],
    },
    {
      columns: ["Sơn La", "Tô Múa", "Xã Chiềng Khoa, Xã Suối Bàng, Xã Tô Múa"],
    },
    {
      columns: [
        "Sơn La",
        "Tường Hạ",
        "Xã Tường Thượng, Xã Tường Phong, Xã Tường Tiến, Xã Tường Hạ",
      ],
    },
    {
      columns: ["Sơn La", "Vân Hồ", "Xã Lóng Luông, Xã Chiềng Yên, Xã Mường Men, Xã Vân Hồ"],
    },
    {
      columns: ["Sơn La", "Vân Sơn", "Phường Bình Minh, Phường Vân Sơn"],
    },
    {
      columns: ["Sơn La", "Xím Vàng", "Xã Hang Chú, Xã Xí m Vàng"],
    },
    {
      columns: ["Sơn La", "Xuân Nha", "Xã Tân Xuân, Xã Xuân Nha"],
    },
    {
      columns: [
        "Sơn La",
        "Yên Châu",
        "Thị trấn Yên Châu, Xã Chiềng Đông, Xã Chiềng Sàng, Xã Chiềng Pằn, Xã Chiềng Khoi, Xã Sặp Vạt",
      ],
    },
    {
      columns: ["Sơn La", "Yên Sơn", "Xã Chiềng On, Xã Yên Sơn"],
    },
    {
      columns: ["Tây Ninh", "An Lục Long", "Xã Dương Xuân Hội, Xã Long Trì, Xã An Lục Long"],
    },
    {
      columns: ["Tây Ninh", "An Ninh", "Xã Lộc Giang, Xã An Ninh Đông, Xã An Ninh Tây"],
    },
    {
      columns: ["Tây Ninh", "An Tịnh", "Phường Lộc Hưng, Phường An Tịnh"],
    },
    {
      columns: [
        "Tây Ninh",
        "Bến Cầu",
        "Thị trấn Bến Cầu, Xã An Thạnh (huyện Bến Cầu), Xã Tiên Thuận, Xã Lợi Thuận",
      ],
    },
    {
      columns: [
        "Tây Ninh",
        "Bến Lức",
        "Xã An Thạnh (huyện Bến Lức), Xã Thanh Phú, Thị trấn Bến Lức",
      ],
    },
    {
      columns: ["Tây Ninh", "Bình Đức", "Xã Thạnh Đức (huyện Bến Lức), Xã Nhựt Chánh, Xã Bình Đức"],
    },
    {
      columns: [
        "Tây Ninh",
        "Bình Hiệp",
        "Xã Thạnh Trị, Xã Bình Tân, Xã Bình Hòa Tây, Xã Bình Hiệp",
      ],
    },
    {
      columns: [
        "Tây Ninh",
        "Bình Hòa",
        "Xã Bình Thạnh (huyện Mộc Hóa), Xã Bình Hòa Đông, Xã Bình Hòa Trung",
      ],
    },
    {
      columns: [
        "Tây Ninh",
        "Bình Minh",
        "Phường Ninh Sơn, Xã Tân Bình (thành phố Tây Ninh), Xã Bình Minh, Xã Thạnh Tân, Xã Suối Đá, Xã Phan",
      ],
    },
    {
      columns: [
        "Tây Ninh",
        "Bình Thành",
        "Xã Tân Hiệp (huyện Thạnh Hóa), Xã Thuận Bình, Xã Bình Hòa Hưng",
      ],
    },
    {
      columns: ["Tây Ninh", "Cần Đước", "Thị trấn Cần Đước, Xã Phước Tuy, Xã Tân Ân, Xã Tân Chánh"],
    },
    {
      columns: ["Tây Ninh", "Cần Giuộc", "Thị trấn Cần Giuộc, Xã Phước Lại, Xã Long Hậu"],
    },
    {
      columns: ["Tây Ninh", "Cầu Khởi", "Xã Phước Ninh, Xã Cầu Khởi, Xã Chà Là"],
    },
    {
      columns: [
        "Tây Ninh",
        "Châu Thành",
        "Thị trấn Châu Thành, Xã Đồng Khởi, Xã An Bình, Xã Thái Bình",
      ],
    },
    {
      columns: [
        "Tây Ninh",
        "Dương Minh Châu",
        "Thị trấn Dương Minh Châu, Xã Phan, Xã Suối Đá, Xã Phước Minh",
      ],
    },
    {
      columns: [
        "Tây Ninh",
        "Đông Thành",
        "Thị trấn Đông Thành, Xã Mỹ Thạnh Tây, Xã Mỹ Thạnh Đông, Xã Mỹ Bình",
      ],
    },
    {
      columns: ["Tây Ninh", "Đức Hòa", "Thị trấn Đức Hòa, Xã Hựu Thạnh, Xã Đức Hòa Hạ"],
    },
    {
      columns: ["Tây Ninh", "Đức Huệ", "Xã Bình Hòa Bắc, Xã Bình Hòa Nam, Xã Bình Thành"],
    },
    {
      columns: ["Tây Ninh", "Đức Lập", "Xã Đức Lập Hạ, Xã Mỹ Hạnh Bắc, Xã Đức Hòa Thượng"],
    },
    {
      columns: ["Tây Ninh", "Gia Lộc", "Xã Phước Đông (huyện Gò Dầu), Phường Gia Lộc"],
    },
    {
      columns: ["Tây Ninh", "Gò Dầu", "Phường Gia Bình, Thị trấn Gò Dầu, Xã Thanh Phước"],
    },
    {
      columns: ["Tây Ninh", "Hảo Đước", "Xã An Cơ, Xã Trí Bình, Xã Hảo Đước"],
    },
    {
      columns: ["Tây Ninh", "Hậu Nghĩa", "Thị trấn Hậu Nghĩa, Xã Đức Lập Thượng, Xã Tân Mỹ"],
    },
    {
      columns: ["Tây Ninh", "Hậu Thạnh", "Xã Hậu Thạnh Đông, Xã Hậu Thạnh Tây, Xã Bắc Hòa"],
    },
    {
      columns: [
        "Tây Ninh",
        "Hiệp Hòa",
        "Xã Tân Phú (huyện Đức Hòa), Xã Hiệp Hòa, Thị trấn Hiệp Hòa",
      ],
    },
    {
      columns: ["Tây Ninh", "Hòa Hội", "Xã Biên Giới, Xã Hòa Thạnh, Xã Hòa Hội"],
    },
    {
      columns: ["Tây Ninh", "Hòa Khánh", "Xã Hòa Khánh Tây, Xã Hòa Khánh Nam, Xã Hòa Khánh Đông"],
    },
    {
      columns: ["Tây Ninh", "Hòa Thành", "Phường Long Thành Trung, Xã Long Thành Nam"],
    },
    {
      columns: ["Tây Ninh", "Hưng Điền", "Xã Hưng Hà, Xã Hưng Điền B, Xã Hưng Điền"],
    },
    {
      columns: ["Tây Ninh", "Hưng Thuận", "Xã Đôn Thuận, Xã Hưng Thuận"],
    },
    {
      columns: ["Tây Ninh", "Khánh Hậu", "Phường Tân Khánh, Phường Khánh Hậu, Xã Lợi Bình Nhơn"],
    },
    {
      columns: [
        "Tây Ninh",
        "Khánh Hưng",
        "Xã Hưng Điền A, Xã Thái Bình Trung, Xã Vĩnh Trị, Xã Thái Trị, Xã Khánh Hưng",
      ],
    },
    {
      columns: ["Tây Ninh", "Kiến Tường", "Phường 1, Phường 2, Phường 3 (thị xã Kiến Tường)"],
    },
    {
      columns: [
        "Tây Ninh",
        "Long An",
        "Phường 1 (thành phố Tân An), Phường 3 (thành phố Tân An), Phường 4, Phường 5, Phường 6, Xã Hướng Thọ Phú, Xã Bình Thạnh (huyện Thủ Thừa)",
      ],
    },
    {
      columns: ["Tây Ninh", "Long Cang", "Xã Long Định, Xã Phước Vân, Xã Long Cang"],
    },
    {
      columns: ["Tây Ninh", "Long Chữ", "Xã Long Vĩnh, Xã Long Phước, Xã Long Chữ"],
    },
    {
      columns: [
        "Tây Ninh",
        "Long Hoa",
        "Phường Long Thành Bắc, Phường Long Hoa, Xã Trường Hòa, Xã Trường Tây, Xã Trường Đông",
      ],
    },
    {
      columns: ["Tây Ninh", "Long Hựu", "Xã Long Hựu Đông, Xã Long Hựu Tây"],
    },
    {
      columns: [
        "Tây Ninh",
        "Long Thuận",
        "Xã Long Thuận (huyện Bến Cầu), Xã Long Giang, Xã Long Khánh",
      ],
    },
    {
      columns: ["Tây Ninh", "Lộc Ninh", "Xã Bến Củi, Xã Lộc Ninh, Xã Phước Minh"],
    },
    {
      columns: ["Tây Ninh", "Lương Hòa", "Xã Tân Bửu, Xã Lương Hòa"],
    },
    {
      columns: [
        "Tây Ninh",
        "Mộc Hóa",
        "Xã Tân Thành, Xã Tân Lập (huyện Mộc Hóa), Thị trấn Bình Phong Thạnh",
      ],
    },
    {
      columns: ["Tây Ninh", "Mỹ An", "Xã Mỹ Phú, Xã Mỹ An"],
    },
    {
      columns: ["Tây Ninh", "Mỹ Hạnh", "Xã Đức Hòa Đông, Xã Mỹ Hạnh Nam, Xã Đức Hòa Thượng"],
    },
    {
      columns: ["Tây Ninh", "Mỹ Lệ", "Xã Tân Trạch, Xã Long Sơn, Xã Mỹ Lệ"],
    },
    {
      columns: ["Tây Ninh", "Mỹ Lộc", "Xã Phước Lâm, Xã Thuận Thành, Xã Mỹ Lộc"],
    },
    {
      columns: ["Tây Ninh", "Mỹ Quý", "Xã Mỹ Thạnh Bắc, Xã Mỹ Quý Đông, Xã Mỹ Quý Tây"],
    },
    {
      columns: [
        "Tây Ninh",
        "Mỹ Thạnh",
        "Xã Bình An, Xã Mỹ Lạc, Xã Mỹ Thạnh, Xã Tân Thành (huyện Thủ Thừa)",
      ],
    },
    {
      columns: ["Tây Ninh", "Mỹ Yên", "Xã Long Hiệp, Xã Phước Lợi, Xã Mỹ Yên"],
    },
    {
      columns: [
        "Tây Ninh",
        "Nhơn Hòa Lập",
        "Xã Tân Lập (huyện Tân Thạnh), Xã Nhơn Hòa, Xã Nhơn Hòa Lập",
      ],
    },
    {
      columns: [
        "Tây Ninh",
        "Nhơn Ninh",
        "Xã Tân Thành (huyện Tân Thạnh), Xã Tân Ninh, Xã Nhơn Ninh",
      ],
    },
    {
      columns: [
        "Tây Ninh",
        "Nhựt Tảo",
        "Xã Tân Bình (huyện Tân Trụ), Xã Quê Mỹ Thạnh, Xã Lạc Tấn, Xã Nhị Thành, Thủ Thừa",
      ],
    },
    {
      columns: ["Tây Ninh", "Ninh Điền", "Xã Thành Long, Xã Ninh Điền"],
    },
    {
      columns: ["Tây Ninh", "Ninh Thạnh", "Phường Ninh Thạnh, Xã Bàu Năng, Xã Chà Là"],
    },
    {
      columns: ["Tây Ninh", "Phước Chỉ", "Xã Phước Bình, Xã Phước Chỉ"],
    },
    {
      columns: ["Tây Ninh", "Phước Lý", "Xã Long Thượng, Xã Phước Hậu, Xã Phước Lý"],
    },
    {
      columns: [
        "Tây Ninh",
        "Phước Thạnh",
        "Xã Hiệp Thạnh (huyện Gò Dầu), Xã Phước Trạch, Xã Phước Thạnh",
      ],
    },
    {
      columns: ["Tây Ninh", "Phước Vinh", "Xã Hòa Hiệp, Xã Phước Vinh"],
    },
    {
      columns: ["Tây Ninh", "Phước Vĩnh Tây", "Xã Long An, Xã Long Phụng, Xã Phước Vĩnh Tây"],
    },
    {
      columns: ["Tây Ninh", "Rạch Kiến", "Xã Long Trạch, Xã Long Khê, Xã Long Hòa"],
    },
    {
      columns: [
        "Tây Ninh",
        "Tầm Vu",
        "Thị trấn Tầm Vu, Xã Hiệp Thạnh (huyện Châu Thành), Xã Phú Ngãi Trị, Xã Phước Tân Hưng",
      ],
    },
    {
      columns: [
        "Tây Ninh",
        "Tân An",
        "Phường 7, Xã Bình Tâm, Xã Nhơn Thạnh Trung, Xã An Vĩnh Ngãi",
      ],
    },
    {
      columns: [
        "Tây Ninh",
        "Tân Biên",
        "Xã Tân Bình (huyện Tân Biên), Xã Thạnh Tây, Thị trấn Tân Biên",
      ],
    },
    {
      columns: [
        "Tây Ninh",
        "Tân Châu",
        "Thị trấn Tân Châu, Xã Thạnh Đông, Xã Tân Phú (huyện Tân Châu), Xã Suối Dây",
      ],
    },
    {
      columns: ["Tây Ninh", "Tân Đông", "Xã Tân Đông (huyện Tân Châu), Xã Tân Hà"],
    },
    {
      columns: ["Tây Ninh", "Tân Hòa", "Xã Tân Hòa (huyện Tân Châu), Xã Suối Ngô"],
    },
    {
      columns: ["Tây Ninh", "Tân Hội", "Xã Tân Hiệp (huyện Tân Châu), Xã Tân Hội"],
    },
    {
      columns: ["Tây Ninh", "Tân Hưng", "Thị trấn Tân Hưng, Xã Vĩnh Thạnh, Xã Vĩnh Lợi"],
    },
    {
      columns: ["Tây Ninh", "Tân Lân", "Xã Phước Đông (huyện Cần Đước), Xã Tân Lân"],
    },
    {
      columns: ["Tây Ninh", "Tân Lập", "Xã Tân Lập (huyện Tân Biên), Xã Thạnh Bắc"],
    },
    {
      columns: [
        "Tây Ninh",
        "Tân Long",
        "Xã Long Thuận (huyện Thủ Thừa), Xã Long Thạnh, Xã Tân Long",
      ],
    },
    {
      columns: [
        "Tây Ninh",
        "Tân Ninh",
        "Phường 1, Phường 2, Phường 3 (thành phố Tây Ninh), Phường IV, Phường Hiệp Ninh, Xã Thái Bình",
      ],
    },
    {
      columns: [
        "Tây Ninh",
        "Tân Phú",
        "Xã Tân Hưng, Xã Mỏ Công, Xã Trà Vong, Xã Tân Phong, Xã Tân Phú (huyện Tân Châu)",
      ],
    },
    {
      columns: ["Tây Ninh", "Tân Tập", "Xã Đông Thạnh, Xã Phước Vĩnh Đông, Xã Tân Tập"],
    },
    {
      columns: ["Tây Ninh", "Tân Tây", "Xã Tân Đông (huyện Thạnh Hóa), Xã Thủy Đông, Xã Tân Tây"],
    },
    {
      columns: ["Tây Ninh", "Tân Thành", "Xã Tân Thành (huyện Tân Châu), Xã Suối Dây"],
    },
    {
      columns: [
        "Tây Ninh",
        "Tân Thạnh",
        "Xã Tân Bình, Xã Tân Hòa (huyện Tân Thạnh), Xã Kiến Bình, Thị trấn Tân Thạnh",
      ],
    },
    {
      columns: [
        "Tây Ninh",
        "Tân Trụ",
        "Thị trấn Tân Trụ, Xã Bình Trinh Đông, Xã Bình Lãng, Xã Bình Tịnh",
      ],
    },
    {
      columns: ["Tây Ninh", "Thạnh Bình", "Xã Thạnh Bình, Xã Tân Phong"],
    },
    {
      columns: ["Tây Ninh", "Thanh Điền", "Phường Hiệp Tân, Xã Thanh Điền"],
    },
    {
      columns: ["Tây Ninh", "Thạnh Đức", "Xã Thạnh Đức (huyện Gò Dầu), Xã Cẩm Giang"],
    },
    {
      columns: ["Tây Ninh", "Thạnh Hóa", "Thị trấn Thạnh Hóa, Xã Thủy Tây, Xã Thạnh An"],
    },
    {
      columns: ["Tây Ninh", "Thạnh Lợi", "Xã Thạnh Hòa, Xã Lương Bình, Xã Thạnh Lợi"],
    },
    {
      columns: ["Tây Ninh", "Thạnh Phước", "Xã Thuận Nghĩa Hòa, Xã Thạnh Phú, Xã Thạnh Phước"],
    },
    {
      columns: [
        "Tây Ninh",
        "Thủ Thừa",
        "Thị trấn Thủ Thừa, Xã Bình Thạnh, Xã Tân Thành (huyện Thủ Thừa), Xã Nhị Thành",
      ],
    },
    {
      columns: ["Tây Ninh", "Thuận Mỹ", "Xã Thanh Phú Long, Xã Thanh Vĩnh Đông, Xã Thuận Mỹ"],
    },
    {
      columns: ["Tây Ninh", "Trà Vong", "-, Xã Mỏ Công, Xã Trà Vong"],
    },
    {
      columns: ["Tây Ninh", "Trảng Bàng", "Phường An Hòa, Phường Trảng Bàng"],
    },
    {
      columns: ["Tây Ninh", "Truông Mít", "Xã Bàu Đồn, Xã Truông Mít"],
    },
    {
      columns: [
        "Tây Ninh",
        "Tuyên Bình",
        "Xã Tuyên Bình, Xã Tuyên Bình Tây, Xã Vĩnh Bình, Xã Vĩnh Thuận, Xã Thái Bình Trung",
      ],
    },
    {
      columns: [
        "Tây Ninh",
        "Tuyên Thạnh",
        "Xã Thạnh Hưng (thị xã Kiến Tường), Xã Tuyên Thạnh, Xã Bắc Hòa",
      ],
    },
    {
      columns: ["Tây Ninh", "Vàm Cỏ", "Xã Tân Phước Tây, Xã Nhựt Ninh, Xã Đức Tân"],
    },
    {
      columns: ["Tây Ninh", "Vĩnh Châu", "Xã Vĩnh Đại, Xã Vĩnh Bửu, Xã Vĩnh Châu A"],
    },
    {
      columns: ["Tây Ninh", "Vĩnh Công", "Xã Hòa Phú, Xã Bình Quới, Xã Vĩnh Công"],
    },
    {
      columns: [
        "Tây Ninh",
        "Vĩnh Hưng",
        "Thị trấn Vĩnh Hưng, Xã Vĩnh Trị, Xã Thái Trị, Xã Khánh Hưng, Xã Thái Bình Trung, Xã Vĩnh Thuận, Xã Vĩnh Bình",
      ],
    },
    {
      columns: [
        "Tây Ninh",
        "Vĩnh Thạnh",
        "Xã Thạnh Hưng (huyện Tân Hưng), Xã Vĩnh Châu B, Xã Hưng Thạnh",
      ],
    },
    {
      columns: ["Thái Nguyên", "An Khánh", "Xã Cù Vân, Xã Hà Thượng, Xã An Khánh"],
    },
    {
      columns: ["Thái Nguyên", "Ba Bể", "Xã Cao Thượng, Xã Nam Mẫu, Xã Khang Ninh"],
    },
    {
      columns: ["Thái Nguyên", "Bá Xuyên", "Phường Mỏ Chè, Phường Châu Sơn, Xã Bá Xuyên"],
    },
    {
      columns: ["Thái Nguyên", "Bách Quang", "Phường Lương Sơn, Phường Bách Quang, Xã Tân Quang"],
    },
    {
      columns: ["Thái Nguyên", "Bạch Thông", "Xã Đồng Thắng, Xã Dương Phong, Xã Quang Thuận"],
    },
    {
      columns: [
        "Thái Nguyên",
        "Bắc Kạn",
        "Phường Sông Cầu, Phường Phùng Chí Kiên, Phường Xuất Hóa, Xã Nông Thượng",
      ],
    },
    {
      columns: ["Thái Nguyên", "Bằng Thành", "Xã Bộc Bố, Xã Nhạn Môn, Xã Giáo Hiệu, Xã Bằng Thành"],
    },
    {
      columns: ["Thái Nguyên", "Bằng Vân", "Xã Thượng Ân, Xã Bằng Vân"],
    },
    {
      columns: ["Thái Nguyên", "Bình Thành", "Xã Sơn Phú, Xã Bình Thành"],
    },
    {
      columns: [
        "Thái Nguyên",
        "Bình Yên",
        "Xã Trung Lương, Xã Định Biên, Xã Thanh Định, Xã Bình Yên",
      ],
    },
    {
      columns: ["Thái Nguyên", "Cao Minh", "Xã Công Bằng, Xã Cổ Linh, Xã Cao Tân"],
    },
    {
      columns: [
        "Thái Nguyên",
        "Cẩm Giàng",
        "Xã Quân Hà, Xã Nguyên Phúc, Xã Mỹ Thanh, Xã Cẩm Giàng",
      ],
    },
    {
      columns: [
        "Thái Nguyên",
        "Chợ Đồn",
        "Thị trấn Bằng Lũng, Xã Ngọc Phái, Xã Phương Viên, Xã Bằng Lãng",
      ],
    },
    {
      columns: ["Thái Nguyên", "Chợ Mới", "Thị trấn Đồng Tâm, Xã Quảng Chu, Xã Như Cố"],
    },
    {
      columns: ["Thái Nguyên", "Chợ Rã", "Thị trấn Chợ Rã, Xã Thượng Giáo, Xã Địa Linh"],
    },
    {
      columns: ["Thái Nguyên", "Côn Minh", "Xã Quang Phong, Xã Dương Sơn, Xã Côn Minh"],
    },
    {
      columns: ["Thái Nguyên", "Cường Lợi", "Xã Văn Vũ, Xã Cường Lợi"],
    },
    {
      columns: ["Thái Nguyên", "Dân Tiến", "Xã Bình Long, Xã Phương Giao, Xã Dân Tiến"],
    },
    {
      columns: [
        "Thái Nguyên",
        "Đại Phúc",
        "Thị trấn Hùng Sơn, Xã Phúc Xuân, Xã Phúc Trìu, Xã Tân Thái, Xã Phúc Tân",
      ],
    },
    {
      columns: ["Thái Nguyên", "Đại Từ", "Xã Bình Thuận, Xã Khôi Kỳ, Xã Mỹ Yên, Xã Lục Ba"],
    },
    {
      columns: ["Thái Nguyên", "Điềm Thụy", "Xã Hà Châu, Xã Nga My, Xã Điềm Thụy, Xã Thượng Đình"],
    },
    {
      columns: [
        "Thái Nguyên",
        "Định Hóa",
        "Thị trấn Chợ Chu, Xã Phúc Chu, Xã Bảo Linh, Xã Đồng Thịnh",
      ],
    },
    {
      columns: [
        "Thái Nguyên",
        "Đồng Hỷ",
        "Thị trấn Hóa Thượng, Thị trấn Sông Cầu, Xã Minh Lập, Xã Hóa Trung",
      ],
    },
    {
      columns: [
        "Thái Nguyên",
        "Đồng Phúc",
        "Xã Quảng Khê, Xã Hoàng Trĩ, Xã Bằng Phúc, Xã Đồng Phúc",
      ],
    },
    {
      columns: ["Thái Nguyên", "Đức Lương", "Xã Minh Tiến, Xã Phúc Lương, Xã Đức Lương"],
    },
    {
      columns: [
        "Thái Nguyên",
        "Đức Xuân",
        "Phường Nguyễn Thị Minh Khai, Phường Huyền Tụng, Phường Đức Xuân",
      ],
    },
    {
      columns: [
        "Thái Nguyên",
        "Gia Sàng",
        "Phường Hương Sơn, Xã Đồng Liên, Phường Gia Sàng, Phường Cam Giá",
      ],
    },
    {
      columns: ["Thái Nguyên", "Hiệp Lực", "Xã Thuần Mang, Xã Hiệp Lực"],
    },
    {
      columns: ["Thái Nguyên", "Hợp Thành", "Xã Ôn Lương, Xã Phủ Lý, Xã Hợp Thành"],
    },
    {
      columns: [
        "Thái Nguyên",
        "Kha Sơn",
        "Xã Lương Phú, Xã Tân Đức, Xã Thanh Ninh, Xã Dương Thành, Xã Kha Sơn",
      ],
    },
    {
      columns: ["Thái Nguyên", "Kim Phượng", "Xã Quy Kỳ, Xã Kim Phượng"],
    },
    {
      columns: ["Thái Nguyên", "La Bằng", "Xã Hoàng Nông, Xã Tiên Hội, Xã La Bằng"],
    },
    {
      columns: ["Thái Nguyên", "La Hiên", "Xã Cúc Đường, Xã La Hiên"],
    },
    {
      columns: ["Thái Nguyên", "Lam Vỹ", "Xã Linh Thông, Xã Lam Vỹ"],
    },
    {
      columns: [
        "Thái Nguyên",
        "Linh Sơn",
        "Phường Chùa Hang, Phường Đồng Bẩm, Xã Cao Ngạn, Xã Huống Thượng, Xã Linh Sơn",
      ],
    },
    {
      columns: ["Thái Nguyên", "Nà Phặc", "Thị trấn Nà Phặc, Xã Trung Hòa"],
    },
    {
      columns: ["Thái Nguyên", "Na Rì", "Thị trấn Yến Lạc, Xã Sơn Thành, Xã Kim Lư"],
    },
    {
      columns: ["Thái Nguyên", "Nam Cường", "Xã Xuân Lạc, Xã Đồng Lạc, Xã Nam Cường"],
    },
    {
      columns: ["Thái Nguyên", "Nam Hòa", "Xã Cây Thị, Xã Nam Hòa"],
    },
    {
      columns: ["Thái Nguyên", "Ngân Sơn", "Thị trấn Vân Tùng, Xã Cốc Đán, Xã Đức Vân"],
    },
    {
      columns: ["Thái Nguyên", "Nghĩa Tá", "Xã Lương Bằng, Xã Bình Trung, Xã Nghĩa Tá"],
    },
    {
      columns: ["Thái Nguyên", "Nghiên Loan", "Xã Xuân La, Xã An Thắng, Xã Nghiên Loan"],
    },
    {
      columns: ["Thái Nguyên", "Nghinh Tường", "Xã Vũ Chấn, Xã Nghinh Tường"],
    },
    {
      columns: [
        "Thái Nguyên",
        "Phan Đình Phùng",
        "Phường Trưng Vương, Phường Túc Duyên, Phường Đồng Quang, Phường Quang Trung, Phường Hoàng Văn Thụ, Phường Tân Thịnh, Phường Phan Đình Phùng, Phường Gia Sàng",
      ],
    },
    {
      columns: ["Thái Nguyên", "Phong Quang", "Xã Dương Quang, Xã Đôn Phong"],
    },
    {
      columns: [
        "Thái Nguyên",
        "Phổ Yên",
        "Phường Ba Hàng, Phường Hồng Tiến, Phường Bãi Bông, Xã Đắc Sơn",
      ],
    },
    {
      columns: [
        "Thái Nguyên",
        "Phú Bình",
        "Thị trấn Hương Sơn, Xã Xuân Phương, Xã Úc Kỳ, Xã Nhã Lộng, Xã Bảo Lý, Xã Thượng Đình",
      ],
    },
    {
      columns: ["Thái Nguyên", "Phú Đình", "Xã Điềm Mặc, Xã Phú Đình"],
    },
    {
      columns: ["Thái Nguyên", "Phú Lạc", "Xã Phục Linh, Xã Tân Linh, Xã Phú Lạc"],
    },
    {
      columns: [
        "Thái Nguyên",
        "Phú Lương",
        "Thị trấn Đu, Thị trấn Giang Tiên, Xã Yên Lạc, Xã Động Đạt",
      ],
    },
    {
      columns: ["Thái Nguyên", "Phú Thịnh", "Xã Bản Ngoại, Xã Phú Cường, Xã Phú Thịnh"],
    },
    {
      columns: [
        "Thái Nguyên",
        "Phủ Thông",
        "Thị trấn Phủ Thông, Xã Vi Hương, Xã Tân Tú, Xã Lục Bình",
      ],
    },
    {
      columns: ["Thái Nguyên", "Phú Xuyên", "Xã Yên Lãng, Xã Phú Xuyên"],
    },
    {
      columns: ["Thái Nguyên", "Phúc Lộc", "Xã Bành Trạch, Xã Hà Hiệu, Xã Phúc Lộc"],
    },
    {
      columns: ["Thái Nguyên", "Phúc Thuận", "Phường Bắc Sơn, Xã Minh Đức, Xã Phúc Thuận"],
    },
    {
      columns: ["Thái Nguyên", "Phượng Tiến", "Xã Tân Dương, Xã Tân Thịnh, Xã Phượng Tiến"],
    },
    {
      columns: [
        "Thái Nguyên",
        "Quan Triều",
        "Phường Tân Long, Phường Quang Vinh, Phường Quan Triều, Xã Sơn Cẩm",
      ],
    },
    {
      columns: ["Thái Nguyên", "Quảng Bạch", "Xã Tân Lập, Xã Quảng Bạch"],
    },
    {
      columns: ["Thái Nguyên", "Quang Sơn", "Xã Tân Long, Xã Quang Sơn"],
    },
    {
      columns: ["Thái Nguyên", "Quân Chu", "Thị trấn Quân Chu, Xã Cát Nê"],
    },
    {
      columns: ["Thái Nguyên", "Quyết Thắng", "Phường Thịnh Đán, Xã Phúc Hà, Xã Quyết Thắng"],
    },
    {
      columns: ["Thái Nguyên", "Sảng Mộc", "Không sáp nhập"],
    },
    {
      columns: ["Thái Nguyên", "Sông Công", "Phường Thắng Lợi, Phường Phố Cò, Phường Cải Đan"],
    },
    {
      columns: ["Thái Nguyên", "Tân Cương", "Xã Thịnh Đức, Xã Bình Sơn, Xã Tân Cương"],
    },
    {
      columns: ["Thái Nguyên", "Tân Khánh", "Xã Bàn Đạt, Xã Đào Xá, Xã Tân Khánh"],
    },
    {
      columns: ["Thái Nguyên", "Tân Kỳ", "Xã Tân Sơn, Xã Cao Kỳ, Xã Hòa Mục"],
    },
    {
      columns: ["Thái Nguyên", "Tân Thành", "Xã Tân Hòa, Xã Tân Kim, Xã Tân Thành"],
    },
    {
      columns: ["Thái Nguyên", "Thành Công", "Xã Vạn Phái, Xã Thành Công"],
    },
    {
      columns: ["Thái Nguyên", "Thanh Mai", "Xã Thanh Vận, Xã Mai Lạp, Xã Thanh Mai"],
    },
    {
      columns: ["Thái Nguyên", "Thanh Thịnh", "Xã Nông Hạ, Xã Thanh Thịnh"],
    },
    {
      columns: ["Thái Nguyên", "Thần Sa", "Xã Thượng Nung, Xã Thần Xa"],
    },
    {
      columns: ["Thái Nguyên", "Thượng Minh", "Xã Yến Dương, Xã Chu Hương, Xã Mỹ Phương"],
    },
    {
      columns: ["Thái Nguyên", "Thượng Quan", "Không sáp nhập"],
    },
    {
      columns: [
        "Thái Nguyên",
        "Tích Lương",
        "Phường Trung Thành (thành phố Thái Nguyên), Phường Phú Xá, Phường Tân Thành, Phường Tân Lập, Phường Tích Lương, Phường Cam Giá",
      ],
    },
    {
      columns: ["Thái Nguyên", "Trại Cau", "Thị trấn Trại Cau, Xã Hợp Tiến"],
    },
    {
      columns: ["Thái Nguyên", "Tràng Xá", "Xã Liên Minh, Xã Tràng Xá"],
    },
    {
      columns: ["Thái Nguyên", "Trần Phú", "Xã Văn Minh, Xã Cư Lễ, Xã Trần Phú"],
    },
    {
      columns: ["Thái Nguyên", "Trung Hội", "Xã Phú Tiến, Xã Bộc Nhiêu, Xã Trung Hội"],
    },
    {
      columns: [
        "Thái Nguyên",
        "Trung Thành",
        "Phường Trung Thành (thành phố Phổ Yên), Phường Đông Cao, Phường Tân Phú, Phường Thuận Thành",
      ],
    },
    {
      columns: ["Thái Nguyên", "Vạn Phú", "Xã Văn Yên, Xã Vạn Phú"],
    },
    {
      columns: [
        "Thái Nguyên",
        "Vạn Xuân",
        "Phường Nam Tiến, Phường Đồng Tiến, Phường Tân Hương, Phường Tiên Phong",
      ],
    },
    {
      columns: ["Thái Nguyên", "Văn Hán", "Xã Khe Mo, Xã Văn Hán"],
    },
    {
      columns: ["Thái Nguyên", "Văn Lang", "Xã Kim Hỷ, Xã Lương Thượng, Xã Văn Lang"],
    },
    {
      columns: ["Thái Nguyên", "Văn Lăng", "Xã Hòa Bình, Xã Văn Lăng"],
    },
    {
      columns: ["Thái Nguyên", "Vĩnh Thông", "Xã Sỹ Bình, Xã Vũ Muộn, Xã Cao Sơn"],
    },
    {
      columns: ["Thái Nguyên", "Võ Nhai", "Thị trấn Đình Cả, Xã Phú Thượng, Xã Lâu Thượng"],
    },
    {
      columns: ["Thái Nguyên", "Vô Tranh", "Xã Tức Tranh, Xã Cổ Lũng, Xã Phú Đô, Xã Vô Tranh"],
    },
    {
      columns: ["Thái Nguyên", "Xuân Dương", "Xã Đổng Xá, Xã Liêm Thủy, Xã Xuân Dương"],
    },
    {
      columns: ["Thái Nguyên", "Yên Bình", "Xã Yên Cư, Xã Bình Văn, Xã Yên Hân"],
    },
    {
      columns: ["Thái Nguyên", "Yên Phong", "Xã Đại Sảo, Xã Yên Mỹ, Xã Yên Phong"],
    },
    {
      columns: ["Thái Nguyên", "Yên Thịnh", "Xã Bản Thi, Xã Yên Thượng, Xã Yên Thịnh"],
    },
    {
      columns: ["Thái Nguyên", "Yên Trạch", "Xã Yên Ninh, Xã Yên Đổ, Xã Yên Trạch"],
    },
    {
      columns: ["Thanh Hóa", "An Nông", "Xã Tiến Nông, Xã Khuyến Nông, Xã Nông Trường, Xã An Nông"],
    },
    {
      columns: ["Thanh Hóa", "Ba Đình", "Xã Nga Vịnh, Xã Nga Trường, Xã Nga Thiện, Xã Ba Đình"],
    },
    {
      columns: ["Thanh Hóa", "Bá Thước", "Thị trấn Cành Nàng, Xã Ban Công, Xã Hạ Trung"],
    },
    {
      columns: ["Thanh Hóa", "Bát Mọt", "Không sáp nhập"],
    },
    {
      columns: ["Thanh Hóa", "Biện Thượng", "Xã Vĩnh Hùng, Xã Minh Tân, Xã Vĩnh Thịnh, Xã Vĩnh An"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Bỉm Sơn",
        "Phường Đông Sơn, Phường Lam Sơn, Phường Ba Đình (thị xã Bỉm Sơn), Xã Hà Vinh",
      ],
    },
    {
      columns: ["Thanh Hóa", "Các Sơn", "Xã Anh Sơn, Xã Các Sơn"],
    },
    {
      columns: ["Thanh Hóa", "Cẩm Tân", "Xã Cẩm Long, Xã Cẩm Phú, Xã Cẩm Tân"],
    },
    {
      columns: ["Thanh Hóa", "Cẩm Thạch", "Xã Cẩm Thành, Xã Cẩm Liên, Xã Cẩm Bình, Xã Cẩm Thạch"],
    },
    {
      columns: ["Thanh Hóa", "Cẩm Thủy", "Thị trấn Phong Sơn, Xã Cẩm Ngọc"],
    },
    {
      columns: ["Thanh Hóa", "Cẩm Tú", "Xã Cẩm Quý, Xã Cẩm Giang, Xã Cẩm Lương, Xã Cẩm Tú"],
    },
    {
      columns: ["Thanh Hóa", "Cẩm Vân", "Xã Cẩm Tâm, Xã Cẩm Châu, Xã Cẩm Yên, Xã Cẩm Vân"],
    },
    {
      columns: ["Thanh Hóa", "Cổ Lũng", "Xã Lũng Cao, Xã Cổ Lũng"],
    },
    {
      columns: ["Thanh Hóa", "Công Chính", "Xã Công Liêm, Xã Yên Mỹ, Xã Công Chính, Xã Thanh Tân"],
    },
    {
      columns: ["Thanh Hóa", "Đào Duy Từ", "Phường Nguyên Bình, Phường Xuân Lâm"],
    },
    {
      columns: ["Thanh Hóa", "Điền Lư", "Xã Ái Thượng, Xã Điền Trung, Xã Điền Lư"],
    },
    {
      columns: ["Thanh Hóa", "Điền Quang", "Xã Điền Thượng, Xã Điền Hạ, Xã Điền Quang"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Định Hòa",
        "Xã Định Bình, Xã Định Công, Xã Định Thành, Xã Định Hòa, Xã Thiệu Long",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Định Tân",
        "Xã Định Hải (huyện Yên Định), Xã Định Hưng, Xã Định Tiến, Xã Định Tân",
      ],
    },
    {
      columns: ["Thanh Hóa", "Đồng Lương", "Xã Tân Phúc (huyện Lang Chánh), Xã Đồng Lương"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Đông Quang",
        "Phường Quảng Thắng, Xã Đông Vinh, Xã Đông Quang, Xã Đông Yên, Xã Đông Văn, Xã Đông Phú, Xã Đông Nam, Phường An Hưng",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Đông Sơn",
        "Phường Rừng Thông, Phường Đông Thịnh, Phường Đông Tân, Xã Đông Hòa, Xã Đông Minh, Xã Đông Hoàng, Xã Đông Khê, Xã Đông Ninh",
      ],
    },
    {
      columns: ["Thanh Hóa", "Đông Thành", "Xã Đồng Lộc, Xã Thành Lộc, Xã Cầu Lộc, Xã Tuy Lộc"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Đông Tiến",
        "Phường Đông Lĩnh, Phường Thiệu Khánh, Xã Đông Thanh, Xã Thiệu Vân, Xã Tân Châu, Xã Thiệu Giao, Xã Đông Tiến",
      ],
    },
    {
      columns: ["Thanh Hóa", "Đồng Tiến", "Xã Đồng Lợi, Xã Đồng Thắng, Xã Đồng Tiến"],
    },
    {
      columns: ["Thanh Hóa", "Giao An", "Xã Giao Thiện, Xã Giao An"],
    },
    {
      columns: ["Thanh Hóa", "Hà Long", "Thị trấn Hà Long, Xã Hà Bắc, Xã Hà Giang"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Hà Trung",
        "Xã Hà Đông, Xã Hà Ngọc, Xã Yến Sơn, Thị trấn Hà Trung, Xã Hà Bình",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Hạc Thành",
        "Phường Phú Sơn, Phường Lam Sơn, Phường Ba Đình, Phường Ngọc Trạo, Phường Đông Sơn (thành phố Thanh Hóa), Phường Trường Thi, Phường Điện Biên, Phường Đông Hương, Phường Đông Hải, Phường Đông Vệ, Phường Đông Thọ, Phường An Hưng",
      ],
    },
    {
      columns: ["Thanh Hóa", "Hải Bình", "Phường Mai Lâm, Phường Tĩnh Hải, Phường Hải Bình"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Hải Lĩnh",
        "Xã Định Hải (thị xã Nghi Sơn), Phường Ninh Hải, Phường Hải Lĩnh",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Hàm Rồng",
        "Phường Thiệu Dương, Phường Đông Cương, Phường Nam Ngạn, Phường Hàm Rồng, Phường Đông Thọ",
      ],
    },
    {
      columns: ["Thanh Hóa", "Hậu Lộc", "Thị trấn Hậu Lộc, Xã Thuần Lộc, Xã Mỹ Lộc, Xã Lộc Sơn"],
    },
    {
      columns: ["Thanh Hóa", "Hiền Kiệt", "Xã Hiền Chung, Xã Hiền Kiệt"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Hoa Lộc",
        "Xã Xuân Lộc (huyện Hậu Lộc), Xã Liên Lộc, Xã Quang Lộc, Xã Phú Lộc, Xã Hòa Lộc, Xã Hoa Lộc",
      ],
    },
    {
      columns: ["Thanh Hóa", "Hóa Quỳ", "Xã Bình Lương, Xã Hóa Quỳ"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Hoạt Giang",
        "Xã Yên Dương, Xã Hoạt Giang, Thị trấn Hà Trung, Xã Hà Bình",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Hoằng Châu",
        "Xã Hoằng Thắng, Xã Hoằng Phong, Xã Hoằng Lưu, Xã Hoằng Châu",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Hoằng Giang",
        "Xã Hoằng Xuân, Xã Hoằng Quỳ, Xã Hoằng Hợp, Xã Hoằng Giang",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Hoằng Hóa",
        "Thị trấn Bút Sơn, Xã Hoằng Đức, Xã Hoằng Đồng, Xã Hoằng Đạo, Xã Hoằng Hà, Xã Hoằng Đạt",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Hoằng Lộc",
        "Xã Hoằng Thịnh, Xã Hoằng Thái, Xã Hoằng Thành, Xã Hoằng Trạch, Xã Hoằng Tân, Xã Hoằng Lộc",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Hoằng Phú",
        "Xã Hoằng Quý, Xã Hoằng Kim, Xã Hoằng Trung, Xã Hoằng Phú",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Hoằng Sơn",
        "Xã Hoằng Trinh, Xã Hoằng Xuyên, Xã Hoằng Cát, Xã Hoằng Sơn",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Hoằng Thanh",
        "Xã Hoằng Đông, Xã Hoằng Ngọc, Xã Hoằng Phụ, Xã Hoằng Thanh",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Hoằng Tiến",
        "Xã Hoằng Yến, Xã Hoằng Hải, Xã Hoằng Trường, Xã Hoằng Tiến",
      ],
    },
    {
      columns: ["Thanh Hóa", "Hồ Vương", "Xã Nga Hải, Xã Nga Thành, Xã Nga Giáp, Xã Nga Liên"],
    },
    {
      columns: ["Thanh Hóa", "Hồi Xuân", "Thị trấn Hồi Xuân, Xã Phú Nghiêm"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Hợp Tiến",
        "Xã Hợp Lý, Xã Hợp Thắng, Xã Hợp Thành, Xã Triệu Thành, Xã Hợp Tiến",
      ],
    },
    {
      columns: ["Thanh Hóa", "Kiên Thọ", "Xã Phúc Thịnh, Xã Phùng Minh, Xã Kiên Thọ"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Kim Tân",
        "Thị trấn Kim Tân, Xã Thành Hưng, Xã Thành Thọ, Xã Thạch Định, Xã Thành Trực, Xã Thành Tiến",
      ],
    },
    {
      columns: ["Thanh Hóa", "Lam Sơn", "Thị trấn Lam Sơn, Xã Xuân Bái, Xã Thọ Xương"],
    },
    {
      columns: ["Thanh Hóa", "Linh Sơn", "Thị trấn Lang Chánh, Xã Trí Nang"],
    },
    {
      columns: ["Thanh Hóa", "Lĩnh Toại", "Xã Hà Hải, Xã Hà Châu, Xã Thái Lai, Xã Lĩnh Toại"],
    },
    {
      columns: ["Thanh Hóa", "Luận Thành", "Xã Xuân Cao, Xã Luận Thành, Xã Luận Khê"],
    },
    {
      columns: ["Thanh Hóa", "Lương Sơn", "Không sáp nhập"],
    },
    {
      columns: ["Thanh Hóa", "Lưu Vệ", "Thị trấn Tân Phong, Xã Quảng Đức, Xã Quảng Định"],
    },
    {
      columns: ["Thanh Hóa", "Mậu Lâm", "Xã Phú Nhuận, Xã Mậu Lâm"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Minh Sơn",
        "Xã Minh Sơn (huyện Ngọc Lặc), Xã Lam Sơn, Xã Cao Ngọc, Xã Minh Tiến",
      ],
    },
    {
      columns: ["Thanh Hóa", "Mường Chanh", "Không sáp nhập"],
    },
    {
      columns: ["Thanh Hóa", "Mường Lát", "Thị trấn Mường Lát"],
    },
    {
      columns: ["Thanh Hóa", "Mường Lý", "Không sáp nhập"],
    },
    {
      columns: ["Thanh Hóa", "Mường Mìn", "Không sáp nhập"],
    },
    {
      columns: ["Thanh Hóa", "Na Mèo", "Không sáp nhập"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Nam Sầm Sơn",
        "Phường Quảng Vinh, Xã Quảng Minh, Xã Đại Hùng, Xã Quảng Giao",
      ],
    },
    {
      columns: ["Thanh Hóa", "Nam Xuân", "Xã Nam Tiến, Xã Nam Xuân"],
    },
    {
      columns: ["Thanh Hóa", "Nga An", "Xã Nga Điền, Xã Nga Phú, Xã Nga An"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Nga Sơn",
        "Thị trấn Nga Sơn, Xã Nga Yên, Xã Nga Thanh, Xã Nga Hiệp, Xã Nga Thủy",
      ],
    },
    {
      columns: ["Thanh Hóa", "Nga Thắng", "Xã Nga Văn, Xã Nga Phượng, Xã Nga Thạch, Xã Nga Thắng"],
    },
    {
      columns: ["Thanh Hóa", "Nghi Sơn", "Phường Hải Thượng, Xã Hải Hà, Xã Nghi Sơn"],
    },
    {
      columns: ["Thanh Hóa", "Ngọc Lặc", "Thị trấn Ngọc Lặc, Xã Mỹ Tân, Xã Thúy Sơn"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Ngọc Liên",
        "Xã Lộc Thịnh, Xã Cao Thịnh, Xã Ngọc Sơn, Xã Ngọc Trung, Xã Ngọc Liên",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Ngọc Sơn",
        "Xã Thanh Sơn (thị xã Nghi Sơn), Xã Thanh Thủy, Phường Hải Châu, Phường Hải Ninh",
      ],
    },
    {
      columns: ["Thanh Hóa", "Ngọc Trạo", "Xã Thành An, Xã Thành Long, Xã Thành Tâm, Xã Ngọc Trạo"],
    },
    {
      columns: ["Thanh Hóa", "Nguyệt Ấn", "Xã Phùng Giáo, Xã Vân Am, Xã Nguyệt Ấn"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Nguyệt Viên",
        "Phường Tào Xuyên, Phường Long Anh, Phường Hoằng Quang, Phường Hoằng Đại",
      ],
    },
    {
      columns: ["Thanh Hóa", "Nhi Sơn", "Không sáp nhập"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Như Thanh",
        "Thị trấn Bến Sung, Xã Xuân Khang, Xã Hải Long, Xã Yên Thọ (huyện Như Thanh)",
      ],
    },
    {
      columns: ["Thanh Hóa", "Như Xuân", "Thị trấn Yên Cát, Xã Tân Bình"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Nông Cống",
        "Thị trấn Nông Cống, Xã Vạn Thắng, Xã Vạn Hòa, Xã Vạn Thiện, Xã Minh Nghĩa, Xã Minh Khôi",
      ],
    },
    {
      columns: ["Thanh Hóa", "Phú Lệ", "Xã Phú Sơn (huyện Quan Hóa), Xã Phú Thanh, Xã Phú Lệ"],
    },
    {
      columns: ["Thanh Hóa", "Phú Xuân", "Không sáp nhập"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Pù Luông",
        "Xã Thành Sơn (huyện Bá Thước), Xã Lũng Niêm, Xã Thành Lâm",
      ],
    },
    {
      columns: ["Thanh Hóa", "Pù Nhi", "Không sáp nhập"],
    },
    {
      columns: ["Thanh Hóa", "Quan Sơn", "Xã Trung Thượng, Thị trấn Sơn Lư"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Quảng Bình",
        "Xã Quảng Lưu, Xã Quảng Lộc, Xã Quảng Thái, Xã Quảng Bình",
      ],
    },
    {
      columns: ["Thanh Hóa", "Quang Chiểu", "Không sáp nhập"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Quảng Chính",
        "Xã Quảng Trường, Xã Quảng Khê, Xã Quảng Trung, Xã Quảng Chính",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Quảng Ngọc",
        "Xã Quảng Hợp, Xã Quảng Văn, Xã Quảng Phúc, Xã Quảng Ngọc",
      ],
    },
    {
      columns: ["Thanh Hóa", "Quảng Ninh", "Xã Quảng Nhân, Xã Quảng Hải, Xã Quảng Ninh"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Quảng Phú",
        "Phường Quảng Hưng, Phường Quảng Tâm, Phường Quảng Thành, Phường Quảng Đông, Phường Quảng Thịnh, Phường Quảng Cát, Phường Quảng Phú",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Quang Trung",
        "Phường Bắc Sơn, Phường Ngọc Trạo, Phường Phú Sơn, Xã Quang Trung (thị xã Bỉm Sơn)",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Quảng Yên",
        "Xã Quảng Trạch, Xã Quảng Hòa, Xã Quảng Long, Xã Quảng Yên",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Quý Lộc",
        "Xã Yên Thọ (huyện Yên Định), Thị trấn Yên Lâm, Thị trấn Quý Lộc",
      ],
    },
    {
      columns: ["Thanh Hóa", "Quý Lương", "Xã Lương Nội, Xã Lương Trung, Xã Lương Ngoại"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Sao Vàng",
        "Thị trấn Sao Vàng, Xã Thọ Lâm, Xã Xuân Phú, Xã Xuân Sinh",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Sầm Sơn",
        "Phường Bắc Sơn (thành phố Sầm Sơn), Phường Quảng Tiến, Phường Quảng Cư, Phường Trung Sơn, Phường Trường Sơn, Phường Quảng Châu, Phường Quảng Thọ",
      ],
    },
    {
      columns: ["Thanh Hóa", "Sơn Điện", "Không sáp nhập"],
    },
    {
      columns: ["Thanh Hóa", "Sơn Thủy", "Không sáp nhập"],
    },
    {
      columns: ["Thanh Hóa", "Tam Chung", "Không sáp nhập"],
    },
    {
      columns: ["Thanh Hóa", "Tam Lư", "Xã Sơn Hà, Xã Tam Lư, Thị trấn Sơn Lư"],
    },
    {
      columns: ["Thanh Hóa", "Tam Thanh", "Không sáp nhập"],
    },
    {
      columns: ["Thanh Hóa", "Tân Dân", "Phường Hải An, Phường Tân Dân, Xã Ngọc Lĩnh"],
    },
    {
      columns: ["Thanh Hóa", "Tân Ninh", "Thị trấn Nưa, Xã Thái Hòa, Xã Vân Sơn"],
    },
    {
      columns: ["Thanh Hóa", "Tân Thành", "Xã Tân Thành, Xã Luận Khê"],
    },
    {
      columns: ["Thanh Hóa", "Tân Tiến", "Xã Nga Tiến, Xã Nga Tân, Xã Nga Thái"],
    },
    {
      columns: ["Thanh Hóa", "Tây Đô", "Xã Vĩnh Quang, Xã Vĩnh Yên, Xã Vĩnh Tiến, Xã Vĩnh Long"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Thạch Bình",
        "Xã Thạch Sơn, Xã Thạch Long, Xã Thạch Cẩm, Xã Thạch Bình",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Thạch Lập",
        "Xã Quang Trung (huyện Ngọc Lặc), Xã Đồng Thịnh, Xã Thạch Lập",
      ],
    },
    {
      columns: ["Thanh Hóa", "Thạch Quảng", "Xã Thạch Lâm, Xã Thạch Tượng, Xã Thạch Quảng"],
    },
    {
      columns: ["Thanh Hóa", "Thanh Kỳ", "Xã Thanh Kỳ, Xã Thanh Tân"],
    },
    {
      columns: ["Thanh Hóa", "Thanh Phong", "Xã Thanh Hòa, Xã Thanh Lâm, Xã Thanh Phong"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Thanh Quân",
        "Xã Thanh Sơn (huyện Như Xuân), Xã Thanh Xuân, Xã Thanh Quân",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Thành Vinh",
        "Xã Thành Minh, Xã Thành Mỹ, Xã Thành Yên, Xã Thành Vinh",
      ],
    },
    {
      columns: ["Thanh Hóa", "Thăng Bình", "Xã Thăng Long, Xã Thăng Thọ, Xã Thăng Bình"],
    },
    {
      columns: ["Thanh Hóa", "Thắng Lộc", "Xã Xuân Lộc (huyện Thường Xuân), Xã Xuân Thắng"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Thắng Lợi",
        "Xã Trung Thành (huyện Nông Cống), Xã Tế Nông, Xã Tế Thắng, Xã Tế Lợi",
      ],
    },
    {
      columns: ["Thanh Hóa", "Thiên Phủ", "Xã Nam Động, Xã Thiên Phủ"],
    },
    {
      columns: ["Thanh Hóa", "Thiết Ống", "Xã Thiết Kế, Xã Thiết Ống"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Thiệu Hóa",
        "Xã Thiệu Phúc, Xã Thiệu Công, Xã Thiệu Nguyên, Thị trấn Thiệu Hóa, Xã Thiệu Long",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Thiệu Quang",
        "Xã Thiệu Duy, Xã Thiệu Hợp, Xã Thiệu Thịnh, Xã Thiệu Giang, Xã Thiệu Quang, Thị trấn Thiệu Hóa",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Thiệu Tiến",
        "Xã Thiệu Ngọc, Xã Thiệu Vũ, Xã Thiệu Thành, Xã Thiệu Tiến",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Thiệu Toán",
        "Thị trấn Hậu Hiền, Xã Thiệu Chính, Xã Thiệu Hòa, Xã Thiệu Toán",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Thiệu Trung",
        "Xã Thiệu Vận, Xã Thiệu Lý, Xã Thiệu Viên, Xã Thiệu Trung, Thị trấn Thiệu Hóa",
      ],
    },
    {
      columns: ["Thanh Hóa", "Thọ Bình", "Xã Thọ Sơn, Xã Bình Sơn, Xã Thọ Bình"],
    },
    {
      columns: ["Thanh Hóa", "Thọ Lập", "Xã Xuân Thiên, Xã Thuận Minh, Xã Thọ Lập"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Thọ Long",
        "Xã Thọ Lộc, Xã Xuân Phong, Xã Nam Giang, Xã Bắc Lương, Xã Tây Hồ",
      ],
    },
    {
      columns: ["Thanh Hóa", "Thọ Ngọc", "Xã Thọ Tiến, Xã Xuân Thọ, Xã Thọ Cường, Xã Thọ Ngọc"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Thọ Phú",
        "Xã Xuân Lộc (huyện Triệu Sơn), Xã Thọ Dân, Xã Thọ Thế, Xã Thọ Tân, Xã Thọ Phú",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Thọ Xuân",
        "Thị trấn Thọ Xuân, Xã Xuân Hồng, Xã Xuân Trường, Xã Xuân Giang",
      ],
    },
    {
      columns: ["Thanh Hóa", "Thượng Ninh", "Xã Cát Tân, Xã Cát Vân, Xã Thượng Ninh"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Thường Xuân",
        "Thị trấn Thường Xuân, Xã Thọ Thanh, Xã Ngọc Phụng, Xã Xuân Dương",
      ],
    },
    {
      columns: ["Thanh Hóa", "Tiên Trang", "Xã Quảng Thạch, Xã Quảng Nham, Xã Tiên Trang"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Tĩnh Gia",
        "Phường Hải Hòa, Phường Bình Minh, Phường Hải Thanh, Xã Hải Nhân",
      ],
    },
    {
      columns: ["Thanh Hóa", "Tống Sơn", "Thị trấn Hà Lĩnh, Xã Hà Tiến, Xã Hà Tân, Xã Hà Sơn"],
    },
    {
      columns: ["Thanh Hóa", "Triệu Lộc", "Xã Đại Lộc, Xã Tiến Lộc, Xã Triệu Lộc"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Triệu Sơn",
        "Thị trấn Triệu Sơn, Xã Minh Sơn (huyện Triệu Sơn), Xã Dân Lực, Xã Dân Lý, Xã Dân Quyền",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Trúc Lâm",
        "Phường Trúc Lâm, Xã Phú Sơn (thị xã Nghi Sơn), Xã Phú Lâm, Xã Tùng Lâm",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Trung Chính",
        "Xã Tân Phúc (huyện Nông Cống), Xã Tân Thọ, Xã Tân Khang, Xã Hoàng Sơn, Xã Hoàng Giang, Xã Trung Chính",
      ],
    },
    {
      columns: ["Thanh Hóa", "Trung Hạ", "Xã Trung Tiến, Xã Trung Xuân, Xã Trung Hạ"],
    },
    {
      columns: ["Thanh Hóa", "Trung Lý", "Không sáp nhập"],
    },
    {
      columns: ["Thanh Hóa", "Trung Sơn", "Không sáp nhập"],
    },
    {
      columns: ["Thanh Hóa", "Trung Thành", "Xã Thành Sơn, Xã Trung Thành (huyện Quan Hóa)"],
    },
    {
      columns: ["Thanh Hóa", "Trường Lâm", "Xã Tân Trường, Xã Trường Lâm"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Trường Văn",
        "Xã Trường Minh, Xã Trường Trung, Xã Trường Sơn, Xã Trường Giang",
      ],
    },
    {
      columns: ["Thanh Hóa", "Tượng Lĩnh", "Xã Tượng Sơn, Xã Tượng Văn, Xã Tượng Lĩnh"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Vạn Lộc",
        "Xã Minh Lộc, Xã Hải Lộc, Xã Hưng Lộc, Xã Ngư Lộc, Xã Đa Lộc",
      ],
    },
    {
      columns: ["Thanh Hóa", "Vạn Xuân", "Không sáp nhập"],
    },
    {
      columns: ["Thanh Hóa", "Văn Nho", "Xã Kỳ Tân, Xã Văn Nho"],
    },
    {
      columns: ["Thanh Hóa", "Văn Phú", "Xã Tam Văn, Xã Lâm Phú"],
    },
    {
      columns: ["Thanh Hóa", "Vân Du", "Thị trấn Vân Du, Xã Thành Công, Xã Thành Tân"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Vĩnh Lộc",
        "Thị trấn Vĩnh Lộc, Xã Ninh Khang, Xã Vĩnh Phúc, Xã Vĩnh Hưng, Xã Vĩnh Hòa",
      ],
    },
    {
      columns: [
        "Thanh Hóa",
        "Xuân Bình",
        "Xã Xuân Hòa (huyện Như Xuân), Xã Bãi Trành, Xã Xuân Bình",
      ],
    },
    {
      columns: ["Thanh Hóa", "Xuân Chinh", "Xã Xuân Lẹ, Xã Xuân Chinh"],
    },
    {
      columns: ["Thanh Hóa", "Xuân Du", "Xã Cán Khê, Xã Phượng Nghi, Xã Xuân Du"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Xuân Hòa",
        "Xã Xuân Hòa (huyện Thọ Xuân), Xã Thọ Hải, Xã Thọ Diên, Xã Xuân Hưng",
      ],
    },
    {
      columns: ["Thanh Hóa", "Xuân Lập", "Xã Xuân Minh, Xã Xuân Lai, Xã Trường Xuân, Xã Xuân Lập"],
    },
    {
      columns: ["Thanh Hóa", "Xuân Thái", "Không sáp nhập"],
    },
    {
      columns: ["Thanh Hóa", "Xuân Tín", "Xã Phú Xuân (huyện Thọ Xuân), Xã Quảng Phú, Xã Xuân Tín"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Yên Định",
        "Thị trấn Quán Lào, Xã Định Liên, Xã Định Long, Xã Định Tăng",
      ],
    },
    {
      columns: ["Thanh Hóa", "Yên Khương", "Không sáp nhập"],
    },
    {
      columns: ["Thanh Hóa", "Yên Nhân", "Không sáp nhập"],
    },
    {
      columns: ["Thanh Hóa", "Yên Ninh", "Xã Yên Hùng, Xã Yên Thịnh, Xã Yên Ninh"],
    },
    {
      columns: ["Thanh Hóa", "Yên Phú", "Thị trấn Thống Nhất, Xã Yên Tâm, Xã Yên Phú"],
    },
    {
      columns: ["Thanh Hóa", "Yên Thắng", "Không sáp nhập"],
    },
    {
      columns: ["Thanh Hóa", "Yên Thọ", "Xã Xuân Phúc, Xã Yên Lạc, Xã Yên Thọ (huyện Như Thanh)"],
    },
    {
      columns: [
        "Thanh Hóa",
        "Yên Trường",
        "Xã Yên Trung, Xã Yên Phong, Xã Yên Thái, Xã Yên Trường",
      ],
    },
    {
      columns: ["TP HCM", "An Đông", "Phường 5, Phường 7, Phường 9 (Quận 5)"],
    },
    {
      columns: ["TP HCM", "An Hội Đông", "Phường 15, Phường 16 (quận Gò Vấp)"],
    },
    {
      columns: ["TP HCM", "An Hội Tây", "Phường 12, Phường 14 (quận Gò Vấp)"],
    },
    {
      columns: [
        "TP HCM",
        "An Khánh",
        "Phường Thủ Thiêm, Phường An Lợi Đông, Phường Thảo Điền, Phường An Khánh, Phường An Phú (thành phố Thủ Đức)",
      ],
    },
    {
      columns: ["TP HCM", "An Lạc", "Phường Bình Trị Đông B, Phường An Lạc A, Phường An Lạc"],
    },
    {
      columns: ["TP HCM", "An Long", "Xã An Linh, Xã Tân Long, Xã An Long"],
    },
    {
      columns: ["TP HCM", "An Nhơn", "Phường 5, Phường 6 (quận Gò Vấp)"],
    },
    {
      columns: ["TP HCM", "An Nhơn Tây", "Xã Phú Mỹ Hưng, Xã An Phú, Xã An Nhơn Tây"],
    },
    {
      columns: ["TP HCM", "An Phú", "Phường An Phú (thành phố Thuận An), Phường Bình Chuẩn"],
    },
    {
      columns: ["TP HCM", "An Phú Đông", "Phường Thạnh Lộc, Phường An Phú Đông"],
    },
    {
      columns: ["TP HCM", "An Thới Đông", "Xã Lý Nhơn, Xã An Thới Đông"],
    },
    {
      columns: ["TP HCM", "Bà Điểm", "Xã Xuân Thới Thượng, Xã Trung Chánh, Xã Bà Điểm"],
    },
    {
      columns: [
        "TP HCM",
        "Bà Rịa",
        "Phường Phước Trung, Phường Phước Nguyên, Phường Long Toàn, Phường Phước Hưng",
      ],
    },
    {
      columns: ["TP HCM", "Bàn Cờ", "Phường 1, Phường 2, Phường 3, Phường 5, Phường 4 (Quận 3)"],
    },
    {
      columns: ["TP HCM", "Bàu Bàng", "Thị trấn Lai Uyên"],
    },
    {
      columns: ["TP HCM", "Bàu Lâm", "Xã Tân Lâm, Xã Bàu Lâm"],
    },
    {
      columns: ["TP HCM", "Bảy Hiền", "Phường 10, Phường 11, Phường 12 (quận Tân Bình)"],
    },
    {
      columns: ["TP HCM", "Bắc Tân Uyên", "Thị trấn Tân Thành, Xã Đất Cuốc, Xã Tân Định"],
    },
    {
      columns: ["TP HCM", "Bến Cát", "Xã Tân Hưng (huyện Bàu Bàng), Xã Lai Hưng, Phường Mỹ Phước"],
    },
    {
      columns: [
        "TP HCM",
        "Bến Thành",
        "Phường Bến Thành, Phường Phạm Ngũ Lão, Phường Cầu Ông Lãnh, Phường Nguyễn Thái Bình",
      ],
    },
    {
      columns: ["TP HCM", "Bình Chánh", "Xã Tân Quý Tây, Xã Bình Chánh, Xã An Phú Tây"],
    },
    {
      columns: ["TP HCM", "Bình Châu", "Không sáp nhập"],
    },
    {
      columns: ["TP HCM", "Bình Cơ", "Xã Bình Mỹ (huyện Bắc Tân Uyên), Phường Hội Nghĩa"],
    },
    {
      columns: [
        "TP HCM",
        "Bình Dương",
        "Phường Phú Mỹ (thành phố Thủ Dầu Một), Phường Hòa Phú, Phường Phú Tân, Phường Phú Chánh",
      ],
    },
    {
      columns: [
        "TP HCM",
        "Bình Đông",
        "Phường 6 (Quận 8), Phường 7 (Quận 8), Xã An Phú Tây, Phường 5 (Quận 8)",
      ],
    },
    {
      columns: ["TP HCM", "Bình Giã", "Xã Bình Trung, Xã Quảng Thành, Xã Bình Giã"],
    },
    {
      columns: ["TP HCM", "Bình Hòa", "Phường Bình Hòa, Phường Vĩnh Phú"],
    },
    {
      columns: ["TP HCM", "Bình Hưng", "Xã Phong Phú, Xã Bình Hưng, Phường 7 (Quận 8)"],
    },
    {
      columns: [
        "TP HCM",
        "Bình Hưng Hòa",
        "Phường Bình Hưng Hòa, Phường Sơn Kỳ, Phường Bình Hưng Hòa A",
      ],
    },
    {
      columns: ["TP HCM", "Bình Khánh", "Xã Tam Thôn Hiệp, Xã Bình Khánh, Xã An Thới Đông"],
    },
    {
      columns: ["TP HCM", "Bình Lợi", "Xã Lê Minh Xuân, Xã Bình Lợi"],
    },
    {
      columns: ["TP HCM", "Bình Lợi Trung", "Phường 5, Phường 11, Phường 13 (quận Bình Thạnh)"],
    },
    {
      columns: ["TP HCM", "Bình Mỹ", "Xã Bình Mỹ (huyện Củ Chi), Xã Hòa Phú, Xã Trung An"],
    },
    {
      columns: ["TP HCM", "Bình Phú", "Phường 10, Phường 11 (Quận 6), Phường 16 (Quận 8)"],
    },
    {
      columns: ["TP HCM", "Bình Quới", "Phường 27, Phường 28"],
    },
    {
      columns: [
        "TP HCM",
        "Bình Tân",
        "Phường Bình Hưng Hòa B, Phường Bình Trị Đông A, Phường Tân Tạo",
      ],
    },
    {
      columns: ["TP HCM", "Bình Tây", "Phường 2, Phường 9 (Quận 6)"],
    },
    {
      columns: ["TP HCM", "Bình Thạnh", "Phường 12, Phường 14 (quận Bình Thạnh), Phường 26"],
    },
    {
      columns: ["TP HCM", "Bình Thới", "Phường 3, Phường 10 (Quận 11), Phường 8 (Quận 11)"],
    },
    {
      columns: ["TP HCM", "Bình Tiên", "Phường 1, Phường 7, Phường 8 (Quận 6)"],
    },
    {
      columns: [
        "TP HCM",
        "Bình Trị Đông",
        "Phường Bình Trị Đông, Phường Bình Hưng Hòa A, Phường Bình Trị Đông A",
      ],
    },
    {
      columns: [
        "TP HCM",
        "Bình Trưng",
        "Phường Bình Trưng Đông, Phường Bình Trưng Tây, Phường An Phú (thành phố Thủ Đức)",
      ],
    },
    {
      columns: ["TP HCM", "Cát Lái", "Phường Thạnh Mỹ Lợi, Phường Cát Lái"],
    },
    {
      columns: ["TP HCM", "Cần Giờ", "Xã Long Hòa (huyện Cần Giờ), Thị trấn Cần Thạnh"],
    },
    {
      columns: [
        "TP HCM",
        "Cầu Kiệu",
        "Phường 1, Phường 2, Phường 7 (quận Phú Nhuận), Phường 15 (quận Phú Nhuận)",
      ],
    },
    {
      columns: [
        "TP HCM",
        "Cầu Ông Lãnh",
        "Phường Nguyễn Cư Trinh, Phường Cầu Kho, Phường Cô Giang, Phường Cầu Ông Lãnh",
      ],
    },
    {
      columns: [
        "TP HCM",
        "Chánh Hiệp",
        "Phường Định Hòa, Phường Tương Bình Hiệp, Phường Hiệp An, Phường Chánh Mỹ",
      ],
    },
    {
      columns: [
        "TP HCM",
        "Chánh Hưng",
        "Phường 4 (Quận 8), Rạch Ông, Phường Hưng Phú, Phường 5 (Quận 8)",
      ],
    },
    {
      columns: ["TP HCM", "Chánh Phú Hòa", "Phường Chánh Phú Hòa, Xã Hưng Hòa"],
    },
    {
      columns: ["TP HCM", "Châu Đức", "Xã Cù Bị, Xã Xà Bang"],
    },
    {
      columns: ["TP HCM", "Châu Pha", "Xã Tóc Tiên, Xã Châu Pha"],
    },
    {
      columns: ["TP HCM", "Chợ Lớn", "Phường 11, Phường 12, Phường 13, Phường 14 (Quận 5)"],
    },
    {
      columns: ["TP HCM", "Chợ Quán", "Phường 1, Phường 2, Phường 4 (Quận 5)"],
    },
    {
      columns: ["TP HCM", "Côn Đảo", "Huyện Côn Đảo"],
    },
    {
      columns: ["TP HCM", "Củ Chi", "Xã Tân Phú Trung, Xã Tân Thông Hội, Xã Phước Vĩnh An"],
    },
    {
      columns: [
        "TP HCM",
        "Dầu Tiếng",
        "Thị trấn Dầu Tiếng, Xã Định An, Xã Định Thành, Xã Định Hiệp",
      ],
    },
    {
      columns: ["TP HCM", "Dĩ An", "Phường An Bình, Phường Dĩ An, Phường Tân Đông Hiệp"],
    },
    {
      columns: ["TP HCM", "Diên Hồng", "Phường 6, Phường 8 (Quận 10), Phường 14 (Quận 10)"],
    },
    {
      columns: [
        "TP HCM",
        "Đất Đỏ",
        "Thị trấn Đất Đỏ, Xã Long Tân (huyện Long Đất), Xã Láng Dài, Xã Phước Long Thọ",
      ],
    },
    {
      columns: ["TP HCM", "Đông Hòa", "Phường Bình An, Phường Bình Thắng, Phường Đông Hòa"],
    },
    {
      columns: [
        "TP HCM",
        "Đông Hưng Thuận",
        "Phường Tân Thới Nhất, Phường Tân Hưng Thuận, Phường Đông Hưng Thuận",
      ],
    },
    {
      columns: ["TP HCM", "Đông Thạnh", "Xã Thới Tam Thôn, Xã Nhị Bình, Xã Đông Thạnh"],
    },
    {
      columns: ["TP HCM", "Đức Nhuận", "Phường 4, Phường 5, Phường 9 (quận Phú Nhuận)"],
    },
    {
      columns: ["TP HCM", "Gia Định", "Phường 1, Phường 2, Phường 7, Phường 17 (quận Bình Thạnh)"],
    },
    {
      columns: ["TP HCM", "Gò Vấp", "Phường 10, Phường 17 (quận Gò Vấp)"],
    },
    {
      columns: ["TP HCM", "Hạnh Thông", "Phường 1, Phường 3 (quận Gò Vấp)"],
    },
    {
      columns: [
        "TP HCM",
        "Hiệp Bình",
        "Phường Hiệp Bình Chánh, Phường Hiệp Bình Phước, Phường Linh Đông",
      ],
    },
    {
      columns: ["TP HCM", "Hiệp Phước", "Xã Nhơn Đức, Xã Long Thới, Xã Hiệp Phước"],
    },
    {
      columns: ["TP HCM", "Hòa Bình", "Phường 5, Phường 14 (Quận 11)"],
    },
    {
      columns: ["TP HCM", "Hòa Hiệp", "Không sáp nhập"],
    },
    {
      columns: ["TP HCM", "Hòa Hội", "Xã Hòa Hưng, Xã Hòa Bình, Xã Hòa Hội"],
    },
    {
      columns: [
        "TP HCM",
        "Hòa Hưng",
        "Phường 12, Phường 13, Phường 15 (Quận 10), Phường 14 (Quận 10)",
      ],
    },
    {
      columns: ["TP HCM", "Hòa Lợi", "Phường Tân Định (thành phố Bến Cát), Phường Hòa Lợi"],
    },
    {
      columns: ["TP HCM", "Hóc Môn", "Xã Tân Hiệp (huyện Hóc Môn), Xã Tân Xuân, Thị trấn Hóc Môn"],
    },
    {
      columns: ["TP HCM", "Hồ Tràm", "Thị trấn Phước Bửu, Xã Phước Tân, Xã Phước Thuận"],
    },
    {
      columns: ["TP HCM", "Hưng Long", "Xã Đa Phước, Xã Qui Đức, Xã Hưng Long"],
    },
    {
      columns: [
        "TP HCM",
        "Khánh Hội",
        "Phường 8, Phường 9 (Quận 4), Phường 2, Phường 4 (Quận 4), Phường 15 (Quận 4)",
      ],
    },
    {
      columns: ["TP HCM", "Kim Long", "Thị trấn Kim Long, Xã Bàu Chinh, Xã Láng Lớn"],
    },
    {
      columns: ["TP HCM", "Lái Thiêu", "Phường Bình Nhâm, Phường Lái Thiêu, Phường Vĩnh Phú"],
    },
    {
      columns: ["TP HCM", "Linh Xuân", "Phường Linh Trung, Phường Linh Xuân, Phường Linh Tây"],
    },
    {
      columns: ["TP HCM", "Long Bình", "Phường Long Bình, Phường Long Thạnh Mỹ"],
    },
    {
      columns: ["TP HCM", "Long Điền", "Thị trấn Long Điền, Xã Tam An"],
    },
    {
      columns: ["TP HCM", "Long Hải", "Thị trấn Long Hải, Xã Phước Tỉnh, Xã Phước Hưng"],
    },
    {
      columns: [
        "TP HCM",
        "Long Hòa",
        "Xã Long Tân, Xã Long Hòa (huyện Dầu Tiếng), Xã Minh Tân, Xã Minh Thạnh",
      ],
    },
    {
      columns: [
        "TP HCM",
        "Long Hương",
        "Xã Tân Hưng (thành phố Bà Rịa), Phường Kim Dinh, Phường Long Hương",
      ],
    },
    {
      columns: ["TP HCM", "Long Nguyên", "Phường An Điền, Xã Long Nguyên, Phường Mỹ Phước"],
    },
    {
      columns: ["TP HCM", "Long Phước", "Phường Trường Thạnh, Phường Long Phước"],
    },
    {
      columns: ["TP HCM", "Long Sơn", "Không sáp nhập"],
    },
    {
      columns: ["TP HCM", "Long Trường", "Phường Phú Hữu, Phường Long Trường"],
    },
    {
      columns: ["TP HCM", "Minh Phụng", "Phường 1, Phường 7, Phường 16 (Quận 11)"],
    },
    {
      columns: ["TP HCM", "Minh Thạnh", "Xã Minh Hòa, Xã Minh Tân, Xã Minh Thạnh"],
    },
    {
      columns: ["TP HCM", "Ngãi Giao", "Thị trấn Ngãi Giao, Xã Bình Ba, Xã Suối Nghệ"],
    },
    {
      columns: ["TP HCM", "Nghĩa Thành", "Xã Đá Bạc, Xã Nghĩa Thành"],
    },
    {
      columns: ["TP HCM", "Nhà Bè", "Thị trấn Nhà Bè, Xã Phú Xuân, Xã Phước Kiển, Xã Phước Lộc"],
    },
    {
      columns: ["TP HCM", "Nhiêu Lộc", "Phường 9, Phường 11, Phường 12, Phường 14 (Quận 3)"],
    },
    {
      columns: ["TP HCM", "Nhuận Đức", "Xã Phạm Văn Cội, Xã Trung Lập Hạ, Xã Nhuận Đức"],
    },
    {
      columns: ["TP HCM", "Phú An", "Phường Tân An, Xã Phú An, Phường Hiệp An"],
    },
    {
      columns: [
        "TP HCM",
        "Phú Định",
        "Phường 14, Phường 15 (Quận 8), Phường Xóm Củi, Phường 16 (Quận 8)",
      ],
    },
    {
      columns: ["TP HCM", "Phú Giáo", "Thị trấn Phước Vĩnh, Xã An Bình, Xã Tam Lập"],
    },
    {
      columns: ["TP HCM", "Phú Hòa Đông", "Xã Tân Thạnh Tây, Xã Tân Thạnh Đông, Xã Phú Hòa Đông"],
    },
    {
      columns: ["TP HCM", "Phú Lâm", "Phường 12, Phường 13, Phường 14 (Quận 6)"],
    },
    {
      columns: [
        "TP HCM",
        "Phú Lợi",
        "Phường Phú Hòa, Phường Phú Lợi, Phường Hiệp Thành (thành phố Thủ Dầu Một)",
      ],
    },
    {
      columns: ["TP HCM", "Phú Mỹ", "Phường Phú Mỹ (thành phố Phú Mỹ), Phường Mỹ Xuân"],
    },
    {
      columns: [
        "TP HCM",
        "Phú Nhuận",
        "Phường 8, Phường 10, Phường 11, Phường 13 (quận Phú Nhuận), Phường 15 (quận Phú Nhuận)",
      ],
    },
    {
      columns: ["TP HCM", "Phú Thạnh", "Phường Hiệp Tân, Phường Phú Thạnh, Phường Tân Thới Hòa"],
    },
    {
      columns: ["TP HCM", "Phú Thọ", "Phường 11, Phường 15 (Quận 11), Phường 8 (Quận 11)"],
    },
    {
      columns: ["TP HCM", "Phú Thọ Hòa", "Phường Phú Thọ Hòa, Phường Tân Thành, Phường Tân Quý"],
    },
    {
      columns: ["TP HCM", "Phú Thuận", "Phường Phú Thuận, Phường Phú Mỹ (Quận 7)"],
    },
    {
      columns: ["TP HCM", "Phước Hải", "Thị trấn Phước Hải, Xã Phước Hội"],
    },
    {
      columns: ["TP HCM", "Phước Hòa", "Xã Vĩnh Hòa, Xã Phước Hòa, Xã Tam Lập"],
    },
    {
      columns: [
        "TP HCM",
        "Phước Long",
        "Phường Phước Bình, Phường Phước Long A, Phường Phước Long B",
      ],
    },
    {
      columns: ["TP HCM", "Phước Thành", "Xã Tân Hiệp (huyện Phú Giáo), Xã An Thái, Xã Phước Sang"],
    },
    {
      columns: ["TP HCM", "Phước Thắng", "Phường 11, Phường 12 (thành phố Vũng Tàu)"],
    },
    {
      columns: [
        "TP HCM",
        "Rạch Dừa",
        "Phường 10 (thành phố Vũng Tàu), Phường Thắng Nhất, Phường Rạch Dừa",
      ],
    },
    {
      columns: ["TP HCM", "Sài Gòn", "Phường Bến Nghé, Phường Đa Kao, Phường Nguyễn Thái Bình"],
    },
    {
      columns: ["TP HCM", "Tam Bình", "Phường Bình Chiểu, Phường Tam Phú, Phường Tam Bình"],
    },
    {
      columns: ["TP HCM", "Tam Long", "Phường Long Tâm, Xã Hòa Long, Xã Long Phước"],
    },
    {
      columns: [
        "TP HCM",
        "Tam Thắng",
        "Phường 7, Phường 8, Phường 9 (thành phố Vũng Tàu), Phường Nguyễn An Ninh",
      ],
    },
    {
      columns: [
        "TP HCM",
        "Tăng Nhơn Phú",
        "Phường Tân Phú (thành phố Thủ Đức), Phường Hiệp Phú, Phường Tăng Nhơn Phú A, Phường Tăng Nhơn Phú B, Phường Long Thạnh Mỹ",
      ],
    },
    {
      columns: ["TP HCM", "Tân An Hội", "Thị trấn Củ Chi, Xã Phước Hiệp, Xã Tân An Hội"],
    },
    {
      columns: [
        "TP HCM",
        "Tân Bình",
        "Phường 13, Phường 14 (quận Tân Bình), Phường 15 (quận Tân Bình)",
      ],
    },
    {
      columns: ["TP HCM", "Tân Định", "Phường Tân Định (Quận 1), Phường Đa Kao"],
    },
    {
      columns: [
        "TP HCM",
        "Tân Đông Hiệp",
        "Phường Tân Bình, Phường Thái Hòa, Phường Tân Đông Hiệp",
      ],
    },
    {
      columns: ["TP HCM", "Tân Hải", "Phường Tân Hòa, Phường Tân Hải"],
    },
    {
      columns: ["TP HCM", "Tân Hiệp", "Phường Khánh Bình, Phường Tân Hiệp"],
    },
    {
      columns: ["TP HCM", "Tân Hòa", "Phường 6, Phường 8, Phường 9 (quận Tân Bình)"],
    },
    {
      columns: [
        "TP HCM",
        "Tân Hưng",
        "Phường Tân Phong, Phường Tân Quy, Phường Tân Kiểng, Phường Tân Hưng",
      ],
    },
    {
      columns: [
        "TP HCM",
        "Tân Khánh",
        "Phường Thạnh Phước, Phường Tân Phước Khánh, Phường Tân Vĩnh Hiệp, Xã Thạnh Hội, Phường Thái Hòa",
      ],
    },
    {
      columns: ["TP HCM", "Tân Mỹ", "Phường Tân Phú (Quận 7), Phường Phú Mỹ (Quận 7)"],
    },
    {
      columns: [
        "TP HCM",
        "Tân Nhựt",
        "Thị trấn Tân Túc, Xã Tân Nhựt, Phường Tân Tạo A, Xã Tân Kiên, Phường 16 (Quận 8)",
      ],
    },
    {
      columns: [
        "TP HCM",
        "Tân Phú",
        "Phường Phú Trung, Phường Hòa Thạnh, Phường Tân Thới Hòa, Phường Tân Thành",
      ],
    },
    {
      columns: ["TP HCM", "Tân Phước", "Phường Phước Hòa, Phường Tân Phước"],
    },
    {
      columns: ["TP HCM", "Tân Sơn", "Phường 15 (quận Tân Bình)"],
    },
    {
      columns: ["TP HCM", "Tân Sơn Hòa", "Phường 1, Phường 2, Phường 3 (quận Tân Bình)"],
    },
    {
      columns: ["TP HCM", "Tân Sơn Nhất", "Phường 4, Phường 5, Phường 7 (quận Tân Bình)"],
    },
    {
      columns: [
        "TP HCM",
        "Tân Sơn Nhì",
        "Phường Tân Sơn Nhì, Phường Sơn Kỳ, Phường Tân Quý, Phường Tân Thành",
      ],
    },
    {
      columns: ["TP HCM", "Tân Tạo", "Xã Tân Kiên, Phường Tân Tạo A, Phường Tân Tạo"],
    },
    {
      columns: ["TP HCM", "Tân Thành", "Phường Hắc Dịch, Xã Sông Xoài"],
    },
    {
      columns: ["TP HCM", "Tân Thới Hiệp", "Phường Hiệp Thành (Quận 12), Phường Tân Thới Hiệp"],
    },
    {
      columns: [
        "TP HCM",
        "Tân Thuận",
        "Phường Bình Thuận, Phường Tân Thuận Đông, Phường Tân Thuận Tây",
      ],
    },
    {
      columns: ["TP HCM", "Tân Uyên", "Phường Uyên Hưng, Xã Bạch Đằng, Xã Tân Lập, Xã Tân Mỹ"],
    },
    {
      columns: ["TP HCM", "Tân Vĩnh Lộc", "Xã Vĩnh Lộc B, Xã Phạm Văn Hai, Phường Tân Tạo"],
    },
    {
      columns: ["TP HCM", "Tây Nam", "Phường An Tây, Xã Thanh Tuyền, Xã An Lập"],
    },
    {
      columns: ["TP HCM", "Tây Thạnh", "Phường Tây Thạnh, Phường Sơn Kỳ"],
    },
    {
      columns: ["TP HCM", "Thái Mỹ", "Xã Trung Lập Thượng, Xã Phước Thạnh, Xã Thái Mỹ"],
    },
    {
      columns: ["TP HCM", "Thanh An", "Xã Thanh An, Xã Định Hiệp, Xã Thanh Tuyền, Xã An Lập"],
    },
    {
      columns: ["TP HCM", "Thạnh An", "Không sáp nhập"],
    },
    {
      columns: ["TP HCM", "Thạnh Mỹ Tây", "Phường 19, Phường 22, Phường 25"],
    },
    {
      columns: ["TP HCM", "Thông Tây Hội", "Phường 8, Phường 11 (quận Gò Vấp)"],
    },
    {
      columns: ["TP HCM", "Thới An", "Phường Thạnh Xuân, Phường Thới An"],
    },
    {
      columns: ["TP HCM", "Thới Hòa", "Không sáp nhập"],
    },
    {
      columns: [
        "TP HCM",
        "Thủ Dầu Một",
        "Phường Phú Cường, Phường Phú Thọ, Phường Chánh Nghĩa, Phường Hiệp Thành (thành phố Thủ Dầu Một), Phường Chánh Mỹ",
      ],
    },
    {
      columns: [
        "TP HCM",
        "Thủ Đức",
        "Phường Bình Thọ, Phường Linh Chiểu, Phường Trường Thọ, Phường Linh Tây, Phường Linh Đông",
      ],
    },
    {
      columns: ["TP HCM", "Thuận An", "Phường Hưng Định, Phường An Thạnh, Xã An Sơn"],
    },
    {
      columns: ["TP HCM", "Thuận Giao", "Phường Thuận Giao, Phường Bình Chuẩn"],
    },
    {
      columns: ["TP HCM", "Thường Tân", "Xã Lạc An, Xã Hiếu Liêm, Xã Thường Tân, Xã Tân Mỹ"],
    },
    {
      columns: ["TP HCM", "Trung Mỹ Tây", "Phường Tân Chánh Hiệp, Phường Trung Mỹ Tây"],
    },
    {
      columns: ["TP HCM", "Trừ Văn Thố", "Xã Trừ Văn Thố, Xã Cây Trường II, Thị trấn Lai Uyên"],
    },
    {
      columns: ["TP HCM", "Vĩnh Hội", "Phường 1, Phường 3 (Quận 4), Phường 2, Phường 4 (Quận 4)"],
    },
    {
      columns: ["TP HCM", "Vĩnh Lộc", "Xã Vĩnh Lộc A, Xã Phạm Văn Hai"],
    },
    {
      columns: ["TP HCM", "Vĩnh Tân", "Phường Vĩnh Tân, Thị trấn Tân Bình"],
    },
    {
      columns: [
        "TP HCM",
        "Vũng Tàu",
        "Phường 1, Phường 2, Phường 3, Phường 4, Phường 5 (thành phố Vũng Tàu), Phường Thắng Nhì, Phường Thắng Tam",
      ],
    },
    {
      columns: [
        "TP HCM",
        "Vườn Lài",
        "Phường 1, Phường 2, Phường 4, Phường 9, Phường 10 (Quận 10)",
      ],
    },
    {
      columns: ["TP HCM", "Xóm Chiếu", "Phường 13, Phường 16, Phường 18, Phường 15 (Quận 4)"],
    },
    {
      columns: ["TP HCM", "Xuân Hòa", "Phường Võ Thị Sáu, Phường 4 (Quận 3)"],
    },
    {
      columns: ["TP HCM", "Xuân Sơn", "Xã Suối Rao, Xã Sơn Bình, Xã Xuân Sơn"],
    },
    {
      columns: ["TP HCM", "Xuân Thới Sơn", "Xã Tân Thới Nhì, Xã Xuân Thới Đông, Xã Xuân Thới Sơn"],
    },
    {
      columns: ["TP HCM", "Xuyên Mộc", "Xã Bông Trang, Xã Bưng Riềng, Xã Xuyên Mộc"],
    },
    {
      columns: [
        "Tuyên Quang",
        "An Tường",
        "Phường Hưng Thành, Phường An Tường, Xã Lưỡng Vượng, Xã An Khang, Xã Hoàng Khai",
      ],
    },
    {
      columns: ["Tuyên Quang", "Bạch Đích", "Xã Phú Lũng, Xã Na Khê, Xã Bạch Đích"],
    },
    {
      columns: ["Tuyên Quang", "Bạch Ngọc", "Xã Ngọc Minh, Xã Bạch Ngọc"],
    },
    {
      columns: ["Tuyên Quang", "Bạch Xa", "Xã Yên Thuận, Xã Minh Khương, Xã Bạch Xa"],
    },
    {
      columns: ["Tuyên Quang", "Bản Máy", "Xã Bản Phùng, Xã Chiến Phố, Xã Bản Máy"],
    },
    {
      columns: ["Tuyên Quang", "Bắc Mê", "Thị trấn Yên Phú, Xã Yên Phong, Xã Lạc Nông"],
    },
    {
      columns: ["Tuyên Quang", "Bắc Quang", "Thị trấn Việt Quang, Xã Quang Minh, Xã Việt Vinh"],
    },
    {
      columns: ["Tuyên Quang", "Bằng Hành", "Xã Kim Ngọc, Xã Vô Điếm, Xã Bằng Hành"],
    },
    {
      columns: ["Tuyên Quang", "Bằng Lang", "Xã Yên Hà, Xã Bằng Lang"],
    },
    {
      columns: ["Tuyên Quang", "Bình An", "Xã Thổ Bình, Xã Bình An"],
    },
    {
      columns: ["Tuyên Quang", "Bình Ca", "Xã Thượng Ấm, Xã Cấp Tiến, Xã Vĩnh Lợi"],
    },
    {
      columns: ["Tuyên Quang", "Bình Thuận", "Phường Đội Cấn, Xã Thái Long"],
    },
    {
      columns: ["Tuyên Quang", "Bình Xa", "Xã Minh Hương, Xã Bình Xa"],
    },
    {
      columns: ["Tuyên Quang", "Cán Tỷ", "Xã Bát Đại Sơn, Xã Cán Tỷ"],
    },
    {
      columns: ["Tuyên Quang", "Cao Bồ", "Không sáp nhập"],
    },
    {
      columns: [
        "Tuyên Quang",
        "Chiêm Hóa",
        "Thị trấn Vĩnh Lộc, Xã Xuân Quang, Xã Phúc Thịnh, Xã Ngọc Hội, Xã Trung Hòa",
      ],
    },
    {
      columns: ["Tuyên Quang", "Côn Lôn", "Xã Sinh Long, Xã Côn Lôn"],
    },
    {
      columns: ["Tuyên Quang", "Du Già", "Xã Du Tiến, Xã Du Già"],
    },
    {
      columns: ["Tuyên Quang", "Đồng Tâm", "Xã Đồng Tiến, Xã Tân Phước, Xã Đồng Tâm"],
    },
    {
      columns: ["Tuyên Quang", "Đông Thọ", "Xã Đồng Quý, Xã Quyết Thắng, Xã Đông Thọ"],
    },
    {
      columns: [
        "Tuyên Quang",
        "Đồng Văn",
        "Thị trấn Đồng Văn, Xã Tả Lủng (huyện Đồng Văn), Xã Tả Phìn, Xã Thài Phìn Tủng, Xã Pải Lủng",
      ],
    },
    {
      columns: ["Tuyên Quang", "Đồng Yên", "Xã Vĩnh Phúc, Xã Đồng Yên"],
    },
    {
      columns: ["Tuyên Quang", "Đường Hồng", "Xã Đường Âm, Xã Phú Nam, Xã Đường Hồng"],
    },
    {
      columns: ["Tuyên Quang", "Đường Thượng", "Xã Lũng Hồ, Xã Đường Thượng"],
    },
    {
      columns: ["Tuyên Quang", "Giáp Trung", "Không sáp nhập"],
    },
    {
      columns: [
        "Tuyên Quang",
        "Hà Giang 1",
        "Phường Nguyễn Trãi, Xã Phương Thiện, Xã Phương Độ, Phường Quang Trung",
      ],
    },
    {
      columns: [
        "Tuyên Quang",
        "Hà Giang 2",
        "Phường Ngọc Hà, Phường Trần Phú, Phường Minh Khai, Phường Quang Trung, Xã Phong Quang",
      ],
    },
    {
      columns: [
        "Tuyên Quang",
        "Hàm Yên",
        "Thị trấn Tân Yên, Xã Tân Thành (huyện Hàm Yên), Xã Bằng Cốc, Xã Nhân Mục",
      ],
    },
    {
      columns: ["Tuyên Quang", "Hòa An", "Xã Tân Thịnh, Xã Nhân Lý, Xã Hòa An"],
    },
    {
      columns: [
        "Tuyên Quang",
        "Hoàng Su Phì",
        "Thị trấn Vinh Quang, Xã Bản Luốc, Xã Ngàm Đăng Vài, Xã Tụ Nhân, Xã Đản Ván",
      ],
    },
    {
      columns: ["Tuyên Quang", "Hồ Thầu", "Xã Nậm Khòa, Xã Nam Sơn, Xã Hồ Thầu"],
    },
    {
      columns: ["Tuyên Quang", "Hồng Sơn", "Xã Chi Thiết, Xã Văn Phú, Xã Hồng Sơn"],
    },
    {
      columns: ["Tuyên Quang", "Hồng Thái", "Xã Đà Vị, Xã Sơn Phú, Xã Hồng Thái"],
    },
    {
      columns: ["Tuyên Quang", "Hùng An", "Xã Việt Hồng, Xã Tiên Kiều, Xã Hùng An"],
    },
    {
      columns: ["Tuyên Quang", "Hùng Đức", "Không sáp nhập"],
    },
    {
      columns: ["Tuyên Quang", "Hùng Lợi", "Xã Trung Minh, Xã Hùng Lợi"],
    },
    {
      columns: ["Tuyên Quang", "Khâu Vai", "Xã Cán Chu Phìn, Xã Lũng Pù, Xã Khâu Vai"],
    },
    {
      columns: ["Tuyên Quang", "Khuôn Lùng", "Xã Nà Chì, Xã Khuôn Lùng"],
    },
    {
      columns: ["Tuyên Quang", "Kiên Đài", "Xã Phú Bình, Xã Kiên Đài"],
    },
    {
      columns: ["Tuyên Quang", "Kiến Thiết", "Không sáp nhập"],
    },
    {
      columns: ["Tuyên Quang", "Kim Bình", "Xã Vinh Quang, Xã Bình Nhân, Xã Kim Bình"],
    },
    {
      columns: ["Tuyên Quang", "Lao Chải", "Xã Xín Chải, Xã Thanh Đức, Xã Lao Chải"],
    },
    {
      columns: ["Tuyên Quang", "Lâm Bình", "Thị trấn Lăng Can, Xã Phúc Yên, Xã Xuân Lập"],
    },
    {
      columns: ["Tuyên Quang", "Liên Hiệp", "Xã Hữu Sản, Xã Đức Xuân, Xã Liên Hiệp"],
    },
    {
      columns: ["Tuyên Quang", "Linh Hồ", "Xã Ngọc Linh, Xã Trung Thành, Xã Linh Hồ"],
    },
    {
      columns: ["Tuyên Quang", "Lũng Cú", "Xã Má Lé, Xã Lũng Táo, Xã Lũng Cú"],
    },
    {
      columns: ["Tuyên Quang", "Lũng Phìn", "Xã Sủng Trái, Xã Hố Quáng Phìn, Xã Lũng Phìn"],
    },
    {
      columns: ["Tuyên Quang", "Lùng Tám", "Xã Thái An, Xã Đông Hà, Xã Lùng Tám"],
    },
    {
      columns: ["Tuyên Quang", "Lực Hành", "Xã Quý Quân, Xã Chiêu Yên, Xã Lực Hành"],
    },
    {
      columns: ["Tuyên Quang", "Mậu Duệ", "Xã Ngam La, Xã Mậu Long, Xã Mậu Duệ"],
    },
    {
      columns: [
        "Tuyên Quang",
        "Mèo Vạc",
        "Thị trấn Mèo Vạc, Xã Tả Lủng (huyện Mèo Vạc), Xã Giàng Chu Phìn, Xã Pả Vi",
      ],
    },
    {
      columns: ["Tuyên Quang", "Minh Ngọc", "Xã Minh Ngọc, Xã Thượng Tân, Xã Yên Định"],
    },
    {
      columns: ["Tuyên Quang", "Minh Quang", "Xã Phúc Sơn, Xã Hồng Quang, Xã Minh Quang"],
    },
    {
      columns: ["Tuyên Quang", "Minh Sơn", "Không sáp nhập"],
    },
    {
      columns: ["Tuyên Quang", "Minh Tân", "Không sáp nhập"],
    },
    {
      columns: ["Tuyên Quang", "Minh Thanh", "Xã Bình Yên, Xã Lương Thiện, Xã Minh Thanh"],
    },
    {
      columns: [
        "Tuyên Quang",
        "Minh Xuân",
        "Phường Ỷ La, Phường Tân Hà, Phường Phan Thiết, Phường Minh Xuân, Phường Tân Quang, Xã Kim Phú",
      ],
    },
    {
      columns: ["Tuyên Quang", "Mỹ Lâm", "Phường Mỹ Lâm, Xã Mỹ Bằng, Xã Kim Phú"],
    },
    {
      columns: ["Tuyên Quang", "Nà Hang", "Thị trấn Na Hang, Xã Năng Khả, Xã Thanh Tương"],
    },
    {
      columns: ["Tuyên Quang", "Nấm Dẩn", "Xã Chế Là, Xã Tả Nhìu, Xã Nấm Dẩn"],
    },
    {
      columns: ["Tuyên Quang", "Nậm Dịch", "Xã Nậm Ty, Xã Tả Sử Choóng, Xã Nậm Dịch"],
    },
    {
      columns: ["Tuyên Quang", "Nghĩa Thuận", "Xã Thanh Vân, Xã Nghĩa Thuận"],
    },
    {
      columns: ["Tuyên Quang", "Ngọc Đường", "Xã Ngọc Đường, Xã Yên Định"],
    },
    {
      columns: ["Tuyên Quang", "Ngọc Long", "Không sáp nhập"],
    },
    {
      columns: ["Tuyên Quang", "Nhữ Khê", "Xã Nhữ Hán, Xã Đội Bình, Xã Nhữ Khê"],
    },
    {
      columns: ["Tuyên Quang", "Niêm Sơn", "Xã Niêm Tòng, Xã Niêm Sơn"],
    },
    {
      columns: ["Tuyên Quang", "Nông Tiến", "Phường Nông Tiến, Xã Tràng Đà, Xã Thái Bình"],
    },
    {
      columns: [
        "Tuyên Quang",
        "Pà Vầy Sủ",
        "Thị trấn Cốc Pài, Xã Nàn Ma, Xã Bản Ngò, Xã Pà Vầy Sủ",
      ],
    },
    {
      columns: [
        "Tuyên Quang",
        "Phố Bảng",
        "Thị trấn Phố Bảng, Xã Phố Là, Xã Phố Cáo, Xã Lũng Thầu",
      ],
    },
    {
      columns: ["Tuyên Quang", "Phú Linh", "Xã Kim Thạch, Xã Kim Linh, Xã Phú Linh"],
    },
    {
      columns: ["Tuyên Quang", "Phú Lương", "Xã Đại Phú, Xã Tam Đa, Xã Phú Lương"],
    },
    {
      columns: ["Tuyên Quang", "Phù Lưu", "Xã Minh Dân, Xã Phù Lưu"],
    },
    {
      columns: ["Tuyên Quang", "Pờ Ly Ngài", "Xã Sán Sả Hồ, Xã Nàng Đôn, Xã Pờ Ly Ngài"],
    },
    {
      columns: ["Tuyên Quang", "Quản Bạ", "Thị trấn Tam Sơn, Xã Quyết Tiến, Xã Quản Bạ"],
    },
    {
      columns: ["Tuyên Quang", "Quang Bình", "Thị trấn Yên Bình, Xã Tân Nam"],
    },
    {
      columns: ["Tuyên Quang", "Quảng Nguyên", "Không sáp nhập"],
    },
    {
      columns: ["Tuyên Quang", "Sà Phìn", "Xã Sủng Là, Xã Sính Lủng, Xã Sảng Tủng, Xã Sà Phìn"],
    },
    {
      columns: [
        "Tuyên Quang",
        "Sơn Dương",
        "Thị trấn Sơn Dương, Xã Hợp Thành, Xã Phúc Ứng, Xã Tú Thịnh",
      ],
    },
    {
      columns: ["Tuyên Quang", "Sơn Thủy", "Xã Ninh Lai, Xã Thiện Kế, Xã Sơn Nam"],
    },
    {
      columns: ["Tuyên Quang", "Sơn Vĩ", "Xã Thượng Phùng, Xã Xín Cái, Xã Sơn Vĩ"],
    },
    {
      columns: ["Tuyên Quang", "Sủng Máng", "Xã Lũng Chinh, Xã Sủng Trà, Xã Sủng Máng"],
    },
    {
      columns: ["Tuyên Quang", "Tát Ngà", "Xã Nậm Ban, Xã Tát Ngà"],
    },
    {
      columns: ["Tuyên Quang", "Tân An", "Xã Hà Lang, Xã Tân An"],
    },
    {
      columns: ["Tuyên Quang", "Tân Long", "Xã Tân Tiến (huyện Yên Sơn), Xã Tân Long"],
    },
    {
      columns: ["Tuyên Quang", "Tân Mỹ", "Xã Hùng Mỹ, Xã Tân Mỹ"],
    },
    {
      columns: [
        "Tuyên Quang",
        "Tân Quang",
        "Xã Tân Thành (huyện Bắc Quang), Xã Tân Lập, Xã Tân Quang",
      ],
    },
    {
      columns: ["Tuyên Quang", "Tân Thanh", "Xã Kháng Nhật, Xã Hợp Hòa, Xã Tân Thanh"],
    },
    {
      columns: [
        "Tuyên Quang",
        "Tân Tiến",
        "Xã Tân Tiến (huyện Hoàng Su Phì), Xã Bản Nhùng, Xã Túng Sán",
      ],
    },
    {
      columns: ["Tuyên Quang", "Tân Trào", "Xã Kim Quan, Xã Trung Yên, Xã Tân Trào"],
    },
    {
      columns: ["Tuyên Quang", "Tân Trịnh", "Xã Tân Bắc, Xã Tân Trịnh"],
    },
    {
      columns: ["Tuyên Quang", "Thái Bình", "Xã Phú Thịnh, Xã Tiến Bộ, Xã Thái Bình"],
    },
    {
      columns: ["Tuyên Quang", "Thái Hòa", "Xã Đức Ninh, Xã Thái Hòa"],
    },
    {
      columns: ["Tuyên Quang", "Thái Sơn", "Xã Thành Long, Xã Thái Sơn"],
    },
    {
      columns: ["Tuyên Quang", "Thàng Tín", "Xã Pố Lồ, Xã Thèn Chu Phìn, Xã Thàng Tín"],
    },
    {
      columns: ["Tuyên Quang", "Thanh Thủy", "Xã Phương Tiến, Xã Thanh Thủy"],
    },
    {
      columns: ["Tuyên Quang", "Thắng Mố", "Xã Sủng Cháng, Xã Sủng Thài, Xã Thắng Mố"],
    },
    {
      columns: ["Tuyên Quang", "Thông Nguyên", "Xã Xuân Minh, Xã Thông Nguyên"],
    },
    {
      columns: ["Tuyên Quang", "Thuận Hòa", "Không sáp nhập"],
    },
    {
      columns: ["Tuyên Quang", "Thượng Lâm", "Xã Khuôn Hà, Xã Thượng Lâm"],
    },
    {
      columns: ["Tuyên Quang", "Thượng Nông", "Xã Thượng Giáp, Xã Thượng Nông"],
    },
    {
      columns: ["Tuyên Quang", "Thượng Sơn", "Không sáp nhập"],
    },
    {
      columns: ["Tuyên Quang", "Tiên Nguyên", "Không sáp nhập"],
    },
    {
      columns: ["Tuyên Quang", "Tiên Yên", "Xã Vĩ Thượng, Xã Hương Sơn, Xã Tiên Yên"],
    },
    {
      columns: ["Tuyên Quang", "Tri Phú", "Xã Linh Phú, Xã Tri Phú"],
    },
    {
      columns: ["Tuyên Quang", "Trung Hà", "Không sáp nhập"],
    },
    {
      columns: ["Tuyên Quang", "Trung Sơn", "Xã Đạo Viện, Xã Công Đa, Xã Trung Sơn"],
    },
    {
      columns: ["Tuyên Quang", "Trung Thịnh", "Xã Cốc Rế, Xã Thu Tà, Xã Trung Thịnh"],
    },
    {
      columns: ["Tuyên Quang", "Trường Sinh", "Xã Hào Phú, Xã Đông Lợi, Xã Trường Sinh"],
    },
    {
      columns: ["Tuyên Quang", "Tùng Bá", "Không sáp nhập"],
    },
    {
      columns: ["Tuyên Quang", "Tùng Vài", "Xã Cao Mã Pờ, Xã Tả Ván, Xã Tùng Vài"],
    },
    {
      columns: [
        "Tuyên Quang",
        "Vị Xuyên",
        "Thị trấn Vị Xuyên, Thị trấn Nông trường Việt Lâm, Xã Đạo Đức, Xã Việt Lâm",
      ],
    },
    {
      columns: ["Tuyên Quang", "Việt Lâm", "Xã Quảng Ngần, Xã Việt Lâm"],
    },
    {
      columns: ["Tuyên Quang", "Vĩnh Tuy", "Thị trấn Vĩnh Tuy, Xã Vĩnh Hảo, Xã Đông Thành"],
    },
    {
      columns: [
        "Tuyên Quang",
        "Xín Mần",
        "Xã Thèn Phàng, Xã Nàn Xỉn, Xã Bản Díu, Xã Chí Cà, Xã Xín Mần",
      ],
    },
    {
      columns: ["Tuyên Quang", "Xuân Giang", "Xã Nà Khương, Xã Xuân Giang"],
    },
    {
      columns: ["Tuyên Quang", "Xuân Vân", "Xã Trung Trực, Xã Phúc Ninh, Xã Xuân Vân"],
    },
    {
      columns: ["Tuyên Quang", "Yên Cường", "Xã Phiêng Luông, Xã Yên Cường"],
    },
    {
      columns: ["Tuyên Quang", "Yên Hoa", "Xã Khâu Tinh, Xã Yên Hoa"],
    },
    {
      columns: ["Tuyên Quang", "Yên Lập", "Xã Bình Phú, Xã Yên Lập"],
    },
    {
      columns: [
        "Tuyên Quang",
        "Yên Minh",
        "Thị trấn Yên Minh, Xã Lao Và Chải, Xã Hữu Vinh, Xã Đông Minh, Xã Vần Chải",
      ],
    },
    {
      columns: ["Tuyên Quang", "Yên Nguyên", "Xã Hòa Phú, Xã Yên Nguyên"],
    },
    {
      columns: ["Tuyên Quang", "Yên Phú", "Xã Yên Lâm, Xã Yên Phú"],
    },
    {
      columns: [
        "Tuyên Quang",
        "Yên Sơn",
        "Thị trấn Yên Sơn, Xã Tứ Quận, Xã Lang Quán, Xã Chân Sơn",
      ],
    },
    {
      columns: ["Tuyên Quang", "Yên Thành", "Xã Bản Rịa, Xã Yên Thành"],
    },
    {
      columns: ["Vĩnh Long", "An Bình", "Xã Hòa Ninh, Xã Bình Hòa Phước, Xã Đồng Phú, Xã An Bình"],
    },
    {
      columns: ["Vĩnh Long", "An Định", "Xã Tân Trung, Xã Minh Đức, Xã An Định"],
    },
    {
      columns: ["Vĩnh Long", "An Hiệp", "Xã Tân Hưng, Xã An Ngãi Tây, Xã An Hiệp"],
    },
    {
      columns: ["Vĩnh Long", "An Hội", "Phường An Hội, Xã Mỹ Thạnh An, Xã Phú Nhuận, Xã Sơn Phú"],
    },
    {
      columns: [
        "Vĩnh Long",
        "An Ngãi Trung",
        "Xã Mỹ Thạnh (huyện Ba Tri), Xã An Phú Trung, Xã An Ngãi Trung",
      ],
    },
    {
      columns: ["Vĩnh Long", "An Phú Tân", "Xã Hòa Tân, Xã An Phú Tân"],
    },
    {
      columns: ["Vĩnh Long", "An Qui", "Xã An Thuận, Xã An Nhơn, Xã An Qui"],
    },
    {
      columns: [
        "Vĩnh Long",
        "An Trường",
        "Xã Tân Bình (huyện Càng Long), Xã An Trường A, Xã An Trường",
      ],
    },
    {
      columns: [
        "Vĩnh Long",
        "Ba Tri",
        "Thị trấn Ba Tri, Xã Vĩnh Hòa (huyện Ba Tri), Xã An Đức, Xã Vĩnh An, Xã An Bình Tây",
      ],
    },
    {
      columns: ["Vĩnh Long", "Bảo Thạnh", "Xã Bảo Thuận, Xã Bảo Thạnh"],
    },
    {
      columns: ["Vĩnh Long", "Bến Tre", "Phường 7, Xã Bình Phú (thành phố Bến Tre), Xã Thanh Tân"],
    },
    {
      columns: ["Vĩnh Long", "Bình Đại", "Thị trấn Bình Đại, Xã Bình Thới, Xã Bình Thắng"],
    },
    {
      columns: ["Vĩnh Long", "Bình Minh", "Xã Thuận An, Phường Thành Phước, Phường Cái Vồn"],
    },
    {
      columns: [
        "Vĩnh Long",
        "Bình Phú",
        "Xã Bình Phú (huyện Càng Long), Xã Đại Phúc, Xã Phương Thạnh",
      ],
    },
    {
      columns: [
        "Vĩnh Long",
        "Bình Phước",
        "Xã Long Mỹ (huyện Mang Thít), Xã Hòa Tịnh, Xã Bình Phước",
      ],
    },
    {
      columns: ["Vĩnh Long", "Cái Ngang", "Xã Mỹ Lộc, Xã Tân Lộc, Xã Hậu Lộc, Xã Phú Lộc"],
    },
    {
      columns: [
        "Vĩnh Long",
        "Cái Nhum",
        "Xã An Phước (huyện Mang Thít), Xã Chánh An, Thị trấn Cái Nhum",
      ],
    },
    {
      columns: [
        "Vĩnh Long",
        "Cái Vồn",
        "Xã Mỹ Hòa (thị xã Bình Minh), Xã Ngãi Tứ, Phường Thành Phước, Phường Cái Vồn",
      ],
    },
    {
      columns: ["Vĩnh Long", "Càng Long", "Thị trấn Càng Long, Xã Mỹ Cẩm, Xã Nhị Long Phú"],
    },
    {
      columns: ["Vĩnh Long", "Cầu Kè", "Thị trấn Cầu Kè, Xã Hòa Ân, Xã Châu Điền"],
    },
    {
      columns: [
        "Vĩnh Long",
        "Cầu Ngang",
        "Xã Mỹ Hòa (huyện Cầu Ngang), Xã Thuận Hòa, Thị trấn Cầu Ngang",
      ],
    },
    {
      columns: ["Vĩnh Long", "Châu Hòa", "Xã Châu Bình, Xã Lương Quới, Xã Châu Hòa"],
    },
    {
      columns: [
        "Vĩnh Long",
        "Châu Hưng",
        "Xã Long Hòa (huyện Bình Đại), Xã Thới Lai, Xã Châu Hưng",
      ],
    },
    {
      columns: [
        "Vĩnh Long",
        "Châu Thành",
        "Thị trấn Châu Thành (huyện Châu Thành, tỉnh Trà Vinh), Xã Mỹ Chánh (huyện Châu Thành), Xã Thanh Mỹ, Xã Đa Lộc",
      ],
    },
    {
      columns: [
        "Vĩnh Long",
        "Chợ Lách",
        "Xã Long Thới (huyện Chợ Lách), Xã Hòa Nghĩa, Thị trấn Chợ Lách",
      ],
    },
    {
      columns: [
        "Vĩnh Long",
        "Duyên Hải",
        "Phường 1 (thị xã Duyên Hải), Xã Long Toàn, Xã Dân Thành",
      ],
    },
    {
      columns: ["Vĩnh Long", "Đại An", "Thị trấn Định An, Xã Định An, Xã Đại An"],
    },
    {
      columns: ["Vĩnh Long", "Đại Điền", "Xã Phú Khánh, Xã Tân Phong, Xã Thới Thạnh, Xã Đại Điền"],
    },
    {
      columns: ["Vĩnh Long", "Đôn Châu", "Xã Đôn Xuân, Xã Đôn Châu"],
    },
    {
      columns: ["Vĩnh Long", "Đông Hải", "Không sáp nhập"],
    },
    {
      columns: ["Vĩnh Long", "Đồng Khởi", "Xã Định Thủy, Xã Phước Hiệp, Xã Bình Khánh"],
    },
    {
      columns: [
        "Vĩnh Long",
        "Đông Thành",
        "Phường Đông Thuận, Xã Đông Bình, Xã Đông Thạnh, Xã Đông Thành",
      ],
    },
    {
      columns: [
        "Vĩnh Long",
        "Giao Long",
        "Xã An Phước (huyện Châu Thành), Xã Quới Sơn, Xã Giao Long",
      ],
    },
    {
      columns: ["Vĩnh Long", "Giồng Trôm", "Thị trấn Giồng Trôm, Xã Bình Hòa, Xã Bình Thành"],
    },
    {
      columns: ["Vĩnh Long", "Hàm Giang", "Xã Hàm Tân, Xã Kim Sơn, Xã Hàm Giang"],
    },
    {
      columns: ["Vĩnh Long", "Hiệp Mỹ", "Xã Long Sơn, Xã Hiệp Mỹ Đông, Xã Hiệp Mỹ Tây"],
    },
    {
      columns: ["Vĩnh Long", "Hiếu Phụng", "Xã Hiếu Thuận, Xã Trung An, Xã Hiếu Phụng"],
    },
    {
      columns: ["Vĩnh Long", "Hiếu Thành", "Xã Hiếu Nhơn, Xã Hiếu Nghĩa, Xã Hiếu Thành"],
    },
    {
      columns: ["Vĩnh Long", "Hòa Bình", "Xã Xuân Hiệp, Xã Thới Hòa, Xã Hòa Bình"],
    },
    {
      columns: ["Vĩnh Long", "Hòa Hiệp", "Xã Hòa Thạnh, Xã Hòa Lộc, Xã Hòa Hiệp"],
    },
    {
      columns: ["Vĩnh Long", "Hòa Minh", "Không sáp nhập"],
    },
    {
      columns: ["Vĩnh Long", "Hoà Thuận", "Phường 5 (thành phố Trà Vinh), Xã Hòa Thuận"],
    },
    {
      columns: ["Vĩnh Long", "Hùng Hoà", "Xã Ngãi Hùng, Xã Tân Hùng, Xã Hùng Hòa"],
    },
    {
      columns: [
        "Vĩnh Long",
        "Hưng Khánh Trung",
        "Xã Vĩnh Hòa (huyện Chợ Lách), Xã Hưng Khánh Trung A, Xã Hưng Khánh Trung B",
      ],
    },
    {
      columns: ["Vĩnh Long", "Hưng Mỹ", "Xã Hòa Lợi (huyện Châu Thành), Xã Phước Hảo, Xã Hưng Mỹ"],
    },
    {
      columns: ["Vĩnh Long", "Hưng Nhượng", "Xã Tân Thanh, Xã Hưng Lễ, Xã Hưng Nhượng"],
    },
    {
      columns: ["Vĩnh Long", "Hương Mỹ", "Xã Ngãi Đăng, Xã Cẩm Sơn, Xã Hương Mỹ"],
    },
    {
      columns: [
        "Vĩnh Long",
        "Long Châu",
        "Phường 1, Phường 9 (thành phố Vĩnh Long), Phường Trường An",
      ],
    },
    {
      columns: ["Vĩnh Long", "Long Đức", "Phường 4 (thành phố Trà Vinh), Xã Long Đức"],
    },
    {
      columns: ["Vĩnh Long", "Long Hiệp", "Xã Ngọc Biên, Xã Tân Hiệp, Xã Long Hiệp"],
    },
    {
      columns: ["Vĩnh Long", "Long Hòa", "Không sáp nhập"],
    },
    {
      columns: ["Vĩnh Long", "Long Hồ", "Thị trấn Long Hồ, Xã Long An, Xã Long Phước"],
    },
    {
      columns: ["Vĩnh Long", "Long Hữu", "Xã Hiệp Thạnh, Xã Long Hữu"],
    },
    {
      columns: ["Vĩnh Long", "Long Thành", "Thị trấn Long Thành, Xã Long Khánh"],
    },
    {
      columns: ["Vĩnh Long", "Long Vĩnh", "Không sáp nhập"],
    },
    {
      columns: ["Vĩnh Long", "Lộc Thuận", "Xã Vang Quới Đông, Xã Vang Quới Tây, Xã Lộc Thuận"],
    },
    {
      columns: ["Vĩnh Long", "Lục Sĩ Thành", "Xã Phú Thành, Xã Lục Sĩ Thành"],
    },
    {
      columns: ["Vĩnh Long", "Lương Hòa", "Xã Lương Hòa (huyện Giồng Trôm), Xã Phong Nẫm"],
    },
    {
      columns: [
        "Vĩnh Long",
        "Lương Phú",
        "Xã Mỹ Thạnh (huyện Giồng Trôm), Xã Thuận Điền, Xã Lương Phú",
      ],
    },
    {
      columns: ["Vĩnh Long", "Lưu Nghiệp Anh", "Xã An Quảng Hữu, Xã Lưu Nghiệp Anh"],
    },
    {
      columns: [
        "Vĩnh Long",
        "Mỏ Cày",
        "Thị trấn Mỏ Cày, Xã An Thạnh (huyện Mỏ Cày Nam), Xã Tân Hội, Xã Đa Phước Hội",
      ],
    },
    {
      columns: ["Vĩnh Long", "Mỹ Chánh Hòa", "Xã Mỹ Hòa, Xã Mỹ Chánh (huyện Ba Tri), Xã Mỹ Nhơn"],
    },
    {
      columns: ["Vĩnh Long", "Mỹ Long", "Thị trấn Mỹ Long, Xã Mỹ Long Bắc, Xã Mỹ Long Nam"],
    },
    {
      columns: ["Vĩnh Long", "Mỹ Thuận", "Xã Thành Trung, Xã Nguyễn Văn Thảnh, Xã Mỹ Thuận"],
    },
    {
      columns: ["Vĩnh Long", "Ngãi Tứ", "Xã Loan Mỹ, Xã Bình Ninh, Xã Ngãi Tứ, Thị trấn Trà Ôn"],
    },
    {
      columns: ["Vĩnh Long", "Ngũ Lạc", "Xã Thạnh Hòa Sơn, Xã Ngũ Lạc"],
    },
    {
      columns: [
        "Vĩnh Long",
        "Nguyệt Hoá",
        "Phường 7, Phường 8 (thành phố Trà Vinh), Xã Nguyệt Hóa",
      ],
    },
    {
      columns: ["Vĩnh Long", "Nhị Long", "Xã Đại Phước, Xã Đức Mỹ, Xã Nhị Long"],
    },
    {
      columns: ["Vĩnh Long", "Nhị Trường", "Xã Hiệp Hòa, Xã Trường Thọ, Xã Nhị Trường"],
    },
    {
      columns: ["Vĩnh Long", "Nhơn Phú", "Xã Mỹ An (huyện Mang Thít), Xã Mỹ Phước, Xã Nhơn Phú"],
    },
    {
      columns: [
        "Vĩnh Long",
        "Nhuận Phú Tân",
        "Xã Khánh Thạnh Tân, Xã Tân Thanh Tây, Xã Nhuận Phú Tân",
      ],
    },
    {
      columns: ["Vĩnh Long", "Phong Thạnh", "Xã Ninh Thới, Xã Phong Phú, Xã Phong Thạnh"],
    },
    {
      columns: [
        "Vĩnh Long",
        "Phú Khương",
        "Phường 8 (thành phố Bến Tre), Phường Phú Khương, Xã Phú Hưng, Xã Nhơn Thạnh",
      ],
    },
    {
      columns: ["Vĩnh Long", "Phú Phụng", "Xã Sơn Định, Xã Vĩnh Bình, Xã Phú Phụng"],
    },
    {
      columns: ["Vĩnh Long", "Phú Quới", "Xã Lộc Hòa, Xã Hòa Phú, Xã Thạnh Quới, Xã Phú Quới"],
    },
    {
      columns: ["Vĩnh Long", "Phú Tân", "Phường Phú Tân, Xã Hữu Định, Xã Phước Thạnh"],
    },
    {
      columns: ["Vĩnh Long", "Phú Thuận", "Xã Long Định, Xã Tam Hiệp, Xã Phú Thuận"],
    },
    {
      columns: [
        "Vĩnh Long",
        "Phú Túc",
        "Thị trấn Châu Thành (huyện Châu Thành, tỉnh Bến Tre), Xã Tân Thạch, Xã Tường Đa, Xã Phú Túc",
      ],
    },
    {
      columns: ["Vĩnh Long", "Phước Hậu", "Phường 3, Phường 4 (thành phố Vĩnh Long), Xã Phước Hậu"],
    },
    {
      columns: [
        "Vĩnh Long",
        "Phước Long",
        "Xã Long Mỹ (huyện Giồng Trôm), Xã Hưng Phong, Xã Phước Long",
      ],
    },
    {
      columns: [
        "Vĩnh Long",
        "Phước Mỹ Trung",
        "Thị trấn Phước Mỹ Trung, Xã Phú Mỹ, Xã Thạnh Ngãi, Xã Tân Phú Tây",
      ],
    },
    {
      columns: ["Vĩnh Long", "Quới An", "Xã Trung Thành Tây, Xã Tân Quới Trung, Xã Quới An"],
    },
    {
      columns: ["Vĩnh Long", "Quới Điền", "Xã Hòa Lợi (huyện Thạnh Phú), Xã Mỹ Hưng, Xã Quới Điền"],
    },
    {
      columns: ["Vĩnh Long", "Quới Thiện", "Xã Thanh Bình, Xã Quới Thiện"],
    },
    {
      columns: [
        "Vĩnh Long",
        "Song Lộc",
        "Xã Lương Hòa (huyện Châu Thành), Xã Lương Hòa A, Xã Song Lộc",
      ],
    },
    {
      columns: [
        "Vĩnh Long",
        "Song Phú",
        "Xã Tân Phú (huyện Tam Bình), Xã Long Phú, Xã Phú Thịnh, Xã Song Phú",
      ],
    },
    {
      columns: ["Vĩnh Long", "Sơn Đông", "Phường 6, Xã Sơn Đông, Xã Tam Phước"],
    },
    {
      columns: ["Vĩnh Long", "Tam Bình", "Xã Mỹ Thạnh Trung, Thị trấn Tam Bình"],
    },
    {
      columns: ["Vĩnh Long", "Tam Ngãi", "Xã Thông Hòa, Xã Thạnh Phú, Xã Tam Ngãi"],
    },
    {
      columns: ["Vĩnh Long", "Tân An", "Xã Huyền Hội, Xã Tân An"],
    },
    {
      columns: ["Vĩnh Long", "Tân Hạnh", "Phường 8 (thành phố Vĩnh Long), Xã Tân Hạnh"],
    },
    {
      columns: ["Vĩnh Long", "Tân Hào", "Xã Tân Lợi Thạnh, Xã Thạnh Phú Đông, Xã Tân Hào"],
    },
    {
      columns: [
        "Vĩnh Long",
        "Tân Hoà",
        "Xã Long Thới (huyện Tiểu Cần), Xã Tân Hòa, Thị trấn Cầu Quan",
      ],
    },
    {
      columns: ["Vĩnh Long", "Tân Long Hội", "Xã Tân An Hội, Xã Tân Long, Xã Tân Long Hội"],
    },
    {
      columns: ["Vĩnh Long", "Tân Lược", "Xã Tân Thành, Xã Tân An Thạnh, Xã Tân Lược"],
    },
    {
      columns: ["Vĩnh Long", "Tân Ngãi", "Phường Tân Hòa, Phường Tân Hội, Phường Tân Ngãi"],
    },
    {
      columns: ["Vĩnh Long", "Tân Phú", "Xã Tân Phú (huyện Châu Thành), Xã Tiên Long, Xã Phú Đức"],
    },
    {
      columns: [
        "Vĩnh Long",
        "Tân Quới",
        "Xã Tân Bình (huyện Bình Tân), Xã Thành Lợi, Thị trấn Tân Quới",
      ],
    },
    {
      columns: [
        "Vĩnh Long",
        "Tân Thành Bình",
        "Xã Tân Bình (huyện Mỏ Cày Bắc), Xã Thành An, Xã Hòa Lộc, Xã Tân Thành Bình",
      ],
    },
    {
      columns: ["Vĩnh Long", "Tân Thủy", "Thị trấn Tiệm Tôm, Xã An Hòa Tây, Xã Tân Thủy"],
    },
    {
      columns: ["Vĩnh Long", "Tân Xuân", "Xã Phú Lễ, Xã Phước Ngãi, Xã Tân Xuân"],
    },
    {
      columns: ["Vĩnh Long", "Tập Ngãi", "Xã Hiếu Tử, Xã Tập Ngãi"],
    },
    {
      columns: ["Vĩnh Long", "Tập Sơn", "Xã Tân Sơn, Xã Phước Hưng, Xã Tập Sơn"],
    },
    {
      columns: ["Vĩnh Long", "Thanh Đức", "Phường 5 (thành phố Vĩnh Long), Xã Thanh Đức"],
    },
    {
      columns: ["Vĩnh Long", "Thạnh Hải", "Xã An Điền, Xã Thạnh Hải"],
    },
    {
      columns: ["Vĩnh Long", "Thạnh Phong", "Xã Giao Thạnh, Xã Thạnh Phong"],
    },
    {
      columns: [
        "Vĩnh Long",
        "Thạnh Phú",
        "Thị trấn Thạnh Phú, Xã An Thạnh (huyện Thạnh Phú), Xã Bình Thạnh, Xã Mỹ An",
      ],
    },
    {
      columns: ["Vĩnh Long", "Thạnh Phước", "Xã Đại Hòa Lộc, Xã Thạnh Phước"],
    },
    {
      columns: ["Vĩnh Long", "Thành Thới", "Xã An Thới, Xã Thành Thới A, Xã Thành Thới B"],
    },
    {
      columns: ["Vĩnh Long", "Thạnh Trị", "Xã Định Trung, Xã Phú Long, Xã Thạnh Trị"],
    },
    {
      columns: ["Vĩnh Long", "Thới Thuận", "Xã Thừa Đức, Xã Thới Thuận"],
    },
    {
      columns: ["Vĩnh Long", "Tiên Thủy", "Thị trấn Tiên Thủy, Xã Thành Triệu, Xã Quới Thành"],
    },
    {
      columns: ["Vĩnh Long", "Tiểu Cần", "Thị trấn Tiểu Cần, Xã Phú Cần, Xã Hiếu Trung"],
    },
    {
      columns: ["Vĩnh Long", "Trà Côn", "Xã Nhơn Bình, Xã Trà Côn, Xã Tân Mỹ, Thị trấn Tam Bình"],
    },
    {
      columns: ["Vĩnh Long", "Trà Cú", "Thị trấn Trà Cú, Xã Ngãi Xuyên, Xã Thanh Sơn"],
    },
    {
      columns: ["Vĩnh Long", "Trà Ôn", "Xã Tích Thiện, Thị trấn Trà Ôn"],
    },
    {
      columns: ["Vĩnh Long", "Trà Vinh", "Phường 1, Phường 3, Phường 9 (thành phố Trà Vinh)"],
    },
    {
      columns: ["Vĩnh Long", "Trung Hiệp", "Xã Tân An Luông, Xã Trung Chánh, Xã Trung Hiệp"],
    },
    {
      columns: ["Vĩnh Long", "Trung Ngãi", "Xã Trung Thành Đông, Xã Trung Nghĩa, Xã Trung Ngãi"],
    },
    {
      columns: ["Vĩnh Long", "Trung Thành", "Thị trấn Vũng Liêm, Xã Trung Hiếu, Xã Trung Thành"],
    },
    {
      columns: ["Vĩnh Long", "Trường Long Hoà", "Phường 2 (thị xã Duyên Hải), Xã Trường Long Hòa"],
    },
    {
      columns: ["Vĩnh Long", "Vinh Kim", "Xã Kim Hòa, Xã Vinh Kim"],
    },
    {
      columns: ["Vĩnh Long", "Vĩnh Thành", "Xã Phú Sơn, Xã Tân Thiềng, Xã Vĩnh Thành"],
    },
    {
      columns: ["Vĩnh Long", "Vĩnh Xuân", "Xã Hựu Thành, Xã Thuận Thới, Xã Vĩnh Xuân"],
    },
  ],
};

export default locationData;
